shadow$provide[12] = function(require,module,exports,global) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, EmptyState:{enumerable:true, get:function() {
  return zE;
}}, Markdown:{enumerable:true, get:function() {
  return HE;
}}, copyContract:{enumerable:true, get:function() {
  return aT;
}}, dispatchEventAgentEvent:{enumerable:true, get:function() {
  return QE;
}}, fireTrigger:{enumerable:true, get:function() {
  return XE;
}}, getContract:{enumerable:true, get:function() {
  return tT;
}}, getDiscordConfig:{enumerable:true, get:function() {
  return jE;
}}, getEventAgentControl:{enumerable:true, get:function() {
  return GE;
}}, getKnoxxAuthContext:{enumerable:true, get:function() {
  return $E;
}}, listAdminTools:{enumerable:true, get:function() {
  return YE;
}}, listContracts:{enumerable:true, get:function() {
  return eT;
}}, resetEventAgentRuntime:{enumerable:true, get:function() {
  return JE;
}}, runEventAgentJob:{enumerable:true, get:function() {
  return VE;
}}, saveContract:{enumerable:true, get:function() {
  return nT;
}}, startEventAgentRuntime:{enumerable:true, get:function() {
  return ZE;
}}, stopEventAgentRuntime:{enumerable:true, get:function() {
  return KE;
}}, updateDiscordConfig:{enumerable:true, get:function() {
  return qE;
}}, updateEventAgentControl:{enumerable:true, get:function() {
  return WE;
}}, validateContract:{enumerable:true, get:function() {
  return rT;
}}});
var require$react_SLASH_jsx_runtime = require("react/jsx-runtime");
var require$react = require("react");
var require$react_dom = require("react-dom");
var default$$require$react = require.esmDefault(require$react);
function ao(e) {
  const t = e.replace("#", "").trim();
  return t.length === 3 ? t.split("").map(n => `${n}${n}`).join("") : t;
}
function io(e) {
  const t = Number(e.toFixed(2));
  return String(t);
}
function k(e, t) {
  const n = ao(e);
  if (n.length !== 6) {
    return e;
  }
  const r = parseInt(n.slice(0, 2), 16), a = parseInt(n.slice(2, 4), 16), i = parseInt(n.slice(4, 6), 16);
  return `rgba(${r}, ${a}, ${i}, ${io(t)})`;
}
function Hi(e, t) {
  if (!t) {
    return e;
  }
  const n = {...e};
  for (const [r, a] of Object.entries(t)) {
    const i = n[r];
    if (a && typeof a == "object" && !Array.isArray(a) && i && typeof i == "object" && !Array.isArray(i)) {
      n[r] = Hi(i, a);
      continue;
    }
    n[r] = a;
  }
  return n;
}
function uo(e, t) {
  const n = {background:{default:e.bg.default, surface:e.bg.darker, elevated:e.bg.tabInactive, highlight:e.bg.lighter, overlay:"rgba(0, 0, 0, 0.6)"}, selection:{default:k(e.bg.selection, 0.5)}, text:{default:e.fg.default, bright:e.fg.bright, panel:e.fg.panel, soft:e.fg.soft, muted:e.fg.muted, subtle:e.fg.subtle, inverse:e.bg.default, secondary:e.fg.muted}, interactive:{default:e.accent.cyan, hover:k(e.accent.cyan, 0.88), active:k(e.accent.cyan, 0.72), disabled:e.fg.muted}, button:{primary:{bg:e.accent.cyan, 
  fg:e.bg.default, hover:k(e.accent.cyan, 0.88), active:k(e.accent.cyan, 0.72)}, secondary:{bg:e.bg.selection, fg:e.fg.default, hover:k(e.bg.selection, 0.88), active:k(e.bg.selection, 0.72)}, ghost:{bg:"transparent", fg:e.fg.default, hover:k(e.fg.default, 0.08), active:k(e.fg.default, 0.14)}, danger:{bg:e.accent.red, fg:e.fg.default, hover:k(e.accent.red, 0.88), active:k(e.accent.red, 0.72)}}, badge:{default:{bg:e.fg.muted, fg:e.fg.default}, success:{bg:k(e.accent.green, 0.15), fg:e.accent.green}, 
  warning:{bg:k(e.accent.orange, 0.15), fg:e.accent.orange}, error:{bg:k(e.accent.red, 0.15), fg:e.accent.red}, info:{bg:k(e.accent.blue, 0.15), fg:e.accent.blue}}, border:{default:e.bg.groupBorder, subtle:e.fg.subtle, focus:e.accent.cyan, error:e.accent.red}, accent:e.accent, semantic:{error:e.semantic.error, warning:e.semantic.warning, success:e.semantic.success, info:e.semantic.info}, status:{alive:e.accent.green, dead:e.accent.red, open:e.accent.green, closed:e.fg.muted, merged:e.accent.magenta, 
  sleeping:e.accent.blue, eating:e.accent.orange, working:e.accent.yellow}, chart:{segment0:e.accent.blue, segment1:e.accent.green, segment2:e.accent.yellow, segment3:e.accent.orange, segment4:e.accent.magenta, segment5:e.fg.soft}, fill:{good:{start:e.accent.green, end:k(e.accent.green, 0.55)}, warn:{start:e.accent.orange, end:k(e.accent.orange, 0.55)}, danger:{start:e.accent.red, end:k(e.accent.red, 0.55)}, neutral:{start:e.accent.blue, end:k(e.accent.blue, 0.55)}}, surface:{panel:k(e.bg.darker, 
  0.82), card:k(e.bg.tabInactive, 0.65), cardAlt:k(e.bg.lighter, 0.55), input:k(e.bg.selection, 0.78), nav:k(e.bg.darker, 0.6)}, alpha:{green:{_08:k(e.accent.green, 0.08), _12:k(e.accent.green, 0.12), _14:k(e.accent.green, 0.14), _15:k(e.accent.green, 0.15), _16:k(e.accent.green, 0.16), _25:k(e.accent.green, 0.25), _28:k(e.accent.green, 0.28), _30:k(e.accent.green, 0.3), _35:k(e.accent.green, 0.35), _38:k(e.accent.green, 0.38), _40:k(e.accent.green, 0.4), _45:k(e.accent.green, 0.45), _50:k(e.accent.green, 
  0.5), _55:k(e.accent.green, 0.55), _60:k(e.accent.green, 0.6), _80:k(e.accent.green, 0.8)}, red:{_12:k(e.accent.red, 0.12), _14:k(e.accent.red, 0.14), _15:k(e.accent.red, 0.15), _25:k(e.accent.red, 0.25), _30:k(e.accent.red, 0.3), _38:k(e.accent.red, 0.38), _40:k(e.accent.red, 0.4), _45:k(e.accent.red, 0.45), _46:k(e.accent.red, 0.46), _50:k(e.accent.red, 0.5)}, orange:{_12:k(e.accent.orange, 0.12), _15:k(e.accent.orange, 0.15), _32:k(e.accent.orange, 0.32), _35:k(e.accent.orange, 0.35), _40:k(e.accent.orange, 
  0.4)}, blue:{_15:k(e.accent.blue, 0.15), _20:k(e.accent.blue, 0.2), _35:k(e.accent.blue, 0.35), _45:k(e.accent.blue, 0.45), _80:k(e.accent.blue, 0.8), _95:k(e.accent.blue, 0.95)}, magenta:{_08:k(e.accent.magenta, 0.08), _14:k(e.accent.magenta, 0.14), _30:k(e.accent.magenta, 0.3)}, yellow:{_06:k(e.accent.yellow, 0.06)}, bg:{_08:k(e.bg.selection, 0.08), _10:k(e.bg.selection, 0.1), _12:k(e.bg.selection, 0.12), _14:k(e.bg.selection, 0.14), _16:k(e.bg.selection, 0.16), _18:k(e.bg.selection, 0.18), _24:k(e.bg.lighter, 
  0.24), _25:k(e.bg.selection, 0.25), _28:k(e.bg.selection, 0.28), _30:k(e.bg.selection, 0.3), _46:k(e.bg.darker, 0.46), _55:k(e.bg.selection, 0.55), _60:k(e.bg.darker, 0.6), _62:k(e.bg.darker, 0.62), _68:k(e.bg.darker, 0.68), _70:k(e.bg.selection, 0.7), _72:k(e.bg.darker, 0.72), _80:k(e.bg.darker, 0.8), _85:k(e.bg.lighter, 0.85), _88:k(e.bg.lighter, 0.88), _88b:k(e.bg.default, 0.88), _90:k(e.bg.darker, 0.9), _95:k(e.bg.darker, 0.95)}, warningBg:k(e.accent.orange, 0.2), errorBg:k(e.accent.red, 0.42), 
  errorBgSolid:k(e.accent.red, 0.9), federationError:k(e.accent.red, 0.22), white:{_08:"rgba(255, 255, 255, 0.08)"}, shadow:"rgba(0, 0, 0, 0.35)", shadowLight:"rgba(0, 0, 0, 0.3)", shadowDeep:"rgba(15, 23, 42, 0.22)"}};
  return Hi(n, t);
}
function zi(e) {
  return e.replace(/([A-Z])/g, "-$1").toLowerCase();
}
function so(e, t) {
  return `var(--uxx-${e.map(zi).join("-")}, ${t})`;
}
function $i(e, t = []) {
  if (typeof e == "string") {
    return so(t, e);
  }
  if (typeof e == "object" && e !== null) {
    const n = Object.entries(e).map(([r, a]) => [r, $i(a, [...t, r])]);
    return Object.fromEntries(n);
  }
  return e;
}
function Xn(e, t, n, r) {
  return {name:e, label:t, appearance:(r == null ? void 0 : r.appearance) ?? "dark", palette:n, colors:uo(n, r == null ? void 0 : r.colorOverrides)};
}
const _e = {bg:{default:"#272822", darker:"#1e1f1c", lighter:"#3e3d32", selection:"#414339", tabInactive:"#34352f", groupBorder:"#34352f"}, fg:{default:"#f8f8f2", bright:"#f8f8f2", panel:"#cccccc", soft:"#90908a", muted:"#75715e", subtle:"#464741"}, accent:{yellow:"#e6db74", orange:"#fd971f", red:"#f92672", magenta:"#ae81ff", blue:"#66d9ef", cyan:"#66d9ef", green:"#a6e22e"}, semantic:{error:"#f92672", warning:"#fd971f", success:"#a6e22e", info:"#66d9ef"}}, me = {bg:{default:"#011627", darker:"#01111d", 
lighter:"#0b2942", selection:"#1d3b53", tabInactive:"#0b253a", groupBorder:"#5f7e97"}, fg:{default:"#d6deeb", bright:"#ffffff", panel:"#d2dee7", soft:"#89a4bb", muted:"#5f7e97", subtle:"#4b6479"}, accent:{yellow:"#ffeb95", orange:"#F78C6C", red:"#EF5350", magenta:"#c792ea", blue:"#82AAFF", cyan:"#80CBC4", green:"#c5e478"}, semantic:{error:"#EF5350", warning:"#FFCA28", success:"#c5e478", info:"#82AAFF"}}, H = {bg:{default:"#0A0C0F", darker:"#0F1318", lighter:"#1E2530", selection:"#131820", tabInactive:"#131820", 
groupBorder:"#1E2530"}, fg:{default:"#E8ECF1", bright:"#F4F7FB", panel:"#D6DCE6", soft:"#A6B1C2", muted:"#8A94A6", subtle:"#5A6478"}, accent:{yellow:"#F5A623", orange:"#F5A623", red:"#FF4C4C", magenta:"#9B8CFF", blue:"#00D4FF", cyan:"#00D4FF", green:"#00E5A0"}, semantic:{error:"#FF4C4C", warning:"#F5A623", success:"#00E5A0", info:"#00D4FF"}}, yt = {monokai:Xn("monokai", "Monokai", _e, {appearance:"dark", colorOverrides:{selection:{default:"rgba(135, 139, 145, 0.5)"}, interactive:{default:_e.accent.green, 
hover:"#8fce26", active:"#7cb824", disabled:_e.fg.muted}, button:{primary:{bg:_e.fg.muted, fg:_e.fg.default, hover:"#8a856e", active:"#6a6654"}, secondary:{bg:_e.bg.selection, fg:_e.fg.default, hover:"#505248", active:"#3a3c33"}, ghost:{bg:"transparent", fg:_e.fg.default, hover:_e.bg.selection, active:_e.bg.tabInactive}, danger:{bg:_e.accent.red, fg:_e.fg.default, hover:"#e61b63", active:"#d1155c"}}, border:{focus:"#99947c"}, chart:{segment5:"#7ca3b5"}, fill:{good:{start:_e.accent.green, end:"#78efb7"}, 
warn:{start:_e.accent.orange, end:"#ffd280"}, danger:{start:_e.accent.red, end:"#ff9e92"}, neutral:{start:"#7aa7bd", end:"#98bfd0"}}, alpha:{warningBg:"rgba(58, 41, 16, 0.88)", errorBg:"rgba(70, 24, 24, 0.42)", errorBgSolid:"rgba(70, 24, 24, 0.9)", federationError:"rgba(127, 29, 29, 0.22)"}}}), "night-owl":Xn("night-owl", "Night Owl", me, {appearance:"dark", colorOverrides:{interactive:{default:me.accent.cyan, hover:"#7fdbca", active:"#21c7a8", disabled:me.fg.muted}, button:{primary:{bg:"#7e57c2cc", 
fg:"#ffffffcc", hover:"#7e57c2", active:"#6747a4"}, secondary:{bg:me.bg.selection, fg:me.fg.default, hover:"#234d708c", active:"#0e293f"}, ghost:{bg:"transparent", fg:me.fg.default, hover:k(me.bg.selection, 0.55), active:me.bg.lighter}, danger:{bg:me.accent.red, fg:"#ffffffcc", hover:"#ec5f67", active:"#d3423e"}}, badge:{default:{bg:me.fg.muted, fg:"#ffffff"}}, border:{default:me.bg.groupBorder, subtle:me.fg.subtle, focus:me.accent.blue}, chart:{segment5:"#5f7e97"}, fill:{good:{start:me.accent.green, 
end:"#d9f5dd"}, warn:{start:me.accent.orange, end:"#ffcb8b"}, danger:{start:me.accent.red, end:"#ff869a"}, neutral:{start:me.accent.blue, end:"#c5e4fd"}}, alpha:{warningBg:"#675700F2", errorBg:"rgba(171, 3, 0, 0.42)", errorBgSolid:"#AB0300F2", federationError:k(me.accent.red, 0.22), shadow:"rgba(1, 22, 39, 0.35)", shadowLight:"rgba(1, 11, 20, 0.3)", shadowDeep:"rgba(1, 17, 29, 0.45)"}}}), "proxy-console":Xn("proxy-console", "Proxy Console", H, {appearance:"dark", colorOverrides:{interactive:{default:H.accent.cyan, 
hover:"#34DEFF", active:"#00B8DE", disabled:H.fg.subtle}, button:{primary:{bg:"#00D4FF", fg:"#0A0C0F", hover:"#34DEFF", active:"#00B8DE"}, secondary:{bg:"#0F1318", fg:"#E8ECF1", hover:"#131820", active:"#1A212C"}, ghost:{bg:"transparent", fg:"#E8ECF1", hover:k(H.accent.cyan, 0.12), active:k(H.accent.cyan, 0.18)}, danger:{bg:"#FF4C4C", fg:"#FDFEFF", hover:"#FF6666", active:"#E64545"}}, badge:{default:{bg:k(H.fg.subtle, 0.2), fg:"#E8ECF1"}, success:{bg:k(H.accent.green, 0.12), fg:"#00E5A0"}, warning:{bg:k(H.accent.orange, 
0.12), fg:"#F5A623"}, error:{bg:k(H.accent.red, 0.12), fg:"#FF4C4C"}, info:{bg:k(H.accent.cyan, 0.12), fg:"#00D4FF"}}, border:{default:"#1E2530", subtle:"#171C25", focus:"#00D4FF", error:"#FF4C4C"}, chart:{segment0:"#00D4FF", segment1:"#00E5A0", segment2:"#F5A623", segment3:"#FF4C4C", segment4:"#9B8CFF", segment5:"#7A90AA"}, fill:{good:{start:"#00E5A0", end:"#57F0C0"}, warn:{start:"#F5A623", end:"#FFD07A"}, danger:{start:"#FF4C4C", end:"#FF8C8C"}, neutral:{start:"#00D4FF", end:"#8EEBFF"}}, surface:{panel:k(H.bg.darker, 
0.92), card:k(H.bg.tabInactive, 0.82), cardAlt:k(H.bg.lighter, 0.62), input:k("#0A0D11", 0.95), nav:k(H.bg.default, 0.88)}, alpha:{green:{_08:k(H.accent.green, 0.08), _12:k(H.accent.green, 0.12), _14:k(H.accent.green, 0.14), _15:k(H.accent.green, 0.15), _16:k(H.accent.green, 0.16), _25:k(H.accent.green, 0.25), _28:k(H.accent.green, 0.28), _30:k(H.accent.green, 0.3), _35:k(H.accent.green, 0.35), _38:k(H.accent.green, 0.38), _40:k(H.accent.green, 0.4), _45:k(H.accent.green, 0.45), _50:k(H.accent.green, 
0.5), _55:k(H.accent.green, 0.55), _60:k(H.accent.green, 0.6), _80:k(H.accent.green, 0.8)}, red:{_12:k(H.accent.red, 0.12), _14:k(H.accent.red, 0.14), _15:k(H.accent.red, 0.15), _25:k(H.accent.red, 0.25), _30:k(H.accent.red, 0.3), _38:k(H.accent.red, 0.38), _40:k(H.accent.red, 0.4), _45:k(H.accent.red, 0.45), _46:k(H.accent.red, 0.46), _50:k(H.accent.red, 0.5)}, orange:{_12:k(H.accent.orange, 0.12), _15:k(H.accent.orange, 0.15), _32:k(H.accent.orange, 0.32), _35:k(H.accent.orange, 0.35), _40:k(H.accent.orange, 
0.4)}, blue:{_15:k(H.accent.blue, 0.15), _20:k(H.accent.blue, 0.2), _35:k(H.accent.blue, 0.35), _45:k(H.accent.blue, 0.45), _80:k(H.accent.blue, 0.8), _95:k(H.accent.blue, 0.95)}, magenta:{_08:k(H.accent.magenta, 0.08), _14:k(H.accent.magenta, 0.14), _30:k(H.accent.magenta, 0.3)}, yellow:{_06:k(H.accent.yellow, 0.06)}, bg:{_08:k(H.bg.tabInactive, 0.08), _10:k(H.bg.tabInactive, 0.1), _12:k(H.bg.tabInactive, 0.12), _14:k(H.bg.tabInactive, 0.14), _16:k(H.bg.tabInactive, 0.16), _18:k(H.bg.tabInactive, 
0.18), _24:k(H.bg.tabInactive, 0.24), _25:k(H.bg.tabInactive, 0.25), _28:k(H.bg.tabInactive, 0.28), _30:k(H.bg.tabInactive, 0.3), _46:k(H.bg.default, 0.46), _55:k(H.bg.tabInactive, 0.55), _60:k(H.bg.default, 0.6), _62:k(H.bg.default, 0.62), _68:k(H.bg.default, 0.68), _70:k(H.bg.tabInactive, 0.7), _72:k(H.bg.default, 0.72), _80:k(H.bg.default, 0.8), _85:k(H.bg.tabInactive, 0.85), _88:k(H.bg.tabInactive, 0.88), _88b:k(H.bg.default, 0.88), _90:k(H.bg.default, 0.9), _95:k(H.bg.default, 0.95)}, warningBg:k("#442E0C", 
0.88), errorBg:k("#5A1C1C", 0.42), errorBgSolid:k("#5A1C1C", 0.9), federationError:k("#7F1D1D", 0.22), white:{_08:k("#FFFFFF", 0.08)}, shadow:k("#000000", 0.4), shadowLight:k("#000000", 0.3), shadowDeep:k("#000000", 0.5)}}})}, Ve = "monokai";
function pn(e) {
  return Object.values(yt).find(t => t.appearance === e) ?? yt[Ve];
}
function Yi(e = Ve) {
  return e === "dark" ? pn("dark").name : e === "light" ? pn("light").name : e === "auto" ? typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: light)").matches ? pn("light").name : pn("dark").name : Ve : e;
}
function oo(e = Ve) {
  return yt[e];
}
function lo(e = Ve) {
  return oo(Yi(e));
}
$i(yt[Ve].colors, ["colors"]);
const rt = 4, co = {1:rt * 1, "1.5":rt * 1.5, 2:rt * 2, 3:rt * 3, 4:rt * 4, 5:rt * 5, 6:rt * 6, 8:rt * 8}, pr = {sans:["Inter", "system-ui", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "sans-serif"].join(", "), mono:["JetBrains Mono", "Fira Code", "Monaco", "Consolas", "Liberation Mono", "Courier New", "monospace"].join(", ")}, we = {xs:"0.75rem", sm:"0.875rem", base:"1rem", lg:"1.125rem", xl:"1.25rem", "2xl":"1.5rem", "3xl":"1.875rem", "4xl":"2.25rem", 
"5xl":"3rem", inlineCode:"0.875em"}, fo = {medium:500, semibold:600}, ho = {none:1, normal:1.5};
we["4xl"], we["3xl"], we["2xl"], we.xl, we.lg, we.base, we.base, we.sm, we.sm, we.xs, pr.mono, we.sm, pr.mono, we.inlineCode;
const po = {fast:"100ms"}, mo = {easeInOut:"cubic-bezier(0.4, 0, 0.2, 1)"}, go = {colors:`color, background-color, border-color ${po.fast} ${mo.easeInOut}`}, mt = {xs:"0 1px 2px 0 rgba(0, 0, 0, 0.05)", sm:"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)", md:"0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)", lg:"0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)", xl:"0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)", 
"2xl":"0 25px 50px -12px rgba(0, 0, 0, 0.25)", inner:"inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)", focus:"0 0 0 2px rgba(166, 226, 46, 0.5)", focusError:"0 0 0 2px rgba(249, 38, 114, 0.5)", none:"none"};
mt.none, mt.sm, mt.md, mt.lg, mt.xl, mt["2xl"];
const bo = {modal:1400}, Eo = {none:"0px", xs:"2px", sm:"4px", md:"6px", lg:"8px", xl:"12px", full:"9999px"};
function st(e) {
  return structuredClone(e);
}
function mr(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function ji(e, t) {
  if (!t) {
    return st(e);
  }
  const n = st(e);
  for (const [r, a] of Object.entries(t)) {
    if (a === void 0) {
      continue;
    }
    const i = n[r];
    if (mr(i) && mr(a)) {
      n[r] = ji(i, a);
      continue;
    }
    n[r] = a;
  }
  return n;
}
function gr(e, t) {
  return ji(e, t);
}
const Qn = {colors:st(yt.monokai.colors), palette:st(_e), fontFamily:pr, fontSize:we, shadow:mt, radius:Eo}, ct = {monokai:Qn, "night-owl":gr(Qn, {colors:st(yt["night-owl"].colors), palette:st(me), shadow:{focus:"0 0 0 2px rgba(130, 170, 255, 0.35)", focusError:"0 0 0 2px rgba(239, 83, 80, 0.35)"}}), "proxy-console":gr(Qn, {colors:st(yt["proxy-console"].colors), palette:st(H), fontFamily:{sans:["IBM Plex Sans", "Segoe UI", "system-ui", "sans-serif"].join(", "), mono:["JetBrains Mono", "Fira Code", 
"monospace"].join(", ")}, shadow:{xs:"0 1px 2px 0 rgba(0, 0, 0, 0.35)", sm:"0 1px 3px rgba(0, 0, 0, 0.4)", md:"0 4px 12px rgba(0, 0, 0, 0.5)", lg:"0 10px 24px rgba(0, 0, 0, 0.55)", xl:"0 20px 36px rgba(0, 0, 0, 0.6)", "2xl":"0 28px 64px rgba(0, 0, 0, 0.65)", inner:"inset 0 1px 2px rgba(0, 0, 0, 0.28)", focus:"0 0 0 2px rgba(0, 212, 255, 0.35)", focusError:"0 0 0 2px rgba(255, 76, 76, 0.35)", none:"none"}, radius:{none:"0px", xs:"2px", sm:"4px", md:"4px", lg:"6px", xl:"8px", full:"9999px"}})};
function To(e) {
  return `--uxx-${e.map(zi).join("-")}`;
}
function At(e, t = []) {
  const n = {};
  for (const [r, a] of Object.entries(e)) {
    const i = [...t, r];
    if (mr(a)) {
      n[r] = At(a, i);
      continue;
    }
    n[r] = `var(${To(i)}, ${String(a)})`;
  }
  return n;
}
const yo = At(ct.monokai.colors, ["colors"]);
At(ct.monokai.palette, ["palette"]);
const br = At(ct.monokai.fontFamily, ["fontFamily"]), De = At(ct.monokai.fontSize, ["fontSize"]), _o = At(ct.monokai.shadow, ["shadow"]), Ao = At(ct.monokai.radius, ["radius"]), xo = {h1:{fontSize:De["4xl"]}, h2:{fontSize:De["3xl"]}, h3:{fontSize:De["2xl"]}, h4:{fontSize:De.xl}, h5:{fontSize:De.lg}, h6:{fontSize:De.base}, body:{fontSize:De.base}, bodySm:{fontSize:De.sm}, label:{fontSize:De.sm}, caption:{fontSize:De.xs}, code:{fontFamily:br.mono, fontSize:De.sm}, codeInline:{fontFamily:br.mono, fontSize:De.inlineCode}}, 
h = {colors:yo, spacing:co, fontFamily:br, fontSize:De, fontWeight:fo, lineHeight:ho, typography:xo, transitions:go, shadow:_o, zIndex:bo, radius:Ao};
function So(e) {
  return ct[e] ?? ct[Ve];
}
function qi(e, t) {
  const n = lo(e), r = gr(So(e), t);
  return {...n, palette:r.palette, colors:r.colors, fontFamily:r.fontFamily, fontSize:r.fontSize, shadow:r.shadow, radius:r.radius};
}
const ko = (0,require$react.createContext)({theme:Ve, themeName:Ve, resolvedTheme:qi(Ve)});
function Co() {
  return (0,require$react.useContext)(ko);
}
function Gi(e) {
  const t = Co();
  return (0,require$react.useMemo)(() => e === void 0 ? t.resolvedTheme : qi(Yi(e)), [t.resolvedTheme, e]);
}
const Io = {primary:{backgroundColor:h.colors.button.primary.bg, color:h.colors.button.primary.fg, border:"none"}, secondary:{backgroundColor:h.colors.button.secondary.bg, color:h.colors.button.secondary.fg, border:`1px solid ${h.colors.border.default}`}, ghost:{backgroundColor:"transparent", color:h.colors.button.ghost.fg, border:"none"}, danger:{backgroundColor:h.colors.button.danger.bg, color:h.colors.button.danger.fg, border:"none"}}, No = {sm:{padding:`${h.spacing[1.5]}px ${h.spacing[3]}px`, 
fontSize:h.typography.bodySm.fontSize, gap:`${h.spacing[1]}px`}, md:{padding:`${h.spacing[2]}px ${h.spacing[4]}px`, fontSize:h.typography.body.fontSize, gap:`${h.spacing[2]}px`}, lg:{padding:`${h.spacing[3]}px ${h.spacing[6]}px`, fontSize:h.typography.body.fontSize, gap:`${h.spacing[2]}px`}}, Oo = {display:"inline-flex", alignItems:"center", justifyContent:"center", fontWeight:h.fontWeight.medium, lineHeight:h.lineHeight.none, borderRadius:h.radius.md, cursor:"pointer", transition:h.transitions.colors, 
outline:"none", fontFamily:h.fontFamily.sans};
function Lo({size:e}) {
  const t = e === "sm" ? 14 : e === "lg" ? 20 : 16;
  return (0,require$react_SLASH_jsx_runtime.jsx)("svg", {width:t, height:t, viewBox:"0 0 24 24", fill:"none", stroke:"currentColor", strokeWidth:"2", strokeLinecap:"round", strokeLinejoin:"round", style:{animation:"spin 1s linear infinite"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("path", {d:"M21 12a9 9 0 11-6.219-8.56"})});
}
const Wi = (0,require$react.forwardRef)(({variant:e = "secondary", size:t = "md", disabled:n = !1, loading:r = !1, fullWidth:a = !1, iconStart:i, iconEnd:u, children:o, type:l = "button", ...c}, f) => {
  const d = n || r, m = {...Oo, ...Io[e], ...No[t], width:a ? "100%" : void 0, opacity:d ? 0.6 : 1, cursor:d ? "not-allowed" : "pointer"};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {ref:f, type:l, disabled:d, "data-component":"button", "data-variant":e, "data-size":t, "data-loading":r || void 0, "data-full-width":a || void 0, "aria-busy":r, style:m, ...c, children:[r && (0,require$react_SLASH_jsx_runtime.jsx)(Lo, {size:t}), !r && i, o, !r && u]});
});
Wi.displayName = "Button";
h.colors.badge.default.bg, h.colors.badge.default.fg, h.colors.badge.success.bg, h.colors.badge.success.fg, h.colors.badge.warning.bg, h.colors.badge.warning.fg, h.colors.badge.error.bg, h.colors.badge.error.fg, h.colors.badge.info.bg, h.colors.badge.info.fg, h.colors.badge.success.bg, h.colors.badge.success.fg, h.colors.badge.default.bg, h.colors.badge.default.fg, h.colors.alpha.magenta._14, h.colors.accent.magenta, h.colors.alpha.green._12, h.colors.accent.green, h.colors.alpha.red._12, h.colors.accent.red, 
h.colors.alpha.blue._15, h.colors.accent.blue, h.colors.badge.default.bg, h.colors.text.muted;
h.fontSize.xs, h.fontSize.xs, h.fontSize.sm;
h.radius.sm, h.fontFamily.sans;
const Ro = `
@keyframes devel-badge-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}
`;
if (typeof document < "u") {
  const e = document.createElement("style");
  e.textContent = Ro, document.head.appendChild(e);
}
const wo = {default:{backgroundColor:h.colors.background.surface, border:`1px solid ${h.colors.border.default}`, boxShadow:h.shadow.sm}, outlined:{backgroundColor:"transparent", border:`1px solid ${h.colors.border.default}`, boxShadow:h.shadow.none}, elevated:{backgroundColor:h.colors.background.elevated, border:`1px solid ${h.colors.border.subtle}`, boxShadow:h.shadow.md}}, ha = {none:{padding:0}, sm:{padding:`${h.spacing[2]}px ${h.spacing[3]}px`}, md:{padding:`${h.spacing[4]}px ${h.spacing[5]}px`}, 
lg:{padding:`${h.spacing[6]}px ${h.spacing[8]}px`}}, Do = {none:h.radius.none, sm:h.radius.sm, md:h.radius.md, lg:h.radius.lg, full:h.radius.full}, Po = {display:"flex", flexDirection:"column", transition:h.transitions.colors, fontFamily:h.fontFamily.sans, overflow:"hidden"}, Fo = {display:"flex", alignItems:"center", justifyContent:"space-between", padding:`${h.spacing[3]}px ${h.spacing[4]}px`, borderBottom:`1px solid ${h.colors.border.default}`, fontWeight:h.fontWeight.semibold, fontSize:h.fontSize.lg}, 
Mo = {flex:1, minHeight:0}, Bo = {display:"flex", alignItems:"center", justifyContent:"flex-end", gap:`${h.spacing[2]}px`, padding:`${h.spacing[3]}px ${h.spacing[4]}px`, borderTop:`1px solid ${h.colors.border.default}`}, vo = (0,require$react.forwardRef)(({variant:e = "default", interactive:t = !1, padding:n = "md", radius:r = "md", header:a, title:i, extra:u, children:o, footer:l, onClick:c, style:f}, d) => {
  const m = t || typeof c == "function", p = ha[n].padding, g = {...Po, ...wo[e], padding:a || l ? void 0 : p, borderRadius:Do[r], cursor:m ? "pointer" : "default"}, T = C => {
    m && (C.key === "Enter" || C.key === " ") && (C.preventDefault(), c == null || c({...C, currentTarget:C.currentTarget}));
  }, A = a !== void 0 || i !== void 0 || u !== void 0, y = A || l ? ha[n].padding : void 0;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:d, "data-component":"card", "data-variant":e, "data-interactive":m || void 0, role:m ? "button" : "region", tabIndex:m ? 0 : void 0, onClick:m ? c : void 0, onKeyDown:m ? T : void 0, style:{...g, ...f}, children:[A && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:Fo, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:h.spacing[2]}, children:[a, i && !a && (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {children:i})]}), u && (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:u})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...Mo, padding:y}, children:o}), l !== void 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:Bo, children:l})]});
});
vo.displayName = "Card";
`${h.colors.border.default}`, h.fontSize.lg;
`${h.colors.border.default}`;
const Uo = {sm:{maxWidth:"400px"}, md:{maxWidth:"600px"}, lg:{maxWidth:"800px"}, xl:{maxWidth:"1000px"}, full:{maxWidth:"calc(100vw - 64px)", maxHeight:"calc(100vh - 64px)"}}, Ho = {position:"fixed", inset:0, backgroundColor:"var(--token-colors-background-overlay)", backdropFilter:"blur(4px)", zIndex:h.zIndex.modal, display:"flex", alignItems:"center", justifyContent:"center", padding:"32px"}, zo = {backgroundColor:h.colors.background.elevated, borderRadius:h.radius.lg, boxShadow:h.shadow["2xl"], 
border:`1px solid ${h.colors.border.subtle}`, display:"flex", flexDirection:"column", width:"100%", maxHeight:"calc(100vh - 64px)", fontFamily:h.fontFamily.sans}, $o = {display:"flex", alignItems:"center", justifyContent:"space-between", padding:`${h.spacing[4]}px ${h.spacing[5]}px`, borderBottom:`1px solid ${h.colors.border.default}`, fontWeight:h.fontWeight.semibold, fontSize:h.fontSize.lg}, Yo = {flex:1, padding:`${h.spacing[4]}px ${h.spacing[5]}px`, overflowY:"auto"}, jo = {display:"flex", alignItems:"center", 
justifyContent:"flex-end", gap:`${h.spacing[2]}px`, padding:`${h.spacing[3]}px ${h.spacing[5]}px`, borderTop:`1px solid ${h.colors.border.default}`}, qo = {background:"none", border:"none", cursor:"pointer", padding:`${h.spacing[1]}px`, fontSize:"20px", lineHeight:1, color:h.colors.text.muted, transition:h.transitions.colors}, Go = (0,require$react.forwardRef)(({open:e = !1, onClose:t, size:n = "md", closable:r = !0, closeOnBackdrop:a = !0, closeOnEscape:i = !0, centered:u = !0, scrollBehavior:o = 
"inside", header:l, title:c, children:f, footer:d}, m) => {
  const p = (0,require$react.useRef)(null), g = (0,require$react.useRef)(null), T = (0,require$react.useId)(), A = (0,require$react.useId)();
  (0,require$react.useEffect)(() => {
    var B;
    if (e) {
      return g.current = document.activeElement, (B = p.current) == null || B.focus(), document.body.style.overflow = "hidden", () => {
        var O;
        document.body.style.overflow = "", (O = g.current) == null || O.focus();
      };
    }
  }, [e]);
  const y = (0,require$react.useCallback)(B => {
    B.key === "Escape" && r && i && t();
  }, [r, i, t]), C = (0,require$react.useCallback)(B => {
    a && r && B.target === B.currentTarget && t();
  }, [a, r, t]), N = (0,require$react.useCallback)(B => {
    var O;
    if (B.key === "Tab") {
      const j = (O = p.current) == null ? void 0 : O.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex\x3d"-1"])');
      if (!j || j.length === 0) {
        return;
      }
      const W = j[0], $ = j[j.length - 1];
      B.shiftKey && document.activeElement === W ? (B.preventDefault(), $.focus()) : !B.shiftKey && document.activeElement === $ && (B.preventDefault(), W.focus());
    }
  }, []);
  if (!e) {
    return null;
  }
  const v = (0,require$react_SLASH_jsx_runtime.jsx)("div", {"data-component":"modal", "data-size":n, "data-open":e, style:Ho, onClick:C, onKeyDown:y, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:B => {
    p.current = B, typeof m == "function" ? m(B) : m && (m.current = B);
  }, role:"dialog", "aria-modal":"true", "aria-labelledby":c ? T : void 0, tabIndex:-1, style:{...zo, ...Uo[n]}, onKeyDown:N, children:[(l !== void 0 || c !== void 0) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:$o, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {id:T, style:{display:"flex", alignItems:"center", gap:h.spacing[2]}, children:[l, c && !l && (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:c})]}), r && (0,require$react_SLASH_jsx_runtime.jsx)("button", 
  {type:"button", style:qo, onClick:t, "aria-label":"Close modal", children:"\u00d7"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:A, style:Yo, children:f}), d !== void 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:jo, children:d})]})});
  return (0,require$react_dom.createPortal)(v, document.body);
});
Go.displayName = "Modal";
`${h.colors.border.default}`, h.fontSize.lg;
`${h.colors.border.default}`;
h.colors.background.surface, h.colors.text.default, h.fontSize.xs, h.radius.sm, h.shadow.md;
const Wo = {sm:{padding:`${h.spacing[1]}px ${h.spacing[2]}px`, fontSize:h.fontSize.sm}, md:{padding:`${h.spacing[2]}px ${h.spacing[3]}px`, fontSize:h.fontSize.base}, lg:{padding:`${h.spacing[3]}px ${h.spacing[4]}px`, fontSize:h.fontSize.lg}}, Vo = {default:{backgroundColor:h.colors.background.default, border:`1px solid ${h.colors.border.default}`}, filled:{backgroundColor:h.colors.background.surface, border:"1px solid transparent"}, unstyled:{backgroundColor:"transparent", border:"none", padding:0}}, 
Xo = {width:"100%", fontFamily:h.fontFamily.sans, color:h.colors.text.default, borderRadius:h.radius.sm, outline:"none", transition:h.transitions.colors}, Qo = {borderColor:h.colors.border.error}, Ko = {backgroundColor:h.colors.background.surface, color:h.colors.text.muted, cursor:"not-allowed", opacity:0.7}, Zo = {borderColor:h.colors.border.focus, boxShadow:`0 0 0 2px ${h.colors.alpha.blue._35}`}, pa = {position:"absolute", top:"50%", transform:"translateY(-50%)", display:"flex", alignItems:"center", 
justifyContent:"center", color:h.colors.text.muted, pointerEvents:"none"}, Jo = {fontSize:h.fontSize.xs, color:h.colors.border.error, marginTop:`${h.spacing[1]}px`}, el = (0,require$react.forwardRef)(({type:e = "text", value:t, defaultValue:n, placeholder:r, size:a = "md", variant:i = "default", disabled:u = !1, readonly:o = !1, required:l = !1, error:c = !1, errorMessage:f, leftIcon:d, rightIcon:m, onChange:p, onFocus:g, onBlur:T, name:A, id:y, autoFocus:C, autoComplete:N, maxLength:v, minLength:B, 
pattern:O}, j) => {
  const [W, $] = (0,require$react.useState)(!1), L = X => {
    $(!0), g == null || g(X);
  }, z = X => {
    $(!1), T == null || T(X);
  }, Y = {...Xo, ...Vo[i], ...(i !== "unstyled" ? Wo[a] : {}), ...(c ? Qo : {}), ...(u ? Ko : {}), ...(W && !u && i !== "unstyled" ? Zo : {}), paddingLeft:d && i !== "unstyled" ? "32px" : void 0, paddingRight:m && i !== "unstyled" ? "32px" : void 0};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative", width:"100%"}, children:[d && i !== "unstyled" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...pa, left:`${h.spacing[2]}px`}, children:d}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {ref:j, "data-component":"input", "data-size":a, "data-variant":i, "data-error":c || void 0, "data-disabled":u || void 0, type:e, value:t, defaultValue:n, placeholder:r, disabled:u, readOnly:o, required:l, name:A, 
  id:y, autoFocus:C, autoComplete:N, maxLength:v, minLength:B, pattern:O, style:Y, onChange:p, onFocus:L, onBlur:z, "aria-invalid":c, "aria-describedby":c && f ? `${y}-error` : void 0}), m && i !== "unstyled" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...pa, right:`${h.spacing[2]}px`}, children:m}), c && f && (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:`${y}-error`, style:Jo, role:"alert", children:f})]});
});
el.displayName = "Input";
const tl = {sm:{padding:`${h.spacing[1]}px ${h.spacing[2]}px`, fontSize:h.fontSize.sm}, md:{padding:`${h.spacing[2]}px ${h.spacing[3]}px`, fontSize:h.fontSize.base}, lg:{padding:`${h.spacing[3]}px ${h.spacing[4]}px`, fontSize:h.fontSize.lg}}, nl = {default:{backgroundColor:"transparent"}, filled:{backgroundColor:h.colors.background.surface}, unstyled:{backgroundColor:"transparent", border:"none", padding:0}}, rl = {display:"inline-flex", alignItems:"center", borderRadius:h.radius.md, border:`1px solid ${h.colors.border.default}`, 
color:h.colors.text.default, fontFamily:h.fontFamily.sans, lineHeight:h.lineHeight.normal, cursor:"pointer", appearance:"none", backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M2.5 4.5L6 8L9.5 4.5' stroke='%2375715e' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`, backgroundRepeat:"no-repeat", backgroundPosition:`right ${h.spacing[2]}px center`, paddingRight:`${h.spacing[6]}px`, 
transition:h.transitions.colors}, al = {borderColor:h.colors.border.error}, il = {opacity:0.5, cursor:"not-allowed"}, ul = (0,require$react.forwardRef)(({size:e = "md", variant:t = "default", error:n = !1, errorMessage:r, options:a, placeholder:i, children:u, className:o, disabled:l, style:c, ...f}, d) => {
  const m = {...rl, ...tl[e], ...nl[t], ...(n ? al : {}), ...(l ? il : {}), ...c};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {"data-component":"select-wrapper", style:{display:"inline-flex", flexDirection:"column", gap:`${h.spacing[1]}px`}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("select", {ref:d, "data-component":"select", "data-size":e, "data-variant":t, "data-error":n || void 0, disabled:l, style:m, className:o, ...f, children:[i && (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"", disabled:!0, children:i}), a == null ? void 0 : a.map(p => 
  (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:p.value, disabled:p.disabled, children:p.label}, p.value)), u]}), n && r && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:h.fontSize.xs, color:h.colors.accent.red}, children:r})]});
});
ul.displayName = "Select";
const sl = {sm:{padding:`${h.spacing[1]}px ${h.spacing[2]}px`, fontSize:h.fontSize.sm}, md:{padding:`${h.spacing[2]}px ${h.spacing[3]}px`, fontSize:h.fontSize.base}, lg:{padding:`${h.spacing[3]}px ${h.spacing[4]}px`, fontSize:h.fontSize.lg}}, ol = {default:{backgroundColor:"transparent"}, filled:{backgroundColor:h.colors.background.surface}, unstyled:{backgroundColor:"transparent", border:"none", padding:0}}, ll = {display:"block", width:"100%", borderRadius:h.radius.md, border:`1px solid ${h.colors.border.default}`, 
color:h.colors.text.default, fontFamily:h.fontFamily.sans, lineHeight:h.lineHeight.normal, resize:"vertical", transition:h.transitions.colors}, cl = {borderColor:h.colors.border.error}, dl = {opacity:0.5, cursor:"not-allowed"}, fl = (0,require$react.forwardRef)(({size:e = "md", variant:t = "default", error:n = !1, errorMessage:r, className:a, disabled:i, style:u, ...o}, l) => {
  const c = {...ll, ...sl[e], ...ol[t], ...(n ? cl : {}), ...(i ? dl : {}), ...u};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {"data-component":"textarea-wrapper", style:{display:"flex", flexDirection:"column", gap:`${h.spacing[1]}px`}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("textarea", {ref:l, "data-component":"textarea", "data-size":e, "data-variant":t, "data-error":n || void 0, disabled:i, style:c, className:a, ...o}), n && r && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:h.fontSize.xs, color:h.colors.accent.red}, children:r})]});
});
fl.displayName = "Textarea";
`${h.colors.alpha.blue._80}${h.colors.accent.cyan}`, `${h.colors.alpha.green._80}${h.colors.accent.green}`, `${h.colors.alpha.orange._40}${h.colors.accent.orange}`, `${h.colors.alpha.red._45}${h.colors.accent.red}`, `${h.colors.alpha.blue._80}${h.colors.accent.blue}`, `${h.colors.alpha.blue._95}${h.colors.alpha.green._80}${h.colors.alpha.magenta._30}`;
h.colors.background.surface, h.radius.sm;
h.radius.sm;
h.fontSize.xs, h.colors.text.muted;
h.fontSize.xs, h.colors.text.muted;
const hl = `
@keyframes devel-progress-indeterminate {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
}
`, pl = `
@keyframes devel-progress-striped {
  0% { background-position: 1rem 0; }
  100% { background-position: 0 0; }
}
`;
if (typeof document < "u") {
  const e = document.createElement("style");
  e.textContent = hl + pl, document.head.appendChild(e);
}
`${h.colors.border.default}`, h.colors.background.default;
h.colors.text.default;
h.colors.text.muted;
h.colors.text.secondary, h.fontFamily.mono;
`${h.colors.border.default}`, h.colors.background.default;
h.colors.text.default;
h.colors.text.secondary;
`${h.colors.border.default}`, h.fontFamily.mono, h.colors.background.elevated, h.colors.text.default;
(0,require$react.createContext)(null);
h.colors.background.overlay;
h.colors.background.elevated, h.shadow["2xl"], `${h.colors.border.subtle}`, h.fontFamily.sans;
`${h.colors.border.default}`;
h.colors.text.default, h.fontSize.lg, h.fontFamily.sans;
h.fontSize.xs, h.colors.text.muted;
h.colors.background.surface;
h.colors.background.surface, h.fontSize.xs, h.colors.text.muted, h.fontFamily.mono;
h.colors.text.muted;
`${h.colors.border.default}`, h.colors.background.default, h.fontFamily.sans;
`${h.colors.border.default}`, h.fontSize.sm, h.colors.text.muted;
h.colors.background.elevated, h.fontSize.xs, h.colors.text.muted;
`${h.colors.border.default}`;
`${h.colors.border.default}`, h.colors.background.surface, h.colors.text.default, h.fontFamily.sans, h.fontSize.sm;
h.colors.button.primary.bg, h.colors.button.primary.fg, h.fontFamily.sans, h.fontSize.sm;
h.fontSize.xs, h.colors.text.muted;
h.colors.text.muted, h.fontSize.sm;
h.fontSize.xs, h.colors.text.muted;
(0,require$react.createContext)(null);
h.colors.badge.info.bg, h.colors.semantic.info, h.colors.badge.success.bg, h.colors.semantic.success, h.colors.badge.warning.bg, h.colors.semantic.warning, h.colors.badge.error.bg, h.colors.semantic.error;
h.radius.md, h.shadow.lg, h.fontFamily.sans;
h.colors.text.muted;
h.fontSize.sm, h.colors.accent.cyan;
h.fontFamily.sans, h.fontSize.sm, h.colors.text.default;
h.colors.background.surface;
h.colors.background.elevated;
h.colors.text.muted;
h.colors.background.surface, h.colors.text.muted;
h.colors.text.muted;
h.fontSize.sm, h.fontSize.base, h.fontSize.lg;
h.colors.text.muted, h.radius.xs;
`${h.colors.border.default}`, h.radius.sm, h.colors.text.muted, h.fontFamily.sans, h.fontSize.sm;
h.fontSize.sm, h.fontSize.base, h.fontSize.lg;
h.fontFamily.sans;
h.fontFamily.sans, h.colors.text.default, h.colors.background.surface, `${h.colors.border.default}`, h.radius.md;
h.colors.border.focus, `${h.colors.alpha.blue._35}`;
h.colors.background.surface, h.colors.text.muted;
h.colors.background.elevated, `${h.colors.border.default}`, h.radius.md, h.shadow.lg;
h.colors.text.default;
h.colors.background.elevated;
h.colors.background.surface, `${h.colors.border.focus}`;
h.colors.text.muted, h.fontSize.sm;
h.fontSize.xs, h.colors.text.muted;
h.colors.border.default;
h.colors.text.muted;
h.colors.background.surface, h.colors.background.surface, `${h.colors.border.default}`, h.colors.background.elevated, h.shadow.sm;
h.fontFamily.sans;
h.colors.background.surface;
h.fontSize.base, h.colors.text.default;
h.fontSize.sm, h.colors.text.muted;
h.fontSize.sm;
h.colors.text.muted;
h.colors.text.default;
h.colors.text.muted;
h.fontSize.sm, h.fontSize.base, h.fontSize.lg;
h.fontFamily.sans;
h.colors.text.default;
h.fontSize.sm, h.colors.text.muted;
h.fontSize.sm, h.colors.text.default;
h.fontSize.xs, h.colors.text.muted, h.colors.background.surface;
`${h.colors.border.default}`;
h.fontSize.sm, h.colors.text.muted;
h.fontSize.xs, h.colors.accent.cyan;
h.fontSize["2xl"], h.colors.text.default;
h.colors.text.muted, h.fontSize.base;
h.fontSize.xs, h.colors.accent.cyan;
h.fontSize.xl, h.colors.text.default;
h.colors.text.muted, h.fontSize.sm;
h.colors.border.default, h.colors.badge.info.fg, h.colors.badge.success.fg, h.colors.badge.warning.fg, h.colors.badge.error.fg;
h.colors.text.muted, h.fontSize.sm;
h.fontSize["2xl"], h.colors.text.default;
h.colors.text.muted, h.fontSize.sm;
`${h.colors.accent.blue}${h.colors.alpha.blue._35}`;
h.fontFamily.sans, h.fontSize.sm;
h.fontSize.xs;
h.colors.text.muted, `${h.colors.border.default}`;
h.colors.background.surface;
`${h.colors.border.subtle}`, h.colors.text.default;
h.colors.text.muted, h.fontSize.sm;
h.colors.text.muted;
`${h.colors.border.default}`, h.colors.background.surface;
`${h.colors.border.default}`, h.colors.background.default, h.colors.text.default, h.fontFamily.sans, h.fontSize.sm;
h.colors.text.muted;
h.fontSize.sm, h.colors.text.secondary, h.fontFamily.sans;
function ma(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), a = 0, i = !1;
  for (; !i;) {
    r === -1 && (r = n.length, i = !0);
    const u = n.slice(a, r).trim();
    (u || !i) && t.push(u), a = r + 1, r = n.indexOf(",", a);
  }
  return t;
}
function Vi(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join((n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")).trim();
}
const ml = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, gl = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, bl = {};
function ga(e, t) {
  return (bl.jsx ? gl : ml).test(e);
}
const El = /[ \t\n\f\r]/g;
function Tl(e) {
  return typeof e == "object" ? e.type === "text" ? ba(e.value) : !1 : ba(e);
}
function ba(e) {
  return e.replace(El, "") === "";
}
class sn {
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
sn.prototype.normal = {};
sn.prototype.property = {};
sn.prototype.space = void 0;
function Xi(e, t) {
  const n = {}, r = {};
  for (const a of e) {
    Object.assign(n, a.property), Object.assign(r, a.normal);
  }
  return new sn(n, r, t);
}
function nn(e) {
  return e.toLowerCase();
}
class Ne {
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Ne.prototype.attribute = "";
Ne.prototype.booleanish = !1;
Ne.prototype.boolean = !1;
Ne.prototype.commaOrSpaceSeparated = !1;
Ne.prototype.commaSeparated = !1;
Ne.prototype.defined = !1;
Ne.prototype.mustUseProperty = !1;
Ne.prototype.number = !1;
Ne.prototype.overloadedBoolean = !1;
Ne.prototype.property = "";
Ne.prototype.spaceSeparated = !1;
Ne.prototype.space = void 0;
let yl = 0;
const Q = xt(), pe = xt(), Er = xt(), M = xt(), ae = xt(), Et = xt(), Pe = xt();
function xt() {
  return 2 ** ++yl;
}
const Tr = Object.freeze(Object.defineProperty({__proto__:null, boolean:Q, booleanish:pe, commaOrSpaceSeparated:Pe, commaSeparated:Et, number:M, overloadedBoolean:Er, spaceSeparated:ae}, Symbol.toStringTag, {value:"Module"})), Kn = Object.keys(Tr);
class Mr extends Ne {
  constructor(t, n, r, a) {
    let i = -1;
    if (super(t, n), Ea(this, "space", a), typeof r == "number") {
      for (; ++i < Kn.length;) {
        const u = Kn[i];
        Ea(this, Kn[i], (r & Tr[u]) === Tr[u]);
      }
    }
  }
}
Mr.prototype.defined = !0;
function Ea(e, t, n) {
  n && (e[t] = n);
}
function Ft(e) {
  const t = {}, n = {};
  for (const [r, a] of Object.entries(e.properties)) {
    const i = new Mr(r, e.transform(e.attributes || {}, r), a, e.space);
    e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[nn(r)] = r, n[nn(i.attribute)] = r;
  }
  return new sn(t, n, e.space);
}
const Qi = Ft({properties:{ariaActiveDescendant:null, ariaAtomic:pe, ariaAutoComplete:null, ariaBusy:pe, ariaChecked:pe, ariaColCount:M, ariaColIndex:M, ariaColSpan:M, ariaControls:ae, ariaCurrent:null, ariaDescribedBy:ae, ariaDetails:null, ariaDisabled:pe, ariaDropEffect:ae, ariaErrorMessage:null, ariaExpanded:pe, ariaFlowTo:ae, ariaGrabbed:pe, ariaHasPopup:null, ariaHidden:pe, ariaInvalid:null, ariaKeyShortcuts:null, ariaLabel:null, ariaLabelledBy:ae, ariaLevel:M, ariaLive:null, ariaModal:pe, ariaMultiLine:pe, 
ariaMultiSelectable:pe, ariaOrientation:null, ariaOwns:ae, ariaPlaceholder:null, ariaPosInSet:M, ariaPressed:pe, ariaReadOnly:pe, ariaRelevant:null, ariaRequired:pe, ariaRoleDescription:ae, ariaRowCount:M, ariaRowIndex:M, ariaRowSpan:M, ariaSelected:pe, ariaSetSize:M, ariaSort:null, ariaValueMax:M, ariaValueMin:M, ariaValueNow:M, ariaValueText:null, role:null}, transform(e, t) {
  return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
}});
function Ki(e, t) {
  return t in e ? e[t] : t;
}
function Zi(e, t) {
  return Ki(e, t.toLowerCase());
}
const _l = Ft({attributes:{acceptcharset:"accept-charset", classname:"class", htmlfor:"for", httpequiv:"http-equiv"}, mustUseProperty:["checked", "multiple", "muted", "selected"], properties:{abbr:null, accept:Et, acceptCharset:ae, accessKey:ae, action:null, allow:null, allowFullScreen:Q, allowPaymentRequest:Q, allowUserMedia:Q, alpha:Q, alt:null, as:null, async:Q, autoCapitalize:null, autoComplete:ae, autoFocus:Q, autoPlay:Q, blocking:ae, capture:null, charSet:null, checked:Q, cite:null, className:ae, 
closedBy:null, colorSpace:null, cols:M, colSpan:M, command:null, commandFor:null, content:null, contentEditable:pe, controls:Q, controlsList:ae, coords:M | Et, crossOrigin:null, data:null, dateTime:null, decoding:null, default:Q, defer:Q, dir:null, dirName:null, disabled:Q, download:Er, draggable:pe, encType:null, enterKeyHint:null, fetchPriority:null, form:null, formAction:null, formEncType:null, formMethod:null, formNoValidate:Q, formTarget:null, headers:ae, height:M, hidden:Er, high:M, href:null, 
hrefLang:null, htmlFor:ae, httpEquiv:ae, id:null, imageSizes:null, imageSrcSet:null, inert:Q, inputMode:null, integrity:null, is:null, isMap:Q, itemId:null, itemProp:ae, itemRef:ae, itemScope:Q, itemType:ae, kind:null, label:null, lang:null, language:null, list:null, loading:null, loop:Q, low:M, manifest:null, max:null, maxLength:M, media:null, method:null, min:null, minLength:M, multiple:Q, muted:Q, name:null, nonce:null, noModule:Q, noValidate:Q, onAbort:null, onAfterPrint:null, onAuxClick:null, 
onBeforeMatch:null, onBeforePrint:null, onBeforeToggle:null, onBeforeUnload:null, onBlur:null, onCancel:null, onCanPlay:null, onCanPlayThrough:null, onChange:null, onClick:null, onClose:null, onContextLost:null, onContextMenu:null, onContextRestored:null, onCopy:null, onCueChange:null, onCut:null, onDblClick:null, onDrag:null, onDragEnd:null, onDragEnter:null, onDragExit:null, onDragLeave:null, onDragOver:null, onDragStart:null, onDrop:null, onDurationChange:null, onEmptied:null, onEnded:null, onError:null, 
onFocus:null, onFormData:null, onHashChange:null, onInput:null, onInvalid:null, onKeyDown:null, onKeyPress:null, onKeyUp:null, onLanguageChange:null, onLoad:null, onLoadedData:null, onLoadedMetadata:null, onLoadEnd:null, onLoadStart:null, onMessage:null, onMessageError:null, onMouseDown:null, onMouseEnter:null, onMouseLeave:null, onMouseMove:null, onMouseOut:null, onMouseOver:null, onMouseUp:null, onOffline:null, onOnline:null, onPageHide:null, onPageShow:null, onPaste:null, onPause:null, onPlay:null, 
onPlaying:null, onPopState:null, onProgress:null, onRateChange:null, onRejectionHandled:null, onReset:null, onResize:null, onScroll:null, onScrollEnd:null, onSecurityPolicyViolation:null, onSeeked:null, onSeeking:null, onSelect:null, onSlotChange:null, onStalled:null, onStorage:null, onSubmit:null, onSuspend:null, onTimeUpdate:null, onToggle:null, onUnhandledRejection:null, onUnload:null, onVolumeChange:null, onWaiting:null, onWheel:null, open:Q, optimum:M, pattern:null, ping:ae, placeholder:null, 
playsInline:Q, popover:null, popoverTarget:null, popoverTargetAction:null, poster:null, preload:null, readOnly:Q, referrerPolicy:null, rel:ae, required:Q, reversed:Q, rows:M, rowSpan:M, sandbox:ae, scope:null, scoped:Q, seamless:Q, selected:Q, shadowRootClonable:Q, shadowRootCustomElementRegistry:Q, shadowRootDelegatesFocus:Q, shadowRootMode:null, shadowRootSerializable:Q, shape:null, size:M, sizes:null, slot:null, span:M, spellCheck:pe, src:null, srcDoc:null, srcLang:null, srcSet:null, start:M, 
step:null, style:null, tabIndex:M, target:null, title:null, translate:null, type:null, typeMustMatch:Q, useMap:null, value:pe, width:M, wrap:null, writingSuggestions:null, align:null, aLink:null, archive:ae, axis:null, background:null, bgColor:null, border:M, borderColor:null, bottomMargin:M, cellPadding:null, cellSpacing:null, char:null, charOff:null, classId:null, clear:null, code:null, codeBase:null, codeType:null, color:null, compact:Q, declare:Q, event:null, face:null, frame:null, frameBorder:null, 
hSpace:M, leftMargin:M, link:null, longDesc:null, lowSrc:null, marginHeight:M, marginWidth:M, noResize:Q, noHref:Q, noShade:Q, noWrap:Q, object:null, profile:null, prompt:null, rev:null, rightMargin:M, rules:null, scheme:null, scrolling:pe, standby:null, summary:null, text:null, topMargin:M, valueType:null, version:null, vAlign:null, vLink:null, vSpace:M, allowTransparency:null, autoCorrect:null, autoSave:null, credentialless:Q, disablePictureInPicture:Q, disableRemotePlayback:Q, exportParts:Et, 
part:ae, prefix:null, property:null, results:M, security:null, unselectable:null}, space:"html", transform:Zi}), Al = Ft({attributes:{accentHeight:"accent-height", alignmentBaseline:"alignment-baseline", arabicForm:"arabic-form", baselineShift:"baseline-shift", capHeight:"cap-height", className:"class", clipPath:"clip-path", clipRule:"clip-rule", colorInterpolation:"color-interpolation", colorInterpolationFilters:"color-interpolation-filters", colorProfile:"color-profile", colorRendering:"color-rendering", 
crossOrigin:"crossorigin", dataType:"datatype", dominantBaseline:"dominant-baseline", enableBackground:"enable-background", fillOpacity:"fill-opacity", fillRule:"fill-rule", floodColor:"flood-color", floodOpacity:"flood-opacity", fontFamily:"font-family", fontSize:"font-size", fontSizeAdjust:"font-size-adjust", fontStretch:"font-stretch", fontStyle:"font-style", fontVariant:"font-variant", fontWeight:"font-weight", glyphName:"glyph-name", glyphOrientationHorizontal:"glyph-orientation-horizontal", 
glyphOrientationVertical:"glyph-orientation-vertical", hrefLang:"hreflang", horizAdvX:"horiz-adv-x", horizOriginX:"horiz-origin-x", horizOriginY:"horiz-origin-y", imageRendering:"image-rendering", letterSpacing:"letter-spacing", lightingColor:"lighting-color", markerEnd:"marker-end", markerMid:"marker-mid", markerStart:"marker-start", maskType:"mask-type", navDown:"nav-down", navDownLeft:"nav-down-left", navDownRight:"nav-down-right", navLeft:"nav-left", navNext:"nav-next", navPrev:"nav-prev", navRight:"nav-right", 
navUp:"nav-up", navUpLeft:"nav-up-left", navUpRight:"nav-up-right", onAbort:"onabort", onActivate:"onactivate", onAfterPrint:"onafterprint", onBeforePrint:"onbeforeprint", onBegin:"onbegin", onCancel:"oncancel", onCanPlay:"oncanplay", onCanPlayThrough:"oncanplaythrough", onChange:"onchange", onClick:"onclick", onClose:"onclose", onCopy:"oncopy", onCueChange:"oncuechange", onCut:"oncut", onDblClick:"ondblclick", onDrag:"ondrag", onDragEnd:"ondragend", onDragEnter:"ondragenter", onDragExit:"ondragexit", 
onDragLeave:"ondragleave", onDragOver:"ondragover", onDragStart:"ondragstart", onDrop:"ondrop", onDurationChange:"ondurationchange", onEmptied:"onemptied", onEnd:"onend", onEnded:"onended", onError:"onerror", onFocus:"onfocus", onFocusIn:"onfocusin", onFocusOut:"onfocusout", onHashChange:"onhashchange", onInput:"oninput", onInvalid:"oninvalid", onKeyDown:"onkeydown", onKeyPress:"onkeypress", onKeyUp:"onkeyup", onLoad:"onload", onLoadedData:"onloadeddata", onLoadedMetadata:"onloadedmetadata", onLoadStart:"onloadstart", 
onMessage:"onmessage", onMouseDown:"onmousedown", onMouseEnter:"onmouseenter", onMouseLeave:"onmouseleave", onMouseMove:"onmousemove", onMouseOut:"onmouseout", onMouseOver:"onmouseover", onMouseUp:"onmouseup", onMouseWheel:"onmousewheel", onOffline:"onoffline", onOnline:"ononline", onPageHide:"onpagehide", onPageShow:"onpageshow", onPaste:"onpaste", onPause:"onpause", onPlay:"onplay", onPlaying:"onplaying", onPopState:"onpopstate", onProgress:"onprogress", onRateChange:"onratechange", onRepeat:"onrepeat", 
onReset:"onreset", onResize:"onresize", onScroll:"onscroll", onSeeked:"onseeked", onSeeking:"onseeking", onSelect:"onselect", onShow:"onshow", onStalled:"onstalled", onStorage:"onstorage", onSubmit:"onsubmit", onSuspend:"onsuspend", onTimeUpdate:"ontimeupdate", onToggle:"ontoggle", onUnload:"onunload", onVolumeChange:"onvolumechange", onWaiting:"onwaiting", onZoom:"onzoom", overlinePosition:"overline-position", overlineThickness:"overline-thickness", paintOrder:"paint-order", panose1:"panose-1", 
pointerEvents:"pointer-events", referrerPolicy:"referrerpolicy", renderingIntent:"rendering-intent", shapeRendering:"shape-rendering", stopColor:"stop-color", stopOpacity:"stop-opacity", strikethroughPosition:"strikethrough-position", strikethroughThickness:"strikethrough-thickness", strokeDashArray:"stroke-dasharray", strokeDashOffset:"stroke-dashoffset", strokeLineCap:"stroke-linecap", strokeLineJoin:"stroke-linejoin", strokeMiterLimit:"stroke-miterlimit", strokeOpacity:"stroke-opacity", strokeWidth:"stroke-width", 
tabIndex:"tabindex", textAnchor:"text-anchor", textDecoration:"text-decoration", textRendering:"text-rendering", transformOrigin:"transform-origin", typeOf:"typeof", underlinePosition:"underline-position", underlineThickness:"underline-thickness", unicodeBidi:"unicode-bidi", unicodeRange:"unicode-range", unitsPerEm:"units-per-em", vAlphabetic:"v-alphabetic", vHanging:"v-hanging", vIdeographic:"v-ideographic", vMathematical:"v-mathematical", vectorEffect:"vector-effect", vertAdvY:"vert-adv-y", vertOriginX:"vert-origin-x", 
vertOriginY:"vert-origin-y", wordSpacing:"word-spacing", writingMode:"writing-mode", xHeight:"x-height", playbackOrder:"playbackorder", timelineBegin:"timelinebegin"}, properties:{about:Pe, accentHeight:M, accumulate:null, additive:null, alignmentBaseline:null, alphabetic:M, amplitude:M, arabicForm:null, ascent:M, attributeName:null, attributeType:null, azimuth:M, bandwidth:null, baselineShift:null, baseFrequency:null, baseProfile:null, bbox:null, begin:null, bias:M, by:null, calcMode:null, capHeight:M, 
className:ae, clip:null, clipPath:null, clipPathUnits:null, clipRule:null, color:null, colorInterpolation:null, colorInterpolationFilters:null, colorProfile:null, colorRendering:null, content:null, contentScriptType:null, contentStyleType:null, crossOrigin:null, cursor:null, cx:null, cy:null, d:null, dataType:null, defaultAction:null, descent:M, diffuseConstant:M, direction:null, display:null, dur:null, divisor:M, dominantBaseline:null, download:Q, dx:null, dy:null, edgeMode:null, editable:null, 
elevation:M, enableBackground:null, end:null, event:null, exponent:M, externalResourcesRequired:null, fill:null, fillOpacity:M, fillRule:null, filter:null, filterRes:null, filterUnits:null, floodColor:null, floodOpacity:null, focusable:null, focusHighlight:null, fontFamily:null, fontSize:null, fontSizeAdjust:null, fontStretch:null, fontStyle:null, fontVariant:null, fontWeight:null, format:null, fr:null, from:null, fx:null, fy:null, g1:Et, g2:Et, glyphName:Et, glyphOrientationHorizontal:null, glyphOrientationVertical:null, 
glyphRef:null, gradientTransform:null, gradientUnits:null, handler:null, hanging:M, hatchContentUnits:null, hatchUnits:null, height:null, href:null, hrefLang:null, horizAdvX:M, horizOriginX:M, horizOriginY:M, id:null, ideographic:M, imageRendering:null, initialVisibility:null, in:null, in2:null, intercept:M, k:M, k1:M, k2:M, k3:M, k4:M, kernelMatrix:Pe, kernelUnitLength:null, keyPoints:null, keySplines:null, keyTimes:null, kerning:null, lang:null, lengthAdjust:null, letterSpacing:null, lightingColor:null, 
limitingConeAngle:M, local:null, markerEnd:null, markerMid:null, markerStart:null, markerHeight:null, markerUnits:null, markerWidth:null, mask:null, maskContentUnits:null, maskType:null, maskUnits:null, mathematical:null, max:null, media:null, mediaCharacterEncoding:null, mediaContentEncodings:null, mediaSize:M, mediaTime:null, method:null, min:null, mode:null, name:null, navDown:null, navDownLeft:null, navDownRight:null, navLeft:null, navNext:null, navPrev:null, navRight:null, navUp:null, navUpLeft:null, 
navUpRight:null, numOctaves:null, observer:null, offset:null, onAbort:null, onActivate:null, onAfterPrint:null, onBeforePrint:null, onBegin:null, onCancel:null, onCanPlay:null, onCanPlayThrough:null, onChange:null, onClick:null, onClose:null, onCopy:null, onCueChange:null, onCut:null, onDblClick:null, onDrag:null, onDragEnd:null, onDragEnter:null, onDragExit:null, onDragLeave:null, onDragOver:null, onDragStart:null, onDrop:null, onDurationChange:null, onEmptied:null, onEnd:null, onEnded:null, onError:null, 
onFocus:null, onFocusIn:null, onFocusOut:null, onHashChange:null, onInput:null, onInvalid:null, onKeyDown:null, onKeyPress:null, onKeyUp:null, onLoad:null, onLoadedData:null, onLoadedMetadata:null, onLoadStart:null, onMessage:null, onMouseDown:null, onMouseEnter:null, onMouseLeave:null, onMouseMove:null, onMouseOut:null, onMouseOver:null, onMouseUp:null, onMouseWheel:null, onOffline:null, onOnline:null, onPageHide:null, onPageShow:null, onPaste:null, onPause:null, onPlay:null, onPlaying:null, onPopState:null, 
onProgress:null, onRateChange:null, onRepeat:null, onReset:null, onResize:null, onScroll:null, onSeeked:null, onSeeking:null, onSelect:null, onShow:null, onStalled:null, onStorage:null, onSubmit:null, onSuspend:null, onTimeUpdate:null, onToggle:null, onUnload:null, onVolumeChange:null, onWaiting:null, onZoom:null, opacity:null, operator:null, order:null, orient:null, orientation:null, origin:null, overflow:null, overlay:null, overlinePosition:M, overlineThickness:M, paintOrder:null, panose1:null, 
path:null, pathLength:M, patternContentUnits:null, patternTransform:null, patternUnits:null, phase:null, ping:ae, pitch:null, playbackOrder:null, pointerEvents:null, points:null, pointsAtX:M, pointsAtY:M, pointsAtZ:M, preserveAlpha:null, preserveAspectRatio:null, primitiveUnits:null, propagate:null, property:Pe, r:null, radius:null, referrerPolicy:null, refX:null, refY:null, rel:Pe, rev:Pe, renderingIntent:null, repeatCount:null, repeatDur:null, requiredExtensions:Pe, requiredFeatures:Pe, requiredFonts:Pe, 
requiredFormats:Pe, resource:null, restart:null, result:null, rotate:null, rx:null, ry:null, scale:null, seed:null, shapeRendering:null, side:null, slope:null, snapshotTime:null, specularConstant:M, specularExponent:M, spreadMethod:null, spacing:null, startOffset:null, stdDeviation:null, stemh:null, stemv:null, stitchTiles:null, stopColor:null, stopOpacity:null, strikethroughPosition:M, strikethroughThickness:M, string:null, stroke:null, strokeDashArray:Pe, strokeDashOffset:null, strokeLineCap:null, 
strokeLineJoin:null, strokeMiterLimit:M, strokeOpacity:M, strokeWidth:null, style:null, surfaceScale:M, syncBehavior:null, syncBehaviorDefault:null, syncMaster:null, syncTolerance:null, syncToleranceDefault:null, systemLanguage:Pe, tabIndex:M, tableValues:null, target:null, targetX:M, targetY:M, textAnchor:null, textDecoration:null, textRendering:null, textLength:null, timelineBegin:null, title:null, transformBehavior:null, type:null, typeOf:Pe, to:null, transform:null, transformOrigin:null, u1:null, 
u2:null, underlinePosition:M, underlineThickness:M, unicode:null, unicodeBidi:null, unicodeRange:null, unitsPerEm:M, values:null, vAlphabetic:M, vMathematical:M, vectorEffect:null, vHanging:M, vIdeographic:M, version:null, vertAdvY:M, vertOriginX:M, vertOriginY:M, viewBox:null, viewTarget:null, visibility:null, width:null, widths:null, wordSpacing:null, writingMode:null, x:null, x1:null, x2:null, xChannelSelector:null, xHeight:M, y:null, y1:null, y2:null, yChannelSelector:null, z:null, zoomAndPan:null}, 
space:"svg", transform:Ki}), Ji = Ft({properties:{xLinkActuate:null, xLinkArcRole:null, xLinkHref:null, xLinkRole:null, xLinkShow:null, xLinkTitle:null, xLinkType:null}, space:"xlink", transform(e, t) {
  return "xlink:" + t.slice(5).toLowerCase();
}}), eu = Ft({attributes:{xmlnsxlink:"xmlns:xlink"}, properties:{xmlnsXLink:null, xmlns:null}, space:"xmlns", transform:Zi}), tu = Ft({properties:{xmlBase:null, xmlLang:null, xmlSpace:null}, space:"xml", transform(e, t) {
  return "xml:" + t.slice(3).toLowerCase();
}}), xl = {classId:"classID", dataType:"datatype", itemId:"itemID", strokeDashArray:"strokeDasharray", strokeDashOffset:"strokeDashoffset", strokeLineCap:"strokeLinecap", strokeLineJoin:"strokeLinejoin", strokeMiterLimit:"strokeMiterlimit", typeOf:"typeof", xLinkActuate:"xlinkActuate", xLinkArcRole:"xlinkArcrole", xLinkHref:"xlinkHref", xLinkRole:"xlinkRole", xLinkShow:"xlinkShow", xLinkTitle:"xlinkTitle", xLinkType:"xlinkType", xmlnsXLink:"xmlnsXlink"}, Sl = /[A-Z]/g, Ta = /-[a-z]/g, kl = /^data[-\w.:]+$/i;
function Pn(e, t) {
  const n = nn(t);
  let r = t, a = Ne;
  if (n in e.normal) {
    return e.property[e.normal[n]];
  }
  if (n.length > 4 && n.slice(0, 4) === "data" && kl.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(Ta, Il);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!Ta.test(i)) {
        let u = i.replace(Sl, Cl);
        u.charAt(0) !== "-" && (u = "-" + u), t = "data" + u;
      }
    }
    a = Mr;
  }
  return new a(r, t);
}
function Cl(e) {
  return "-" + e.toLowerCase();
}
function Il(e) {
  return e.charAt(1).toUpperCase();
}
const on = Xi([Qi, _l, Ji, eu, tu], "html"), dt = Xi([Qi, Al, Ji, eu, tu], "svg");
function ya(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function nu(e) {
  return e.join(" ").trim();
}
var Cn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ru(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Br = {}, _a = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Nl = /\n/g, Ol = /^\s*/, Ll = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Rl = /^:\s*/, wl = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Dl = /^[;\s]*/, Pl = /^\s+|\s+$/g, Fl = `
`, Aa = "/", xa = "*", gt = "", Ml = "comment", Bl = "declaration";
function vl(e, t) {
  if (typeof e != "string") {
    throw new TypeError("First argument must be a string");
  }
  if (!e) {
    return [];
  }
  t = t || {};
  var n = 1, r = 1;
  function a(g) {
    var T = g.match(Nl);
    T && (n += T.length);
    var A = g.lastIndexOf(Fl);
    r = ~A ? g.length - A : r + g.length;
  }
  function i() {
    var g = {line:n, column:r};
    return function(T) {
      return T.position = new u(g), c(), T;
    };
  }
  function u(g) {
    this.start = g, this.end = {line:n, column:r}, this.source = t.source;
  }
  u.prototype.content = e;
  function o(g) {
    var T = new Error(t.source + ":" + n + ":" + r + ": " + g);
    if (T.reason = g, T.filename = t.source, T.line = n, T.column = r, T.source = e, !t.silent) {
      throw T;
    }
  }
  function l(g) {
    var T = g.exec(e);
    if (T) {
      var A = T[0];
      return a(A), e = e.slice(A.length), T;
    }
  }
  function c() {
    l(Ol);
  }
  function f(g) {
    var T;
    for (g = g || []; T = d();) {
      T !== !1 && g.push(T);
    }
    return g;
  }
  function d() {
    var g = i();
    if (!(Aa != e.charAt(0) || xa != e.charAt(1))) {
      for (var T = 2; gt != e.charAt(T) && (xa != e.charAt(T) || Aa != e.charAt(T + 1));) {
        ++T;
      }
      if (T += 2, gt === e.charAt(T - 1)) {
        return o("End of comment missing");
      }
      var A = e.slice(2, T - 2);
      return r += 2, a(A), e = e.slice(T), r += 2, g({type:Ml, comment:A});
    }
  }
  function m() {
    var g = i(), T = l(Ll);
    if (T) {
      if (d(), !l(Rl)) {
        return o("property missing ':'");
      }
      var A = l(wl), y = g({type:Bl, property:Sa(T[0].replace(_a, gt)), value:A ? Sa(A[0].replace(_a, gt)) : gt});
      return l(Dl), y;
    }
  }
  function p() {
    var g = [];
    f(g);
    for (var T; T = m();) {
      T !== !1 && (g.push(T), f(g));
    }
    return g;
  }
  return c(), p();
}
function Sa(e) {
  return e ? e.replace(Pl, gt) : gt;
}
var Ul = vl, Hl = Cn && Cn.__importDefault || function(e) {
  return e && e.__esModule ? e : {default:e};
};
Object.defineProperty(Br, "__esModule", {value:!0});
Br.default = $l;
const zl = Hl(Ul);
function $l(e, t) {
  let n = null;
  if (!e || typeof e != "string") {
    return n;
  }
  const r = (0,zl.default)(e), a = typeof t == "function";
  return r.forEach(i => {
    if (i.type !== "declaration") {
      return;
    }
    const {property:u, value:o} = i;
    a ? t(u, o, i) : o && (n = n || {}, n[u] = o);
  }), n;
}
var Fn = {};
Object.defineProperty(Fn, "__esModule", {value:!0});
Fn.camelCase = void 0;
var Yl = /^--[a-zA-Z0-9_-]+$/, jl = /-([a-z])/g, ql = /^[^-]+$/, Gl = /^-(webkit|moz|ms|o|khtml)-/, Wl = /^-(ms)-/, Vl = function(e) {
  return !e || ql.test(e) || Yl.test(e);
}, Xl = function(e, t) {
  return t.toUpperCase();
}, ka = function(e, t) {
  return "".concat(t, "-");
}, Ql = function(e, t) {
  return t === void 0 && (t = {}), Vl(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(Wl, ka) : e = e.replace(Gl, ka), e.replace(jl, Xl));
};
Fn.camelCase = Ql;
var Kl = Cn && Cn.__importDefault || function(e) {
  return e && e.__esModule ? e : {default:e};
}, Zl = Kl(Br), Jl = Fn;
function yr(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0,Zl.default)(e, function(r, a) {
    r && a && (n[(0,Jl.camelCase)(r, t)] = a);
  }), n;
}
yr.default = yr;
var ec = yr;
const tc = ru(ec), Mn = au("end"), Qe = au("start");
function au(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0) {
      return {line:r.line, column:r.column, offset:typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0};
    }
  }
}
function nc(e) {
  const t = Qe(e), n = Mn(e);
  if (t && n) {
    return {start:t, end:n};
  }
}
function Wt(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Ca(e.position) : "start" in e || "end" in e ? Ca(e) : "line" in e || "column" in e ? _r(e) : "";
}
function _r(e) {
  return Ia(e && e.line) + ":" + Ia(e && e.column);
}
function Ca(e) {
  return _r(e && e.start) + "-" + _r(e && e.end);
}
function Ia(e) {
  return e && typeof e == "number" ? e : 1;
}
class xe extends Error {
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let a = "", i = {}, u = !1;
    if (n && ("line" in n && "column" in n ? i = {place:n} : "start" in n && "end" in n ? i = {place:n} : "type" in n ? i = {ancestors:[n], place:n.position} : i = {...n}), typeof t == "string" ? a = t : !i.cause && t && (u = !0, a = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const l = r.indexOf(":");
      l === -1 ? i.ruleId = r : (i.source = r.slice(0, l), i.ruleId = r.slice(l + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const l = i.ancestors[i.ancestors.length - 1];
      l && (i.place = l.position);
    }
    const o = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file = "", this.message = a, this.line = o ? o.line : void 0, this.name = Wt(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = u && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = 
    void 0, this.url = void 0;
  }
}
xe.prototype.file = "";
xe.prototype.name = "";
xe.prototype.reason = "";
xe.prototype.message = "";
xe.prototype.stack = "";
xe.prototype.column = void 0;
xe.prototype.line = void 0;
xe.prototype.ancestors = void 0;
xe.prototype.cause = void 0;
xe.prototype.fatal = void 0;
xe.prototype.place = void 0;
xe.prototype.ruleId = void 0;
xe.prototype.source = void 0;
const vr = {}.hasOwnProperty, rc = new Map(), ac = /[A-Z]/g, ic = new Set(["table", "tbody", "thead", "tfoot", "tr"]), uc = new Set(["td", "th"]), iu = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function sc(e, t) {
  if (!t || t.Fragment === void 0) {
    throw new TypeError("Expected `Fragment` in options");
  }
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function") {
      throw new TypeError("Expected `jsxDEV` in options when `development: true`");
    }
    r = mc(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function") {
      throw new TypeError("Expected `jsx` in production options");
    }
    if (typeof t.jsxs != "function") {
      throw new TypeError("Expected `jsxs` in production options");
    }
    r = pc(n, t.jsx, t.jsxs);
  }
  const a = {Fragment:t.Fragment, ancestors:[], components:t.components || {}, create:r, elementAttributeNameCase:t.elementAttributeNameCase || "react", evaluater:t.createEvaluater ? t.createEvaluater() : void 0, filePath:n, ignoreInvalidStyle:t.ignoreInvalidStyle || !1, passKeys:t.passKeys !== !1, passNode:t.passNode || !1, schema:t.space === "svg" ? dt : on, stylePropertyNameCase:t.stylePropertyNameCase || "dom", tableCellAlignToStyle:t.tableCellAlignToStyle !== !1}, i = uu(a, e, void 0);
  return i && typeof i != "string" ? i : a.create(e, a.Fragment, {children:i || void 0}, void 0);
}
function uu(e, t, n) {
  if (t.type === "element") {
    return oc(e, t, n);
  }
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression") {
    return lc(e, t);
  }
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement") {
    return dc(e, t, n);
  }
  if (t.type === "mdxjsEsm") {
    return cc(e, t);
  }
  if (t.type === "root") {
    return fc(e, t, n);
  }
  if (t.type === "text") {
    return hc(e, t);
  }
}
function oc(e, t, n) {
  const r = e.schema;
  let a = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (a = dt, e.schema = a), e.ancestors.push(t);
  const i = ou(e, t.tagName, !1), u = gc(e, t);
  let o = Hr(e, t);
  return ic.has(t.tagName) && (o = o.filter(function(l) {
    return typeof l == "string" ? !Tl(l) : !0;
  })), su(e, u, i, t), Ur(u, o), e.ancestors.pop(), e.schema = r, e.create(t, i, u, n);
}
function lc(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, e.evaluater.evaluateExpression(r.expression);
  }
  rn(e, t.position);
}
function cc(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    return e.evaluater.evaluateProgram(t.data.estree);
  }
  rn(e, t.position);
}
function dc(e, t, n) {
  const r = e.schema;
  let a = r;
  t.name === "svg" && r.space === "html" && (a = dt, e.schema = a), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : ou(e, t.name, !0), u = bc(e, t), o = Hr(e, t);
  return su(e, u, i, t), Ur(u, o), e.ancestors.pop(), e.schema = r, e.create(t, i, u, n);
}
function fc(e, t, n) {
  const r = {};
  return Ur(r, Hr(e, t)), e.create(t, e.Fragment, r, n);
}
function hc(e, t) {
  return t.value;
}
function su(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Ur(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function pc(e, t, n) {
  return r;
  function r(a, i, u, o) {
    const c = Array.isArray(u.children) ? n : t;
    return o ? c(i, u, o) : c(i, u);
  }
}
function mc(e, t) {
  return n;
  function n(r, a, i, u) {
    const o = Array.isArray(i.children), l = Qe(r);
    return t(a, i, u, o, {columnNumber:l ? l.column - 1 : void 0, fileName:e, lineNumber:l ? l.line : void 0}, void 0);
  }
}
function gc(e, t) {
  const n = {};
  let r, a;
  for (a in t.properties) {
    if (a !== "children" && vr.call(t.properties, a)) {
      const i = Ec(e, a, t.properties[a]);
      if (i) {
        const [u, o] = i;
        e.tableCellAlignToStyle && u === "align" && typeof o == "string" && uc.has(t.tagName) ? r = o : n[u] = o;
      }
    }
  }
  if (r) {
    const i = n.style || (n.style = {});
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function bc(e, t) {
  const n = {};
  for (const r of t.attributes) {
    if (r.type === "mdxJsxExpressionAttribute") {
      if (r.data && r.data.estree && e.evaluater) {
        const i = r.data.estree.body[0];
        i.type;
        const u = i.expression;
        u.type;
        const o = u.properties[0];
        o.type, Object.assign(n, e.evaluater.evaluateExpression(o.argument));
      } else {
        rn(e, t.position);
      }
    } else {
      const a = r.name;
      let i;
      if (r.value && typeof r.value == "object") {
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const o = r.value.data.estree.body[0];
          o.type, i = e.evaluater.evaluateExpression(o.expression);
        } else {
          rn(e, t.position);
        }
      } else {
        i = r.value === null ? !0 : r.value;
      }
      n[a] = i;
    }
  }
  return n;
}
function Hr(e, t) {
  const n = [];
  let r = -1;
  const a = e.passKeys ? new Map() : rc;
  for (; ++r < t.children.length;) {
    const i = t.children[r];
    let u;
    if (e.passKeys) {
      const l = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (l) {
        const c = a.get(l) || 0;
        u = l + "-" + c, a.set(l, c + 1);
      }
    }
    const o = uu(e, i, u);
    o !== void 0 && n.push(o);
  }
  return n;
}
function Ec(e, t, n) {
  const r = Pn(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? Vi(n) : nu(n)), r.property === "style") {
      let a = typeof n == "object" ? n : Tc(e, String(n));
      return e.stylePropertyNameCase === "css" && (a = yc(a)), ["style", a];
    }
    return [e.elementAttributeNameCase === "react" && r.space ? xl[r.property] || r.property : r.attribute, n];
  }
}
function Tc(e, t) {
  try {
    return tc(t, {reactCompat:!0});
  } catch (n) {
    if (e.ignoreInvalidStyle) {
      return {};
    }
    const r = n, a = new xe("Cannot parse `style` attribute", {ancestors:e.ancestors, cause:r, ruleId:"style", source:"hast-util-to-jsx-runtime"});
    throw a.file = e.filePath || void 0, a.url = iu + "#cannot-parse-style-attribute", a;
  }
}
function ou(e, t, n) {
  let r;
  if (!n) {
    r = {type:"Literal", value:t};
  } else if (t.includes(".")) {
    const a = t.split(".");
    let i = -1, u;
    for (; ++i < a.length;) {
      const o = ga(a[i]) ? {type:"Identifier", name:a[i]} : {type:"Literal", value:a[i]};
      u = u ? {type:"MemberExpression", object:u, property:o, computed:!!(i && o.type === "Literal"), optional:!1} : o;
    }
    r = u;
  } else {
    r = ga(t) && !/^[a-z]/.test(t) ? {type:"Identifier", name:t} : {type:"Literal", value:t};
  }
  if (r.type === "Literal") {
    const a = r.value;
    return vr.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater) {
    return e.evaluater.evaluateExpression(r);
  }
  rn(e);
}
function rn(e, t) {
  const n = new xe("Cannot handle MDX estrees without `createEvaluater`", {ancestors:e.ancestors, place:t, ruleId:"mdx-estree", source:"hast-util-to-jsx-runtime"});
  throw n.file = e.filePath || void 0, n.url = iu + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function yc(e) {
  const t = {};
  let n;
  for (n in e) {
    vr.call(e, n) && (t[_c(n)] = e[n]);
  }
  return t;
}
function _c(e) {
  let t = e.replace(ac, Ac);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Ac(e) {
  return "-" + e.toLowerCase();
}
const Zn = {action:["form"], cite:["blockquote", "del", "ins", "q"], data:["object"], formAction:["button", "input"], href:["a", "area", "base", "link"], icon:["menuitem"], itemId:null, manifest:["html"], ping:["a", "area"], poster:["video"], src:["audio", "embed", "iframe", "img", "input", "script", "source", "track", "video"]}, xc = {};
function zr(e, t) {
  const n = xc, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, a = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return lu(e, r, a);
}
function lu(e, t, n) {
  if (Sc(e)) {
    if ("value" in e) {
      return e.type === "html" && !n ? "" : e.value;
    }
    if (t && "alt" in e && e.alt) {
      return e.alt;
    }
    if ("children" in e) {
      return Na(e.children, t, n);
    }
  }
  return Array.isArray(e) ? Na(e, t, n) : "";
}
function Na(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length;) {
    r[a] = lu(e[a], t, n);
  }
  return r.join("");
}
function Sc(e) {
  return !!(e && typeof e == "object");
}
const Oa = document.createElement("i");
function $r(e) {
  const t = "\x26" + e + ";";
  Oa.innerHTML = t;
  const n = Oa.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Fe(e, t, n, r) {
  const a = e.length;
  let i = 0, u;
  if (t < 0 ? t = -t > a ? 0 : a + t : t = t > a ? a : t, n = n > 0 ? n : 0, r.length < 1e4) {
    u = Array.from(r), u.unshift(t, n), e.splice(...u);
  } else {
    for (n && e.splice(t, n); i < r.length;) {
      u = r.slice(i, i + 1e4), u.unshift(t, 0), e.splice(...u), i += 1e4, t += 1e4;
    }
  }
}
function Be(e, t) {
  return e.length > 0 ? (Fe(e, e.length, 0, t), e) : t;
}
const La = {}.hasOwnProperty;
function cu(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length;) {
    kc(t, e[n]);
  }
  return t;
}
function kc(e, t) {
  let n;
  for (n in t) {
    const a = (La.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let u;
    if (i) {
      for (u in i) {
        La.call(a, u) || (a[u] = []);
        const o = i[u];
        Cc(a[u], Array.isArray(o) ? o : o ? [o] : []);
      }
    }
  }
}
function Cc(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length;) {
    (t[n].add === "after" ? e : r).push(t[n]);
  }
  Fe(e, 0, 0, r);
}
function du(e, t) {
  const n = Number.parseInt(e, t);
  return n < 9 || n === 11 || n > 13 && n < 32 || n > 126 && n < 160 || n > 55295 && n < 57344 || n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || n > 1114111 ? "\ufffd" : String.fromCodePoint(n);
}
function He(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const ke = ft(/[A-Za-z]/), Ae = ft(/[\dA-Za-z]/), Ic = ft(/[#-'*+\--9=?A-Z^-~]/);
function In(e) {
  return e !== null && (e < 32 || e === 127);
}
const Ar = ft(/\d/), Nc = ft(/[\dA-Fa-f]/), Oc = ft(/[!-/:-@[-`{-~]/);
function G(e) {
  return e !== null && e < -2;
}
function ie(e) {
  return e !== null && (e < 0 || e === 32);
}
function J(e) {
  return e === -2 || e === -1 || e === 32;
}
const Bn = ft(new RegExp("\\p{P}|\\p{S}", "u")), _t = ft(/\s/);
function ft(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Mt(e) {
  const t = [];
  let n = -1, r = 0, a = 0;
  for (; ++n < e.length;) {
    const i = e.charCodeAt(n);
    let u = "";
    if (i === 37 && Ae(e.charCodeAt(n + 1)) && Ae(e.charCodeAt(n + 2))) {
      a = 2;
    } else if (i < 128) {
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (u = String.fromCharCode(i));
    } else if (i > 55295 && i < 57344) {
      const o = e.charCodeAt(n + 1);
      i < 56320 && o > 56319 && o < 57344 ? (u = String.fromCharCode(i, o), a = 1) : u = "\ufffd";
    } else {
      u = String.fromCharCode(i);
    }
    u && (t.push(e.slice(r, n), encodeURIComponent(u)), r = n + a + 1, u = ""), a && (n += a, a = 0);
  }
  return t.join("") + e.slice(r);
}
function te(e, t, n, r) {
  const a = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return u;
  function u(l) {
    return J(l) ? (e.enter(n), o(l)) : t(l);
  }
  function o(l) {
    return J(l) && i++ < a ? (e.consume(l), o) : (e.exit(n), t(l));
  }
}
const Lc = {tokenize:Rc};
function Rc(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, a);
  let n;
  return t;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), te(e, t, "linePrefix");
  }
  function a(o) {
    return e.enter("paragraph"), i(o);
  }
  function i(o) {
    const l = e.enter("chunkText", {contentType:"text", previous:n});
    return n && (n.next = l), n = l, u(o);
  }
  function u(o) {
    if (o === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(o);
      return;
    }
    return G(o) ? (e.consume(o), e.exit("chunkText"), i) : (e.consume(o), u);
  }
}
const wc = {tokenize:Dc}, Ra = {tokenize:Pc};
function Dc(e) {
  const t = this, n = [];
  let r = 0, a, i, u;
  return o;
  function o(N) {
    if (r < n.length) {
      const v = n[r];
      return t.containerState = v[1], e.attempt(v[0].continuation, l, c)(N);
    }
    return c(N);
  }
  function l(N) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, a && C();
      const v = t.events.length;
      let B = v, O;
      for (; B--;) {
        if (t.events[B][0] === "exit" && t.events[B][1].type === "chunkFlow") {
          O = t.events[B][1].end;
          break;
        }
      }
      y(r);
      let j = v;
      for (; j < t.events.length;) {
        t.events[j][1].end = {...O}, j++;
      }
      return Fe(t.events, B + 1, 0, t.events.slice(v)), t.events.length = j, c(N);
    }
    return o(N);
  }
  function c(N) {
    if (r === n.length) {
      if (!a) {
        return m(N);
      }
      if (a.currentConstruct && a.currentConstruct.concrete) {
        return g(N);
      }
      t.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Ra, f, d)(N);
  }
  function f(N) {
    return a && C(), y(r), m(N);
  }
  function d(N) {
    return t.parser.lazy[t.now().line] = r !== n.length, u = t.now().offset, g(N);
  }
  function m(N) {
    return t.containerState = {}, e.attempt(Ra, p, g)(N);
  }
  function p(N) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(N);
  }
  function g(N) {
    if (N === null) {
      a && C(), y(0), e.consume(N);
      return;
    }
    return a = a || t.parser.flow(t.now()), e.enter("chunkFlow", {_tokenizer:a, contentType:"flow", previous:i}), T(N);
  }
  function T(N) {
    if (N === null) {
      A(e.exit("chunkFlow"), !0), y(0), e.consume(N);
      return;
    }
    return G(N) ? (e.consume(N), A(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, o) : (e.consume(N), T);
  }
  function A(N, v) {
    const B = t.sliceStream(N);
    if (v && B.push(null), N.previous = i, i && (i.next = N), i = N, a.defineSkip(N.start), a.write(B), t.parser.lazy[N.start.line]) {
      let O = a.events.length;
      for (; O--;) {
        if (a.events[O][1].start.offset < u && (!a.events[O][1].end || a.events[O][1].end.offset > u)) {
          return;
        }
      }
      const j = t.events.length;
      let W = j, $, L;
      for (; W--;) {
        if (t.events[W][0] === "exit" && t.events[W][1].type === "chunkFlow") {
          if ($) {
            L = t.events[W][1].end;
            break;
          }
          $ = !0;
        }
      }
      for (y(r), O = j; O < t.events.length;) {
        t.events[O][1].end = {...L}, O++;
      }
      Fe(t.events, W + 1, 0, t.events.slice(j)), t.events.length = O;
    }
  }
  function y(N) {
    let v = n.length;
    for (; v-- > N;) {
      const B = n[v];
      t.containerState = B[1], B[0].exit.call(t, e);
    }
    n.length = N;
  }
  function C() {
    a.write([null]), i = void 0, a = void 0, t.containerState._closeFlow = void 0;
  }
}
function Pc(e, t, n) {
  return te(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Rt(e) {
  if (e === null || ie(e) || _t(e)) {
    return 1;
  }
  if (Bn(e)) {
    return 2;
  }
}
function vn(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length;) {
    const i = e[a].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const xr = {name:"attention", resolveAll:Fc, tokenize:Mc};
function Fc(e, t) {
  let n = -1, r, a, i, u, o, l, c, f;
  for (; ++n < e.length;) {
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--;) {
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3)) {
            continue;
          }
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = {...e[r][1].end}, m = {...e[n][1].start};
          wa(d, -l), wa(m, l), u = {type:l > 1 ? "strongSequence" : "emphasisSequence", start:d, end:{...e[r][1].end}}, o = {type:l > 1 ? "strongSequence" : "emphasisSequence", start:{...e[n][1].start}, end:m}, i = {type:l > 1 ? "strongText" : "emphasisText", start:{...e[r][1].end}, end:{...e[n][1].start}}, a = {type:l > 1 ? "strong" : "emphasis", start:{...u.start}, end:{...o.end}}, e[r][1].end = {...u.start}, e[n][1].start = {...o.end}, c = [], e[r][1].end.offset - e[r][1].start.offset && (c = 
          Be(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = Be(c, [["enter", a, t], ["enter", u, t], ["exit", u, t], ["enter", i, t]]), c = Be(c, vn(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = Be(c, [["exit", i, t], ["enter", o, t], ["exit", o, t], ["exit", a, t]]), e[n][1].end.offset - e[n][1].start.offset ? (f = 2, c = Be(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : f = 0, Fe(e, r - 1, n - r + 3, c), n = r + c.length - f - 2;
          break;
        }
      }
    }
  }
  for (n = -1; ++n < e.length;) {
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  }
  return e;
}
function Mc(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, a = Rt(r);
  let i;
  return u;
  function u(l) {
    return i = l, e.enter("attentionSequence"), o(l);
  }
  function o(l) {
    if (l === i) {
      return e.consume(l), o;
    }
    const c = e.exit("attentionSequence"), f = Rt(l), d = !f || f === 2 && a || n.includes(l), m = !a || a === 2 && f || n.includes(r);
    return c._open = !!(i === 42 ? d : d && (a || !m)), c._close = !!(i === 42 ? m : m && (f || !d)), t(l);
  }
}
function wa(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Bc = {name:"autolink", tokenize:vc};
function vc(e, t, n) {
  let r = 0;
  return a;
  function a(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(p) {
    return ke(p) ? (e.consume(p), u) : p === 64 ? n(p) : c(p);
  }
  function u(p) {
    return p === 43 || p === 45 || p === 46 || Ae(p) ? (r = 1, o(p)) : c(p);
  }
  function o(p) {
    return p === 58 ? (e.consume(p), r = 0, l) : (p === 43 || p === 45 || p === 46 || Ae(p)) && r++ < 32 ? (e.consume(p), o) : (r = 0, c(p));
  }
  function l(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || In(p) ? n(p) : (e.consume(p), l);
  }
  function c(p) {
    return p === 64 ? (e.consume(p), f) : Ic(p) ? (e.consume(p), c) : n(p);
  }
  function f(p) {
    return Ae(p) ? d(p) : n(p);
  }
  function d(p) {
    return p === 46 ? (e.consume(p), r = 0, f) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(p);
  }
  function m(p) {
    if ((p === 45 || Ae(p)) && r++ < 63) {
      const g = p === 45 ? m : d;
      return e.consume(p), g;
    }
    return n(p);
  }
}
const ln = {partial:!0, tokenize:Uc};
function Uc(e, t, n) {
  return r;
  function r(i) {
    return J(i) ? te(e, a, "linePrefix")(i) : a(i);
  }
  function a(i) {
    return i === null || G(i) ? t(i) : n(i);
  }
}
const fu = {continuation:{tokenize:zc}, exit:$c, name:"blockQuote", tokenize:Hc};
function Hc(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    if (u === 62) {
      const o = r.containerState;
      return o.open || (e.enter("blockQuote", {_container:!0}), o.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(u), e.exit("blockQuoteMarker"), i;
    }
    return n(u);
  }
  function i(u) {
    return J(u) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(u), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(u));
  }
}
function zc(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return J(u) ? te(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(u) : i(u);
  }
  function i(u) {
    return e.attempt(fu, t, n)(u);
  }
}
function $c(e) {
  e.exit("blockQuote");
}
const hu = {name:"characterEscape", tokenize:Yc};
function Yc(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), a;
  }
  function a(i) {
    return Oc(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const pu = {name:"characterReference", tokenize:jc};
function jc(e, t, n) {
  const r = this;
  let a = 0, i, u;
  return o;
  function o(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), l;
  }
  function l(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), i = 31, u = Ae, f(d));
  }
  function c(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, u = Nc, f) : (e.enter("characterReferenceValue"), i = 7, u = Ar, f(d));
  }
  function f(d) {
    if (d === 59 && a) {
      const m = e.exit("characterReferenceValue");
      return u === Ae && !$r(r.sliceSerialize(m)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return u(d) && a++ < i ? (e.consume(d), f) : n(d);
  }
}
const Da = {partial:!0, tokenize:Gc}, Pa = {concrete:!0, name:"codeFenced", tokenize:qc};
function qc(e, t, n) {
  const r = this, a = {partial:!0, tokenize:B};
  let i = 0, u = 0, o;
  return l;
  function l(O) {
    return c(O);
  }
  function c(O) {
    const j = r.events[r.events.length - 1];
    return i = j && j[1].type === "linePrefix" ? j[2].sliceSerialize(j[1], !0).length : 0, o = O, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f(O);
  }
  function f(O) {
    return O === o ? (u++, e.consume(O), f) : u < 3 ? n(O) : (e.exit("codeFencedFenceSequence"), J(O) ? te(e, d, "whitespace")(O) : d(O));
  }
  function d(O) {
    return O === null || G(O) ? (e.exit("codeFencedFence"), r.interrupt ? t(O) : e.check(Da, T, v)(O)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {contentType:"string"}), m(O));
  }
  function m(O) {
    return O === null || G(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(O)) : J(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), te(e, p, "whitespace")(O)) : O === 96 && O === o ? n(O) : (e.consume(O), m);
  }
  function p(O) {
    return O === null || G(O) ? d(O) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {contentType:"string"}), g(O));
  }
  function g(O) {
    return O === null || G(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(O)) : O === 96 && O === o ? n(O) : (e.consume(O), g);
  }
  function T(O) {
    return e.attempt(a, v, A)(O);
  }
  function A(O) {
    return e.enter("lineEnding"), e.consume(O), e.exit("lineEnding"), y;
  }
  function y(O) {
    return i > 0 && J(O) ? te(e, C, "linePrefix", i + 1)(O) : C(O);
  }
  function C(O) {
    return O === null || G(O) ? e.check(Da, T, v)(O) : (e.enter("codeFlowValue"), N(O));
  }
  function N(O) {
    return O === null || G(O) ? (e.exit("codeFlowValue"), C(O)) : (e.consume(O), N);
  }
  function v(O) {
    return e.exit("codeFenced"), t(O);
  }
  function B(O, j, W) {
    let $ = 0;
    return L;
    function L(V) {
      return O.enter("lineEnding"), O.consume(V), O.exit("lineEnding"), z;
    }
    function z(V) {
      return O.enter("codeFencedFence"), J(V) ? te(O, Y, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(V) : Y(V);
    }
    function Y(V) {
      return V === o ? (O.enter("codeFencedFenceSequence"), ne(V)) : W(V);
    }
    function ne(V) {
      return V === o ? ($++, O.consume(V), ne) : $ >= u ? (O.exit("codeFencedFenceSequence"), J(V) ? te(O, X, "whitespace")(V) : X(V)) : W(V);
    }
    function X(V) {
      return V === null || G(V) ? (O.exit("codeFencedFence"), j(V)) : W(V);
    }
  }
}
function Gc(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return u === null ? n(u) : (e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), i);
  }
  function i(u) {
    return r.parser.lazy[r.now().line] ? n(u) : t(u);
  }
}
const Jn = {name:"codeIndented", tokenize:Vc}, Wc = {partial:!0, tokenize:Xc};
function Vc(e, t, n) {
  const r = this;
  return a;
  function a(c) {
    return e.enter("codeIndented"), te(e, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? u(c) : n(c);
  }
  function u(c) {
    return c === null ? l(c) : G(c) ? e.attempt(Wc, u, l)(c) : (e.enter("codeFlowValue"), o(c));
  }
  function o(c) {
    return c === null || G(c) ? (e.exit("codeFlowValue"), u(c)) : (e.consume(c), o);
  }
  function l(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function Xc(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return r.parser.lazy[r.now().line] ? n(u) : G(u) ? (e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), a) : te(e, i, "linePrefix", 5)(u);
  }
  function i(u) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(u) : G(u) ? a(u) : n(u);
  }
}
const Qc = {name:"codeText", previous:Zc, resolve:Kc, tokenize:Jc};
function Kc(e) {
  let t = e.length - 4, n = 3, r, a;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t;) {
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
    }
  }
  for (r = n - 1, t++; ++r <= t;) {
    a === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (a = r) : (r === t || e[r][1].type === "lineEnding") && (e[a][1].type = "codeTextData", r !== a + 2 && (e[a][1].end = e[r - 1][1].end, e.splice(a + 2, r - a - 2), t -= r - a - 2, r = a + 2), a = void 0);
  }
  return e;
}
function Zc(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Jc(e, t, n) {
  let r = 0, a, i;
  return u;
  function u(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), o(d);
  }
  function o(d) {
    return d === 96 ? (e.consume(d), r++, o) : (e.exit("codeTextSequence"), l(d));
  }
  function l(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), l) : d === 96 ? (i = e.enter("codeTextSequence"), a = 0, f(d)) : G(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), l) : (e.enter("codeTextData"), c(d));
  }
  function c(d) {
    return d === null || d === 32 || d === 96 || G(d) ? (e.exit("codeTextData"), l(d)) : (e.consume(d), c);
  }
  function f(d) {
    return d === 96 ? (e.consume(d), a++, f) : a === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (i.type = "codeTextData", c(d));
  }
}
class ed {
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length) {
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    }
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  get length() {
    return this.left.length + this.right.length;
  }
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  splice(t, n, r) {
    const a = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return r && $t(this.left, r), i.reverse();
  }
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), $t(this.left, t);
  }
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  unshiftMany(t) {
    this.setCursor(0), $t(this.right, t.reverse());
  }
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0)) {
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        $t(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        $t(this.left, n.reverse());
      }
    }
  }
}
function $t(e, t) {
  let n = 0;
  if (t.length < 1e4) {
    e.push(...t);
  } else {
    for (; n < t.length;) {
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
    }
  }
}
function mu(e) {
  const t = {};
  let n = -1, r, a, i, u, o, l, c;
  const f = new ed(e);
  for (; ++n < f.length;) {
    for (; n in t;) {
      n = t[n];
    }
    if (r = f.get(n), n && r[1].type === "chunkFlow" && f.get(n - 1)[1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, i = 0, i < l.length && l[i][1].type === "lineEndingBlank" && (i += 2), i < l.length && l[i][1].type === "content")) {
      for (; ++i < l.length && l[i][1].type !== "content";) {
        l[i][1].type === "chunkText" && (l[i][1]._isInFirstContentOfListItem = !0, i++);
      }
    }
    if (r[0] === "enter") {
      r[1].contentType && (Object.assign(t, td(f, n)), n = t[n], c = !0);
    } else if (r[1]._container) {
      for (i = n, a = void 0; i--;) {
        if (u = f.get(i), u[1].type === "lineEnding" || u[1].type === "lineEndingBlank") {
          u[0] === "enter" && (a && (f.get(a)[1].type = "lineEndingBlank"), u[1].type = "lineEnding", a = i);
        } else if (!(u[1].type === "linePrefix" || u[1].type === "listItemIndent")) {
          break;
        }
      }
      a && (r[1].end = {...f.get(a)[1].start}, o = f.slice(a, n), o.unshift(r), f.splice(a, n - a + 1, o));
    }
  }
  return Fe(e, 0, Number.POSITIVE_INFINITY, f.slice(0)), !c;
}
function td(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let a = t - 1;
  const i = [];
  let u = n._tokenizer;
  u || (u = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (u._contentTypeTextTrailing = !0));
  const o = u.events, l = [], c = {};
  let f, d, m = -1, p = n, g = 0, T = 0;
  const A = [T];
  for (; p;) {
    for (; e.get(++a)[1] !== p;) {
    }
    i.push(a), p._tokenizer || (f = r.sliceStream(p), p.next || f.push(null), d && u.defineSkip(p.start), p._isInFirstContentOfListItem && (u._gfmTasklistFirstContentOfListItem = !0), u.write(f), p._isInFirstContentOfListItem && (u._gfmTasklistFirstContentOfListItem = void 0)), d = p, p = p.next;
  }
  for (p = n; ++m < o.length;) {
    o[m][0] === "exit" && o[m - 1][0] === "enter" && o[m][1].type === o[m - 1][1].type && o[m][1].start.line !== o[m][1].end.line && (T = m + 1, A.push(T), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  }
  for (u.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : A.pop(), m = A.length; m--;) {
    const y = o.slice(A[m], A[m + 1]), C = i.pop();
    l.push([C, C + y.length - 1]), e.splice(C, 2, y);
  }
  for (l.reverse(), m = -1; ++m < l.length;) {
    c[g + l[m][0]] = g + l[m][1], g += l[m][1] - l[m][0] - 1;
  }
  return c;
}
const nd = {resolve:ad, tokenize:id}, rd = {partial:!0, tokenize:ud};
function ad(e) {
  return mu(e), e;
}
function id(e, t) {
  let n;
  return r;
  function r(o) {
    return e.enter("content"), n = e.enter("chunkContent", {contentType:"content"}), a(o);
  }
  function a(o) {
    return o === null ? i(o) : G(o) ? e.check(rd, u, i)(o) : (e.consume(o), a);
  }
  function i(o) {
    return e.exit("chunkContent"), e.exit("content"), t(o);
  }
  function u(o) {
    return e.consume(o), e.exit("chunkContent"), n.next = e.enter("chunkContent", {contentType:"content", previous:n}), n = n.next, a;
  }
}
function ud(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), te(e, i, "linePrefix");
  }
  function i(u) {
    if (u === null || G(u)) {
      return n(u);
    }
    const o = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(u) : e.interrupt(r.parser.constructs.flow, n, t)(u);
  }
}
function gu(e, t, n, r, a, i, u, o, l) {
  const c = l || Number.POSITIVE_INFINITY;
  let f = 0;
  return d;
  function d(y) {
    return y === 60 ? (e.enter(r), e.enter(a), e.enter(i), e.consume(y), e.exit(i), m) : y === null || y === 32 || y === 41 || In(y) ? n(y) : (e.enter(r), e.enter(u), e.enter(o), e.enter("chunkString", {contentType:"string"}), T(y));
  }
  function m(y) {
    return y === 62 ? (e.enter(i), e.consume(y), e.exit(i), e.exit(a), e.exit(r), t) : (e.enter(o), e.enter("chunkString", {contentType:"string"}), p(y));
  }
  function p(y) {
    return y === 62 ? (e.exit("chunkString"), e.exit(o), m(y)) : y === null || y === 60 || G(y) ? n(y) : (e.consume(y), y === 92 ? g : p);
  }
  function g(y) {
    return y === 60 || y === 62 || y === 92 ? (e.consume(y), p) : p(y);
  }
  function T(y) {
    return !f && (y === null || y === 41 || ie(y)) ? (e.exit("chunkString"), e.exit(o), e.exit(u), e.exit(r), t(y)) : f < c && y === 40 ? (e.consume(y), f++, T) : y === 41 ? (e.consume(y), f--, T) : y === null || y === 32 || y === 40 || In(y) ? n(y) : (e.consume(y), y === 92 ? A : T);
  }
  function A(y) {
    return y === 40 || y === 41 || y === 92 ? (e.consume(y), T) : T(y);
  }
}
function bu(e, t, n, r, a, i) {
  const u = this;
  let o = 0, l;
  return c;
  function c(p) {
    return e.enter(r), e.enter(a), e.consume(p), e.exit(a), e.enter(i), f;
  }
  function f(p) {
    return o > 999 || p === null || p === 91 || p === 93 && !l || p === 94 && !o && "_hiddenFootnoteSupport" in u.parser.constructs ? n(p) : p === 93 ? (e.exit(i), e.enter(a), e.consume(p), e.exit(a), e.exit(r), t) : G(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), f) : (e.enter("chunkString", {contentType:"string"}), d(p));
  }
  function d(p) {
    return p === null || p === 91 || p === 93 || G(p) || o++ > 999 ? (e.exit("chunkString"), f(p)) : (e.consume(p), l || (l = !J(p)), p === 92 ? m : d);
  }
  function m(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, d) : d(p);
  }
}
function Eu(e, t, n, r, a, i) {
  let u;
  return o;
  function o(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(a), e.consume(m), e.exit(a), u = m === 40 ? 41 : m, l) : n(m);
  }
  function l(m) {
    return m === u ? (e.enter(a), e.consume(m), e.exit(a), e.exit(r), t) : (e.enter(i), c(m));
  }
  function c(m) {
    return m === u ? (e.exit(i), l(u)) : m === null ? n(m) : G(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), te(e, c, "linePrefix")) : (e.enter("chunkString", {contentType:"string"}), f(m));
  }
  function f(m) {
    return m === u || m === null || G(m) ? (e.exit("chunkString"), c(m)) : (e.consume(m), m === 92 ? d : f);
  }
  function d(m) {
    return m === u || m === 92 ? (e.consume(m), f) : f(m);
  }
}
function Vt(e, t) {
  let n;
  return r;
  function r(a) {
    return G(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), n = !0, r) : J(a) ? te(e, r, n ? "linePrefix" : "lineSuffix")(a) : t(a);
  }
}
const sd = {name:"definition", tokenize:ld}, od = {partial:!0, tokenize:cd};
function ld(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(p) {
    return e.enter("definition"), u(p);
  }
  function u(p) {
    return bu.call(r, e, o, n, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(p);
  }
  function o(p) {
    return a = He(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), l) : n(p);
  }
  function l(p) {
    return ie(p) ? Vt(e, c)(p) : c(p);
  }
  function c(p) {
    return gu(e, f, n, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(p);
  }
  function f(p) {
    return e.attempt(od, d, d)(p);
  }
  function d(p) {
    return J(p) ? te(e, m, "whitespace")(p) : m(p);
  }
  function m(p) {
    return p === null || G(p) ? (e.exit("definition"), r.parser.defined.push(a), t(p)) : n(p);
  }
}
function cd(e, t, n) {
  return r;
  function r(o) {
    return ie(o) ? Vt(e, a)(o) : n(o);
  }
  function a(o) {
    return Eu(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(o);
  }
  function i(o) {
    return J(o) ? te(e, u, "whitespace")(o) : u(o);
  }
  function u(o) {
    return o === null || G(o) ? t(o) : n(o);
  }
}
const dd = {name:"hardBreakEscape", tokenize:fd};
function fd(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), a;
  }
  function a(i) {
    return G(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const hd = {name:"headingAtx", resolve:pd, tokenize:md};
function pd(e, t) {
  let n = e.length - 2, r = 3, a, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (a = {type:"atxHeadingText", start:e[r][1].start, end:e[n][1].end}, i = {type:"chunkText", start:e[r][1].start, end:e[n][1].end, contentType:"text"}, Fe(e, r, n - r + 1, [["enter", a, t], ["enter", i, t], ["exit", i, t], ["exit", a, t]])), e;
}
function md(e, t, n) {
  let r = 0;
  return a;
  function a(f) {
    return e.enter("atxHeading"), i(f);
  }
  function i(f) {
    return e.enter("atxHeadingSequence"), u(f);
  }
  function u(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), u) : f === null || ie(f) ? (e.exit("atxHeadingSequence"), o(f)) : n(f);
  }
  function o(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), l(f)) : f === null || G(f) ? (e.exit("atxHeading"), t(f)) : J(f) ? te(e, o, "whitespace")(f) : (e.enter("atxHeadingText"), c(f));
  }
  function l(f) {
    return f === 35 ? (e.consume(f), l) : (e.exit("atxHeadingSequence"), o(f));
  }
  function c(f) {
    return f === null || f === 35 || ie(f) ? (e.exit("atxHeadingText"), o(f)) : (e.consume(f), c);
  }
}
const gd = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "search", "section", "summary", "table", "tbody", "td", "tfoot", 
"th", "thead", "title", "tr", "track", "ul"], Fa = ["pre", "script", "style", "textarea"], bd = {concrete:!0, name:"htmlFlow", resolveTo:yd, tokenize:_d}, Ed = {partial:!0, tokenize:xd}, Td = {partial:!0, tokenize:Ad};
function yd(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow");) {
  }
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function _d(e, t, n) {
  const r = this;
  let a, i, u, o, l;
  return c;
  function c(S) {
    return f(S);
  }
  function f(S) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(S), d;
  }
  function d(S) {
    return S === 33 ? (e.consume(S), m) : S === 47 ? (e.consume(S), i = !0, T) : S === 63 ? (e.consume(S), a = 3, r.interrupt ? t : x) : ke(S) ? (e.consume(S), u = String.fromCharCode(S), A) : n(S);
  }
  function m(S) {
    return S === 45 ? (e.consume(S), a = 2, p) : S === 91 ? (e.consume(S), a = 5, o = 0, g) : ke(S) ? (e.consume(S), a = 4, r.interrupt ? t : x) : n(S);
  }
  function p(S) {
    return S === 45 ? (e.consume(S), r.interrupt ? t : x) : n(S);
  }
  function g(S) {
    const Te = "CDATA[";
    return S === Te.charCodeAt(o++) ? (e.consume(S), o === Te.length ? r.interrupt ? t : Y : g) : n(S);
  }
  function T(S) {
    return ke(S) ? (e.consume(S), u = String.fromCharCode(S), A) : n(S);
  }
  function A(S) {
    if (S === null || S === 47 || S === 62 || ie(S)) {
      const Te = S === 47, Me = u.toLowerCase();
      return !Te && !i && Fa.includes(Me) ? (a = 1, r.interrupt ? t(S) : Y(S)) : gd.includes(u.toLowerCase()) ? (a = 6, Te ? (e.consume(S), y) : r.interrupt ? t(S) : Y(S)) : (a = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(S) : i ? C(S) : N(S));
    }
    return S === 45 || Ae(S) ? (e.consume(S), u += String.fromCharCode(S), A) : n(S);
  }
  function y(S) {
    return S === 62 ? (e.consume(S), r.interrupt ? t : Y) : n(S);
  }
  function C(S) {
    return J(S) ? (e.consume(S), C) : L(S);
  }
  function N(S) {
    return S === 47 ? (e.consume(S), L) : S === 58 || S === 95 || ke(S) ? (e.consume(S), v) : J(S) ? (e.consume(S), N) : L(S);
  }
  function v(S) {
    return S === 45 || S === 46 || S === 58 || S === 95 || Ae(S) ? (e.consume(S), v) : B(S);
  }
  function B(S) {
    return S === 61 ? (e.consume(S), O) : J(S) ? (e.consume(S), B) : N(S);
  }
  function O(S) {
    return S === null || S === 60 || S === 61 || S === 62 || S === 96 ? n(S) : S === 34 || S === 39 ? (e.consume(S), l = S, j) : J(S) ? (e.consume(S), O) : W(S);
  }
  function j(S) {
    return S === l ? (e.consume(S), l = null, $) : S === null || G(S) ? n(S) : (e.consume(S), j);
  }
  function W(S) {
    return S === null || S === 34 || S === 39 || S === 47 || S === 60 || S === 61 || S === 62 || S === 96 || ie(S) ? B(S) : (e.consume(S), W);
  }
  function $(S) {
    return S === 47 || S === 62 || J(S) ? N(S) : n(S);
  }
  function L(S) {
    return S === 62 ? (e.consume(S), z) : n(S);
  }
  function z(S) {
    return S === null || G(S) ? Y(S) : J(S) ? (e.consume(S), z) : n(S);
  }
  function Y(S) {
    return S === 45 && a === 2 ? (e.consume(S), ue) : S === 60 && a === 1 ? (e.consume(S), oe) : S === 62 && a === 4 ? (e.consume(S), he) : S === 63 && a === 3 ? (e.consume(S), x) : S === 93 && a === 5 ? (e.consume(S), Oe) : G(S) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(Ed, Ee, ne)(S)) : S === null || G(S) ? (e.exit("htmlFlowData"), ne(S)) : (e.consume(S), Y);
  }
  function ne(S) {
    return e.check(Td, X, Ee)(S);
  }
  function X(S) {
    return e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), V;
  }
  function V(S) {
    return S === null || G(S) ? ne(S) : (e.enter("htmlFlowData"), Y(S));
  }
  function ue(S) {
    return S === 45 ? (e.consume(S), x) : Y(S);
  }
  function oe(S) {
    return S === 47 ? (e.consume(S), u = "", se) : Y(S);
  }
  function se(S) {
    if (S === 62) {
      const Te = u.toLowerCase();
      return Fa.includes(Te) ? (e.consume(S), he) : Y(S);
    }
    return ke(S) && u.length < 8 ? (e.consume(S), u += String.fromCharCode(S), se) : Y(S);
  }
  function Oe(S) {
    return S === 93 ? (e.consume(S), x) : Y(S);
  }
  function x(S) {
    return S === 62 ? (e.consume(S), he) : S === 45 && a === 2 ? (e.consume(S), x) : Y(S);
  }
  function he(S) {
    return S === null || G(S) ? (e.exit("htmlFlowData"), Ee(S)) : (e.consume(S), he);
  }
  function Ee(S) {
    return e.exit("htmlFlow"), t(S);
  }
}
function Ad(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return G(u) ? (e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), i) : n(u);
  }
  function i(u) {
    return r.parser.lazy[r.now().line] ? n(u) : t(u);
  }
}
function xd(e, t, n) {
  return r;
  function r(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(ln, t, n);
  }
}
const Sd = {name:"htmlText", tokenize:kd};
function kd(e, t, n) {
  const r = this;
  let a, i, u;
  return o;
  function o(x) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(x), l;
  }
  function l(x) {
    return x === 33 ? (e.consume(x), c) : x === 47 ? (e.consume(x), B) : x === 63 ? (e.consume(x), N) : ke(x) ? (e.consume(x), W) : n(x);
  }
  function c(x) {
    return x === 45 ? (e.consume(x), f) : x === 91 ? (e.consume(x), i = 0, g) : ke(x) ? (e.consume(x), C) : n(x);
  }
  function f(x) {
    return x === 45 ? (e.consume(x), p) : n(x);
  }
  function d(x) {
    return x === null ? n(x) : x === 45 ? (e.consume(x), m) : G(x) ? (u = d, oe(x)) : (e.consume(x), d);
  }
  function m(x) {
    return x === 45 ? (e.consume(x), p) : d(x);
  }
  function p(x) {
    return x === 62 ? ue(x) : x === 45 ? m(x) : d(x);
  }
  function g(x) {
    const he = "CDATA[";
    return x === he.charCodeAt(i++) ? (e.consume(x), i === he.length ? T : g) : n(x);
  }
  function T(x) {
    return x === null ? n(x) : x === 93 ? (e.consume(x), A) : G(x) ? (u = T, oe(x)) : (e.consume(x), T);
  }
  function A(x) {
    return x === 93 ? (e.consume(x), y) : T(x);
  }
  function y(x) {
    return x === 62 ? ue(x) : x === 93 ? (e.consume(x), y) : T(x);
  }
  function C(x) {
    return x === null || x === 62 ? ue(x) : G(x) ? (u = C, oe(x)) : (e.consume(x), C);
  }
  function N(x) {
    return x === null ? n(x) : x === 63 ? (e.consume(x), v) : G(x) ? (u = N, oe(x)) : (e.consume(x), N);
  }
  function v(x) {
    return x === 62 ? ue(x) : N(x);
  }
  function B(x) {
    return ke(x) ? (e.consume(x), O) : n(x);
  }
  function O(x) {
    return x === 45 || Ae(x) ? (e.consume(x), O) : j(x);
  }
  function j(x) {
    return G(x) ? (u = j, oe(x)) : J(x) ? (e.consume(x), j) : ue(x);
  }
  function W(x) {
    return x === 45 || Ae(x) ? (e.consume(x), W) : x === 47 || x === 62 || ie(x) ? $(x) : n(x);
  }
  function $(x) {
    return x === 47 ? (e.consume(x), ue) : x === 58 || x === 95 || ke(x) ? (e.consume(x), L) : G(x) ? (u = $, oe(x)) : J(x) ? (e.consume(x), $) : ue(x);
  }
  function L(x) {
    return x === 45 || x === 46 || x === 58 || x === 95 || Ae(x) ? (e.consume(x), L) : z(x);
  }
  function z(x) {
    return x === 61 ? (e.consume(x), Y) : G(x) ? (u = z, oe(x)) : J(x) ? (e.consume(x), z) : $(x);
  }
  function Y(x) {
    return x === null || x === 60 || x === 61 || x === 62 || x === 96 ? n(x) : x === 34 || x === 39 ? (e.consume(x), a = x, ne) : G(x) ? (u = Y, oe(x)) : J(x) ? (e.consume(x), Y) : (e.consume(x), X);
  }
  function ne(x) {
    return x === a ? (e.consume(x), a = void 0, V) : x === null ? n(x) : G(x) ? (u = ne, oe(x)) : (e.consume(x), ne);
  }
  function X(x) {
    return x === null || x === 34 || x === 39 || x === 60 || x === 61 || x === 96 ? n(x) : x === 47 || x === 62 || ie(x) ? $(x) : (e.consume(x), X);
  }
  function V(x) {
    return x === 47 || x === 62 || ie(x) ? $(x) : n(x);
  }
  function ue(x) {
    return x === 62 ? (e.consume(x), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(x);
  }
  function oe(x) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), se;
  }
  function se(x) {
    return J(x) ? te(e, Oe, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(x) : Oe(x);
  }
  function Oe(x) {
    return e.enter("htmlTextData"), u(x);
  }
}
const Yr = {name:"labelEnd", resolveAll:Od, resolveTo:Ld, tokenize:Rd}, Cd = {tokenize:wd}, Id = {tokenize:Dd}, Nd = {tokenize:Pd};
function Od(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length;) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const a = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += a;
    }
  }
  return e.length !== n.length && Fe(e, 0, e.length, n), e;
}
function Ld(e, t) {
  let n = e.length, r = 0, a, i, u, o;
  for (; n--;) {
    if (a = e[n][1], i) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive) {
        break;
      }
      e[n][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (u) {
      if (e[n][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (i = n, a.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else {
      a.type === "labelEnd" && (u = n);
    }
  }
  const l = {type:e[i][1].type === "labelLink" ? "link" : "image", start:{...e[i][1].start}, end:{...e[e.length - 1][1].end}}, c = {type:"label", start:{...e[i][1].start}, end:{...e[u][1].end}}, f = {type:"labelText", start:{...e[i + r + 2][1].end}, end:{...e[u - 2][1].start}};
  return o = [["enter", l, t], ["enter", c, t]], o = Be(o, e.slice(i + 1, i + r + 3)), o = Be(o, [["enter", f, t]]), o = Be(o, vn(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, u - 3), t)), o = Be(o, [["exit", f, t], e[u - 2], e[u - 1], ["exit", c, t]]), o = Be(o, e.slice(u + 1)), o = Be(o, [["exit", l, t]]), Fe(e, i, e.length, o), e;
}
function Rd(e, t, n) {
  const r = this;
  let a = r.events.length, i, u;
  for (; a--;) {
    if ((r.events[a][1].type === "labelImage" || r.events[a][1].type === "labelLink") && !r.events[a][1]._balanced) {
      i = r.events[a][1];
      break;
    }
  }
  return o;
  function o(m) {
    return i ? i._inactive ? d(m) : (u = r.parser.defined.includes(He(r.sliceSerialize({start:i.end, end:r.now()}))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(m);
  }
  function l(m) {
    return m === 40 ? e.attempt(Cd, f, u ? f : d)(m) : m === 91 ? e.attempt(Id, f, u ? c : d)(m) : u ? f(m) : d(m);
  }
  function c(m) {
    return e.attempt(Nd, f, d)(m);
  }
  function f(m) {
    return t(m);
  }
  function d(m) {
    return i._balanced = !0, n(m);
  }
}
function wd(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), a;
  }
  function a(d) {
    return ie(d) ? Vt(e, i)(d) : i(d);
  }
  function i(d) {
    return d === 41 ? f(d) : gu(e, u, o, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function u(d) {
    return ie(d) ? Vt(e, l)(d) : f(d);
  }
  function o(d) {
    return n(d);
  }
  function l(d) {
    return d === 34 || d === 39 || d === 40 ? Eu(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : f(d);
  }
  function c(d) {
    return ie(d) ? Vt(e, f)(d) : f(d);
  }
  function f(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function Dd(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return bu.call(r, e, i, u, "reference", "referenceMarker", "referenceString")(o);
  }
  function i(o) {
    return r.parser.defined.includes(He(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(o) : n(o);
  }
  function u(o) {
    return n(o);
  }
}
function Pd(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), a;
  }
  function a(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const Fd = {name:"labelStartImage", resolveAll:Yr.resolveAll, tokenize:Md};
function Md(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(o), e.exit("labelImageMarker"), i;
  }
  function i(o) {
    return o === 91 ? (e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelImage"), u) : n(o);
  }
  function u(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const Bd = {name:"labelStartLink", resolveAll:Yr.resolveAll, tokenize:vd};
function vd(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(u), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(u) {
    return u === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(u) : t(u);
  }
}
const er = {name:"lineEnding", tokenize:Ud};
function Ud(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), te(e, t, "linePrefix");
  }
}
const An = {name:"thematicBreak", tokenize:Hd};
function Hd(e, t, n) {
  let r = 0, a;
  return i;
  function i(c) {
    return e.enter("thematicBreak"), u(c);
  }
  function u(c) {
    return a = c, o(c);
  }
  function o(c) {
    return c === a ? (e.enter("thematicBreakSequence"), l(c)) : r >= 3 && (c === null || G(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function l(c) {
    return c === a ? (e.consume(c), r++, l) : (e.exit("thematicBreakSequence"), J(c) ? te(e, o, "whitespace")(c) : o(c));
  }
}
const Ie = {continuation:{tokenize:jd}, exit:Gd, name:"list", tokenize:Yd}, zd = {partial:!0, tokenize:Wd}, $d = {partial:!0, tokenize:qd};
function Yd(e, t, n) {
  const r = this, a = r.events[r.events.length - 1];
  let i = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, u = 0;
  return o;
  function o(p) {
    const g = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : Ar(p)) {
      if (r.containerState.type || (r.containerState.type = g, e.enter(g, {_container:!0})), g === "listUnordered") {
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(An, n, c)(p) : c(p);
      }
      if (!r.interrupt || p === 49) {
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(p);
      }
    }
    return n(p);
  }
  function l(p) {
    return Ar(p) && ++u < 10 ? (e.consume(p), l) : (!r.interrupt || u < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), c(p)) : n(p);
  }
  function c(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(ln, r.interrupt ? n : f, e.attempt(zd, m, d));
  }
  function f(p) {
    return r.containerState.initialBlankLine = !0, i++, m(p);
  }
  function d(p) {
    return J(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), m) : n(p);
  }
  function m(p) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function jd(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(ln, a, i);
  function a(o) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, te(e, t, "listItemIndent", r.containerState.size + 1)(o);
  }
  function i(o) {
    return r.containerState.furtherBlankLines || !J(o) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, u(o)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt($d, t, u)(o));
  }
  function u(o) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, te(e, e.attempt(Ie, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o);
  }
}
function qd(e, t, n) {
  const r = this;
  return te(e, a, "listItemIndent", r.containerState.size + 1);
  function a(i) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "listItemIndent" && u[2].sliceSerialize(u[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function Gd(e) {
  e.exit(this.containerState.type);
}
function Wd(e, t, n) {
  const r = this;
  return te(e, a, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(i) {
    const u = r.events[r.events.length - 1];
    return !J(i) && u && u[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const Ma = {name:"setextUnderline", resolveTo:Vd, tokenize:Xd};
function Vd(e, t) {
  let n = e.length, r, a, i;
  for (; n--;) {
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (a = n);
    } else {
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
    }
  }
  const u = {type:"setextHeading", start:{...e[r][1].start}, end:{...e[e.length - 1][1].end}};
  return e[a][1].type = "setextHeadingText", i ? (e.splice(a, 0, ["enter", u, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {...e[i][1].end}) : e[r][1] = u, e.push(["exit", u, t]), e;
}
function Xd(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(c) {
    let f = r.events.length, d;
    for (; f--;) {
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        d = r.events[f][1].type === "paragraph";
        break;
      }
    }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), a = c, u(c)) : n(c);
  }
  function u(c) {
    return e.enter("setextHeadingLineSequence"), o(c);
  }
  function o(c) {
    return c === a ? (e.consume(c), o) : (e.exit("setextHeadingLineSequence"), J(c) ? te(e, l, "lineSuffix")(c) : l(c));
  }
  function l(c) {
    return c === null || G(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const Qd = {tokenize:Kd};
function Kd(e) {
  const t = this, n = e.attempt(ln, r, e.attempt(this.parser.constructs.flowInitial, a, te(e, e.attempt(this.parser.constructs.flow, a, e.attempt(nd, a)), "linePrefix")));
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function a(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const Zd = {resolveAll:yu()}, Jd = Tu("string"), ef = Tu("text");
function Tu(e) {
  return {resolveAll:yu(e === "text" ? tf : void 0), tokenize:t};
  function t(n) {
    const r = this, a = this.parser.constructs[e], i = n.attempt(a, u, o);
    return u;
    function u(f) {
      return c(f) ? i(f) : o(f);
    }
    function o(f) {
      if (f === null) {
        n.consume(f);
        return;
      }
      return n.enter("data"), n.consume(f), l;
    }
    function l(f) {
      return c(f) ? (n.exit("data"), i(f)) : (n.consume(f), l);
    }
    function c(f) {
      if (f === null) {
        return !0;
      }
      const d = a[f];
      let m = -1;
      if (d) {
        for (; ++m < d.length;) {
          const p = d[m];
          if (!p.previous || p.previous.call(r, r.previous)) {
            return !0;
          }
        }
      }
      return !1;
    }
  }
}
function yu(e) {
  return t;
  function t(n, r) {
    let a = -1, i;
    for (; ++a <= n.length;) {
      i === void 0 ? n[a] && n[a][1].type === "data" && (i = a, a++) : (!n[a] || n[a][1].type !== "data") && (a !== i + 2 && (n[i][1].end = n[a - 1][1].end, n.splice(i + 2, a - i - 2), a = i + 2), i = void 0);
    }
    return e ? e(n, r) : n;
  }
}
function tf(e, t) {
  let n = 0;
  for (; ++n <= e.length;) {
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], a = t.sliceStream(r);
      let i = a.length, u = -1, o = 0, l;
      for (; i--;) {
        const c = a[i];
        if (typeof c == "string") {
          for (u = c.length; c.charCodeAt(u - 1) === 32;) {
            o++, u--;
          }
          if (u) {
            break;
          }
          u = -1;
        } else if (c === -2) {
          l = !0, o++;
        } else if (c !== -1) {
          i++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (o = 0), o) {
        const c = {type:n === e.length || l || o < 2 ? "lineSuffix" : "hardBreakTrailing", start:{_bufferIndex:i ? u : r.start._bufferIndex + u, _index:r.start._index + i, line:r.end.line, column:r.end.column - o, offset:r.end.offset - o}, end:{...r.end}};
        r.end = {...c.start}, r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(n, 0, ["enter", c, t], ["exit", c, t]), n += 2);
      }
      n++;
    }
  }
  return e;
}
const nf = {42:Ie, 43:Ie, 45:Ie, 48:Ie, 49:Ie, 50:Ie, 51:Ie, 52:Ie, 53:Ie, 54:Ie, 55:Ie, 56:Ie, 57:Ie, 62:fu}, rf = {91:sd}, af = {[-2]:Jn, [-1]:Jn, 32:Jn}, uf = {35:hd, 42:An, 45:[Ma, An], 60:bd, 61:Ma, 95:An, 96:Pa, 126:Pa}, sf = {38:pu, 92:hu}, of = {[-5]:er, [-4]:er, [-3]:er, 33:Fd, 38:pu, 42:xr, 60:[Bc, Sd], 91:Bd, 92:[dd, hu], 93:Yr, 95:xr, 96:Qc}, lf = {null:[xr, Zd]}, cf = {null:[42, 95]}, df = {null:[]}, ff = Object.freeze(Object.defineProperty({__proto__:null, attentionMarkers:cf, contentInitial:rf, 
disable:df, document:nf, flow:uf, flowInitial:af, insideSpan:lf, string:sf, text:of}, Symbol.toStringTag, {value:"Module"}));
function hf(e, t, n) {
  let r = {_bufferIndex:-1, _index:0, line:n && n.line || 1, column:n && n.column || 1, offset:n && n.offset || 0};
  const a = {}, i = [];
  let u = [], o = [];
  const l = {attempt:j(B), check:j(O), consume:C, enter:N, exit:v, interrupt:j(O, {interrupt:!0})}, c = {code:null, containerState:{}, defineSkip:T, events:[], now:g, parser:e, previous:null, sliceSerialize:m, sliceStream:p, write:d};
  let f = t.tokenize.call(c, l);
  return t.resolveAll && i.push(t), c;
  function d(z) {
    return u = Be(u, z), A(), u[u.length - 1] !== null ? [] : (W(t, 0), c.events = vn(i, c.events, c), c.events);
  }
  function m(z, Y) {
    return mf(p(z), Y);
  }
  function p(z) {
    return pf(u, z);
  }
  function g() {
    const {_bufferIndex:z, _index:Y, line:ne, column:X, offset:V} = r;
    return {_bufferIndex:z, _index:Y, line:ne, column:X, offset:V};
  }
  function T(z) {
    a[z.line] = z.column, L();
  }
  function A() {
    let z;
    for (; r._index < u.length;) {
      const Y = u[r._index];
      if (typeof Y == "string") {
        for (z = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === z && r._bufferIndex < Y.length;) {
          y(Y.charCodeAt(r._bufferIndex));
        }
      } else {
        y(Y);
      }
    }
  }
  function y(z) {
    f = f(z);
  }
  function C(z) {
    G(z) ? (r.line++, r.column = 1, r.offset += z === -3 ? 2 : 1, L()) : z !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === u[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = z;
  }
  function N(z, Y) {
    const ne = Y || {};
    return ne.type = z, ne.start = g(), c.events.push(["enter", ne, c]), o.push(ne), ne;
  }
  function v(z) {
    const Y = o.pop();
    return Y.end = g(), c.events.push(["exit", Y, c]), Y;
  }
  function B(z, Y) {
    W(z, Y.from);
  }
  function O(z, Y) {
    Y.restore();
  }
  function j(z, Y) {
    return ne;
    function ne(X, V, ue) {
      let oe, se, Oe, x;
      return Array.isArray(X) ? Ee(X) : "tokenize" in X ? Ee([X]) : he(X);
      function he(ce) {
        return $e;
        function $e(Ye) {
          const je = Ye !== null && ce[Ye], kt = Ye !== null && ce.null, hn = [...(Array.isArray(je) ? je : je ? [je] : []), ...(Array.isArray(kt) ? kt : kt ? [kt] : [])];
          return Ee(hn)(Ye);
        }
      }
      function Ee(ce) {
        return oe = ce, se = 0, ce.length === 0 ? ue : S(ce[se]);
      }
      function S(ce) {
        return $e;
        function $e(Ye) {
          return x = $(), Oe = ce, ce.partial || (c.currentConstruct = ce), ce.name && c.parser.constructs.disable.null.includes(ce.name) ? Me() : ce.tokenize.call(Y ? Object.assign(Object.create(c), Y) : c, l, Te, Me)(Ye);
        }
      }
      function Te(ce) {
        return z(Oe, x), V;
      }
      function Me(ce) {
        return x.restore(), ++se < oe.length ? S(oe[se]) : ue;
      }
    }
  }
  function W(z, Y) {
    z.resolveAll && !i.includes(z) && i.push(z), z.resolve && Fe(c.events, Y, c.events.length - Y, z.resolve(c.events.slice(Y), c)), z.resolveTo && (c.events = z.resolveTo(c.events, c));
  }
  function $() {
    const z = g(), Y = c.previous, ne = c.currentConstruct, X = c.events.length, V = Array.from(o);
    return {from:X, restore:ue};
    function ue() {
      r = z, c.previous = Y, c.currentConstruct = ne, c.events.length = X, o = V, L();
    }
  }
  function L() {
    r.line in a && r.column < 2 && (r.column = a[r.line], r.offset += a[r.line] - 1);
  }
}
function pf(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, a = t.end._index, i = t.end._bufferIndex;
  let u;
  if (n === a) {
    u = [e[n].slice(r, i)];
  } else {
    if (u = e.slice(n, a), r > -1) {
      const o = u[0];
      typeof o == "string" ? u[0] = o.slice(r) : u.shift();
    }
    i > 0 && u.push(e[a].slice(0, i));
  }
  return u;
}
function mf(e, t) {
  let n = -1;
  const r = [];
  let a;
  for (; ++n < e.length;) {
    const i = e[n];
    let u;
    if (typeof i == "string") {
      u = i;
    } else {
      switch(i) {
        case -5:
          {
            u = "\r";
            break;
          }
        case -4:
          {
            u = `
`;
            break;
          }
        case -3:
          {
            u = `\r
`;
            break;
          }
        case -2:
          {
            u = t ? " " : "\t";
            break;
          }
        case -1:
          {
            if (!t && a) {
              continue;
            }
            u = " ";
            break;
          }
        default:
          u = String.fromCharCode(i);
      }
    }
    a = i === -2, r.push(u);
  }
  return r.join("");
}
function gf(e) {
  const r = {constructs:cu([ff, ...((e || {}).extensions || [])]), content:a(Lc), defined:[], document:a(wc), flow:a(Qd), lazy:{}, string:a(Jd), text:a(ef)};
  return r;
  function a(i) {
    return u;
    function u(o) {
      return hf(r, i, o);
    }
  }
}
function bf(e) {
  for (; !mu(e);) {
  }
  return e;
}
const Ba = /[\0\t\n\r]/g;
function Ef() {
  let e = 1, t = "", n = !0, r;
  return a;
  function a(i, u, o) {
    const l = [];
    let c, f, d, m, p;
    for (i = t + (typeof i == "string" ? i.toString() : (new TextDecoder(u || void 0)).decode(i)), d = 0, t = "", n && (i.charCodeAt(0) === 65279 && d++, n = void 0); d < i.length;) {
      if (Ba.lastIndex = d, c = Ba.exec(i), m = c && c.index !== void 0 ? c.index : i.length, p = i.charCodeAt(m), !c) {
        t = i.slice(d);
        break;
      }
      if (p === 10 && d === m && r) {
        l.push(-3), r = void 0;
      } else {
        switch(r && (l.push(-5), r = void 0), d < m && (l.push(i.slice(d, m)), e += m - d), p) {
          case 0:
            {
              l.push(65533), e++;
              break;
            }
          case 9:
            {
              for (f = Math.ceil(e / 4) * 4, l.push(-2); e++ < f;) {
                l.push(-1);
              }
              break;
            }
          case 10:
            {
              l.push(-4), e = 1;
              break;
            }
          default:
            r = !0, e = 1;
        }
      }
      d = m + 1;
    }
    return o && (r && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
const Tf = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function yf(e) {
  return e.replace(Tf, _f);
}
function _f(e, t, n) {
  if (t) {
    return t;
  }
  if (n.charCodeAt(0) === 35) {
    const a = n.charCodeAt(1), i = a === 120 || a === 88;
    return du(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return $r(n) || e;
}
const _u = {}.hasOwnProperty;
function Af(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), xf(n)(bf(gf(n).document().write(Ef()(e, t, !0))));
}
function xf(e) {
  const t = {transforms:[], canContainEols:["emphasis", "fragment", "heading", "paragraph", "strong"], enter:{autolink:i(la), autolinkProtocol:$, autolinkEmail:$, atxHeading:i(ua), blockQuote:i(kt), characterEscape:$, characterReference:$, codeFenced:i(hn), codeFencedFenceInfo:u, codeFencedFenceMeta:u, codeIndented:i(hn, u), codeText:i(js, u), codeTextData:$, data:$, codeFlowValue:$, definition:i(qs), definitionDestinationString:u, definitionLabelString:u, definitionTitleString:u, emphasis:i(Gs), 
  hardBreakEscape:i(sa), hardBreakTrailing:i(sa), htmlFlow:i(oa, u), htmlFlowData:$, htmlText:i(oa, u), htmlTextData:$, image:i(Ws), label:u, link:i(la), listItem:i(Vs), listItemValue:m, listOrdered:i(ca, d), listUnordered:i(ca), paragraph:i(Xs), reference:S, referenceString:u, resourceDestinationString:u, resourceTitleString:u, setextHeading:i(ua), strong:i(Qs), thematicBreak:i(Zs)}, exit:{atxHeading:l(), atxHeadingSequence:B, autolink:l(), autolinkEmail:je, autolinkProtocol:Ye, blockQuote:l(), 
  characterEscapeValue:L, characterReferenceMarkerHexadecimal:Me, characterReferenceMarkerNumeric:Me, characterReferenceValue:ce, characterReference:$e, codeFenced:l(A), codeFencedFence:T, codeFencedFenceInfo:p, codeFencedFenceMeta:g, codeFlowValue:L, codeIndented:l(y), codeText:l(V), codeTextData:L, data:L, definition:l(), definitionDestinationString:v, definitionLabelString:C, definitionTitleString:N, emphasis:l(), hardBreakEscape:l(Y), hardBreakTrailing:l(Y), htmlFlow:l(ne), htmlFlowData:L, htmlText:l(X), 
  htmlTextData:L, image:l(oe), label:Oe, labelText:se, lineEnding:z, link:l(ue), listItem:l(), listOrdered:l(), listUnordered:l(), paragraph:l(), referenceString:Te, resourceDestinationString:x, resourceTitleString:he, resource:Ee, setextHeading:l(W), setextHeadingLineSequence:j, setextHeadingText:O, strong:l(), thematicBreak:l()}};
  Au(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(w) {
    let U = {type:"root", children:[]};
    const K = {stack:[U], tokenStack:[], config:t, enter:o, exit:c, buffer:u, resume:f, data:n}, ee = [];
    let re = -1;
    for (; ++re < w.length;) {
      if (w[re][1].type === "listOrdered" || w[re][1].type === "listUnordered") {
        if (w[re][0] === "enter") {
          ee.push(re);
        } else {
          const Ue = ee.pop();
          re = a(w, Ue, re);
        }
      }
    }
    for (re = -1; ++re < w.length;) {
      const Ue = t[w[re][0]];
      _u.call(Ue, w[re][1].type) && Ue[w[re][1].type].call(Object.assign({sliceSerialize:w[re][2].sliceSerialize}, K), w[re][1]);
    }
    if (K.tokenStack.length > 0) {
      const Ue = K.tokenStack[K.tokenStack.length - 1];
      (Ue[1] || va).call(K, void 0, Ue[0]);
    }
    for (U.position = {start:at(w.length > 0 ? w[0][1].start : {line:1, column:1, offset:0}), end:at(w.length > 0 ? w[w.length - 2][1].end : {line:1, column:1, offset:0})}, re = -1; ++re < t.transforms.length;) {
      U = t.transforms[re](U) || U;
    }
    return U;
  }
  function a(w, U, K) {
    let ee = U - 1, re = -1, Ue = !1, ht, Ze, Ht, zt;
    for (; ++ee <= K;) {
      const Le = w[ee];
      switch(Le[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote":
          {
            Le[0] === "enter" ? re++ : re--, zt = void 0;
            break;
          }
        case "lineEndingBlank":
          {
            Le[0] === "enter" && (ht && !zt && !re && !Ht && (Ht = ee), zt = void 0);
            break;
          }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          zt = void 0;
      }
      if (!re && Le[0] === "enter" && Le[1].type === "listItemPrefix" || re === -1 && Le[0] === "exit" && (Le[1].type === "listUnordered" || Le[1].type === "listOrdered")) {
        if (ht) {
          let Ct = ee;
          for (Ze = void 0; Ct--;) {
            const Je = w[Ct];
            if (Je[1].type === "lineEnding" || Je[1].type === "lineEndingBlank") {
              if (Je[0] === "exit") {
                continue;
              }
              Ze && (w[Ze][1].type = "lineEndingBlank", Ue = !0), Je[1].type = "lineEnding", Ze = Ct;
            } else if (!(Je[1].type === "linePrefix" || Je[1].type === "blockQuotePrefix" || Je[1].type === "blockQuotePrefixWhitespace" || Je[1].type === "blockQuoteMarker" || Je[1].type === "listItemIndent")) {
              break;
            }
          }
          Ht && (!Ze || Ht < Ze) && (ht._spread = !0), ht.end = Object.assign({}, Ze ? w[Ze][1].start : Le[1].end), w.splice(Ze || ee, 0, ["exit", ht, Le[2]]), ee++, K++;
        }
        if (Le[1].type === "listItemPrefix") {
          const Ct = {type:"listItem", _spread:!1, start:Object.assign({}, Le[1].start), end:void 0};
          ht = Ct, w.splice(ee, 0, ["enter", Ct, Le[2]]), ee++, K++, Ht = void 0, zt = !0;
        }
      }
    }
    return w[U][1]._spread = Ue, K;
  }
  function i(w, U) {
    return K;
    function K(ee) {
      o.call(this, w(ee), ee), U && U.call(this, ee);
    }
  }
  function u() {
    this.stack.push({type:"fragment", children:[]});
  }
  function o(w, U, K) {
    this.stack[this.stack.length - 1].children.push(w), this.stack.push(w), this.tokenStack.push([U, K || void 0]), w.position = {start:at(U.start), end:void 0};
  }
  function l(w) {
    return U;
    function U(K) {
      w && w.call(this, K), c.call(this, K);
    }
  }
  function c(w, U) {
    const K = this.stack.pop(), ee = this.tokenStack.pop();
    if (ee) {
      ee[0].type !== w.type && (U ? U.call(this, w, ee[0]) : (ee[1] || va).call(this, w, ee[0]));
    } else {
      throw new Error("Cannot close `" + w.type + "` (" + Wt({start:w.start, end:w.end}) + "): it\u2019s not open");
    }
    K.position.end = at(w.end);
  }
  function f() {
    return zr(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(w) {
    if (this.data.expectingFirstListItemValue) {
      const U = this.stack[this.stack.length - 2];
      U.start = Number.parseInt(this.sliceSerialize(w), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.lang = w;
  }
  function g() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.meta = w;
  }
  function T() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function A() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = w.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function y() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = w.replace(/(\r?\n|\r)$/g, "");
  }
  function C(w) {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.label = U, K.identifier = He(this.sliceSerialize(w)).toLowerCase();
  }
  function N() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = w;
  }
  function v() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = w;
  }
  function B(w) {
    const U = this.stack[this.stack.length - 1];
    if (!U.depth) {
      const K = this.sliceSerialize(w).length;
      U.depth = K;
    }
  }
  function O() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function j(w) {
    const U = this.stack[this.stack.length - 1];
    U.depth = this.sliceSerialize(w).codePointAt(0) === 61 ? 1 : 2;
  }
  function W() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function $(w) {
    const K = this.stack[this.stack.length - 1].children;
    let ee = K[K.length - 1];
    (!ee || ee.type !== "text") && (ee = Ks(), ee.position = {start:at(w.start), end:void 0}, K.push(ee)), this.stack.push(ee);
  }
  function L(w) {
    const U = this.stack.pop();
    U.value += this.sliceSerialize(w), U.position.end = at(w.end);
  }
  function z(w) {
    const U = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const K = U.children[U.children.length - 1];
      K.position.end = at(w.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(U.type) && ($.call(this, w), L.call(this, w));
  }
  function Y() {
    this.data.atHardBreak = !0;
  }
  function ne() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = w;
  }
  function X() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = w;
  }
  function V() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = w;
  }
  function ue() {
    const w = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      w.type += "Reference", w.referenceType = U, delete w.url, delete w.title;
    } else {
      delete w.identifier, delete w.label;
    }
    this.data.referenceType = void 0;
  }
  function oe() {
    const w = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      w.type += "Reference", w.referenceType = U, delete w.url, delete w.title;
    } else {
      delete w.identifier, delete w.label;
    }
    this.data.referenceType = void 0;
  }
  function se(w) {
    const U = this.sliceSerialize(w), K = this.stack[this.stack.length - 2];
    K.label = yf(U), K.identifier = He(U).toLowerCase();
  }
  function Oe() {
    const w = this.stack[this.stack.length - 1], U = this.resume(), K = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, K.type === "link") {
      const ee = w.children;
      K.children = ee;
    } else {
      K.alt = U;
    }
  }
  function x() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = w;
  }
  function he() {
    const w = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = w;
  }
  function Ee() {
    this.data.inReference = void 0;
  }
  function S() {
    this.data.referenceType = "collapsed";
  }
  function Te(w) {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.label = U, K.identifier = He(this.sliceSerialize(w)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(w) {
    this.data.characterReferenceType = w.type;
  }
  function ce(w) {
    const U = this.sliceSerialize(w), K = this.data.characterReferenceType;
    let ee;
    K ? (ee = du(U, K === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ee = $r(U);
    const re = this.stack[this.stack.length - 1];
    re.value += ee;
  }
  function $e(w) {
    const U = this.stack.pop();
    U.position.end = at(w.end);
  }
  function Ye(w) {
    L.call(this, w);
    const U = this.stack[this.stack.length - 1];
    U.url = this.sliceSerialize(w);
  }
  function je(w) {
    L.call(this, w);
    const U = this.stack[this.stack.length - 1];
    U.url = "mailto:" + this.sliceSerialize(w);
  }
  function kt() {
    return {type:"blockquote", children:[]};
  }
  function hn() {
    return {type:"code", lang:null, meta:null, value:""};
  }
  function js() {
    return {type:"inlineCode", value:""};
  }
  function qs() {
    return {type:"definition", identifier:"", label:null, title:null, url:""};
  }
  function Gs() {
    return {type:"emphasis", children:[]};
  }
  function ua() {
    return {type:"heading", depth:0, children:[]};
  }
  function sa() {
    return {type:"break"};
  }
  function oa() {
    return {type:"html", value:""};
  }
  function Ws() {
    return {type:"image", title:null, url:"", alt:null};
  }
  function la() {
    return {type:"link", title:null, url:"", children:[]};
  }
  function ca(w) {
    return {type:"list", ordered:w.type === "listOrdered", start:null, spread:w._spread, children:[]};
  }
  function Vs(w) {
    return {type:"listItem", spread:w._spread, checked:null, children:[]};
  }
  function Xs() {
    return {type:"paragraph", children:[]};
  }
  function Qs() {
    return {type:"strong", children:[]};
  }
  function Ks() {
    return {type:"text", value:""};
  }
  function Zs() {
    return {type:"thematicBreak"};
  }
}
function at(e) {
  return {line:e.line, column:e.column, offset:e.offset};
}
function Au(e, t) {
  let n = -1;
  for (; ++n < t.length;) {
    const r = t[n];
    Array.isArray(r) ? Au(e, r) : Sf(e, r);
  }
}
function Sf(e, t) {
  let n;
  for (n in t) {
    if (_u.call(t, n)) {
      switch(n) {
        case "canContainEols":
          {
            const r = t[n];
            r && e[n].push(...r);
            break;
          }
        case "transforms":
          {
            const r = t[n];
            r && e[n].push(...r);
            break;
          }
        case "enter":
        case "exit":
          {
            const r = t[n];
            r && Object.assign(e[n], r);
            break;
          }
      }
    }
  }
}
function va(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Wt({start:e.start, end:e.end}) + "): a different token (`" + t.type + "`, " + Wt({start:t.start, end:t.end}) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Wt({start:t.start, end:t.end}) + ") is still open");
}
function kf(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return Af(r, {...t.data("settings"), ...e, extensions:t.data("micromarkExtensions") || [], mdastExtensions:t.data("fromMarkdownExtensions") || []});
  }
}
function Cf(e, t) {
  const n = {type:"element", tagName:"blockquote", properties:{}, children:e.wrap(e.all(t), !0)};
  return e.patch(t, n), e.applyData(t, n);
}
function If(e, t) {
  const n = {type:"element", tagName:"br", properties:{}, children:[]};
  return e.patch(t, n), [e.applyData(t, n), {type:"text", value:`
`}];
}
function Nf(e, t) {
  const n = t.value ? t.value + `
` : "", r = {}, a = t.lang ? t.lang.split(/\s+/) : [];
  a.length > 0 && (r.className = ["language-" + a[0]]);
  let i = {type:"element", tagName:"code", properties:r, children:[{type:"text", value:n}]};
  return t.meta && (i.data = {meta:t.meta}), e.patch(t, i), i = e.applyData(t, i), i = {type:"element", tagName:"pre", properties:{}, children:[i]}, e.patch(t, i), i;
}
function Of(e, t) {
  const n = {type:"element", tagName:"del", properties:{}, children:e.all(t)};
  return e.patch(t, n), e.applyData(t, n);
}
function Lf(e, t) {
  const n = {type:"element", tagName:"em", properties:{}, children:e.all(t)};
  return e.patch(t, n), e.applyData(t, n);
}
function Rf(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), a = Mt(r.toLowerCase()), i = e.footnoteOrder.indexOf(r);
  let u, o = e.footnoteCounts.get(r);
  o === void 0 ? (o = 0, e.footnoteOrder.push(r), u = e.footnoteOrder.length) : u = i + 1, o += 1, e.footnoteCounts.set(r, o);
  const l = {type:"element", tagName:"a", properties:{href:"#" + n + "fn-" + a, id:n + "fnref-" + a + (o > 1 ? "-" + o : ""), dataFootnoteRef:!0, ariaDescribedBy:["footnote-label"]}, children:[{type:"text", value:String(u)}]};
  e.patch(t, l);
  const c = {type:"element", tagName:"sup", properties:{}, children:[l]};
  return e.patch(t, c), e.applyData(t, c);
}
function wf(e, t) {
  const n = {type:"element", tagName:"h" + t.depth, properties:{}, children:e.all(t)};
  return e.patch(t, n), e.applyData(t, n);
}
function Df(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = {type:"raw", value:t.value};
    return e.patch(t, n), e.applyData(t, n);
  }
}
function xu(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference") {
    return [{type:"text", value:"![" + t.alt + r}];
  }
  const a = e.all(t), i = a[0];
  i && i.type === "text" ? i.value = "[" + i.value : a.unshift({type:"text", value:"["});
  const u = a[a.length - 1];
  return u && u.type === "text" ? u.value += r : a.push({type:"text", value:r}), a;
}
function Pf(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r) {
    return xu(e, t);
  }
  const a = {src:Mt(r.url || ""), alt:t.alt};
  r.title !== null && r.title !== void 0 && (a.title = r.title);
  const i = {type:"element", tagName:"img", properties:a, children:[]};
  return e.patch(t, i), e.applyData(t, i);
}
function Ff(e, t) {
  const n = {src:Mt(t.url)};
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {type:"element", tagName:"img", properties:n, children:[]};
  return e.patch(t, r), e.applyData(t, r);
}
function Mf(e, t) {
  const n = {type:"text", value:t.value.replace(/\r?\n|\r/g, " ")};
  e.patch(t, n);
  const r = {type:"element", tagName:"code", properties:{}, children:[n]};
  return e.patch(t, r), e.applyData(t, r);
}
function Bf(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r) {
    return xu(e, t);
  }
  const a = {href:Mt(r.url || "")};
  r.title !== null && r.title !== void 0 && (a.title = r.title);
  const i = {type:"element", tagName:"a", properties:a, children:e.all(t)};
  return e.patch(t, i), e.applyData(t, i);
}
function vf(e, t) {
  const n = {href:Mt(t.url)};
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {type:"element", tagName:"a", properties:n, children:e.all(t)};
  return e.patch(t, r), e.applyData(t, r);
}
function Uf(e, t, n) {
  const r = e.all(t), a = n ? Hf(n) : Su(t), i = {}, u = [];
  if (typeof t.checked == "boolean") {
    const f = r[0];
    let d;
    f && f.type === "element" && f.tagName === "p" ? d = f : (d = {type:"element", tagName:"p", properties:{}, children:[]}, r.unshift(d)), d.children.length > 0 && d.children.unshift({type:"text", value:" "}), d.children.unshift({type:"element", tagName:"input", properties:{type:"checkbox", checked:t.checked, disabled:!0}, children:[]}), i.className = ["task-list-item"];
  }
  let o = -1;
  for (; ++o < r.length;) {
    const f = r[o];
    (a || o !== 0 || f.type !== "element" || f.tagName !== "p") && u.push({type:"text", value:`
`}), f.type === "element" && f.tagName === "p" && !a ? u.push(...f.children) : u.push(f);
  }
  const l = r[r.length - 1];
  l && (a || l.type !== "element" || l.tagName !== "p") && u.push({type:"text", value:`
`});
  const c = {type:"element", tagName:"li", properties:i, children:u};
  return e.patch(t, c), e.applyData(t, c);
}
function Hf(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length;) {
      t = Su(n[r]);
    }
  }
  return t;
}
function Su(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function zf(e, t) {
  const n = {}, r = e.all(t);
  let a = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++a < r.length;) {
    const u = r[a];
    if (u.type === "element" && u.tagName === "li" && u.properties && Array.isArray(u.properties.className) && u.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {type:"element", tagName:t.ordered ? "ol" : "ul", properties:n, children:e.wrap(r, !0)};
  return e.patch(t, i), e.applyData(t, i);
}
function $f(e, t) {
  const n = {type:"element", tagName:"p", properties:{}, children:e.all(t)};
  return e.patch(t, n), e.applyData(t, n);
}
function Yf(e, t) {
  const n = {type:"root", children:e.wrap(e.all(t))};
  return e.patch(t, n), e.applyData(t, n);
}
function jf(e, t) {
  const n = {type:"element", tagName:"strong", properties:{}, children:e.all(t)};
  return e.patch(t, n), e.applyData(t, n);
}
function qf(e, t) {
  const n = e.all(t), r = n.shift(), a = [];
  if (r) {
    const u = {type:"element", tagName:"thead", properties:{}, children:e.wrap([r], !0)};
    e.patch(t.children[0], u), a.push(u);
  }
  if (n.length > 0) {
    const u = {type:"element", tagName:"tbody", properties:{}, children:e.wrap(n, !0)}, o = Qe(t.children[1]), l = Mn(t.children[t.children.length - 1]);
    o && l && (u.position = {start:o, end:l}), a.push(u);
  }
  const i = {type:"element", tagName:"table", properties:{}, children:e.wrap(a, !0)};
  return e.patch(t, i), e.applyData(t, i);
}
function Gf(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", u = n && n.type === "table" ? n.align : void 0, o = u ? u.length : t.children.length;
  let l = -1;
  const c = [];
  for (; ++l < o;) {
    const d = t.children[l], m = {}, p = u ? u[l] : void 0;
    p && (m.align = p);
    let g = {type:"element", tagName:i, properties:m, children:[]};
    d && (g.children = e.all(d), e.patch(d, g), g = e.applyData(d, g)), c.push(g);
  }
  const f = {type:"element", tagName:"tr", properties:{}, children:e.wrap(c, !0)};
  return e.patch(t, f), e.applyData(t, f);
}
function Wf(e, t) {
  const n = {type:"element", tagName:"td", properties:{}, children:e.all(t)};
  return e.patch(t, n), e.applyData(t, n);
}
const Ua = 9, Ha = 32;
function Vf(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), a = 0;
  const i = [];
  for (; r;) {
    i.push(za(t.slice(a, r.index), a > 0, !0), r[0]), a = r.index + r[0].length, r = n.exec(t);
  }
  return i.push(za(t.slice(a), a > 0, !1)), i.join("");
}
function za(e, t, n) {
  let r = 0, a = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === Ua || i === Ha;) {
      r++, i = e.codePointAt(r);
    }
  }
  if (n) {
    let i = e.codePointAt(a - 1);
    for (; i === Ua || i === Ha;) {
      a--, i = e.codePointAt(a - 1);
    }
  }
  return a > r ? e.slice(r, a) : "";
}
function Xf(e, t) {
  const n = {type:"text", value:Vf(String(t.value))};
  return e.patch(t, n), e.applyData(t, n);
}
function Qf(e, t) {
  const n = {type:"element", tagName:"hr", properties:{}, children:[]};
  return e.patch(t, n), e.applyData(t, n);
}
const Kf = {blockquote:Cf, break:If, code:Nf, delete:Of, emphasis:Lf, footnoteReference:Rf, heading:wf, html:Df, imageReference:Pf, image:Ff, inlineCode:Mf, linkReference:Bf, link:vf, listItem:Uf, list:zf, paragraph:$f, root:Yf, strong:jf, table:qf, tableCell:Wf, tableRow:Gf, text:Xf, thematicBreak:Qf, toml:mn, yaml:mn, definition:mn, footnoteDefinition:mn};
function mn() {
}
const ku = -1, Un = 0, Xt = 1, Nn = 2, jr = 3, qr = 4, Gr = 5, Wr = 6, Cu = 7, Iu = 8, Zf = typeof self == "object" ? self : globalThis, $a = (e, t) => {
  switch(e) {
    case "Function":
    case "SharedWorker":
    case "Worker":
    case "eval":
    case "setInterval":
    case "setTimeout":
      throw new TypeError("unable to deserialize " + e);
  }
  return new Zf[e](t);
}, Jf = (e, t) => {
  const n = (a, i) => (e.set(i, a), a), r = a => {
    if (e.has(a)) {
      return e.get(a);
    }
    const [i, u] = t[a];
    switch(i) {
      case Un:
      case ku:
        return n(u, a);
      case Xt:
        {
          const o = n([], a);
          for (const l of u) {
            o.push(r(l));
          }
          return o;
        }
      case Nn:
        {
          const o = n({}, a);
          for (const [l, c] of u) {
            o[r(l)] = r(c);
          }
          return o;
        }
      case jr:
        return n(new Date(u), a);
      case qr:
        {
          const {source:o, flags:l} = u;
          return n(new RegExp(o, l), a);
        }
      case Gr:
        {
          const o = n(new Map(), a);
          for (const [l, c] of u) {
            o.set(r(l), r(c));
          }
          return o;
        }
      case Wr:
        {
          const o = n(new Set(), a);
          for (const l of u) {
            o.add(r(l));
          }
          return o;
        }
      case Cu:
        {
          const {name:o, message:l} = u;
          return n($a(o, l), a);
        }
      case Iu:
        return n(BigInt(u), a);
      case "BigInt":
        return n(Object(BigInt(u)), a);
      case "ArrayBuffer":
        return n((new Uint8Array(u)).buffer, u);
      case "DataView":
        {
          const {buffer:o} = new Uint8Array(u);
          return n(new DataView(o), u);
        }
    }
    return n($a(i, u), a);
  };
  return r;
}, Ya = e => Jf(new Map(), e)(0), It = "", {toString:e0} = {}, {keys:t0} = Object, Yt = e => {
  const t = typeof e;
  if (t !== "object" || !e) {
    return [Un, t];
  }
  const n = e0.call(e).slice(8, -1);
  switch(n) {
    case "Array":
      return [Xt, It];
    case "Object":
      return [Nn, It];
    case "Date":
      return [jr, It];
    case "RegExp":
      return [qr, It];
    case "Map":
      return [Gr, It];
    case "Set":
      return [Wr, It];
    case "DataView":
      return [Xt, n];
  }
  return n.includes("Array") ? [Xt, n] : n.includes("Error") ? [Cu, n] : [Nn, n];
}, gn = ([e, t]) => e === Un && (t === "function" || t === "symbol"), n0 = (e, t, n, r) => {
  const a = (u, o) => {
    const l = r.push(u) - 1;
    return n.set(o, l), l;
  }, i = u => {
    if (n.has(u)) {
      return n.get(u);
    }
    let [o, l] = Yt(u);
    switch(o) {
      case Un:
        {
          let f = u;
          switch(l) {
            case "bigint":
              o = Iu, f = u.toString();
              break;
            case "function":
            case "symbol":
              if (e) {
                throw new TypeError("unable to serialize " + l);
              }
              f = null;
              break;
            case "undefined":
              return a([ku], u);
          }
          return a([o, f], u);
        }
      case Xt:
        {
          if (l) {
            let m = u;
            return l === "DataView" ? m = new Uint8Array(u.buffer) : l === "ArrayBuffer" && (m = new Uint8Array(u)), a([l, [...m]], u);
          }
          const f = [], d = a([o, f], u);
          for (const m of u) {
            f.push(i(m));
          }
          return d;
        }
      case Nn:
        {
          if (l) {
            switch(l) {
              case "BigInt":
                return a([l, u.toString()], u);
              case "Boolean":
              case "Number":
              case "String":
                return a([l, u.valueOf()], u);
            }
          }
          if (t && "toJSON" in u) {
            return i(u.toJSON());
          }
          const f = [], d = a([o, f], u);
          for (const m of t0(u)) {
            (e || !gn(Yt(u[m]))) && f.push([i(m), i(u[m])]);
          }
          return d;
        }
      case jr:
        return a([o, u.toISOString()], u);
      case qr:
        {
          const {source:f, flags:d} = u;
          return a([o, {source:f, flags:d}], u);
        }
      case Gr:
        {
          const f = [], d = a([o, f], u);
          for (const [m, p] of u) {
            (e || !(gn(Yt(m)) || gn(Yt(p)))) && f.push([i(m), i(p)]);
          }
          return d;
        }
      case Wr:
        {
          const f = [], d = a([o, f], u);
          for (const m of u) {
            (e || !gn(Yt(m))) && f.push(i(m));
          }
          return d;
        }
    }
    const {message:c} = u;
    return a([o, {name:l, message:c}], u);
  };
  return i;
}, ja = (e, {json:t, lossy:n} = {}) => {
  const r = [];
  return n0(!(t || n), !!t, new Map(), r)(e), r;
}, wt = typeof structuredClone == "function" ? (e, t) => t && ("json" in t || "lossy" in t) ? Ya(ja(e, t)) : structuredClone(e) : (e, t) => Ya(ja(e, t));
function r0(e, t) {
  const n = [{type:"text", value:"\u21a9"}];
  return t > 1 && n.push({type:"element", tagName:"sup", properties:{}, children:[{type:"text", value:String(t)}]}), n;
}
function a0(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function i0(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || r0, r = e.options.footnoteBackLabel || a0, a = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", u = e.options.footnoteLabelProperties || {className:["sr-only"]}, o = [];
  let l = -1;
  for (; ++l < e.footnoteOrder.length;) {
    const c = e.footnoteById.get(e.footnoteOrder[l]);
    if (!c) {
      continue;
    }
    const f = e.all(c), d = String(c.identifier).toUpperCase(), m = Mt(d.toLowerCase());
    let p = 0;
    const g = [], T = e.footnoteCounts.get(d);
    for (; T !== void 0 && ++p <= T;) {
      g.length > 0 && g.push({type:"text", value:" "});
      let C = typeof n == "string" ? n : n(l, p);
      typeof C == "string" && (C = {type:"text", value:C}), g.push({type:"element", tagName:"a", properties:{href:"#" + t + "fnref-" + m + (p > 1 ? "-" + p : ""), dataFootnoteBackref:"", ariaLabel:typeof r == "string" ? r : r(l, p), className:["data-footnote-backref"]}, children:Array.isArray(C) ? C : [C]});
    }
    const A = f[f.length - 1];
    if (A && A.type === "element" && A.tagName === "p") {
      const C = A.children[A.children.length - 1];
      C && C.type === "text" ? C.value += " " : A.children.push({type:"text", value:" "}), A.children.push(...g);
    } else {
      f.push(...g);
    }
    const y = {type:"element", tagName:"li", properties:{id:t + "fn-" + m}, children:e.wrap(f, !0)};
    e.patch(c, y), o.push(y);
  }
  if (o.length !== 0) {
    return {type:"element", tagName:"section", properties:{dataFootnotes:!0, className:["footnotes"]}, children:[{type:"element", tagName:i, properties:{...wt(u), id:"footnote-label"}, children:[{type:"text", value:a}]}, {type:"text", value:`
`}, {type:"element", tagName:"ol", properties:{}, children:e.wrap(o, !0)}, {type:"text", value:`
`}]};
  }
}
const Hn = function(e) {
  if (e == null) {
    return l0;
  }
  if (typeof e == "function") {
    return zn(e);
  }
  if (typeof e == "object") {
    return Array.isArray(e) ? u0(e) : s0(e);
  }
  if (typeof e == "string") {
    return o0(e);
  }
  throw new Error("Expected function, string, or object as test");
};
function u0(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length;) {
    t[n] = Hn(e[n]);
  }
  return zn(r);
  function r(...a) {
    let i = -1;
    for (; ++i < t.length;) {
      if (t[i].apply(this, a)) {
        return !0;
      }
    }
    return !1;
  }
}
function s0(e) {
  const t = e;
  return zn(n);
  function n(r) {
    const a = r;
    let i;
    for (i in e) {
      if (a[i] !== t[i]) {
        return !1;
      }
    }
    return !0;
  }
}
function o0(e) {
  return zn(t);
  function t(n) {
    return n && n.type === e;
  }
}
function zn(e) {
  return t;
  function t(n, r, a) {
    return !!(c0(n) && e.call(this, n, typeof r == "number" ? r : void 0, a || void 0));
  }
}
function l0() {
  return !0;
}
function c0(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Nu = [], d0 = !0, Sr = !1, f0 = "skip";
function Ou(e, t, n, r) {
  let a;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : a = t;
  const i = Hn(a), u = r ? -1 : 1;
  o(e, void 0, [])();
  function o(l, c, f) {
    const d = l && typeof l == "object" ? l : {};
    if (typeof d.type == "string") {
      const p = typeof d.tagName == "string" ? d.tagName : typeof d.name == "string" ? d.name : void 0;
      Object.defineProperty(m, "name", {value:"node (" + (l.type + (p ? "\x3c" + p + "\x3e" : "")) + ")"});
    }
    return m;
    function m() {
      let p = Nu, g, T, A;
      if ((!t || i(l, c, f[f.length - 1] || void 0)) && (p = h0(n(l, f)), p[0] === Sr)) {
        return p;
      }
      if ("children" in l && l.children) {
        const y = l;
        if (y.children && p[0] !== f0) {
          for (T = (r ? y.children.length : -1) + u, A = f.concat(y); T > -1 && T < y.children.length;) {
            const C = y.children[T];
            if (g = o(C, T, A)(), g[0] === Sr) {
              return g;
            }
            T = typeof g[1] == "number" ? g[1] : T + u;
          }
        }
      }
      return p;
    }
  }
}
function h0(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [d0, e] : e == null ? Nu : [e];
}
function $n(e, t, n, r) {
  let a, i, u;
  typeof t == "function" && typeof n != "function" ? (i = void 0, u = t, a = n) : (i = t, u = n, a = r), Ou(e, i, o, a);
  function o(l, c) {
    const f = c[c.length - 1], d = f ? f.children.indexOf(l) : void 0;
    return u(l, d, f);
  }
}
const kr = {}.hasOwnProperty, p0 = {};
function m0(e, t) {
  const n = t || p0, r = new Map(), a = new Map(), i = new Map(), u = {...Kf, ...n.handlers}, o = {all:c, applyData:b0, definitionById:r, footnoteById:a, footnoteCounts:i, footnoteOrder:[], handlers:u, one:l, options:n, patch:g0, wrap:T0};
  return $n(e, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const d = f.type === "definition" ? r : a, m = String(f.identifier).toUpperCase();
      d.has(m) || d.set(m, f);
    }
  }), o;
  function l(f, d) {
    const m = f.type, p = o.handlers[m];
    if (kr.call(o.handlers, m) && p) {
      return p(o, f, d);
    }
    if (o.options.passThrough && o.options.passThrough.includes(m)) {
      if ("children" in f) {
        const {children:T, ...A} = f, y = wt(A);
        return y.children = o.all(f), y;
      }
      return wt(f);
    }
    return (o.options.unknownHandler || E0)(o, f, d);
  }
  function c(f) {
    const d = [];
    if ("children" in f) {
      const m = f.children;
      let p = -1;
      for (; ++p < m.length;) {
        const g = o.one(m[p], f);
        if (g) {
          if (p && m[p - 1].type === "break" && (!Array.isArray(g) && g.type === "text" && (g.value = qa(g.value)), !Array.isArray(g) && g.type === "element")) {
            const T = g.children[0];
            T && T.type === "text" && (T.value = qa(T.value));
          }
          Array.isArray(g) ? d.push(...g) : d.push(g);
        }
      }
    }
    return d;
  }
}
function g0(e, t) {
  e.position && (t.position = nc(e));
}
function b0(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, a = e.data.hChildren, i = e.data.hProperties;
    if (typeof r == "string") {
      if (n.type === "element") {
        n.tagName = r;
      } else {
        const u = "children" in n ? n.children : [n];
        n = {type:"element", tagName:r, properties:{}, children:u};
      }
    }
    n.type === "element" && i && Object.assign(n.properties, wt(i)), "children" in n && n.children && a !== null && a !== void 0 && (n.children = a);
  }
  return n;
}
function E0(e, t) {
  const n = t.data || {}, r = "value" in t && !(kr.call(n, "hProperties") || kr.call(n, "hChildren")) ? {type:"text", value:t.value} : {type:"element", tagName:"div", properties:{}, children:e.all(t)};
  return e.patch(t, r), e.applyData(t, r);
}
function T0(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({type:"text", value:`
`}); ++r < e.length;) {
    r && n.push({type:"text", value:`
`}), n.push(e[r]);
  }
  return t && e.length > 0 && n.push({type:"text", value:`
`}), n;
}
function qa(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32;) {
    t++, n = e.charCodeAt(t);
  }
  return e.slice(t);
}
function Ga(e, t) {
  const n = m0(e, t), r = n.one(e, void 0), a = i0(n), i = Array.isArray(r) ? {type:"root", children:r} : r || {type:"root", children:[]};
  return a && i.children.push({type:"text", value:`
`}, a), i;
}
function y0(e, t) {
  return e && "run" in e ? async function(n, r) {
    const a = Ga(n, {file:r, ...t});
    await e.run(a, r);
  } : function(n, r) {
    return Ga(n, {file:r, ...(e || t)});
  };
}
function Wa(e) {
  if (e) {
    throw e;
  }
}
var xn = Object.prototype.hasOwnProperty, Lu = Object.prototype.toString, Va = Object.defineProperty, Xa = Object.getOwnPropertyDescriptor, Qa = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Lu.call(t) === "[object Array]";
}, Ka = function(t) {
  if (!t || Lu.call(t) !== "[object Object]") {
    return !1;
  }
  var n = xn.call(t, "constructor"), r = t.constructor && t.constructor.prototype && xn.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r) {
    return !1;
  }
  var a;
  for (a in t) {
  }
  return typeof a > "u" || xn.call(t, a);
}, Za = function(t, n) {
  Va && n.name === "__proto__" ? Va(t, n.name, {enumerable:!0, configurable:!0, value:n.newValue, writable:!0}) : t[n.name] = n.newValue;
}, Ja = function(t, n) {
  if (n === "__proto__") {
    if (xn.call(t, n)) {
      if (Xa) {
        return Xa(t, n).value;
      }
    } else {
      return;
    }
  }
  return t[n];
}, _0 = function e() {
  var t, n, r, a, i, u, o = arguments[0], l = 1, c = arguments.length, f = !1;
  for (typeof o == "boolean" && (f = o, o = arguments[1] || {}, l = 2), (o == null || typeof o != "object" && typeof o != "function") && (o = {}); l < c; ++l) {
    if (t = arguments[l], t != null) {
      for (n in t) {
        r = Ja(o, n), a = Ja(t, n), o !== a && (f && a && (Ka(a) || (i = Qa(a))) ? (i ? (i = !1, u = r && Qa(r) ? r : []) : u = r && Ka(r) ? r : {}, Za(o, {name:n, newValue:e(f, u, a)})) : typeof a < "u" && Za(o, {name:n, newValue:a}));
      }
    }
  }
  return o;
};
const tr = ru(_0);
function Cr(e) {
  if (typeof e != "object" || e === null) {
    return !1;
  }
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function A0() {
  const e = [], t = {run:n, use:r};
  return t;
  function n(...a) {
    let i = -1;
    const u = a.pop();
    if (typeof u != "function") {
      throw new TypeError("Expected function as last argument, not " + u);
    }
    o(null, ...a);
    function o(l, ...c) {
      const f = e[++i];
      let d = -1;
      if (l) {
        u(l);
        return;
      }
      for (; ++d < a.length;) {
        (c[d] === null || c[d] === void 0) && (c[d] = a[d]);
      }
      a = c, f ? x0(f, o)(...c) : u(null, ...c);
    }
  }
  function r(a) {
    if (typeof a != "function") {
      throw new TypeError("Expected `middelware` to be a function, not " + a);
    }
    return e.push(a), t;
  }
}
function x0(e, t) {
  let n;
  return r;
  function r(...u) {
    const o = e.length > u.length;
    let l;
    o && u.push(a);
    try {
      l = e.apply(this, u);
    } catch (c) {
      const f = c;
      if (o && n) {
        throw f;
      }
      return a(f);
    }
    o || (l && l.then && typeof l.then == "function" ? l.then(i, a) : l instanceof Error ? a(l) : i(l));
  }
  function a(u, ...o) {
    n || (n = !0, t(u, ...o));
  }
  function i(u) {
    a(null, u);
  }
}
const qe = {basename:S0, dirname:k0, extname:C0, join:I0, sep:"/"};
function S0(e, t) {
  if (t !== void 0 && typeof t != "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  cn(e);
  let n = 0, r = -1, a = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; a--;) {
      if (e.codePointAt(a) === 47) {
        if (i) {
          n = a + 1;
          break;
        }
      } else {
        r < 0 && (i = !0, r = a + 1);
      }
    }
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e) {
    return "";
  }
  let u = -1, o = t.length - 1;
  for (; a--;) {
    if (e.codePointAt(a) === 47) {
      if (i) {
        n = a + 1;
        break;
      }
    } else {
      u < 0 && (i = !0, u = a + 1), o > -1 && (e.codePointAt(a) === t.codePointAt(o--) ? o < 0 && (r = a) : (o = -1, r = u));
    }
  }
  return n === r ? r = u : r < 0 && (r = e.length), e.slice(n, r);
}
function k0(e) {
  if (cn(e), e.length === 0) {
    return ".";
  }
  let t = -1, n = e.length, r;
  for (; --n;) {
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else {
      r || (r = !0);
    }
  }
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function C0(e) {
  cn(e);
  let t = e.length, n = -1, r = 0, a = -1, i = 0, u;
  for (; t--;) {
    const o = e.codePointAt(t);
    if (o === 47) {
      if (u) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (u = !0, n = t + 1), o === 46 ? a < 0 ? a = t : i !== 1 && (i = 1) : a > -1 && (i = -1);
  }
  return a < 0 || n < 0 || i === 0 || i === 1 && a === n - 1 && a === r + 1 ? "" : e.slice(a, n);
}
function I0(...e) {
  let t = -1, n;
  for (; ++t < e.length;) {
    cn(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  }
  return n === void 0 ? "." : N0(n);
}
function N0(e) {
  cn(e);
  const t = e.codePointAt(0) === 47;
  let n = O0(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function O0(e, t) {
  let n = "", r = 0, a = -1, i = 0, u = -1, o, l;
  for (; ++u <= e.length;) {
    if (u < e.length) {
      o = e.codePointAt(u);
    } else {
      if (o === 47) {
        break;
      }
      o = 47;
    }
    if (o === 47) {
      if (!(a === u - 1 || i === 1)) {
        if (a !== u - 1 && i === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), a = u, i = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, a = u, i = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else {
          n.length > 0 ? n += "/" + e.slice(a + 1, u) : n = e.slice(a + 1, u), r = u - a - 1;
        }
      }
      a = u, i = 0;
    } else {
      o === 46 && i > -1 ? i++ : i = -1;
    }
  }
  return n;
}
function cn(e) {
  if (typeof e != "string") {
    throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
  }
}
const L0 = {cwd:R0};
function R0() {
  return "/";
}
function Ir(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && e.auth === void 0);
}
function w0(e) {
  if (typeof e == "string") {
    e = new URL(e);
  } else if (!Ir(e)) {
    const t = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + e + "`");
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return D0(e);
}
function D0(e) {
  if (e.hostname !== "") {
    const r = new TypeError('File URL host must be "localhost" or empty on darwin');
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length;) {
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const a = new TypeError("File URL path must not include encoded / characters");
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  }
  return decodeURIComponent(t);
}
const nr = ["history", "path", "basename", "stem", "extname", "dirname"];
class Ru {
  constructor(t) {
    let n;
    t ? Ir(t) ? n = {path:t} : typeof t == "string" || P0(t) ? n = {value:t} : n = t : n = {}, this.cwd = "cwd" in n ? "" : L0.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < nr.length;) {
      const i = nr[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let a;
    for (a in n) {
      nr.includes(a) || (this[a] = n[a]);
    }
  }
  get basename() {
    return typeof this.path == "string" ? qe.basename(this.path) : void 0;
  }
  set basename(t) {
    ar(t, "basename"), rr(t, "basename"), this.path = qe.join(this.dirname || "", t);
  }
  get dirname() {
    return typeof this.path == "string" ? qe.dirname(this.path) : void 0;
  }
  set dirname(t) {
    ei(this.basename, "dirname"), this.path = qe.join(t || "", this.basename);
  }
  get extname() {
    return typeof this.path == "string" ? qe.extname(this.path) : void 0;
  }
  set extname(t) {
    if (rr(t, "extname"), ei(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (t.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = qe.join(this.dirname, this.stem + (t || ""));
  }
  get path() {
    return this.history[this.history.length - 1];
  }
  set path(t) {
    Ir(t) && (t = w0(t)), ar(t, "path"), this.path !== t && this.history.push(t);
  }
  get stem() {
    return typeof this.path == "string" ? qe.basename(this.path, this.extname) : void 0;
  }
  set stem(t) {
    ar(t, "stem"), rr(t, "stem"), this.path = qe.join(this.dirname || "", t + (this.extname || ""));
  }
  fail(t, n, r) {
    const a = this.message(t, n, r);
    throw a.fatal = !0, a;
  }
  info(t, n, r) {
    const a = this.message(t, n, r);
    return a.fatal = void 0, a;
  }
  message(t, n, r) {
    const a = new xe(t, n, r);
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : (new TextDecoder(t || void 0)).decode(this.value);
  }
}
function rr(e, t) {
  if (e && e.includes(qe.sep)) {
    throw new Error("`" + t + "` cannot be a path: did not expect `" + qe.sep + "`");
  }
}
function ar(e, t) {
  if (!e) {
    throw new Error("`" + t + "` cannot be empty");
  }
}
function ei(e, t) {
  if (!e) {
    throw new Error("Setting `" + t + "` requires `path` to be set too");
  }
}
function P0(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const F0 = function(e) {
  const r = this.constructor.prototype, a = r[e], i = function() {
    return a.apply(i, arguments);
  };
  return Object.setPrototypeOf(i, r), i;
}, M0 = {}.hasOwnProperty;
class Vr extends F0 {
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = A0();
  }
  copy() {
    const t = new Vr();
    let n = -1;
    for (; ++n < this.attachers.length;) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(tr(!0, {}, this.namespace)), t;
  }
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (sr("data", this.frozen), this.namespace[t] = n, this) : M0.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (sr("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  freeze() {
    if (this.frozen) {
      return this;
    }
    const t = this;
    for (; ++this.freezeIndex < this.attachers.length;) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1) {
        continue;
      }
      r[0] === !0 && (r[0] = void 0);
      const a = n.call(t, ...r);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  parse(t) {
    this.freeze();
    const n = bn(t), r = this.parser || this.Parser;
    return ir("parse", r), r(String(n), n);
  }
  process(t, n) {
    const r = this;
    return this.freeze(), ir("process", this.parser || this.Parser), ur("process", this.compiler || this.Compiler), n ? a(void 0, n) : new Promise(a);
    function a(i, u) {
      const o = bn(t), l = r.parse(o);
      r.run(l, o, function(f, d, m) {
        if (f || !d || !m) {
          return c(f);
        }
        const p = d, g = r.stringify(p, m);
        U0(g) ? m.value = g : m.result = g, c(f, m);
      });
      function c(f, d) {
        f || !d ? u(f) : i ? i(d) : n(void 0, d);
      }
    }
  }
  processSync(t) {
    let n = !1, r;
    return this.freeze(), ir("processSync", this.parser || this.Parser), ur("processSync", this.compiler || this.Compiler), this.process(t, a), ni("processSync", "process", n), r;
    function a(i, u) {
      n = !0, Wa(i), r = u;
    }
  }
  run(t, n, r) {
    ti(t), this.freeze();
    const a = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(u, o) {
      const l = bn(n);
      a.run(t, l, c);
      function c(f, d, m) {
        const p = d || t;
        f ? o(f) : u ? u(p) : r(void 0, p, m);
      }
    }
  }
  runSync(t, n) {
    let r = !1, a;
    return this.run(t, n, i), ni("runSync", "run", r), a;
    function i(u, o) {
      Wa(u), a = o, r = !0;
    }
  }
  stringify(t, n) {
    this.freeze();
    const r = bn(n), a = this.compiler || this.Compiler;
    return ur("stringify", a), ti(t), a(t, r);
  }
  use(t, ...n) {
    const r = this.attachers, a = this.namespace;
    if (sr("use", this.frozen), t != null) {
      if (typeof t == "function") {
        l(t, n);
      } else if (typeof t == "object") {
        Array.isArray(t) ? o(t) : u(t);
      } else {
        throw new TypeError("Expected usable value, not `" + t + "`");
      }
    }
    return this;
    function i(c) {
      if (typeof c == "function") {
        l(c, []);
      } else if (typeof c == "object") {
        if (Array.isArray(c)) {
          const [f, ...d] = c;
          l(f, d);
        } else {
          u(c);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + c + "`");
      }
    }
    function u(c) {
      if (!("plugins" in c) && !("settings" in c)) {
        throw new Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
      }
      o(c.plugins), c.settings && (a.settings = tr(!0, a.settings, c.settings));
    }
    function o(c) {
      let f = -1;
      if (c != null) {
        if (Array.isArray(c)) {
          for (; ++f < c.length;) {
            const d = c[f];
            i(d);
          }
        } else {
          throw new TypeError("Expected a list of plugins, not `" + c + "`");
        }
      }
    }
    function l(c, f) {
      let d = -1, m = -1;
      for (; ++d < r.length;) {
        if (r[d][0] === c) {
          m = d;
          break;
        }
      }
      if (m === -1) {
        r.push([c, ...f]);
      } else if (f.length > 0) {
        let [p, ...g] = f;
        const T = r[m][1];
        Cr(T) && Cr(p) && (p = tr(!0, T, p)), r[m] = [c, p, ...g];
      }
    }
  }
}
const B0 = (new Vr()).freeze();
function ir(e, t) {
  if (typeof t != "function") {
    throw new TypeError("Cannot `" + e + "` without `parser`");
  }
}
function ur(e, t) {
  if (typeof t != "function") {
    throw new TypeError("Cannot `" + e + "` without `compiler`");
  }
}
function sr(e, t) {
  if (t) {
    throw new Error("Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
  }
}
function ti(e) {
  if (!Cr(e) || typeof e.type != "string") {
    throw new TypeError("Expected node, got `" + e + "`");
  }
}
function ni(e, t, n) {
  if (!n) {
    throw new Error("`" + e + "` finished async. Use `" + t + "` instead");
  }
}
function bn(e) {
  return v0(e) ? e : new Ru(e);
}
function v0(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function U0(e) {
  return typeof e == "string" || H0(e);
}
function H0(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const z0 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", ri = [], ai = {allowDangerousHtml:!0}, $0 = /^(https?|ircs?|mailto|xmpp)$/i, Y0 = [{from:"astPlugins", id:"remove-buggy-html-in-markdown-parser"}, {from:"allowDangerousHtml", id:"remove-buggy-html-in-markdown-parser"}, {from:"allowNode", id:"replace-allownode-allowedtypes-and-disallowedtypes", to:"allowElement"}, {from:"allowedTypes", id:"replace-allownode-allowedtypes-and-disallowedtypes", to:"allowedElements"}, {from:"className", 
id:"remove-classname"}, {from:"disallowedTypes", id:"replace-allownode-allowedtypes-and-disallowedtypes", to:"disallowedElements"}, {from:"escapeHtml", id:"remove-buggy-html-in-markdown-parser"}, {from:"includeElementIndex", id:"#remove-includeelementindex"}, {from:"includeNodeIndex", id:"change-includenodeindex-to-includeelementindex"}, {from:"linkTarget", id:"remove-linktarget"}, {from:"plugins", id:"change-plugins-to-remarkplugins", to:"remarkPlugins"}, {from:"rawSourcePos", id:"#remove-rawsourcepos"}, 
{from:"renderers", id:"change-renderers-to-components", to:"components"}, {from:"source", id:"change-source-to-children", to:"children"}, {from:"sourcePos", id:"#remove-sourcepos"}, {from:"transformImageUri", id:"#add-urltransform", to:"urlTransform"}, {from:"transformLinkUri", id:"#add-urltransform", to:"urlTransform"}];
function j0(e) {
  const t = q0(e), n = G0(e);
  return W0(t.runSync(t.parse(n), n), e);
}
function q0(e) {
  const t = e.rehypePlugins || ri, n = e.remarkPlugins || ri, r = e.remarkRehypeOptions ? {...e.remarkRehypeOptions, ...ai} : ai;
  return B0().use(kf).use(n).use(y0, r).use(t);
}
function G0(e) {
  const t = e.children || "", n = new Ru();
  return typeof t == "string" && (n.value = t), n;
}
function W0(e, t) {
  const n = t.allowedElements, r = t.allowElement, a = t.components, i = t.disallowedElements, u = t.skipHtml, o = t.unwrapDisallowed, l = t.urlTransform || V0;
  for (const f of Y0) {
    Object.hasOwn(t, f.from) && ("" + f.from + (f.to ? "use `" + f.to + "` instead" : "remove it") + z0 + f.id, void 0);
  }
  return $n(e, c), sc(e, {Fragment:require$react_SLASH_jsx_runtime.Fragment, components:a, ignoreInvalidStyle:!0, jsx:require$react_SLASH_jsx_runtime.jsx, jsxs:require$react_SLASH_jsx_runtime.jsxs, passKeys:!0, passNode:!0});
  function c(f, d, m) {
    if (f.type === "raw" && m && typeof d == "number") {
      return u ? m.children.splice(d, 1) : m.children[d] = {type:"text", value:f.value}, d;
    }
    if (f.type === "element") {
      let p;
      for (p in Zn) {
        if (Object.hasOwn(Zn, p) && Object.hasOwn(f.properties, p)) {
          const g = f.properties[p], T = Zn[p];
          (T === null || T.includes(f.tagName)) && (f.properties[p] = l(String(g || ""), p, f));
        }
      }
    }
    if (f.type === "element") {
      let p = n ? !n.includes(f.tagName) : i ? i.includes(f.tagName) : !1;
      if (!p && r && typeof d == "number" && (p = !r(f, d, m)), p && m && typeof d == "number") {
        return o && f.children ? m.children.splice(d, 1, ...f.children) : m.children.splice(d, 1), d;
      }
    }
  }
}
function V0(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), a = e.indexOf("/");
  return t === -1 || a !== -1 && t > a || n !== -1 && t > n || r !== -1 && t > r || $0.test(e.slice(0, t)) ? e : "";
}
function ii(e, t) {
  const n = String(e);
  if (typeof t != "string") {
    throw new TypeError("Expected character");
  }
  let r = 0, a = n.indexOf(t);
  for (; a !== -1;) {
    r++, a = n.indexOf(t, a + t.length);
  }
  return r;
}
function X0(e) {
  if (typeof e != "string") {
    throw new TypeError("Expected a string");
  }
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$\x26").replace(/-/g, "\\x2d");
}
function Q0(e, t, n) {
  const a = Hn((n || {}).ignore || []), i = K0(t);
  let u = -1;
  for (; ++u < i.length;) {
    Ou(e, "text", o);
  }
  function o(c, f) {
    let d = -1, m;
    for (; ++d < f.length;) {
      const p = f[d], g = m ? m.children : void 0;
      if (a(p, g ? g.indexOf(p) : void 0, m)) {
        return;
      }
      m = p;
    }
    if (m) {
      return l(c, f);
    }
  }
  function l(c, f) {
    const d = f[f.length - 1], m = i[u][0], p = i[u][1];
    let g = 0;
    const A = d.children.indexOf(c);
    let y = !1, C = [];
    m.lastIndex = 0;
    let N = m.exec(c.value);
    for (; N;) {
      const v = N.index, B = {index:N.index, input:N.input, stack:[...f, c]};
      let O = p(...N, B);
      if (typeof O == "string" && (O = O.length > 0 ? {type:"text", value:O} : void 0), O === !1 ? m.lastIndex = v + 1 : (g !== v && C.push({type:"text", value:c.value.slice(g, v)}), Array.isArray(O) ? C.push(...O) : O && C.push(O), g = v + N[0].length, y = !0), !m.global) {
        break;
      }
      N = m.exec(c.value);
    }
    return y ? (g < c.value.length && C.push({type:"text", value:c.value.slice(g)}), d.children.splice(A, 1, ...C)) : C = [c], A + C.length;
  }
}
function K0(e) {
  const t = [];
  if (!Array.isArray(e)) {
    throw new TypeError("Expected find and replace tuple or list of tuples");
  }
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length;) {
    const a = n[r];
    t.push([Z0(a[0]), J0(a[1])]);
  }
  return t;
}
function Z0(e) {
  return typeof e == "string" ? new RegExp(X0(e), "g") : e;
}
function J0(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const or = "phrasing", lr = ["autolink", "link", "image", "label"];
function eh() {
  return {transforms:[sh], enter:{literalAutolink:nh, literalAutolinkEmail:cr, literalAutolinkHttp:cr, literalAutolinkWww:cr}, exit:{literalAutolink:uh, literalAutolinkEmail:ih, literalAutolinkHttp:rh, literalAutolinkWww:ah}};
}
function th() {
  return {unsafe:[{character:"@", before:"[+\\-.\\w]", after:"[\\-.\\w]", inConstruct:or, notInConstruct:lr}, {character:".", before:"[Ww]", after:"[\\-.\\w]", inConstruct:or, notInConstruct:lr}, {character:":", before:"[ps]", after:"\\/", inConstruct:or, notInConstruct:lr}]};
}
function nh(e) {
  this.enter({type:"link", title:null, url:"", children:[]}, e);
}
function cr(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function rh(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function ah(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function ih(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function uh(e) {
  this.exit(e);
}
function sh(e) {
  Q0(e, [[/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, oh], [new RegExp("(?\x3c\x3d^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), lh]], {ignore:["link", "linkReference"]});
}
function oh(e, t, n, r, a) {
  let i = "";
  if (!wu(a) || (/^w/i.test(t) && (n = t + n, t = "", i = "http://"), !ch(n))) {
    return !1;
  }
  const u = dh(n + r);
  if (!u[0]) {
    return !1;
  }
  const o = {type:"link", title:null, url:i + t + u[0], children:[{type:"text", value:t + u[0]}]};
  return u[1] ? [o, {type:"text", value:u[1]}] : o;
}
function lh(e, t, n, r) {
  return !wu(r, !0) || /[-\d_]$/.test(n) ? !1 : {type:"link", title:null, url:"mailto:" + t + "@" + n, children:[{type:"text", value:t + "@" + n}]};
}
function ch(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function dh(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t) {
    return [e, void 0];
  }
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const a = ii(e, "(");
  let i = ii(e, ")");
  for (; r !== -1 && a > i;) {
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), i++;
  }
  return [e, n];
}
function wu(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || _t(n) || Bn(n)) && (!t || n !== 47);
}
Du.peek = yh;
function fh() {
  this.buffer();
}
function hh(e) {
  this.enter({type:"footnoteReference", identifier:"", label:""}, e);
}
function ph() {
  this.buffer();
}
function mh(e) {
  this.enter({type:"footnoteDefinition", identifier:"", label:"", children:[]}, e);
}
function gh(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = He(this.sliceSerialize(e)).toLowerCase(), n.label = t;
}
function bh(e) {
  this.exit(e);
}
function Eh(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = He(this.sliceSerialize(e)).toLowerCase(), n.label = t;
}
function Th(e) {
  this.exit(e);
}
function yh() {
  return "[";
}
function Du(e, t, n, r) {
  const a = n.createTracker(r);
  let i = a.move("[^");
  const u = n.enter("footnoteReference"), o = n.enter("reference");
  return i += a.move(n.safe(n.associationId(e), {after:"]", before:i})), o(), u(), i += a.move("]"), i;
}
function _h() {
  return {enter:{gfmFootnoteCallString:fh, gfmFootnoteCall:hh, gfmFootnoteDefinitionLabelString:ph, gfmFootnoteDefinition:mh}, exit:{gfmFootnoteCallString:gh, gfmFootnoteCall:bh, gfmFootnoteDefinitionLabelString:Eh, gfmFootnoteDefinition:Th}};
}
function Ah(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {handlers:{footnoteDefinition:n, footnoteReference:Du}, unsafe:[{character:"[", inConstruct:["label", "phrasing", "reference"]}]};
  function n(r, a, i, u) {
    const o = i.createTracker(u);
    let l = o.move("[^");
    const c = i.enter("footnoteDefinition"), f = i.enter("label");
    return l += o.move(i.safe(i.associationId(r), {before:l, after:"]"})), f(), l += o.move("]:"), r.children && r.children.length > 0 && (o.shift(4), l += o.move((t ? `
` : " ") + i.indentLines(i.containerFlow(r, o.current()), t ? Pu : xh))), c(), l;
  }
}
function xh(e, t, n) {
  return t === 0 ? e : Pu(e, t, n);
}
function Pu(e, t, n) {
  return (n ? "" : "    ") + e;
}
const Sh = ["autolink", "destinationLiteral", "destinationRaw", "reference", "titleQuote", "titleApostrophe"];
Fu.peek = Oh;
function kh() {
  return {canContainEols:["delete"], enter:{strikethrough:Ih}, exit:{strikethrough:Nh}};
}
function Ch() {
  return {unsafe:[{character:"~", inConstruct:"phrasing", notInConstruct:Sh}], handlers:{delete:Fu}};
}
function Ih(e) {
  this.enter({type:"delete", children:[]}, e);
}
function Nh(e) {
  this.exit(e);
}
function Fu(e, t, n, r) {
  const a = n.createTracker(r), i = n.enter("strikethrough");
  let u = a.move("~~");
  return u += n.containerPhrasing(e, {...a.current(), before:u, after:"~"}), u += a.move("~~"), i(), u;
}
function Oh() {
  return "~";
}
function Lh(e) {
  return e.length;
}
function Rh(e, t) {
  const n = t || {}, r = (n.align || []).concat(), a = n.stringLength || Lh, i = [], u = [], o = [], l = [];
  let c = 0, f = -1;
  for (; ++f < e.length;) {
    const T = [], A = [];
    let y = -1;
    for (e[f].length > c && (c = e[f].length); ++y < e[f].length;) {
      const C = wh(e[f][y]);
      if (n.alignDelimiters !== !1) {
        const N = a(C);
        A[y] = N, (l[y] === void 0 || N > l[y]) && (l[y] = N);
      }
      T.push(C);
    }
    u[f] = T, o[f] = A;
  }
  let d = -1;
  if (typeof r == "object" && "length" in r) {
    for (; ++d < c;) {
      i[d] = ui(r[d]);
    }
  } else {
    const T = ui(r);
    for (; ++d < c;) {
      i[d] = T;
    }
  }
  d = -1;
  const m = [], p = [];
  for (; ++d < c;) {
    const T = i[d];
    let A = "", y = "";
    T === 99 ? (A = ":", y = ":") : T === 108 ? A = ":" : T === 114 && (y = ":");
    let C = n.alignDelimiters === !1 ? 1 : Math.max(1, l[d] - A.length - y.length);
    const N = A + "-".repeat(C) + y;
    n.alignDelimiters !== !1 && (C = A.length + C + y.length, C > l[d] && (l[d] = C), p[d] = C), m[d] = N;
  }
  u.splice(1, 0, m), o.splice(1, 0, p), f = -1;
  const g = [];
  for (; ++f < u.length;) {
    const T = u[f], A = o[f];
    d = -1;
    const y = [];
    for (; ++d < c;) {
      const C = T[d] || "";
      let N = "", v = "";
      if (n.alignDelimiters !== !1) {
        const B = l[d] - (A[d] || 0), O = i[d];
        O === 114 ? N = " ".repeat(B) : O === 99 ? B % 2 ? (N = " ".repeat(B / 2 + 0.5), v = " ".repeat(B / 2 - 0.5)) : (N = " ".repeat(B / 2), v = N) : v = " ".repeat(B);
      }
      n.delimiterStart !== !1 && !d && y.push("|"), n.padding !== !1 && !(n.alignDelimiters === !1 && C === "") && (n.delimiterStart !== !1 || d) && y.push(" "), n.alignDelimiters !== !1 && y.push(N), y.push(C), n.alignDelimiters !== !1 && y.push(v), n.padding !== !1 && y.push(" "), (n.delimiterEnd !== !1 || d !== c - 1) && y.push("|");
    }
    g.push(n.delimiterEnd === !1 ? y.join("").replace(/ +$/, "") : y.join(""));
  }
  return g.join(`
`);
}
function wh(e) {
  return e == null ? "" : String(e);
}
function ui(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
const si = {}.hasOwnProperty;
function Mu(e, t) {
  const n = t || {};
  function r(a, ...i) {
    let u = r.invalid;
    const o = r.handlers;
    if (a && si.call(a, e)) {
      const l = String(a[e]);
      u = si.call(o, l) ? o[l] : r.unknown;
    }
    if (u) {
      return u.call(this, a, ...i);
    }
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
function Dh(e, t, n, r) {
  const a = n.enter("blockquote"), i = n.createTracker(r);
  i.move("\x3e "), i.shift(2);
  const u = n.indentLines(n.containerFlow(e, i.current()), Ph);
  return a(), u;
}
function Ph(e, t, n) {
  return "\x3e" + (n ? "" : " ") + e;
}
function Fh(e, t) {
  return oi(e, t.inConstruct, !0) && !oi(e, t.notInConstruct, !1);
}
function oi(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0) {
    return n;
  }
  let r = -1;
  for (; ++r < t.length;) {
    if (e.includes(t[r])) {
      return !0;
    }
  }
  return !1;
}
function li(e, t, n, r) {
  let a = -1;
  for (; ++a < n.unsafe.length;) {
    if (n.unsafe[a].character === `
` && Fh(n.stack, n.unsafe[a])) {
      return /[ \t]/.test(r.before) ? "" : " ";
    }
  }
  return `\\
`;
}
function Mh(e, t) {
  const n = String(e);
  let r = n.indexOf(t), a = r, i = 0, u = 0;
  if (typeof t != "string") {
    throw new TypeError("Expected substring");
  }
  for (; r !== -1;) {
    r === a ? ++i > u && (u = i) : i = 1, a = r + t.length, r = n.indexOf(t, a);
  }
  return u;
}
function Bh(e, t) {
  return !!(t.options.fences === !1 && e.value && !e.lang && /[^ \r\n]/.test(e.value) && !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function vh(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~") {
    throw new Error("Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`");
  }
  return t;
}
function Uh(e, t, n, r) {
  const a = vh(n), i = e.value || "", u = a === "`" ? "GraveAccent" : "Tilde";
  if (Bh(e, n)) {
    const d = n.enter("codeIndented"), m = n.indentLines(i, Hh);
    return d(), m;
  }
  const o = n.createTracker(r), l = a.repeat(Math.max(Mh(i, a) + 1, 3)), c = n.enter("codeFenced");
  let f = o.move(l);
  if (e.lang) {
    const d = n.enter(`codeFencedLang${u}`);
    f += o.move(n.safe(e.lang, {before:f, after:" ", encode:["`"], ...o.current()})), d();
  }
  if (e.lang && e.meta) {
    const d = n.enter(`codeFencedMeta${u}`);
    f += o.move(" "), f += o.move(n.safe(e.meta, {before:f, after:`
`, encode:["`"], ...o.current()})), d();
  }
  return f += o.move(`
`), i && (f += o.move(i + `
`)), f += o.move(l), c(), f;
}
function Hh(e, t, n) {
  return (n ? "" : "    ") + e;
}
function Xr(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'") {
    throw new Error("Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`");
  }
  return t;
}
function zh(e, t, n, r) {
  const a = Xr(n), i = a === '"' ? "Quote" : "Apostrophe", u = n.enter("definition");
  let o = n.enter("label");
  const l = n.createTracker(r);
  let c = l.move("[");
  return c += l.move(n.safe(n.associationId(e), {before:c, after:"]", ...l.current()})), c += l.move("]: "), o(), !e.url || /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += l.move("\x3c"), c += l.move(n.safe(e.url, {before:c, after:"\x3e", ...l.current()})), c += l.move("\x3e")) : (o = n.enter("destinationRaw"), c += l.move(n.safe(e.url, {before:c, after:e.title ? " " : `
`, ...l.current()}))), o(), e.title && (o = n.enter(`title${i}`), c += l.move(" " + a), c += l.move(n.safe(e.title, {before:c, after:a, ...l.current()})), c += l.move(a), o()), u(), c;
}
function $h(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_") {
    throw new Error("Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`");
  }
  return t;
}
function an(e) {
  return "\x26#x" + e.toString(16).toUpperCase() + ";";
}
function On(e, t, n) {
  const r = Rt(e), a = Rt(t);
  return r === void 0 ? a === void 0 ? n === "_" ? {inside:!0, outside:!0} : {inside:!1, outside:!1} : a === 1 ? {inside:!0, outside:!0} : {inside:!1, outside:!0} : r === 1 ? a === void 0 ? {inside:!1, outside:!1} : a === 1 ? {inside:!0, outside:!0} : {inside:!1, outside:!1} : a === void 0 ? {inside:!1, outside:!1} : a === 1 ? {inside:!0, outside:!1} : {inside:!1, outside:!1};
}
Bu.peek = Yh;
function Bu(e, t, n, r) {
  const a = $h(n), i = n.enter("emphasis"), u = n.createTracker(r), o = u.move(a);
  let l = u.move(n.containerPhrasing(e, {after:a, before:o, ...u.current()}));
  const c = l.charCodeAt(0), f = On(r.before.charCodeAt(r.before.length - 1), c, a);
  f.inside && (l = an(c) + l.slice(1));
  const d = l.charCodeAt(l.length - 1), m = On(r.after.charCodeAt(0), d, a);
  m.inside && (l = l.slice(0, -1) + an(d));
  const p = u.move(a);
  return i(), n.attentionEncodeSurroundingInfo = {after:m.outside, before:f.outside}, o + l + p;
}
function Yh(e, t, n) {
  return n.options.emphasis || "*";
}
function jh(e, t) {
  let n = !1;
  return $n(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break") {
      return n = !0, Sr;
    }
  }), !!((!e.depth || e.depth < 3) && zr(e) && (t.options.setext || n));
}
function qh(e, t, n, r) {
  const a = Math.max(Math.min(6, e.depth || 1), 1), i = n.createTracker(r);
  if (jh(e, n)) {
    const f = n.enter("headingSetext"), d = n.enter("phrasing"), m = n.containerPhrasing(e, {...i.current(), before:`
`, after:`
`});
    return d(), f(), m + `
` + (a === 1 ? "\x3d" : "-").repeat(m.length - (Math.max(m.lastIndexOf("\r"), m.lastIndexOf(`
`)) + 1));
  }
  const u = "#".repeat(a), o = n.enter("headingAtx"), l = n.enter("phrasing");
  i.move(u + " ");
  let c = n.containerPhrasing(e, {before:"# ", after:`
`, ...i.current()});
  return /^[\t ]/.test(c) && (c = an(c.charCodeAt(0)) + c.slice(1)), c = c ? u + " " + c : u, n.options.closeAtx && (c += " " + u), l(), o(), c;
}
vu.peek = Gh;
function vu(e) {
  return e.value || "";
}
function Gh() {
  return "\x3c";
}
Uu.peek = Wh;
function Uu(e, t, n, r) {
  const a = Xr(n), i = a === '"' ? "Quote" : "Apostrophe", u = n.enter("image");
  let o = n.enter("label");
  const l = n.createTracker(r);
  let c = l.move("![");
  return c += l.move(n.safe(e.alt, {before:c, after:"]", ...l.current()})), c += l.move("]("), o(), !e.url && e.title || /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += l.move("\x3c"), c += l.move(n.safe(e.url, {before:c, after:"\x3e", ...l.current()})), c += l.move("\x3e")) : (o = n.enter("destinationRaw"), c += l.move(n.safe(e.url, {before:c, after:e.title ? " " : ")", ...l.current()}))), o(), e.title && (o = n.enter(`title${i}`), c += l.move(" " + a), c += l.move(n.safe(e.title, 
  {before:c, after:a, ...l.current()})), c += l.move(a), o()), c += l.move(")"), u(), c;
}
function Wh() {
  return "!";
}
Hu.peek = Vh;
function Hu(e, t, n, r) {
  const a = e.referenceType, i = n.enter("imageReference");
  let u = n.enter("label");
  const o = n.createTracker(r);
  let l = o.move("![");
  const c = n.safe(e.alt, {before:l, after:"]", ...o.current()});
  l += o.move(c + "]["), u();
  const f = n.stack;
  n.stack = [], u = n.enter("reference");
  const d = n.safe(n.associationId(e), {before:l, after:"]", ...o.current()});
  return u(), n.stack = f, i(), a === "full" || !c || c !== d ? l += o.move(d + "]") : a === "shortcut" ? l = l.slice(0, -1) : l += o.move("]"), l;
}
function Vh() {
  return "!";
}
zu.peek = Xh;
function zu(e, t, n) {
  let r = e.value || "", a = "`", i = -1;
  for (; (new RegExp("(^|[^`])" + a + "([^`]|$)")).test(r);) {
    a += "`";
  }
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++i < n.unsafe.length;) {
    const u = n.unsafe[i], o = n.compilePattern(u);
    let l;
    if (u.atBreak) {
      for (; l = o.exec(r);) {
        let c = l.index;
        r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(l.index + 1);
      }
    }
  }
  return a + r + a;
}
function Xh() {
  return "`";
}
function $u(e, t) {
  const n = zr(e);
  return !!(!t.options.resourceLink && e.url && !e.title && e.children && e.children.length === 1 && e.children[0].type === "text" && (n === e.url || "mailto:" + n === e.url) && /^[a-z][a-z+.-]+:/i.test(e.url) && !/[\0- <>\u007F]/.test(e.url));
}
Yu.peek = Qh;
function Yu(e, t, n, r) {
  const a = Xr(n), i = a === '"' ? "Quote" : "Apostrophe", u = n.createTracker(r);
  let o, l;
  if ($u(e, n)) {
    const f = n.stack;
    n.stack = [], o = n.enter("autolink");
    let d = u.move("\x3c");
    return d += u.move(n.containerPhrasing(e, {before:d, after:"\x3e", ...u.current()})), d += u.move("\x3e"), o(), n.stack = f, d;
  }
  o = n.enter("link"), l = n.enter("label");
  let c = u.move("[");
  return c += u.move(n.containerPhrasing(e, {before:c, after:"](", ...u.current()})), c += u.move("]("), l(), !e.url && e.title || /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("\x3c"), c += u.move(n.safe(e.url, {before:c, after:"\x3e", ...u.current()})), c += u.move("\x3e")) : (l = n.enter("destinationRaw"), c += u.move(n.safe(e.url, {before:c, after:e.title ? " " : ")", ...u.current()}))), l(), e.title && (l = n.enter(`title${i}`), c += u.move(" " + a), c += u.move(n.safe(e.title, 
  {before:c, after:a, ...u.current()})), c += u.move(a), l()), c += u.move(")"), o(), c;
}
function Qh(e, t, n) {
  return $u(e, n) ? "\x3c" : "[";
}
ju.peek = Kh;
function ju(e, t, n, r) {
  const a = e.referenceType, i = n.enter("linkReference");
  let u = n.enter("label");
  const o = n.createTracker(r);
  let l = o.move("[");
  const c = n.containerPhrasing(e, {before:l, after:"]", ...o.current()});
  l += o.move(c + "]["), u();
  const f = n.stack;
  n.stack = [], u = n.enter("reference");
  const d = n.safe(n.associationId(e), {before:l, after:"]", ...o.current()});
  return u(), n.stack = f, i(), a === "full" || !c || c !== d ? l += o.move(d + "]") : a === "shortcut" ? l = l.slice(0, -1) : l += o.move("]"), l;
}
function Kh() {
  return "[";
}
function Qr(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-") {
    throw new Error("Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`");
  }
  return t;
}
function Zh(e) {
  const t = Qr(e), n = e.options.bulletOther;
  if (!n) {
    return t === "*" ? "-" : "*";
  }
  if (n !== "*" && n !== "+" && n !== "-") {
    throw new Error("Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`");
  }
  if (n === t) {
    throw new Error("Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different");
  }
  return n;
}
function Jh(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")") {
    throw new Error("Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`");
  }
  return t;
}
function qu(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_") {
    throw new Error("Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`");
  }
  return t;
}
function ep(e, t, n, r) {
  const a = n.enter("list"), i = n.bulletCurrent;
  let u = e.ordered ? Jh(n) : Qr(n);
  const o = e.ordered ? u === "." ? ")" : "." : Zh(n);
  let l = t && n.bulletLastUsed ? u === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const f = e.children ? e.children[0] : void 0;
    if ((u === "*" || u === "-") && f && (!f.children || !f.children[0]) && n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (l = !0), qu(n) === u && f) {
      let d = -1;
      for (; ++d < e.children.length;) {
        const m = e.children[d];
        if (m && m.type === "listItem" && m.children && m.children[0] && m.children[0].type === "thematicBreak") {
          l = !0;
          break;
        }
      }
    }
  }
  l && (u = o), n.bulletCurrent = u;
  const c = n.containerFlow(e, r);
  return n.bulletLastUsed = u, n.bulletCurrent = i, a(), c;
}
function tp(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed") {
    throw new Error("Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
  }
  return t;
}
function np(e, t, n, r) {
  const a = tp(n);
  let i = n.bulletCurrent || Qr(n);
  t && t.type === "list" && t.ordered && (i = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + i);
  let u = i.length + 1;
  (a === "tab" || a === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (u = Math.ceil(u / 4) * 4);
  const o = n.createTracker(r);
  o.move(i + " ".repeat(u - i.length)), o.shift(u);
  const l = n.enter("listItem"), c = n.indentLines(n.containerFlow(e, o.current()), f);
  return l(), c;
  function f(d, m, p) {
    return m ? (p ? "" : " ".repeat(u)) + d : (p ? i : i + " ".repeat(u - i.length)) + d;
  }
}
function rp(e, t, n, r) {
  const a = n.enter("paragraph"), i = n.enter("phrasing"), u = n.containerPhrasing(e, r);
  return i(), a(), u;
}
const ap = Hn(["break", "delete", "emphasis", "footnote", "footnoteReference", "image", "imageReference", "inlineCode", "inlineMath", "link", "linkReference", "mdxJsxTextElement", "mdxTextExpression", "strong", "text", "textDirective"]);
function ip(e, t, n, r) {
  return (e.children.some(function(u) {
    return ap(u);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function up(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_") {
    throw new Error("Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`");
  }
  return t;
}
Gu.peek = sp;
function Gu(e, t, n, r) {
  const a = up(n), i = n.enter("strong"), u = n.createTracker(r), o = u.move(a + a);
  let l = u.move(n.containerPhrasing(e, {after:a, before:o, ...u.current()}));
  const c = l.charCodeAt(0), f = On(r.before.charCodeAt(r.before.length - 1), c, a);
  f.inside && (l = an(c) + l.slice(1));
  const d = l.charCodeAt(l.length - 1), m = On(r.after.charCodeAt(0), d, a);
  m.inside && (l = l.slice(0, -1) + an(d));
  const p = u.move(a + a);
  return i(), n.attentionEncodeSurroundingInfo = {after:m.outside, before:f.outside}, o + l + p;
}
function sp(e, t, n) {
  return n.options.strong || "*";
}
function op(e, t, n, r) {
  return n.safe(e.value, r);
}
function lp(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3) {
    throw new Error("Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more");
  }
  return t;
}
function cp(e, t, n) {
  const r = (qu(n) + (n.options.ruleSpaces ? " " : "")).repeat(lp(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const Wu = {blockquote:Dh, break:li, code:Uh, definition:zh, emphasis:Bu, hardBreak:li, heading:qh, html:vu, image:Uu, imageReference:Hu, inlineCode:zu, link:Yu, linkReference:ju, list:ep, listItem:np, paragraph:rp, root:ip, strong:Gu, text:op, thematicBreak:cp};
function dp() {
  return {enter:{table:fp, tableData:ci, tableHeader:ci, tableRow:pp}, exit:{codeText:mp, table:hp, tableData:dr, tableHeader:dr, tableRow:dr}};
}
function fp(e) {
  const t = e._align;
  this.enter({type:"table", align:t.map(function(n) {
    return n === "none" ? null : n;
  }), children:[]}, e), this.data.inTable = !0;
}
function hp(e) {
  this.exit(e), this.data.inTable = void 0;
}
function pp(e) {
  this.enter({type:"tableRow", children:[]}, e);
}
function dr(e) {
  this.exit(e);
}
function ci(e) {
  this.enter({type:"tableCell", children:[]}, e);
}
function mp(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, gp));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function gp(e, t) {
  return t === "|" ? t : e;
}
function bp(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, a = t.stringLength, i = n ? " " : "|";
  return {unsafe:[{character:"\r", inConstruct:"tableCell"}, {character:`
`, inConstruct:"tableCell"}, {atBreak:!0, character:"|", after:"[\t :-]"}, {character:"|", inConstruct:"tableCell"}, {atBreak:!0, character:":", after:"-"}, {atBreak:!0, character:"-", after:"[:|-]"}], handlers:{inlineCode:m, table:u, tableCell:l, tableRow:o}};
  function u(p, g, T, A) {
    return c(f(p, T, A), p.align);
  }
  function o(p, g, T, A) {
    const y = d(p, T, A), C = c([y]);
    return C.slice(0, C.indexOf(`
`));
  }
  function l(p, g, T, A) {
    const y = T.enter("tableCell"), C = T.enter("phrasing"), N = T.containerPhrasing(p, {...A, before:i, after:i});
    return C(), y(), N;
  }
  function c(p, g) {
    return Rh(p, {align:g, alignDelimiters:r, padding:n, stringLength:a});
  }
  function f(p, g, T) {
    const A = p.children;
    let y = -1;
    const C = [], N = g.enter("table");
    for (; ++y < A.length;) {
      C[y] = d(A[y], g, T);
    }
    return N(), C;
  }
  function d(p, g, T) {
    const A = p.children;
    let y = -1;
    const C = [], N = g.enter("tableRow");
    for (; ++y < A.length;) {
      C[y] = l(A[y], p, g, T);
    }
    return N(), C;
  }
  function m(p, g, T) {
    let A = Wu.inlineCode(p, g, T);
    return T.stack.includes("tableCell") && (A = A.replace(/\|/g, "\\$\x26")), A;
  }
}
function Ep() {
  return {exit:{taskListCheckValueChecked:di, taskListCheckValueUnchecked:di, paragraph:yp}};
}
function Tp() {
  return {unsafe:[{atBreak:!0, character:"-", after:"[:|-]"}], handlers:{listItem:_p}};
}
function di(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function yp(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const a = t.children;
      let i = -1, u;
      for (; ++i < a.length;) {
        const o = a[i];
        if (o.type === "paragraph") {
          u = o;
          break;
        }
      }
      u === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function _p(e, t, n, r) {
  const a = e.children[0], i = typeof e.checked == "boolean" && a && a.type === "paragraph", u = "[" + (e.checked ? "x" : " ") + "] ", o = n.createTracker(r);
  i && o.move(u);
  let l = Wu.listItem(e, t, n, {...r, ...o.current()});
  return i && (l = l.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), l;
  function c(f) {
    return f + u;
  }
}
function Ap() {
  return [eh(), _h(), kh(), dp(), Ep()];
}
function xp(e) {
  return {extensions:[th(), Ah(e), Ch(), bp(e), Tp()]};
}
const Sp = {tokenize:Lp, partial:!0}, Vu = {tokenize:Rp, partial:!0}, Xu = {tokenize:wp, partial:!0}, Qu = {tokenize:Dp, partial:!0}, kp = {tokenize:Pp, partial:!0}, Ku = {name:"wwwAutolink", tokenize:Np, previous:Ju}, Zu = {name:"protocolAutolink", tokenize:Op, previous:es}, nt = {name:"emailAutolink", tokenize:Ip, previous:ts}, Ke = {};
function Cp() {
  return {text:Ke};
}
let pt = 48;
for (; pt < 123;) {
  Ke[pt] = nt, pt++, pt === 58 ? pt = 65 : pt === 91 && (pt = 97);
}
Ke[43] = nt;
Ke[45] = nt;
Ke[46] = nt;
Ke[95] = nt;
Ke[72] = [nt, Zu];
Ke[104] = [nt, Zu];
Ke[87] = [nt, Ku];
Ke[119] = [nt, Ku];
function Ip(e, t, n) {
  const r = this;
  let a, i;
  return u;
  function u(d) {
    return !Nr(d) || !ts.call(r, r.previous) || Kr(r.events) ? n(d) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), o(d));
  }
  function o(d) {
    return Nr(d) ? (e.consume(d), o) : d === 64 ? (e.consume(d), l) : n(d);
  }
  function l(d) {
    return d === 46 ? e.check(kp, f, c)(d) : d === 45 || d === 95 || Ae(d) ? (i = !0, e.consume(d), l) : f(d);
  }
  function c(d) {
    return e.consume(d), a = !0, l;
  }
  function f(d) {
    return i && a && ke(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(d)) : n(d);
  }
}
function Np(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return u !== 87 && u !== 119 || !Ju.call(r, r.previous) || Kr(r.events) ? n(u) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(Sp, e.attempt(Vu, e.attempt(Xu, i), n), n)(u));
  }
  function i(u) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(u);
  }
}
function Op(e, t, n) {
  const r = this;
  let a = "", i = !1;
  return u;
  function u(d) {
    return (d === 72 || d === 104) && es.call(r, r.previous) && !Kr(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), a += String.fromCodePoint(d), e.consume(d), o) : n(d);
  }
  function o(d) {
    if (ke(d) && a.length < 5) {
      return a += String.fromCodePoint(d), e.consume(d), o;
    }
    if (d === 58) {
      const m = a.toLowerCase();
      if (m === "http" || m === "https") {
        return e.consume(d), l;
      }
    }
    return n(d);
  }
  function l(d) {
    return d === 47 ? (e.consume(d), i ? c : (i = !0, l)) : n(d);
  }
  function c(d) {
    return d === null || In(d) || ie(d) || _t(d) || Bn(d) ? n(d) : e.attempt(Vu, e.attempt(Xu, f), n)(d);
  }
  function f(d) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(d);
  }
}
function Lp(e, t, n) {
  let r = 0;
  return a;
  function a(u) {
    return (u === 87 || u === 119) && r < 3 ? (r++, e.consume(u), a) : u === 46 && r === 3 ? (e.consume(u), i) : n(u);
  }
  function i(u) {
    return u === null ? n(u) : t(u);
  }
}
function Rp(e, t, n) {
  let r, a, i;
  return u;
  function u(c) {
    return c === 46 || c === 95 ? e.check(Qu, l, o)(c) : c === null || ie(c) || _t(c) || c !== 45 && Bn(c) ? l(c) : (i = !0, e.consume(c), u);
  }
  function o(c) {
    return c === 95 ? r = !0 : (a = r, r = void 0), e.consume(c), u;
  }
  function l(c) {
    return a || r || !i ? n(c) : t(c);
  }
}
function wp(e, t) {
  let n = 0, r = 0;
  return a;
  function a(u) {
    return u === 40 ? (n++, e.consume(u), a) : u === 41 && r < n ? i(u) : u === 33 || u === 34 || u === 38 || u === 39 || u === 41 || u === 42 || u === 44 || u === 46 || u === 58 || u === 59 || u === 60 || u === 63 || u === 93 || u === 95 || u === 126 ? e.check(Qu, t, i)(u) : u === null || ie(u) || _t(u) ? t(u) : (e.consume(u), a);
  }
  function i(u) {
    return u === 41 && r++, e.consume(u), a;
  }
}
function Dp(e, t, n) {
  return r;
  function r(o) {
    return o === 33 || o === 34 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 63 || o === 95 || o === 126 ? (e.consume(o), r) : o === 38 ? (e.consume(o), i) : o === 93 ? (e.consume(o), a) : o === 60 || o === null || ie(o) || _t(o) ? t(o) : n(o);
  }
  function a(o) {
    return o === null || o === 40 || o === 91 || ie(o) || _t(o) ? t(o) : r(o);
  }
  function i(o) {
    return ke(o) ? u(o) : n(o);
  }
  function u(o) {
    return o === 59 ? (e.consume(o), r) : ke(o) ? (e.consume(o), u) : n(o);
  }
}
function Pp(e, t, n) {
  return r;
  function r(i) {
    return e.consume(i), a;
  }
  function a(i) {
    return Ae(i) ? n(i) : t(i);
  }
}
function Ju(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || ie(e);
}
function es(e) {
  return !ke(e);
}
function ts(e) {
  return !(e === 47 || Nr(e));
}
function Nr(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Ae(e);
}
function Kr(e) {
  let t = e.length, n = !1;
  for (; t--;) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const Fp = {tokenize:Yp, partial:!0};
function Mp() {
  return {document:{91:{name:"gfmFootnoteDefinition", tokenize:Hp, continuation:{tokenize:zp}, exit:$p}}, text:{91:{name:"gfmFootnoteCall", tokenize:Up}, 93:{name:"gfmPotentialFootnoteCall", add:"after", tokenize:Bp, resolveTo:vp}}};
}
function Bp(e, t, n) {
  const r = this;
  let a = r.events.length;
  const i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let u;
  for (; a--;) {
    const l = r.events[a][1];
    if (l.type === "labelImage") {
      u = l;
      break;
    }
    if (l.type === "gfmFootnoteCall" || l.type === "labelLink" || l.type === "label" || l.type === "image" || l.type === "link") {
      break;
    }
  }
  return o;
  function o(l) {
    if (!u || !u._balanced) {
      return n(l);
    }
    const c = He(r.sliceSerialize({start:u.end, end:r.now()}));
    return c.codePointAt(0) !== 94 || !i.includes(c.slice(1)) ? n(l) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(l), e.exit("gfmFootnoteCallLabelMarker"), t(l));
  }
}
function vp(e, t) {
  let n = e.length;
  for (; n--;) {
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {type:"gfmFootnoteCall", start:Object.assign({}, e[n + 3][1].start), end:Object.assign({}, e[e.length - 1][1].end)}, a = {type:"gfmFootnoteCallMarker", start:Object.assign({}, e[n + 3][1].end), end:Object.assign({}, e[n + 3][1].end)};
  a.end.column++, a.end.offset++, a.end._bufferIndex++;
  const i = {type:"gfmFootnoteCallString", start:Object.assign({}, a.end), end:Object.assign({}, e[e.length - 1][1].start)}, u = {type:"chunkString", contentType:"string", start:Object.assign({}, i.start), end:Object.assign({}, i.end)}, o = [e[n + 1], e[n + 2], ["enter", r, t], e[n + 3], e[n + 4], ["enter", a, t], ["exit", a, t], ["enter", i, t], ["enter", u, t], ["exit", u, t], ["exit", i, t], e[e.length - 2], e[e.length - 1], ["exit", r, t]];
  return e.splice(n, e.length - n + 1, ...o), e;
}
function Up(e, t, n) {
  const r = this, a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i = 0, u;
  return o;
  function o(d) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), l;
  }
  function l(d) {
    return d !== 94 ? n(d) : (e.enter("gfmFootnoteCallMarker"), e.consume(d), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(d) {
    if (i > 999 || d === 93 && !u || d === null || d === 91 || ie(d)) {
      return n(d);
    }
    if (d === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteCallString");
      return a.includes(He(r.sliceSerialize(m))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(d);
    }
    return ie(d) || (u = !0), i++, e.consume(d), d === 92 ? f : c;
  }
  function f(d) {
    return d === 91 || d === 92 || d === 93 ? (e.consume(d), i++, c) : c(d);
  }
}
function Hp(e, t, n) {
  const r = this, a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i, u = 0, o;
  return l;
  function l(g) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(g) {
    return g === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", f) : n(g);
  }
  function f(g) {
    if (u > 999 || g === 93 && !o || g === null || g === 91 || ie(g)) {
      return n(g);
    }
    if (g === 93) {
      e.exit("chunkString");
      const T = e.exit("gfmFootnoteDefinitionLabelString");
      return i = He(r.sliceSerialize(T)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), m;
    }
    return ie(g) || (o = !0), u++, e.consume(g), g === 92 ? d : f;
  }
  function d(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), u++, f) : f(g);
  }
  function m(g) {
    return g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), a.includes(i) || a.push(i), te(e, p, "gfmFootnoteDefinitionWhitespace")) : n(g);
  }
  function p(g) {
    return t(g);
  }
}
function zp(e, t, n) {
  return e.check(ln, t, e.attempt(Fp, t, n));
}
function $p(e) {
  e.exit("gfmFootnoteDefinition");
}
function Yp(e, t, n) {
  const r = this;
  return te(e, a, "gfmFootnoteDefinitionIndent", 5);
  function a(i) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "gfmFootnoteDefinitionIndent" && u[2].sliceSerialize(u[1], !0).length === 4 ? t(i) : n(i);
  }
}
function jp(e) {
  let n = (e || {}).singleTilde;
  const r = {name:"strikethrough", tokenize:i, resolveAll:a};
  return n == null && (n = !0), {text:{126:r}, insideSpan:{null:[r]}, attentionMarkers:{null:[126]}};
  function a(u, o) {
    let l = -1;
    for (; ++l < u.length;) {
      if (u[l][0] === "enter" && u[l][1].type === "strikethroughSequenceTemporary" && u[l][1]._close) {
        let c = l;
        for (; c--;) {
          if (u[c][0] === "exit" && u[c][1].type === "strikethroughSequenceTemporary" && u[c][1]._open && u[l][1].end.offset - u[l][1].start.offset === u[c][1].end.offset - u[c][1].start.offset) {
            u[l][1].type = "strikethroughSequence", u[c][1].type = "strikethroughSequence";
            const f = {type:"strikethrough", start:Object.assign({}, u[c][1].start), end:Object.assign({}, u[l][1].end)}, d = {type:"strikethroughText", start:Object.assign({}, u[c][1].end), end:Object.assign({}, u[l][1].start)}, m = [["enter", f, o], ["enter", u[c][1], o], ["exit", u[c][1], o], ["enter", d, o]], p = o.parser.constructs.insideSpan.null;
            p && Fe(m, m.length, 0, vn(p, u.slice(c + 1, l), o)), Fe(m, m.length, 0, [["exit", d, o], ["enter", u[l][1], o], ["exit", u[l][1], o], ["exit", f, o]]), Fe(u, c - 1, l - c + 3, m), l = c + m.length - 2;
            break;
          }
        }
      }
    }
    for (l = -1; ++l < u.length;) {
      u[l][1].type === "strikethroughSequenceTemporary" && (u[l][1].type = "data");
    }
    return u;
  }
  function i(u, o, l) {
    const c = this.previous, f = this.events;
    let d = 0;
    return m;
    function m(g) {
      return c === 126 && f[f.length - 1][1].type !== "characterEscape" ? l(g) : (u.enter("strikethroughSequenceTemporary"), p(g));
    }
    function p(g) {
      const T = Rt(c);
      if (g === 126) {
        return d > 1 ? l(g) : (u.consume(g), d++, p);
      }
      if (d < 2 && !n) {
        return l(g);
      }
      const A = u.exit("strikethroughSequenceTemporary"), y = Rt(g);
      return A._open = !y || y === 2 && !!T, A._close = !T || T === 2 && !!y, o(g);
    }
  }
}
class qp {
  constructor() {
    this.map = [];
  }
  add(t, n, r) {
    Gp(this, t, n, r);
  }
  consume(t) {
    if (this.map.sort(function(i, u) {
      return i[0] - u[0];
    }), this.map.length === 0) {
      return;
    }
    let n = this.map.length;
    const r = [];
    for (; n > 0;) {
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    }
    r.push(t.slice()), t.length = 0;
    let a = r.pop();
    for (; a;) {
      for (const i of a) {
        t.push(i);
      }
      a = r.pop();
    }
    this.map.length = 0;
  }
}
function Gp(e, t, n, r) {
  let a = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; a < e.map.length;) {
      if (e.map[a][0] === t) {
        e.map[a][1] += n, e.map[a][2].push(...r);
        return;
      }
      a += 1;
    }
    e.map.push([t, n, r]);
  }
}
function Wp(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length;) {
    const a = e[t];
    if (n) {
      if (a[0] === "enter") {
        a[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      } else if (a[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const i = r.length - 1;
          r[i] = r[i] === "left" ? "center" : "right";
        }
      } else if (a[1].type === "tableDelimiterRow") {
        break;
      }
    } else {
      a[0] === "enter" && a[1].type === "tableDelimiterRow" && (n = !0);
    }
    t += 1;
  }
  return r;
}
function Vp() {
  return {flow:{null:{name:"table", tokenize:Xp, resolveAll:Qp}}};
}
function Xp(e, t, n) {
  const r = this;
  let a = 0, i = 0, u;
  return o;
  function o(L) {
    let z = r.events.length - 1;
    for (; z > -1;) {
      const X = r.events[z][1].type;
      if (X === "lineEnding" || X === "linePrefix") {
        z--;
      } else {
        break;
      }
    }
    const Y = z > -1 ? r.events[z][1].type : null, ne = Y === "tableHead" || Y === "tableRow" ? O : l;
    return ne === O && r.parser.lazy[r.now().line] ? n(L) : ne(L);
  }
  function l(L) {
    return e.enter("tableHead"), e.enter("tableRow"), c(L);
  }
  function c(L) {
    return L === 124 || (u = !0, i += 1), f(L);
  }
  function f(L) {
    return L === null ? n(L) : G(L) ? i > 1 ? (i = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(L), e.exit("lineEnding"), p) : n(L) : J(L) ? te(e, f, "whitespace")(L) : (i += 1, u && (u = !1, a += 1), L === 124 ? (e.enter("tableCellDivider"), e.consume(L), e.exit("tableCellDivider"), u = !0, f) : (e.enter("data"), d(L)));
  }
  function d(L) {
    return L === null || L === 124 || ie(L) ? (e.exit("data"), f(L)) : (e.consume(L), L === 92 ? m : d);
  }
  function m(L) {
    return L === 92 || L === 124 ? (e.consume(L), d) : d(L);
  }
  function p(L) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(L) : (e.enter("tableDelimiterRow"), u = !1, J(L) ? te(e, g, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(L) : g(L));
  }
  function g(L) {
    return L === 45 || L === 58 ? A(L) : L === 124 ? (u = !0, e.enter("tableCellDivider"), e.consume(L), e.exit("tableCellDivider"), T) : B(L);
  }
  function T(L) {
    return J(L) ? te(e, A, "whitespace")(L) : A(L);
  }
  function A(L) {
    return L === 58 ? (i += 1, u = !0, e.enter("tableDelimiterMarker"), e.consume(L), e.exit("tableDelimiterMarker"), y) : L === 45 ? (i += 1, y(L)) : L === null || G(L) ? v(L) : B(L);
  }
  function y(L) {
    return L === 45 ? (e.enter("tableDelimiterFiller"), C(L)) : B(L);
  }
  function C(L) {
    return L === 45 ? (e.consume(L), C) : L === 58 ? (u = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(L), e.exit("tableDelimiterMarker"), N) : (e.exit("tableDelimiterFiller"), N(L));
  }
  function N(L) {
    return J(L) ? te(e, v, "whitespace")(L) : v(L);
  }
  function v(L) {
    return L === 124 ? g(L) : L === null || G(L) ? !u || a !== i ? B(L) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(L)) : B(L);
  }
  function B(L) {
    return n(L);
  }
  function O(L) {
    return e.enter("tableRow"), j(L);
  }
  function j(L) {
    return L === 124 ? (e.enter("tableCellDivider"), e.consume(L), e.exit("tableCellDivider"), j) : L === null || G(L) ? (e.exit("tableRow"), t(L)) : J(L) ? te(e, j, "whitespace")(L) : (e.enter("data"), W(L));
  }
  function W(L) {
    return L === null || L === 124 || ie(L) ? (e.exit("data"), j(L)) : (e.consume(L), L === 92 ? $ : W);
  }
  function $(L) {
    return L === 92 || L === 124 ? (e.consume(L), W) : W(L);
  }
}
function Qp(e, t) {
  let n = -1, r = !0, a = 0, i = [0, 0, 0, 0], u = [0, 0, 0, 0], o = !1, l = 0, c, f, d;
  const m = new qp();
  for (; ++n < e.length;) {
    const p = e[n], g = p[1];
    p[0] === "enter" ? g.type === "tableHead" ? (o = !1, l !== 0 && (fi(m, t, l, c, f), f = void 0, l = 0), c = {type:"table", start:Object.assign({}, g.start), end:Object.assign({}, g.end)}, m.add(n, 0, [["enter", c, t]])) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (r = !0, d = void 0, i = [0, 0, 0, 0], u = [0, n + 1, 0, 0], o && (o = !1, f = {type:"tableBody", start:Object.assign({}, g.start), end:Object.assign({}, g.end)}, m.add(n, 0, [["enter", f, t]])), a = g.type === "tableDelimiterRow" ? 
    2 : f ? 3 : 1) : a && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") ? (r = !1, u[2] === 0 && (i[1] !== 0 && (u[0] = u[1], d = En(m, t, i, a, void 0, d), i = [0, 0, 0, 0]), u[2] = n)) : g.type === "tableCellDivider" && (r ? r = !1 : (i[1] !== 0 && (u[0] = u[1], d = En(m, t, i, a, void 0, d)), i = u, u = [i[1], n, 0, 0])) : g.type === "tableHead" ? (o = !0, l = n) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (l = n, i[1] !== 0 ? (u[0] = 
    u[1], d = En(m, t, i, a, n, d)) : u[1] !== 0 && (d = En(m, t, u, a, n, d)), a = 0) : a && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") && (u[3] = n);
  }
  for (l !== 0 && fi(m, t, l, c, f), m.consume(t.events), n = -1; ++n < t.events.length;) {
    const p = t.events[n];
    p[0] === "enter" && p[1].type === "table" && (p[1]._align = Wp(t.events, n));
  }
  return e;
}
function En(e, t, n, r, a, i) {
  const u = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", o = "tableContent";
  n[0] !== 0 && (i.end = Object.assign({}, Ot(t.events, n[0])), e.add(n[0], 0, [["exit", i, t]]));
  const l = Ot(t.events, n[1]);
  if (i = {type:u, start:Object.assign({}, l), end:Object.assign({}, l)}, e.add(n[1], 0, [["enter", i, t]]), n[2] !== 0) {
    const c = Ot(t.events, n[2]), f = Ot(t.events, n[3]), d = {type:o, start:Object.assign({}, c), end:Object.assign({}, f)};
    if (e.add(n[2], 0, [["enter", d, t]]), r !== 2) {
      const m = t.events[n[2]], p = t.events[n[3]];
      if (m[1].end = Object.assign({}, p[1].end), m[1].type = "chunkText", m[1].contentType = "text", n[3] > n[2] + 1) {
        const g = n[2] + 1, T = n[3] - n[2] - 1;
        e.add(g, T, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", d, t]]);
  }
  return a !== void 0 && (i.end = Object.assign({}, Ot(t.events, a)), e.add(a, 0, [["exit", i, t]]), i = void 0), i;
}
function fi(e, t, n, r, a) {
  const i = [], u = Ot(t.events, n);
  a && (a.end = Object.assign({}, u), i.push(["exit", a, t])), r.end = Object.assign({}, u), i.push(["exit", r, t]), e.add(n + 1, 0, i);
}
function Ot(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const Kp = {name:"tasklistCheck", tokenize:Jp};
function Zp() {
  return {text:{91:Kp}};
}
function Jp(e, t, n) {
  const r = this;
  return a;
  function a(l) {
    return r.previous !== null || !r._gfmTasklistFirstContentOfListItem ? n(l) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), i);
  }
  function i(l) {
    return ie(l) ? (e.enter("taskListCheckValueUnchecked"), e.consume(l), e.exit("taskListCheckValueUnchecked"), u) : l === 88 || l === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(l), e.exit("taskListCheckValueChecked"), u) : n(l);
  }
  function u(l) {
    return l === 93 ? (e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), o) : n(l);
  }
  function o(l) {
    return G(l) ? t(l) : J(l) ? e.check({tokenize:em}, t, n)(l) : n(l);
  }
}
function em(e, t, n) {
  return te(e, r, "whitespace");
  function r(a) {
    return a === null ? n(a) : t(a);
  }
}
function tm(e) {
  return cu([Cp(), Mp(), jp(e), Vp(), Zp()]);
}
const nm = {};
function rm(e) {
  const t = this, n = e || nm, r = t.data(), a = r.micromarkExtensions || (r.micromarkExtensions = []), i = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), u = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  a.push(tm(n)), i.push(Ap()), u.push(xp(n));
}
const hi = /[#.]/g;
function am(e, t) {
  const n = e || "", r = {};
  let a = 0, i, u;
  for (; a < n.length;) {
    hi.lastIndex = a;
    const o = hi.exec(n), l = n.slice(a, o ? o.index : n.length);
    l && (i ? i === "#" ? r.id = l : Array.isArray(r.className) ? r.className.push(l) : r.className = [l] : u = l, a += l.length), o && (i = o[0], a++);
  }
  return {type:"element", tagName:u || t || "div", properties:r, children:[]};
}
function ns(e, t, n) {
  const r = n ? om(n) : void 0;
  function a(i, u, ...o) {
    let l;
    if (i == null) {
      l = {type:"root", children:[]};
      const c = u;
      o.unshift(c);
    } else {
      l = am(i, t);
      const c = l.tagName.toLowerCase(), f = r ? r.get(c) : void 0;
      if (l.tagName = f || c, im(u)) {
        o.unshift(u);
      } else {
        for (const [d, m] of Object.entries(u)) {
          um(e, l.properties, d, m);
        }
      }
    }
    for (const c of o) {
      Or(l.children, c);
    }
    return l.type === "element" && l.tagName === "template" && (l.content = {type:"root", children:l.children}, l.children = []), l;
  }
  return a;
}
function im(e) {
  if (e === null || typeof e != "object" || Array.isArray(e)) {
    return !0;
  }
  if (typeof e.type != "string") {
    return !1;
  }
  const t = e, n = Object.keys(e);
  for (const r of n) {
    const a = t[r];
    if (a && typeof a == "object") {
      if (!Array.isArray(a)) {
        return !0;
      }
      const i = a;
      for (const u of i) {
        if (typeof u != "number" && typeof u != "string") {
          return !0;
        }
      }
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function um(e, t, n, r) {
  const a = Pn(e, n);
  let i;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) {
        return;
      }
      i = r;
    } else {
      typeof r == "boolean" ? i = r : typeof r == "string" ? a.spaceSeparated ? i = ya(r) : a.commaSeparated ? i = ma(r) : a.commaOrSpaceSeparated ? i = ya(ma(r).join(" ")) : i = pi(a, a.property, r) : Array.isArray(r) ? i = [...r] : i = a.property === "style" ? sm(r) : String(r);
    }
    if (Array.isArray(i)) {
      const u = [];
      for (const o of i) {
        u.push(pi(a, a.property, o));
      }
      i = u;
    }
    a.property === "className" && Array.isArray(t.className) && (i = t.className.concat(i)), t[a.property] = i;
  }
}
function Or(e, t) {
  if (t != null) {
    if (typeof t == "number" || typeof t == "string") {
      e.push({type:"text", value:String(t)});
    } else if (Array.isArray(t)) {
      for (const n of t) {
        Or(e, n);
      }
    } else if (typeof t == "object" && "type" in t) {
      t.type === "root" ? Or(e, t.children) : e.push(t);
    } else {
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
    }
  }
}
function pi(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n))) {
      return Number(n);
    }
    if ((e.boolean || e.overloadedBoolean) && (n === "" || nn(n) === nn(t))) {
      return !0;
    }
  }
  return n;
}
function sm(e) {
  const t = [];
  for (const [n, r] of Object.entries(e)) {
    t.push([n, r].join(": "));
  }
  return t.join("; ");
}
function om(e) {
  const t = new Map();
  for (const n of e) {
    t.set(n.toLowerCase(), n);
  }
  return t;
}
const lm = ["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", 
"glyphRef", "linearGradient", "radialGradient", "solidColor", "textArea", "textPath"], cm = ns(on, "div"), dm = ns(dt, "g", lm);
function fm(e) {
  const t = String(e), n = [];
  return {toOffset:a, toPoint:r};
  function r(i) {
    if (typeof i == "number" && i > -1 && i <= t.length) {
      let u = 0;
      for (;;) {
        let o = n[u];
        if (o === void 0) {
          const l = mi(t, n[u - 1]);
          o = l === -1 ? t.length + 1 : l + 1, n[u] = o;
        }
        if (o > i) {
          return {line:u + 1, column:i - (u > 0 ? n[u - 1] : 0) + 1, offset:i};
        }
        u++;
      }
    }
  }
  function a(i) {
    if (i && typeof i.line == "number" && typeof i.column == "number" && !Number.isNaN(i.line) && !Number.isNaN(i.column)) {
      for (; n.length < i.line;) {
        const o = n[n.length - 1], l = mi(t, o), c = l === -1 ? t.length + 1 : l + 1;
        if (o === c) {
          break;
        }
        n.push(c);
      }
      const u = (i.line > 1 ? n[i.line - 2] : 0) + i.column - 1;
      if (u < n[i.line - 1]) {
        return u;
      }
    }
  }
}
function mi(e, t) {
  const n = e.indexOf("\r", t), r = e.indexOf(`
`, t);
  return r === -1 ? n : n === -1 || n + 1 === r ? r : n < r ? n : r;
}
const bt = {html:"http://www.w3.org/1999/xhtml", mathml:"http://www.w3.org/1998/Math/MathML", svg:"http://www.w3.org/2000/svg", xlink:"http://www.w3.org/1999/xlink", xml:"http://www.w3.org/XML/1998/namespace", xmlns:"http://www.w3.org/2000/xmlns/"}, rs = {}.hasOwnProperty, hm = Object.prototype;
function pm(e, t) {
  const n = t || {};
  return Zr({file:n.file || void 0, location:!1, schema:n.space === "svg" ? dt : on, verbose:n.verbose || !1}, e);
}
function Zr(e, t) {
  let n;
  switch(t.nodeName) {
    case "#comment":
      {
        const r = t;
        return n = {type:"comment", value:r.data}, Sn(e, r, n), n;
      }
    case "#document":
    case "#document-fragment":
      {
        const r = t, a = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
        if (n = {type:"root", children:as(e, t.childNodes), data:{quirksMode:a}}, e.file && e.location) {
          const i = String(e.file), u = fm(i), o = u.toPoint(0), l = u.toPoint(i.length);
          n.position = {start:o, end:l};
        }
        return n;
      }
    case "#documentType":
      {
        const r = t;
        return n = {type:"doctype"}, Sn(e, r, n), n;
      }
    case "#text":
      {
        const r = t;
        return n = {type:"text", value:r.value}, Sn(e, r, n), n;
      }
    default:
      return n = mm(e, t), n;
  }
}
function as(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length;) {
    const a = Zr(e, t[n]);
    r.push(a);
  }
  return r;
}
function mm(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === bt.svg ? dt : on;
  let r = -1;
  const a = {};
  for (; ++r < t.attrs.length;) {
    const o = t.attrs[r], l = (o.prefix ? o.prefix + ":" : "") + o.name;
    rs.call(hm, l) || (a[l] = o.value);
  }
  const u = (e.schema.space === "svg" ? dm : cm)(t.tagName, a, as(e, t.childNodes));
  if (Sn(e, t, u), u.tagName === "template") {
    const o = t, l = o.sourceCodeLocation, c = l && l.startTag && Lt(l.startTag), f = l && l.endTag && Lt(l.endTag), d = Zr(e, o.content);
    c && f && e.file && (d.position = {start:c.end, end:f.start}), u.content = d;
  }
  return e.schema = n, u;
}
function Sn(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = gm(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function gm(e, t, n) {
  const r = Lt(n);
  if (t.type === "element") {
    const a = t.children[t.children.length - 1];
    if (r && !n.endTag && a && a.position && a.position.end && (r.end = Object.assign({}, a.position.end)), e.verbose) {
      const i = {};
      let u;
      if (n.attrs) {
        for (u in n.attrs) {
          rs.call(n.attrs, u) && (i[Pn(e.schema, u).property] = Lt(n.attrs[u]));
        }
      }
      n.startTag;
      const o = Lt(n.startTag), l = n.endTag ? Lt(n.endTag) : void 0, c = {opening:o};
      l && (c.closing = l), c.properties = i, t.data = {position:c};
    }
  }
  return r;
}
function Lt(e) {
  const t = gi({line:e.startLine, column:e.startCol, offset:e.startOffset}), n = gi({line:e.endLine, column:e.endCol, offset:e.endOffset});
  return t || n ? {start:t, end:n} : void 0;
}
function gi(e) {
  return e.line && e.column ? e : void 0;
}
const bm = {}, Em = {}.hasOwnProperty, is = Mu("type", {handlers:{root:ym, element:km, text:xm, comment:Sm, doctype:Am}});
function Tm(e, t) {
  const r = (t || bm).space;
  return is(e, r === "svg" ? dt : on);
}
function ym(e, t) {
  const n = {nodeName:"#document", mode:(e.data || {}).quirksMode ? "quirks" : "no-quirks", childNodes:[]};
  return n.childNodes = Jr(e.children, n, t), Bt(e, n), n;
}
function _m(e, t) {
  const n = {nodeName:"#document-fragment", childNodes:[]};
  return n.childNodes = Jr(e.children, n, t), Bt(e, n), n;
}
function Am(e) {
  const t = {nodeName:"#documentType", name:"html", publicId:"", systemId:"", parentNode:null};
  return Bt(e, t), t;
}
function xm(e) {
  const t = {nodeName:"#text", value:e.value, parentNode:null};
  return Bt(e, t), t;
}
function Sm(e) {
  const t = {nodeName:"#comment", data:e.value, parentNode:null};
  return Bt(e, t), t;
}
function km(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = dt);
  const a = [];
  let i;
  if (e.properties) {
    for (i in e.properties) {
      if (i !== "children" && Em.call(e.properties, i)) {
        const l = Cm(r, i, e.properties[i]);
        l && a.push(l);
      }
    }
  }
  const u = r.space, o = {nodeName:e.tagName, tagName:e.tagName, attrs:a, namespaceURI:bt[u], childNodes:[], parentNode:null};
  return o.childNodes = Jr(e.children, o, r), Bt(e, o), e.tagName === "template" && e.content && (o.content = _m(e.content, r)), o;
}
function Cm(e, t, n) {
  const r = Pn(e, t);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean) {
    return;
  }
  Array.isArray(n) && (n = r.commaSeparated ? Vi(n) : nu(n));
  const a = {name:r.attribute, value:n === !0 ? "" : String(n)};
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const i = a.name.indexOf(":");
    i < 0 ? a.prefix = "" : (a.name = a.name.slice(i + 1), a.prefix = r.attribute.slice(0, i)), a.namespace = bt[r.space];
  }
  return a;
}
function Jr(e, t, n) {
  let r = -1;
  const a = [];
  if (e) {
    for (; ++r < e.length;) {
      const i = is(e[r], n);
      i.parentNode = t, a.push(i);
    }
  }
  return a;
}
function Bt(e, t) {
  const n = e.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, t.sourceCodeLocation = {startLine:n.start.line, startCol:n.start.column, startOffset:n.start.offset, endLine:n.end.line, endCol:n.end.column, endOffset:n.end.offset});
}
const Im = ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"], Nm = new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]), le = "\ufffd";
var b;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 
  57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(b || (b = {}));
const Ce = {DASH_DASH:"--", CDATA_START:"[CDATA[", DOCTYPE:"doctype", SCRIPT:"script", PUBLIC:"public", SYSTEM:"system"};
function us(e) {
  return e >= 55296 && e <= 57343;
}
function Om(e) {
  return e >= 56320 && e <= 57343;
}
function Lm(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function ss(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function os(e) {
  return e >= 64976 && e <= 65007 || Nm.has(e);
}
var R;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", 
  e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = 
  "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = 
  "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = 
  "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", 
  e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = 
  "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", 
  e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = 
  "eof-in-element-that-can-contain-only-text";
})(R || (R = {}));
const Rm = 65536;
class wm {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Rm, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, n) {
    const {line:r, col:a, offset:i} = this, u = a + n, o = i + n;
    return {code:t, startLine:r, endLine:r, startCol:u, endCol:u, startOffset:o, endOffset:o};
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (Om(n)) {
        return this.pos++, this._addGap(), Lm(t, n);
      }
    } else if (!this.lastChunkWritten) {
      return this.endOfChunkHit = !0, b.EOF;
    }
    return this._err(R.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, n) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, n) {
    if (this.pos + t.length > this.html.length) {
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    }
    if (n) {
      return this.html.startsWith(t, this.pos);
    }
    for (let r = 0; r < t.length; r++) {
      if ((this.html.charCodeAt(this.pos + r) | 32) !== t.charCodeAt(r)) {
        return !1;
      }
    }
    return !0;
  }
  peek(t) {
    const n = this.pos + t;
    if (n >= this.html.length) {
      return this.endOfChunkHit = !this.lastChunkWritten, b.EOF;
    }
    const r = this.html.charCodeAt(n);
    return r === b.CARRIAGE_RETURN ? b.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length) {
      return this.endOfChunkHit = !this.lastChunkWritten, b.EOF;
    }
    let t = this.html.charCodeAt(this.pos);
    return t === b.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, b.LINE_FEED) : t === b.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, us(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === b.LINE_FEED || t === b.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    ss(t) ? this._err(R.controlCharacterInInputStream) : os(t) && this._err(R.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos;) {
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    }
    this.isEol = !1;
  }
}
var Z;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(Z || (Z = {}));
function ls(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--) {
    if (e.attrs[n].name === t) {
      return e.attrs[n].value;
    }
  }
  return null;
}
const Dm = new Uint16Array('\u1d41\x3c\u00d5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\x00\x00\x00\x00\x00\x00\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\u007f\u0084\u008b\u0090\u0095\u0098\u00a6\u00b3\u00b9\u00c8\u00cflig\u803b\u00c6\u40c6P\u803b\x26\u4026cute\u803b\u00c1\u40c1reve;\u4102\u0100iyx}rc\u803b\u00c2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\u00c0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\u009d\u00a1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\u00c5\u40c5\u0100cs\u00be\u00c3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\u00c3\u40c3ml\u803b\u00c4\u40c4\u0400aceforsu\u00e5\u00fb\u00fe\u0117\u011c\u0122\u0127\u012a\u0100cr\u00ea\u00f2kslash;\u6216\u0176\u00f6\u00f8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\u00f2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\u00a9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\u00c7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\u00f2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\x00\x00\x00\u0342\u0354\x00\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\u00ec\u0239o\u0274\u0379\x00\x00\u037b\u00bb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\u00e5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\x00\x00\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\x00\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\u00d0\u40d0cute\u803b\u00c9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\u00ca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\u00c8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\u00cb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\x00\x00\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\x00\u05bf\x00\x00\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\u00f2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b\x3e\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\x00\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\u00f2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\u00f0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\u00cd\u40cd\u0100iy\u0713\u0718rc\u803b\u00ce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\u00cc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\u00f3\u03dd\u01f4\u0749\x00\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\x00\u079ecy;\u4406l\u803b\u00cf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\x00\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b\x3c\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\x00\u08c3bleBracket;\u67e6n\u01d4\u08c8\x00\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\u00e1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\u00e1\u03bfight\u00e1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\u00f2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\u00f2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\u00eb\u0ad9eryThi\u00ee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\u00f2\u0673essLes\u00f3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\u00d1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\u00d3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\u00d4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\u00d2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\u00d8\u40d8i\u016c\u0e37\u0e3cde\u803b\u00d5\u40d5es;\u6a37ml\u803b\u00d6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\u00e5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\u00ae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\u00bb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\x00\u1005bleBracket;\u67e7n\u01d4\u100a\x00\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\u00bb\u041eeftArrow\u00bb\u089aightArrow\u00bb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\x00\x00\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\u00e1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\u00bb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\u00de\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\x00\u132c\u1331\x00\x00\x00\x00\x00\u1338\u133d\u1377\u1385\x00\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\u00da\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\x00\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\u00db\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\u00d9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\u00e1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\u00dc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\u00dd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\x00\u155boWidt\u00e8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\x00\u15b0\u15b6\u15bf\x00\x00\x00\x00\u15c6\u15db\u15eb\u165f\u166d\x00\u1695\u169b\u16b2\u16b9\x00\u16becute\u803b\u00e1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\u00e2\u40e2te\u80bb\u00b4\u0306;\u4430lig\u803b\u00e6\u40e6\u0100;r\u00b2\u15ba;\uc000\ud835\udd1erave\u803b\u00e0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\u00e8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\x00\x00\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\u00bb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\u00bb\u00b9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\u00f1\u1683ing\u803b\u00e5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\u00f1\u0288ilde\u803b\u00e3\u40e3ml\u803b\u00e4\u40e4\u0100ci\u16c2\u16c8onin\u00f4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\u00bb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\u00e9\u170cno\u00f5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\u00f0\u0760rc;\u65efp\u00bb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\x00\x00\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\u00e5\u1444\u00e5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\x00\u1833\u01b2\u182f\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000\x3d\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\u00bb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\u00a6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\u00bb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\x00\u19e8\u1a11\u1a15\u1a32\x00\u1a37\u1a50\x00\x00\u1ab4\x00\x00\u1ac1\x00\x00\u1b21\u1b2e\u1b4d\u1b52\x00\u1bfd\x00\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\u00ee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\x00\u19f8s;\u6a4don;\u410ddil\u803b\u00e7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\u00b8\u01adptyv;\u69b2t\u8100\u00a2;e\u1a2d\u1a2e\u40a2r\u00e4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\u00bb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\x00\x00\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\u00bb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\u00bb\u1abc\u02ec\u1ac7\u1ad4\u1afa\x00\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\u00c7\u00c6\u026d\u1ad9\x00\x00\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\u00ee\u1160e\u0100mx\u1af1\u1af6ent\u00bb\u1ae9e\u00f3\u024d\u01e7\u1afe\x00\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\u00f4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\u00e4\u0254\u8100\u00a9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\x00\x00\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\x00\x00\u1bd2re\u00e3\u1b73u\u00e3\u1b75ee;\u62ceedge;\u62cfen\u803b\u00a4\u40a4earrow\u0100lr\u1bee\u1bf3eft\u00bb\u1b80ight\u00bb\u1bbde\u00e4\u1bdd\u0100ci\u1c01\u1c07onin\u00f4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\u00f2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\u00f2\u1133h\u0100;v\u1c5a\u1c5b\u6010\u00bb\u090a\u016b\u1c61\u1c67arow;\u690fa\u00e3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\u00b0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\u00bb\u08dc\u00bb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\u00f7;o\u1ce7\u1cf0ntimes;\u62c7n\u00f8\u1cf7cy;\u4452c\u026f\u1d06\x00\x00\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\u00e5\u00fan\u0180adh\u112e\u1d5d\u1d67ownarrow\u00f3\u1c83arpoon\u0100lr\u1d72\u1d76ef\u00f4\u1cb4igh\u00f4\u1cb6\u0162\u1d7f\u1d85karo\u00f7\u0f42\u026f\u1d8a\x00\x00\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\u00f2\u0429a\u00f2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\u00f4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\u00e9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\u00ea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\u00e8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\u00bb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\u00bb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\u00bb\u1e2e\u0269\u1ef9\x00\x00\u1efb\u00ed\u0548ant\u0100gl\u1f02\u1f06tr\u00bb\u1e5dess\u00bb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\u00f4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\u00f0\u40f0\u0100mr\u1f53\u1f57l\u803b\u00eb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\u00f4\u056e\u0100eo\u1f6c\u1f74ctatio\u00ee\u0559nential\u00e5\u0579\u09e1\u1f92\x00\u1f9e\x00\u1fa1\u1fa7\x00\x00\u1fc6\u1fcc\x00\u1fd3\x00\u1fe6\u1fea\u2000\x00\u2008\u205allingdotse\u00f1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\x00\x00\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\x00\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\x00\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\x00\u202e\u803b\u00bd\u40bd;\u6153\u803b\u00bc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\x00\u2036;\u6154;\u6156\u02b4\u203e\u2041\x00\x00\u2043\u803b\u00be\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\x00\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\u00f4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\u00bb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300\x3e;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\x00\u218epro\u00f8\u209er;\u6978q\u0100lq\u063f\u2196les\u00f3\u2088i\u00ed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\u00c5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\u00f2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\u00f0\u1484f\u00bb\u2024il\u00f4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\u00bb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\u00e8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\u00bb\u1c5b\u0ae1\u22a3\x00\u22aa\x00\u22b8\u22c5\u22ce\x00\u22d5\u22f3\x00\x00\u22f8\u2322\u2367\u2362\u237f\x00\u2386\u23aa\u23b4cute\u803b\u00ed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\u00ee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\u00a1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\u00ec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\u00e5\u078ear\u00f4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\u00f4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\u00f3\u1563\u00e3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\u00bf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\x00\u23bccy;\u4456l\u803b\u00ef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\x00\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\u00f2\u09c6\u00f2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\x00\u24aa\x00\u24b1\x00\x00\x00\x00\x00\u24b5\u24ba\x00\u24c6\u24c8\u24cd\x00\u24f9ute;\u413amptyv;\u69b4ra\u00ee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\u00e5\u088e;\u6a85uo\u803b\u00ab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\u00eb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\u00ec\u08b0\u00e2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\u00e9\u24f6arpoon\u0100du\u25af\u25b4own\u00bb\u045ap\u00bb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\u00f3\u0f98quigarro\u00f7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\u00f4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\u00f8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\u00f4\u0989gt\u00f2\u248c\u00f4\u099bi\u00ed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\u00f2\u25c1orne\u00f2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\u00bb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\u00bb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\u00eb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\u00e1\u09f2apsto;\u67fcight\u00e1\u09fdparrow\u0100lr\u2725\u2729ef\u00f4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\u00e1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\u00bb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\u00f2\u08a8orne\u00f2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400\x3c;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\u00e5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\u00c5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\u00af\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\u00bb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\u00ee\u048cef\u00f4\u090f\u00f0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\u00bb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\u00b5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\u00f4\u16a7ir;\u6af0ot\u80bb\u00b7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\u00f2\u2212\u00f0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\u00bb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\u00bb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\u00f8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\x00\u29e3p\u80bb\u00a0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\x00\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\u00f6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\u00ed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\u00f4\u0be2i\u00ed\u0bea\u0100;r\u0bb6\u2a81\u00bb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\u00f2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\u00f2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\u00f7\u2ac1ightarro\u00f7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\u00f4\u0c55\u0100;s\u0c55\u2af4\u00bb\u0c36i\u00ed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\u00e4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\u00ac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\u00ec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\u00e5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\u00f1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\u00f2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\u00bb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\u00e5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\x00\x00\u2bd6ar\u00e1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\u00e5\u0cf8\u00e5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\u00f1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\u00ec\u0bd7lde\u803b\u00f1\u40f1\u00e7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\u00f1\u0c26ight\u0100;e\u0ccb\u2c65\u00f1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000\x3e\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000\x3c\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2d2d\x00\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\x00\x00\u2d8d\u2dab\x00\u2dc8\u2dce\x00\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\u00f3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\u00f4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\x00\x00\u2d7c\x00\u2d82n;\u42dbave\u803b\u00f2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\u00f2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\u00e5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\u00f2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\u00bb\u2dff\u803b\u00aa\u40aa\u803b\u00ba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\u00f2\u2e01ash\u803b\u00f8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\u00f5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\u00f6\u40f6bar;\u633d\u0ae1\u2e5e\x00\u2e7d\x00\u2e80\u2e9d\x00\u2ea2\u2eb9\x00\x00\u2ecb\u0e9c\x00\u2f13\x00\x00\u2f2b\u2fbc\x00\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\u00b6;l\u2e6d\u2e6e\u40b6le\u00ec\u0403\u0269\u2e78\x00\x00\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\u00f4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\u00bb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\u00f6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\u00b1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\u00a3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\u00e5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\u00f8\u2f43urlye\u00f1\u0ed9\u00f1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\u00ed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\u00f0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\u00ef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\u00f3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\u00f1\u1f19\u00f4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\u00f2\u10b3\u00f2\u03ddail;\u691car\u00f2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\u00e3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\u00e5\u0fd1uo\u803b\u00bb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\u00eb\u225d\u00f0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\u00f3\u0f1e\u0180abr\u30e7\u30ea\u30eer\u00f2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\u00ec\u0ff2\u00e2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\u00e5\u10bbar\u00f4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\u00bb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\u00e9\u30c8arpoon\u0100du\u31bb\u31bfow\u00ee\u317ep\u00bb\u1092eft\u0100ah\u31ca\u31d0rrow\u00f3\u0feaarpoon\u00f3\u0551ightarrows;\u61c9quigarro\u00f7\u30cbhreetimes;\u62ccg;\u42daingdotse\u00f1\u1f32\u0180ahm\u320d\u3210\u3213r\u00f2\u0feaa\u00f2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\u00bb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\u00eb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\u00f2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\u00e5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\x00\u337a\u33a4\x00\x00\u33ec\u33f0\x00\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\x00\u3616\x00\x00\u3633cute;\u415bqu\u00ef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\x00\u32fc;\u6ab8on;\u4161u\u00e5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\u00ed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\u00eb\u2228\u0100;o\u0a36\u0a34t\u803b\u00a7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\u00f0nu\u00f3\u00f1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\x00\x00\u339ci\u00e4\u1464ara\u00ec\u2e6f\u803b\u00ad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\u00f2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\u00e9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\u00bb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\u00f1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\u00f1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\u00bb\u117car\u00f2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\u00ee\u00f1i\u00ec\u3415ar\u00e6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\u00ee\u1ee0h\u00e9\u2eafs\u00bb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\u00f8\u32faurlye\u00f1\u11fe\u00f1\u11f3\u0180aes\u3582\u3588\u331bppro\u00f8\u331aq\u00f1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\u00b9\u40b9\u803b\u00b2\u40b2\u803b\u00b3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\u00eb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\u00df\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\x00\u367e\u36c2\x00\x00\x00\x00\x00\u36db\u3703\x00\u3709\u376c\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365bget;\u6316;\u43c4r\u00eb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\u00f8\u12c1im\u00bb\u12acs\u00f0\u129e\u0100as\u36ba\u36ae\u00f0\u12c1rn\u803b\u00fe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\u00d7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\u00e1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\u00e1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\u00e5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\u00bb\u1dbbeft\u0100;e\u2800\u373e\u00f1\u092e;\u625cight\u0100;e\u32aa\u374b\u00f1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\u00f4\u1777head\u0100lr\u3797\u37a0eftarro\u00f7\u084fightarrow\u00bb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\u00f2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\u00fa\u40fa\u00f2\u1150r\u01e3\u37ea\x00\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\u00fb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\u00f2\u13adlac;\u4171a\u00f2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\u00f9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\u00bb\u0957\u00bb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\x00\x00\u384arn\u0100;e\u3845\u3846\u631cr\u00bb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\u00a8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\u00e1\u13b3arpoon\u0100lr\u3888\u388cef\u00f4\u382digh\u00f4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\u00bb\u13faon\u00bb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\x00\x00\u38c1rn\u0100;e\u38bc\u38bd\u631dr\u00bb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\u00bb\u1813\u0100am\u38ef\u38f2r\u00f2\u38a8l\u803b\u00fc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\u00f2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\u00e8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\u00e1\u2415othin\u00e7\u1e96\u0180hir\u34eb\u2ec8\u3959op\u00f4\u2fb5\u0100;h\u13b7\u3962\u00ef\u318d\u0100iu\u3969\u396dgm\u00e1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\u00e1\u369ciangle\u0100lr\u39aa\u39afeft\u00bb\u0925ight\u00bb\u1051y;\u4432ash\u00bb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\u00f2\u1469r;\uc000\ud835\udd33tr\u00e9\u39aesu\u0100bp\u39ef\u39f1\u00bb\u0d1c\u00bb\u0d59pf;\uc000\ud835\udd67ro\u00f0\u0efbtr\u00e9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\u00bb\u397en\u0100Ee\u3992\u3a1e\u00bb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\u00e8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\x00\u3a8b\x00\u3a90\u3a9b\x00\x00\u3a9d\u3aa8\u3aab\u3aaf\x00\x00\u3ac3\u3ace\x00\u3ad8\u17dc\u17dftr\u00e9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\u00f2\u03c3r\u00f2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\u00f2\u03b8r\u00f2\u09eba\u00f0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\u00e5\u17b2\u0100Aa\u3ac7\u3acar\u00f2\u03cer\u00f2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\u00e9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\u00fd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\u00a5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\u00ff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\u00e6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c'.split("").map(e => 
e.charCodeAt(0))), Pm = new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
function Fm(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = Pm.get(e)) !== null && t !== void 0 ? t : e;
}
var be;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(be || (be = {}));
const Mm = 32;
var ot;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(ot || (ot = {}));
function Lr(e) {
  return e >= be.ZERO && e <= be.NINE;
}
function Bm(e) {
  return e >= be.UPPER_A && e <= be.UPPER_F || e >= be.LOWER_A && e <= be.LOWER_F;
}
function vm(e) {
  return e >= be.UPPER_A && e <= be.UPPER_Z || e >= be.LOWER_A && e <= be.LOWER_Z || Lr(e);
}
function Um(e) {
  return e === be.EQUALS || vm(e);
}
var ge;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(ge || (ge = {}));
var et;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(et || (et = {}));
class Hm {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = ge.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = et.Strict;
  }
  startEntity(t) {
    this.decodeMode = t, this.state = ge.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  write(t, n) {
    switch(this.state) {
      case ge.EntityStart:
        return t.charCodeAt(n) === be.NUM ? (this.state = ge.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = ge.NamedEntity, this.stateNamedEntity(t, n));
      case ge.NumericStart:
        return this.stateNumericStart(t, n);
      case ge.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case ge.NumericHex:
        return this.stateNumericHex(t, n);
      case ge.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | Mm) === be.LOWER_X ? (this.state = ge.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = ge.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, a) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(a, i) + Number.parseInt(t.substr(n, i), a), this.consumed += i;
    }
  }
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length;) {
      const a = t.charCodeAt(n);
      if (Lr(a) || Bm(a)) {
        n += 1;
      } else {
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(a, 3);
      }
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length;) {
      const a = t.charCodeAt(n);
      if (Lr(a)) {
        n += 1;
      } else {
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(a, 2);
      }
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n) {
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    }
    if (t === be.SEMI) {
      this.consumed += 1;
    } else if (this.decodeMode === et.Strict) {
      return 0;
    }
    return this.emitCodePoint(Fm(this.result), this.consumed), this.errors && (t !== be.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  stateNamedEntity(t, n) {
    const {decodeTree:r} = this;
    let a = r[this.treeIndex], i = (a & ot.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const u = t.charCodeAt(n);
      if (this.treeIndex = zm(r, a, this.treeIndex + Math.max(1, i), u), this.treeIndex < 0) {
        return this.result === 0 || this.decodeMode === et.Attribute && (i === 0 || Um(u)) ? 0 : this.emitNotTerminatedNamedEntity();
      }
      if (a = r[this.treeIndex], i = (a & ot.VALUE_LENGTH) >> 14, i !== 0) {
        if (u === be.SEMI) {
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        }
        this.decodeMode !== et.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  emitNotTerminatedNamedEntity() {
    var t;
    const {result:n, decodeTree:r} = this, a = (r[n] & ot.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, a, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  emitNamedEntityData(t, n, r) {
    const {decodeTree:a} = this;
    return this.emitCodePoint(n === 1 ? a[t] & ~ot.VALUE_LENGTH : a[t + 1], r), n === 3 && this.emitCodePoint(a[t + 2], r), r;
  }
  end() {
    var t;
    switch(this.state) {
      case ge.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== et.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case ge.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case ge.NumericHex:
        return this.emitNumericEntity(0, 3);
      case ge.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case ge.EntityStart:
        return 0;
    }
  }
}
function zm(e, t, n, r) {
  const a = (t & ot.BRANCH_LENGTH) >> 7, i = t & ot.JUMP_TABLE;
  if (a === 0) {
    return i !== 0 && r === i ? n : -1;
  }
  if (i) {
    const l = r - i;
    return l < 0 || l >= a ? -1 : e[n + l] - 1;
  }
  let u = n, o = u + a - 1;
  for (; u <= o;) {
    const l = u + o >>> 1, c = e[l];
    if (c < r) {
      u = l + 1;
    } else if (c > r) {
      o = l - 1;
    } else {
      return e[l + a];
    }
  }
  return -1;
}
var P;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(P || (P = {}));
var Tt;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(Tt || (Tt = {}));
var ve;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(ve || (ve = {}));
var I;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = 
  "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", 
  e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", 
  e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = 
  "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(I || (I = {}));
var s;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", 
  e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", 
  e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = 
  "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", 
  e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", 
  e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = 
  "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(s || (s = {}));
const $m = new Map([[I.A, s.A], [I.ADDRESS, s.ADDRESS], [I.ANNOTATION_XML, s.ANNOTATION_XML], [I.APPLET, s.APPLET], [I.AREA, s.AREA], [I.ARTICLE, s.ARTICLE], [I.ASIDE, s.ASIDE], [I.B, s.B], [I.BASE, s.BASE], [I.BASEFONT, s.BASEFONT], [I.BGSOUND, s.BGSOUND], [I.BIG, s.BIG], [I.BLOCKQUOTE, s.BLOCKQUOTE], [I.BODY, s.BODY], [I.BR, s.BR], [I.BUTTON, s.BUTTON], [I.CAPTION, s.CAPTION], [I.CENTER, s.CENTER], [I.CODE, s.CODE], [I.COL, s.COL], [I.COLGROUP, s.COLGROUP], [I.DD, s.DD], [I.DESC, s.DESC], [I.DETAILS, 
s.DETAILS], [I.DIALOG, s.DIALOG], [I.DIR, s.DIR], [I.DIV, s.DIV], [I.DL, s.DL], [I.DT, s.DT], [I.EM, s.EM], [I.EMBED, s.EMBED], [I.FIELDSET, s.FIELDSET], [I.FIGCAPTION, s.FIGCAPTION], [I.FIGURE, s.FIGURE], [I.FONT, s.FONT], [I.FOOTER, s.FOOTER], [I.FOREIGN_OBJECT, s.FOREIGN_OBJECT], [I.FORM, s.FORM], [I.FRAME, s.FRAME], [I.FRAMESET, s.FRAMESET], [I.H1, s.H1], [I.H2, s.H2], [I.H3, s.H3], [I.H4, s.H4], [I.H5, s.H5], [I.H6, s.H6], [I.HEAD, s.HEAD], [I.HEADER, s.HEADER], [I.HGROUP, s.HGROUP], [I.HR, 
s.HR], [I.HTML, s.HTML], [I.I, s.I], [I.IMG, s.IMG], [I.IMAGE, s.IMAGE], [I.INPUT, s.INPUT], [I.IFRAME, s.IFRAME], [I.KEYGEN, s.KEYGEN], [I.LABEL, s.LABEL], [I.LI, s.LI], [I.LINK, s.LINK], [I.LISTING, s.LISTING], [I.MAIN, s.MAIN], [I.MALIGNMARK, s.MALIGNMARK], [I.MARQUEE, s.MARQUEE], [I.MATH, s.MATH], [I.MENU, s.MENU], [I.META, s.META], [I.MGLYPH, s.MGLYPH], [I.MI, s.MI], [I.MO, s.MO], [I.MN, s.MN], [I.MS, s.MS], [I.MTEXT, s.MTEXT], [I.NAV, s.NAV], [I.NOBR, s.NOBR], [I.NOFRAMES, s.NOFRAMES], [I.NOEMBED, 
s.NOEMBED], [I.NOSCRIPT, s.NOSCRIPT], [I.OBJECT, s.OBJECT], [I.OL, s.OL], [I.OPTGROUP, s.OPTGROUP], [I.OPTION, s.OPTION], [I.P, s.P], [I.PARAM, s.PARAM], [I.PLAINTEXT, s.PLAINTEXT], [I.PRE, s.PRE], [I.RB, s.RB], [I.RP, s.RP], [I.RT, s.RT], [I.RTC, s.RTC], [I.RUBY, s.RUBY], [I.S, s.S], [I.SCRIPT, s.SCRIPT], [I.SEARCH, s.SEARCH], [I.SECTION, s.SECTION], [I.SELECT, s.SELECT], [I.SOURCE, s.SOURCE], [I.SMALL, s.SMALL], [I.SPAN, s.SPAN], [I.STRIKE, s.STRIKE], [I.STRONG, s.STRONG], [I.STYLE, s.STYLE], [I.SUB, 
s.SUB], [I.SUMMARY, s.SUMMARY], [I.SUP, s.SUP], [I.TABLE, s.TABLE], [I.TBODY, s.TBODY], [I.TEMPLATE, s.TEMPLATE], [I.TEXTAREA, s.TEXTAREA], [I.TFOOT, s.TFOOT], [I.TD, s.TD], [I.TH, s.TH], [I.THEAD, s.THEAD], [I.TITLE, s.TITLE], [I.TR, s.TR], [I.TRACK, s.TRACK], [I.TT, s.TT], [I.U, s.U], [I.UL, s.UL], [I.SVG, s.SVG], [I.VAR, s.VAR], [I.WBR, s.WBR], [I.XMP, s.XMP]]);
function vt(e) {
  var t;
  return (t = $m.get(e)) !== null && t !== void 0 ? t : s.UNKNOWN;
}
const F = s, Ym = {[P.HTML]:new Set([F.ADDRESS, F.APPLET, F.AREA, F.ARTICLE, F.ASIDE, F.BASE, F.BASEFONT, F.BGSOUND, F.BLOCKQUOTE, F.BODY, F.BR, F.BUTTON, F.CAPTION, F.CENTER, F.COL, F.COLGROUP, F.DD, F.DETAILS, F.DIR, F.DIV, F.DL, F.DT, F.EMBED, F.FIELDSET, F.FIGCAPTION, F.FIGURE, F.FOOTER, F.FORM, F.FRAME, F.FRAMESET, F.H1, F.H2, F.H3, F.H4, F.H5, F.H6, F.HEAD, F.HEADER, F.HGROUP, F.HR, F.HTML, F.IFRAME, F.IMG, F.INPUT, F.LI, F.LINK, F.LISTING, F.MAIN, F.MARQUEE, F.MENU, F.META, F.NAV, F.NOEMBED, 
F.NOFRAMES, F.NOSCRIPT, F.OBJECT, F.OL, F.P, F.PARAM, F.PLAINTEXT, F.PRE, F.SCRIPT, F.SECTION, F.SELECT, F.SOURCE, F.STYLE, F.SUMMARY, F.TABLE, F.TBODY, F.TD, F.TEMPLATE, F.TEXTAREA, F.TFOOT, F.TH, F.THEAD, F.TITLE, F.TR, F.TRACK, F.UL, F.WBR, F.XMP]), [P.MATHML]:new Set([F.MI, F.MO, F.MN, F.MS, F.MTEXT, F.ANNOTATION_XML]), [P.SVG]:new Set([F.TITLE, F.FOREIGN_OBJECT, F.DESC]), [P.XLINK]:new Set(), [P.XML]:new Set(), [P.XMLNS]:new Set()}, Rr = new Set([F.H1, F.H2, F.H3, F.H4, F.H5, F.H6]);
I.STYLE, I.SCRIPT, I.XMP, I.IFRAME, I.NOEMBED, I.NOFRAMES, I.PLAINTEXT;
var E;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 
  12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 
  20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", 
  e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", 
  e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", 
  e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = 
  "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 
  59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 
  65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(E || (E = {}));
const fe = {DATA:E.DATA, RCDATA:E.RCDATA, RAWTEXT:E.RAWTEXT, SCRIPT_DATA:E.SCRIPT_DATA, PLAINTEXT:E.PLAINTEXT, CDATA_SECTION:E.CDATA_SECTION};
function jm(e) {
  return e >= b.DIGIT_0 && e <= b.DIGIT_9;
}
function Gt(e) {
  return e >= b.LATIN_CAPITAL_A && e <= b.LATIN_CAPITAL_Z;
}
function qm(e) {
  return e >= b.LATIN_SMALL_A && e <= b.LATIN_SMALL_Z;
}
function it(e) {
  return qm(e) || Gt(e);
}
function bi(e) {
  return it(e) || jm(e);
}
function Tn(e) {
  return e + 32;
}
function cs(e) {
  return e === b.SPACE || e === b.LINE_FEED || e === b.TABULATION || e === b.FORM_FEED;
}
function Ei(e) {
  return cs(e) || e === b.SOLIDUS || e === b.GREATER_THAN_SIGN;
}
function Gm(e) {
  return e === b.NULL ? R.nullCharacterReference : e > 1114111 ? R.characterReferenceOutsideUnicodeRange : us(e) ? R.surrogateCharacterReference : os(e) ? R.noncharacterCharacterReference : ss(e) || e === b.CARRIAGE_RETURN ? R.controlCharacterReference : null;
}
class Wm {
  constructor(t, n) {
    this.options = t, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = E.DATA, this.returnState = E.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = {name:"", value:""}, this.preprocessor = new wm(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new Hm(Dm, (r, a) => {
      this.preprocessor.pos = this.entityStartPos + a - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {missingSemicolonAfterCharacterReference:() => {
      this._err(R.missingSemicolonAfterCharacterReference, 1);
    }, absenceOfDigitsInNumericCharacterReference:r => {
      this._err(R.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
    }, validateNumericCharacterReference:r => {
      const a = Gm(r);
      a && this._err(a, 1);
    }} : void 0);
  }
  _err(t, n = 0) {
    var r, a;
    (a = (r = this.handler).onParseError) === null || a === void 0 || a.call(r, this.preprocessor.getError(t, n));
  }
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {startLine:this.preprocessor.line, startCol:this.preprocessor.col - t, startOffset:this.preprocessor.offset - t, endLine:-1, endCol:-1, endOffset:-1} : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused;) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused) {
      throw new Error("Parser was already resumed");
    }
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t == null || t());
  }
  write(t, n, r) {
    this.active = !0, this.preprocessor.write(t, n), this._runParsingLoop(), this.paused || r == null || r();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let n = 0; n < t; n++) {
      this.preprocessor.advance();
    }
  }
  _consumeSequenceIfMatch(t, n) {
    return this.preprocessor.startsWith(t, n) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  _createStartTagToken() {
    this.currentToken = {type:Z.START_TAG, tagName:"", tagID:s.UNKNOWN, selfClosing:!1, ackSelfClosing:!1, attrs:[], location:this.getCurrentLocation(1)};
  }
  _createEndTagToken() {
    this.currentToken = {type:Z.END_TAG, tagName:"", tagID:s.UNKNOWN, selfClosing:!1, ackSelfClosing:!1, attrs:[], location:this.getCurrentLocation(2)};
  }
  _createCommentToken(t) {
    this.currentToken = {type:Z.COMMENT, data:"", location:this.getCurrentLocation(t)};
  }
  _createDoctypeToken(t) {
    this.currentToken = {type:Z.DOCTYPE, name:t, forceQuirks:!1, publicId:null, systemId:null, location:this.currentLocation};
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {type:t, chars:n, location:this.currentLocation};
  }
  _createAttr(t) {
    this.currentAttr = {name:t, value:""}, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, n;
    const r = this.currentToken;
    if (ls(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const a = (t = (n = r.location).attrs) !== null && t !== void 0 ? t : n.attrs = Object.create(null);
        a[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else {
      this._err(R.duplicateAttribute);
    }
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = vt(t.tagName), t.type === Z.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(R.endTagWithAttributes), t.selfClosing && this._err(R.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch(t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case Z.CHARACTER:
          {
            this.handler.onCharacter(this.currentCharacterToken);
            break;
          }
        case Z.NULL_CHARACTER:
          {
            this.handler.onNullCharacter(this.currentCharacterToken);
            break;
          }
        case Z.WHITESPACE_CHARACTER:
          {
            this.handler.onWhitespaceCharacter(this.currentCharacterToken);
            break;
          }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({type:Z.EOF, location:t}), this.active = !1;
  }
  _appendCharToCurrentCharacterToken(t, n) {
    if (this.currentCharacterToken) {
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += n;
        return;
      } else {
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
      }
    }
    this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    const n = cs(t) ? Z.WHITESPACE_CHARACTER : t === b.NULL ? Z.NULL_CHARACTER : Z.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(t));
  }
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Z.CHARACTER, t);
  }
  _startCharacterReference() {
    this.returnState = this.state, this.state = E.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? et.Attribute : et.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === E.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === E.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === E.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  _callState(t) {
    switch(this.state) {
      case E.DATA:
        {
          this._stateData(t);
          break;
        }
      case E.RCDATA:
        {
          this._stateRcdata(t);
          break;
        }
      case E.RAWTEXT:
        {
          this._stateRawtext(t);
          break;
        }
      case E.SCRIPT_DATA:
        {
          this._stateScriptData(t);
          break;
        }
      case E.PLAINTEXT:
        {
          this._statePlaintext(t);
          break;
        }
      case E.TAG_OPEN:
        {
          this._stateTagOpen(t);
          break;
        }
      case E.END_TAG_OPEN:
        {
          this._stateEndTagOpen(t);
          break;
        }
      case E.TAG_NAME:
        {
          this._stateTagName(t);
          break;
        }
      case E.RCDATA_LESS_THAN_SIGN:
        {
          this._stateRcdataLessThanSign(t);
          break;
        }
      case E.RCDATA_END_TAG_OPEN:
        {
          this._stateRcdataEndTagOpen(t);
          break;
        }
      case E.RCDATA_END_TAG_NAME:
        {
          this._stateRcdataEndTagName(t);
          break;
        }
      case E.RAWTEXT_LESS_THAN_SIGN:
        {
          this._stateRawtextLessThanSign(t);
          break;
        }
      case E.RAWTEXT_END_TAG_OPEN:
        {
          this._stateRawtextEndTagOpen(t);
          break;
        }
      case E.RAWTEXT_END_TAG_NAME:
        {
          this._stateRawtextEndTagName(t);
          break;
        }
      case E.SCRIPT_DATA_LESS_THAN_SIGN:
        {
          this._stateScriptDataLessThanSign(t);
          break;
        }
      case E.SCRIPT_DATA_END_TAG_OPEN:
        {
          this._stateScriptDataEndTagOpen(t);
          break;
        }
      case E.SCRIPT_DATA_END_TAG_NAME:
        {
          this._stateScriptDataEndTagName(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPE_START:
        {
          this._stateScriptDataEscapeStart(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPE_START_DASH:
        {
          this._stateScriptDataEscapeStartDash(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPED:
        {
          this._stateScriptDataEscaped(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPED_DASH:
        {
          this._stateScriptDataEscapedDash(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPED_DASH_DASH:
        {
          this._stateScriptDataEscapedDashDash(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
        {
          this._stateScriptDataEscapedLessThanSign(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
        {
          this._stateScriptDataEscapedEndTagOpen(t);
          break;
        }
      case E.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
        {
          this._stateScriptDataEscapedEndTagName(t);
          break;
        }
      case E.SCRIPT_DATA_DOUBLE_ESCAPE_START:
        {
          this._stateScriptDataDoubleEscapeStart(t);
          break;
        }
      case E.SCRIPT_DATA_DOUBLE_ESCAPED:
        {
          this._stateScriptDataDoubleEscaped(t);
          break;
        }
      case E.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
        {
          this._stateScriptDataDoubleEscapedDash(t);
          break;
        }
      case E.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
        {
          this._stateScriptDataDoubleEscapedDashDash(t);
          break;
        }
      case E.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
        {
          this._stateScriptDataDoubleEscapedLessThanSign(t);
          break;
        }
      case E.SCRIPT_DATA_DOUBLE_ESCAPE_END:
        {
          this._stateScriptDataDoubleEscapeEnd(t);
          break;
        }
      case E.BEFORE_ATTRIBUTE_NAME:
        {
          this._stateBeforeAttributeName(t);
          break;
        }
      case E.ATTRIBUTE_NAME:
        {
          this._stateAttributeName(t);
          break;
        }
      case E.AFTER_ATTRIBUTE_NAME:
        {
          this._stateAfterAttributeName(t);
          break;
        }
      case E.BEFORE_ATTRIBUTE_VALUE:
        {
          this._stateBeforeAttributeValue(t);
          break;
        }
      case E.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
        {
          this._stateAttributeValueDoubleQuoted(t);
          break;
        }
      case E.ATTRIBUTE_VALUE_SINGLE_QUOTED:
        {
          this._stateAttributeValueSingleQuoted(t);
          break;
        }
      case E.ATTRIBUTE_VALUE_UNQUOTED:
        {
          this._stateAttributeValueUnquoted(t);
          break;
        }
      case E.AFTER_ATTRIBUTE_VALUE_QUOTED:
        {
          this._stateAfterAttributeValueQuoted(t);
          break;
        }
      case E.SELF_CLOSING_START_TAG:
        {
          this._stateSelfClosingStartTag(t);
          break;
        }
      case E.BOGUS_COMMENT:
        {
          this._stateBogusComment(t);
          break;
        }
      case E.MARKUP_DECLARATION_OPEN:
        {
          this._stateMarkupDeclarationOpen(t);
          break;
        }
      case E.COMMENT_START:
        {
          this._stateCommentStart(t);
          break;
        }
      case E.COMMENT_START_DASH:
        {
          this._stateCommentStartDash(t);
          break;
        }
      case E.COMMENT:
        {
          this._stateComment(t);
          break;
        }
      case E.COMMENT_LESS_THAN_SIGN:
        {
          this._stateCommentLessThanSign(t);
          break;
        }
      case E.COMMENT_LESS_THAN_SIGN_BANG:
        {
          this._stateCommentLessThanSignBang(t);
          break;
        }
      case E.COMMENT_LESS_THAN_SIGN_BANG_DASH:
        {
          this._stateCommentLessThanSignBangDash(t);
          break;
        }
      case E.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
        {
          this._stateCommentLessThanSignBangDashDash(t);
          break;
        }
      case E.COMMENT_END_DASH:
        {
          this._stateCommentEndDash(t);
          break;
        }
      case E.COMMENT_END:
        {
          this._stateCommentEnd(t);
          break;
        }
      case E.COMMENT_END_BANG:
        {
          this._stateCommentEndBang(t);
          break;
        }
      case E.DOCTYPE:
        {
          this._stateDoctype(t);
          break;
        }
      case E.BEFORE_DOCTYPE_NAME:
        {
          this._stateBeforeDoctypeName(t);
          break;
        }
      case E.DOCTYPE_NAME:
        {
          this._stateDoctypeName(t);
          break;
        }
      case E.AFTER_DOCTYPE_NAME:
        {
          this._stateAfterDoctypeName(t);
          break;
        }
      case E.AFTER_DOCTYPE_PUBLIC_KEYWORD:
        {
          this._stateAfterDoctypePublicKeyword(t);
          break;
        }
      case E.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
        {
          this._stateBeforeDoctypePublicIdentifier(t);
          break;
        }
      case E.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
        {
          this._stateDoctypePublicIdentifierDoubleQuoted(t);
          break;
        }
      case E.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
        {
          this._stateDoctypePublicIdentifierSingleQuoted(t);
          break;
        }
      case E.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
        {
          this._stateAfterDoctypePublicIdentifier(t);
          break;
        }
      case E.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
        {
          this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
          break;
        }
      case E.AFTER_DOCTYPE_SYSTEM_KEYWORD:
        {
          this._stateAfterDoctypeSystemKeyword(t);
          break;
        }
      case E.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
        {
          this._stateBeforeDoctypeSystemIdentifier(t);
          break;
        }
      case E.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
        {
          this._stateDoctypeSystemIdentifierDoubleQuoted(t);
          break;
        }
      case E.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
        {
          this._stateDoctypeSystemIdentifierSingleQuoted(t);
          break;
        }
      case E.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
        {
          this._stateAfterDoctypeSystemIdentifier(t);
          break;
        }
      case E.BOGUS_DOCTYPE:
        {
          this._stateBogusDoctype(t);
          break;
        }
      case E.CDATA_SECTION:
        {
          this._stateCdataSection(t);
          break;
        }
      case E.CDATA_SECTION_BRACKET:
        {
          this._stateCdataSectionBracket(t);
          break;
        }
      case E.CDATA_SECTION_END:
        {
          this._stateCdataSectionEnd(t);
          break;
        }
      case E.CHARACTER_REFERENCE:
        {
          this._stateCharacterReference();
          break;
        }
      case E.AMBIGUOUS_AMPERSAND:
        {
          this._stateAmbiguousAmpersand(t);
          break;
        }
      default:
        throw new Error("Unknown state");
    }
  }
  _stateData(t) {
    switch(t) {
      case b.LESS_THAN_SIGN:
        {
          this.state = E.TAG_OPEN;
          break;
        }
      case b.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitCodePoint(t);
          break;
        }
      case b.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateRcdata(t) {
    switch(t) {
      case b.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.RCDATA_LESS_THAN_SIGN;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateRawtext(t) {
    switch(t) {
      case b.LESS_THAN_SIGN:
        {
          this.state = E.RAWTEXT_LESS_THAN_SIGN;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateScriptData(t) {
    switch(t) {
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_LESS_THAN_SIGN;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _statePlaintext(t) {
    switch(t) {
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateTagOpen(t) {
    if (it(t)) {
      this._createStartTagToken(), this.state = E.TAG_NAME, this._stateTagName(t);
    } else {
      switch(t) {
        case b.EXCLAMATION_MARK:
          {
            this.state = E.MARKUP_DECLARATION_OPEN;
            break;
          }
        case b.SOLIDUS:
          {
            this.state = E.END_TAG_OPEN;
            break;
          }
        case b.QUESTION_MARK:
          {
            this._err(R.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = E.BOGUS_COMMENT, this._stateBogusComment(t);
            break;
          }
        case b.EOF:
          {
            this._err(R.eofBeforeTagName), this._emitChars("\x3c"), this._emitEOFToken();
            break;
          }
        default:
          this._err(R.invalidFirstCharacterOfTagName), this._emitChars("\x3c"), this.state = E.DATA, this._stateData(t);
      }
    }
  }
  _stateEndTagOpen(t) {
    if (it(t)) {
      this._createEndTagToken(), this.state = E.TAG_NAME, this._stateTagName(t);
    } else {
      switch(t) {
        case b.GREATER_THAN_SIGN:
          {
            this._err(R.missingEndTagName), this.state = E.DATA;
            break;
          }
        case b.EOF:
          {
            this._err(R.eofBeforeTagName), this._emitChars("\x3c/"), this._emitEOFToken();
            break;
          }
        default:
          this._err(R.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = E.BOGUS_COMMENT, this._stateBogusComment(t);
      }
    }
  }
  _stateTagName(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this.state = E.BEFORE_ATTRIBUTE_NAME;
          break;
        }
      case b.SOLIDUS:
        {
          this.state = E.SELF_CLOSING_START_TAG;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentTagToken();
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.tagName += le;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        n.tagName += String.fromCodePoint(Gt(t) ? Tn(t) : t);
    }
  }
  _stateRcdataLessThanSign(t) {
    t === b.SOLIDUS ? this.state = E.RCDATA_END_TAG_OPEN : (this._emitChars("\x3c"), this.state = E.RCDATA, this._stateRcdata(t));
  }
  _stateRcdataEndTagOpen(t) {
    it(t) ? (this.state = E.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("\x3c/"), this.state = E.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1)) {
      return !this._ensureHibernation();
    }
    this._createEndTagToken();
    const n = this.currentToken;
    switch(n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = E.BEFORE_ATTRIBUTE_NAME, !1;
      case b.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = E.SELF_CLOSING_START_TAG, !1;
      case b.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = E.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("\x3c/"), this.state = E.RCDATA, this._stateRcdata(t));
  }
  _stateRawtextLessThanSign(t) {
    t === b.SOLIDUS ? this.state = E.RAWTEXT_END_TAG_OPEN : (this._emitChars("\x3c"), this.state = E.RAWTEXT, this._stateRawtext(t));
  }
  _stateRawtextEndTagOpen(t) {
    it(t) ? (this.state = E.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("\x3c/"), this.state = E.RAWTEXT, this._stateRawtext(t));
  }
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("\x3c/"), this.state = E.RAWTEXT, this._stateRawtext(t));
  }
  _stateScriptDataLessThanSign(t) {
    switch(t) {
      case b.SOLIDUS:
        {
          this.state = E.SCRIPT_DATA_END_TAG_OPEN;
          break;
        }
      case b.EXCLAMATION_MARK:
        {
          this.state = E.SCRIPT_DATA_ESCAPE_START, this._emitChars("\x3c!");
          break;
        }
      default:
        this._emitChars("\x3c"), this.state = E.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  _stateScriptDataEndTagOpen(t) {
    it(t) ? (this.state = E.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("\x3c/"), this.state = E.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("\x3c/"), this.state = E.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEscapeStart(t) {
    t === b.HYPHEN_MINUS ? (this.state = E.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = E.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEscapeStartDash(t) {
    t === b.HYPHEN_MINUS ? (this.state = E.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = E.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEscaped(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateScriptDataEscapedDash(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.state = E.SCRIPT_DATA_ESCAPED, this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = E.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataEscapedDashDash(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this._emitChars("-");
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA, this._emitChars("\x3e");
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.state = E.SCRIPT_DATA_ESCAPED, this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = E.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataEscapedLessThanSign(t) {
    t === b.SOLIDUS ? this.state = E.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : it(t) ? (this._emitChars("\x3c"), this.state = E.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("\x3c"), this.state = E.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataEscapedEndTagOpen(t) {
    it(t) ? (this.state = E.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("\x3c/"), this.state = E.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("\x3c/"), this.state = E.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(Ce.SCRIPT, !1) && Ei(this.preprocessor.peek(Ce.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < Ce.SCRIPT.length; n++) {
        this._emitCodePoint(this._consume());
      }
      this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else {
      this._ensureHibernation() || (this.state = E.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
    }
  }
  _stateScriptDataDoubleEscaped(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("\x3c");
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateScriptDataDoubleEscapedDash(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("\x3c");
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this._emitChars("-");
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("\x3c");
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.SCRIPT_DATA, this._emitChars("\x3e");
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(le);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === b.SOLIDUS ? (this.state = E.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(Ce.SCRIPT, !1) && Ei(this.preprocessor.peek(Ce.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < Ce.SCRIPT.length; n++) {
        this._emitCodePoint(this._consume());
      }
      this.state = E.SCRIPT_DATA_ESCAPED;
    } else {
      this._ensureHibernation() || (this.state = E.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
    }
  }
  _stateBeforeAttributeName(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.SOLIDUS:
      case b.GREATER_THAN_SIGN:
      case b.EOF:
        {
          this.state = E.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
          break;
        }
      case b.EQUALS_SIGN:
        {
          this._err(R.unexpectedEqualsSignBeforeAttributeName), this._createAttr("\x3d"), this.state = E.ATTRIBUTE_NAME;
          break;
        }
      default:
        this._createAttr(""), this.state = E.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  _stateAttributeName(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
      case b.SOLIDUS:
      case b.GREATER_THAN_SIGN:
      case b.EOF:
        {
          this._leaveAttrName(), this.state = E.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
          break;
        }
      case b.EQUALS_SIGN:
        {
          this._leaveAttrName(), this.state = E.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
      case b.QUOTATION_MARK:
      case b.APOSTROPHE:
      case b.LESS_THAN_SIGN:
        {
          this._err(R.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.currentAttr.name += le;
          break;
        }
      default:
        this.currentAttr.name += String.fromCodePoint(Gt(t) ? Tn(t) : t);
    }
  }
  _stateAfterAttributeName(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.SOLIDUS:
        {
          this.state = E.SELF_CLOSING_START_TAG;
          break;
        }
      case b.EQUALS_SIGN:
        {
          this.state = E.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentTagToken();
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this._createAttr(""), this.state = E.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  _stateBeforeAttributeValue(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.QUOTATION_MARK:
        {
          this.state = E.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          this.state = E.ATTRIBUTE_VALUE_SINGLE_QUOTED;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.missingAttributeValue), this.state = E.DATA, this.emitCurrentTagToken();
          break;
        }
      default:
        this.state = E.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  _stateAttributeValueDoubleQuoted(t) {
    switch(t) {
      case b.QUOTATION_MARK:
        {
          this.state = E.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
      case b.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.currentAttr.value += le;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  _stateAttributeValueSingleQuoted(t) {
    switch(t) {
      case b.APOSTROPHE:
        {
          this.state = E.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
      case b.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.currentAttr.value += le;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  _stateAttributeValueUnquoted(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this._leaveAttrValue(), this.state = E.BEFORE_ATTRIBUTE_NAME;
          break;
        }
      case b.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._leaveAttrValue(), this.state = E.DATA, this.emitCurrentTagToken();
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), this.currentAttr.value += le;
          break;
        }
      case b.QUOTATION_MARK:
      case b.APOSTROPHE:
      case b.LESS_THAN_SIGN:
      case b.EQUALS_SIGN:
      case b.GRAVE_ACCENT:
        {
          this._err(R.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  _stateAfterAttributeValueQuoted(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this._leaveAttrValue(), this.state = E.BEFORE_ATTRIBUTE_NAME;
          break;
        }
      case b.SOLIDUS:
        {
          this._leaveAttrValue(), this.state = E.SELF_CLOSING_START_TAG;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._leaveAttrValue(), this.state = E.DATA, this.emitCurrentTagToken();
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingWhitespaceBetweenAttributes), this.state = E.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  _stateSelfClosingStartTag(t) {
    switch(t) {
      case b.GREATER_THAN_SIGN:
        {
          const n = this.currentToken;
          n.selfClosing = !0, this.state = E.DATA, this.emitCurrentTagToken();
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.unexpectedSolidusInTag), this.state = E.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  _stateBogusComment(t) {
    const n = this.currentToken;
    switch(t) {
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentComment(n);
          break;
        }
      case b.EOF:
        {
          this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.data += le;
          break;
        }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(Ce.DASH_DASH, !0) ? (this._createCommentToken(Ce.DASH_DASH.length + 1), this.state = E.COMMENT_START) : this._consumeSequenceIfMatch(Ce.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(Ce.DOCTYPE.length + 1), this.state = E.DOCTYPE) : this._consumeSequenceIfMatch(Ce.CDATA_START, !0) ? this.inForeignNode ? this.state = E.CDATA_SECTION : (this._err(R.cdataInHtmlContent), this._createCommentToken(Ce.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", 
    this.state = E.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(R.incorrectlyOpenedComment), this._createCommentToken(2), this.state = E.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  _stateCommentStart(t) {
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.COMMENT_START_DASH;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.abruptClosingOfEmptyComment), this.state = E.DATA;
          const n = this.currentToken;
          this.emitCurrentComment(n);
          break;
        }
      default:
        this.state = E.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentStartDash(t) {
    const n = this.currentToken;
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.COMMENT_END;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.abruptClosingOfEmptyComment), this.state = E.DATA, this.emitCurrentComment(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "-", this.state = E.COMMENT, this._stateComment(t);
    }
  }
  _stateComment(t) {
    const n = this.currentToken;
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.COMMENT_END_DASH;
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          n.data += "\x3c", this.state = E.COMMENT_LESS_THAN_SIGN;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.data += le;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  _stateCommentLessThanSign(t) {
    const n = this.currentToken;
    switch(t) {
      case b.EXCLAMATION_MARK:
        {
          n.data += "!", this.state = E.COMMENT_LESS_THAN_SIGN_BANG;
          break;
        }
      case b.LESS_THAN_SIGN:
        {
          n.data += "\x3c";
          break;
        }
      default:
        this.state = E.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentLessThanSignBang(t) {
    t === b.HYPHEN_MINUS ? this.state = E.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = E.COMMENT, this._stateComment(t));
  }
  _stateCommentLessThanSignBangDash(t) {
    t === b.HYPHEN_MINUS ? this.state = E.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = E.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  _stateCommentLessThanSignBangDashDash(t) {
    t !== b.GREATER_THAN_SIGN && t !== b.EOF && this._err(R.nestedComment), this.state = E.COMMENT_END, this._stateCommentEnd(t);
  }
  _stateCommentEndDash(t) {
    const n = this.currentToken;
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          this.state = E.COMMENT_END;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "-", this.state = E.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentEnd(t) {
    const n = this.currentToken;
    switch(t) {
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentComment(n);
          break;
        }
      case b.EXCLAMATION_MARK:
        {
          this.state = E.COMMENT_END_BANG;
          break;
        }
      case b.HYPHEN_MINUS:
        {
          n.data += "-";
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "--", this.state = E.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentEndBang(t) {
    const n = this.currentToken;
    switch(t) {
      case b.HYPHEN_MINUS:
        {
          n.data += "--!", this.state = E.COMMENT_END_DASH;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.incorrectlyClosedComment), this.state = E.DATA, this.emitCurrentComment(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "--!", this.state = E.COMMENT, this._stateComment(t);
    }
  }
  _stateDoctype(t) {
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this.state = E.BEFORE_DOCTYPE_NAME;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingWhitespaceBeforeDoctypeName), this.state = E.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  _stateBeforeDoctypeName(t) {
    if (Gt(t)) {
      this._createDoctypeToken(String.fromCharCode(Tn(t))), this.state = E.DOCTYPE_NAME;
    } else {
      switch(t) {
        case b.SPACE:
        case b.LINE_FEED:
        case b.TABULATION:
        case b.FORM_FEED:
          break;
        case b.NULL:
          {
            this._err(R.unexpectedNullCharacter), this._createDoctypeToken(le), this.state = E.DOCTYPE_NAME;
            break;
          }
        case b.GREATER_THAN_SIGN:
          {
            this._err(R.missingDoctypeName), this._createDoctypeToken(null);
            const n = this.currentToken;
            n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = E.DATA;
            break;
          }
        case b.EOF:
          {
            this._err(R.eofInDoctype), this._createDoctypeToken(null);
            const n = this.currentToken;
            n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
            break;
          }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = E.DOCTYPE_NAME;
      }
    }
  }
  _stateDoctypeName(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this.state = E.AFTER_DOCTYPE_NAME;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.name += le;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.name += String.fromCodePoint(Gt(t) ? Tn(t) : t);
    }
  }
  _stateAfterDoctypeName(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._consumeSequenceIfMatch(Ce.PUBLIC, !1) ? this.state = E.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(Ce.SYSTEM, !1) ? this.state = E.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(R.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  _stateAfterDoctypePublicKeyword(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this.state = E.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
      case b.QUOTATION_MARK:
        {
          this._err(R.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = E.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          this._err(R.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = E.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBeforeDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.QUOTATION_MARK:
        {
          n.publicId = "", this.state = E.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          n.publicId = "", this.state = E.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch(t) {
      case b.QUOTATION_MARK:
        {
          this.state = E.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.publicId += le;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch(t) {
      case b.APOSTROPHE:
        {
          this.state = E.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.publicId += le;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  _stateAfterDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this.state = E.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.QUOTATION_MARK:
        {
          this._err(R.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          this._err(R.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.GREATER_THAN_SIGN:
        {
          this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.QUOTATION_MARK:
        {
          n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateAfterDoctypeSystemKeyword(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        {
          this.state = E.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
      case b.QUOTATION_MARK:
        {
          this._err(R.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          this._err(R.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBeforeDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.QUOTATION_MARK:
        {
          n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case b.APOSTROPHE:
        {
          n.systemId = "", this.state = E.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = E.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch(t) {
      case b.QUOTATION_MARK:
        {
          this.state = E.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.systemId += le;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch(t) {
      case b.APOSTROPHE:
        {
          this.state = E.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter), n.systemId += le;
          break;
        }
      case b.GREATER_THAN_SIGN:
        {
          this._err(R.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  _stateAfterDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch(t) {
      case b.SPACE:
      case b.LINE_FEED:
      case b.TABULATION:
      case b.FORM_FEED:
        break;
      case b.GREATER_THAN_SIGN:
        {
          this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(R.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = E.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBogusDoctype(t) {
    const n = this.currentToken;
    switch(t) {
      case b.GREATER_THAN_SIGN:
        {
          this.emitCurrentDoctype(n), this.state = E.DATA;
          break;
        }
      case b.NULL:
        {
          this._err(R.unexpectedNullCharacter);
          break;
        }
      case b.EOF:
        {
          this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
    }
  }
  _stateCdataSection(t) {
    switch(t) {
      case b.RIGHT_SQUARE_BRACKET:
        {
          this.state = E.CDATA_SECTION_BRACKET;
          break;
        }
      case b.EOF:
        {
          this._err(R.eofInCdata), this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateCdataSectionBracket(t) {
    t === b.RIGHT_SQUARE_BRACKET ? this.state = E.CDATA_SECTION_END : (this._emitChars("]"), this.state = E.CDATA_SECTION, this._stateCdataSection(t));
  }
  _stateCdataSectionEnd(t) {
    switch(t) {
      case b.GREATER_THAN_SIGN:
        {
          this.state = E.DATA;
          break;
        }
      case b.RIGHT_SQUARE_BRACKET:
        {
          this._emitChars("]");
          break;
        }
      default:
        this._emitChars("]]"), this.state = E.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0) {
      if (this.preprocessor.lastChunkWritten) {
        t = this.entityDecoder.end();
      } else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(b.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && bi(this.preprocessor.peek(1)) ? E.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  _stateAmbiguousAmpersand(t) {
    bi(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === b.SEMICOLON && this._err(R.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const ds = new Set([s.DD, s.DT, s.LI, s.OPTGROUP, s.OPTION, s.P, s.RB, s.RP, s.RT, s.RTC]), Ti = new Set([...ds, s.CAPTION, s.COLGROUP, s.TBODY, s.TD, s.TFOOT, s.TH, s.THEAD, s.TR]), Ln = new Set([s.APPLET, s.CAPTION, s.HTML, s.MARQUEE, s.OBJECT, s.TABLE, s.TD, s.TEMPLATE, s.TH]), Vm = new Set([...Ln, s.OL, s.UL]), Xm = new Set([...Ln, s.BUTTON]), yi = new Set([s.ANNOTATION_XML, s.MI, s.MN, s.MO, s.MS, s.MTEXT]), _i = new Set([s.DESC, s.FOREIGN_OBJECT, s.TITLE]), Qm = new Set([s.TR, s.TEMPLATE, s.HTML]), 
Km = new Set([s.TBODY, s.TFOOT, s.THEAD, s.TEMPLATE, s.HTML]), Zm = new Set([s.TABLE, s.TEMPLATE, s.HTML]), Jm = new Set([s.TD, s.TH]);
class eg {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = s.UNKNOWN, this.current = t;
  }
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  _isInTemplate() {
    return this.currentTagId === s.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === P.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  push(t, n) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, n, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(t, n, r) {
    const a = this._indexOf(t) + 1;
    this.items.splice(a, 0, n), this.tagIDs.splice(a, 0, r), this.stackTop++, a === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, a === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let n = this.stackTop + 1;
    do {
      n = this.tagIDs.lastIndexOf(t, n - 1);
    } while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== P.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t;) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const n = this._indexOf(t);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(Rr, P.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Jm, P.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      if (t.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n) {
        return r;
      }
    }
    return -1;
  }
  clearBackTo(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(Zm, P.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(Km, P.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(Qm, P.HTML);
  }
  remove(t) {
    const n = this._indexOf(t);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === s.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const n = this._indexOf(t) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === s.HTML;
  }
  hasInDynamicScope(t, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const a = this.tagIDs[r];
      switch(this.treeAdapter.getNamespaceURI(this.items[r])) {
        case P.HTML:
          {
            if (a === t) {
              return !0;
            }
            if (n.has(a)) {
              return !1;
            }
            break;
          }
        case P.SVG:
          {
            if (_i.has(a)) {
              return !1;
            }
            break;
          }
        case P.MATHML:
          {
            if (yi.has(a)) {
              return !1;
            }
            break;
          }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, Ln);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, Vm);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, Xm);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.tagIDs[t];
      switch(this.treeAdapter.getNamespaceURI(this.items[t])) {
        case P.HTML:
          {
            if (Rr.has(n)) {
              return !0;
            }
            if (Ln.has(n)) {
              return !1;
            }
            break;
          }
        case P.SVG:
          {
            if (_i.has(n)) {
              return !1;
            }
            break;
          }
        case P.MATHML:
          {
            if (yi.has(n)) {
              return !1;
            }
            break;
          }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === P.HTML) {
        switch(this.tagIDs[n]) {
          case t:
            return !0;
          case s.TABLE:
          case s.HTML:
            return !1;
        }
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === P.HTML) {
        switch(this.tagIDs[t]) {
          case s.TBODY:
          case s.THEAD:
          case s.TFOOT:
            return !0;
          case s.TABLE:
          case s.HTML:
            return !1;
        }
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === P.HTML) {
        switch(this.tagIDs[n]) {
          case t:
            return !0;
          case s.OPTION:
          case s.OPTGROUP:
            break;
          default:
            return !1;
        }
      }
    }
    return !0;
  }
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && ds.has(this.currentTagId);) {
      this.pop();
    }
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && Ti.has(this.currentTagId);) {
      this.pop();
    }
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && Ti.has(this.currentTagId);) {
      this.pop();
    }
  }
}
const fr = 3;
var We;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(We || (We = {}));
const Ai = {type:We.Marker};
class tg {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  _getNoahArkConditionCandidates(t, n) {
    const r = [], a = n.length, i = this.treeAdapter.getTagName(t), u = this.treeAdapter.getNamespaceURI(t);
    for (let o = 0; o < this.entries.length; o++) {
      const l = this.entries[o];
      if (l.type === We.Marker) {
        break;
      }
      const {element:c} = l;
      if (this.treeAdapter.getTagName(c) === i && this.treeAdapter.getNamespaceURI(c) === u) {
        const f = this.treeAdapter.getAttrList(c);
        f.length === a && r.push({idx:o, attrs:f});
      }
    }
    return r;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < fr) {
      return;
    }
    const n = this.treeAdapter.getAttrList(t), r = this._getNoahArkConditionCandidates(t, n);
    if (r.length < fr) {
      return;
    }
    const a = new Map(n.map(u => [u.name, u.value]));
    let i = 0;
    for (let u = 0; u < r.length; u++) {
      const o = r[u];
      o.attrs.every(l => a.get(l.name) === l.value) && (i += 1, i >= fr && this.entries.splice(o.idx, 1));
    }
  }
  insertMarker() {
    this.entries.unshift(Ai);
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.unshift({type:We.Element, element:t, token:n});
  }
  insertElementAfterBookmark(t, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {type:We.Element, element:t, token:n});
  }
  removeEntry(t) {
    const n = this.entries.indexOf(t);
    n !== -1 && this.entries.splice(n, 1);
  }
  clearToLastMarker() {
    const t = this.entries.indexOf(Ai);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  getElementEntryInScopeWithTagName(t) {
    const n = this.entries.find(r => r.type === We.Marker || this.treeAdapter.getTagName(r.element) === t);
    return n && n.type === We.Element ? n : null;
  }
  getElementEntry(t) {
    return this.entries.find(n => n.type === We.Element && n.element === t);
  }
}
const ut = {createDocument() {
  return {nodeName:"#document", mode:ve.NO_QUIRKS, childNodes:[]};
}, createDocumentFragment() {
  return {nodeName:"#document-fragment", childNodes:[]};
}, createElement(e, t, n) {
  return {nodeName:e, tagName:e, attrs:n, namespaceURI:t, childNodes:[], parentNode:null};
}, createCommentNode(e) {
  return {nodeName:"#comment", data:e, parentNode:null};
}, createTextNode(e) {
  return {nodeName:"#text", value:e, parentNode:null};
}, appendChild(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, insertBefore(e, t, n) {
  const r = e.childNodes.indexOf(n);
  e.childNodes.splice(r, 0, t), t.parentNode = e;
}, setTemplateContent(e, t) {
  e.content = t;
}, getTemplateContent(e) {
  return e.content;
}, setDocumentType(e, t, n, r) {
  const a = e.childNodes.find(i => i.nodeName === "#documentType");
  if (a) {
    a.name = t, a.publicId = n, a.systemId = r;
  } else {
    const i = {nodeName:"#documentType", name:t, publicId:n, systemId:r, parentNode:null};
    ut.appendChild(e, i);
  }
}, setDocumentMode(e, t) {
  e.mode = t;
}, getDocumentMode(e) {
  return e.mode;
}, detachNode(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
}, insertText(e, t) {
  if (e.childNodes.length > 0) {
    const n = e.childNodes[e.childNodes.length - 1];
    if (ut.isTextNode(n)) {
      n.value += t;
      return;
    }
  }
  ut.appendChild(e, ut.createTextNode(t));
}, insertTextBefore(e, t, n) {
  const r = e.childNodes[e.childNodes.indexOf(n) - 1];
  r && ut.isTextNode(r) ? r.value += t : ut.insertBefore(e, ut.createTextNode(t), n);
}, adoptAttributes(e, t) {
  const n = new Set(e.attrs.map(r => r.name));
  for (let r = 0; r < t.length; r++) {
    n.has(t[r].name) || e.attrs.push(t[r]);
  }
}, getFirstChild(e) {
  return e.childNodes[0];
}, getChildNodes(e) {
  return e.childNodes;
}, getParentNode(e) {
  return e.parentNode;
}, getAttrList(e) {
  return e.attrs;
}, getTagName(e) {
  return e.tagName;
}, getNamespaceURI(e) {
  return e.namespaceURI;
}, getTextNodeContent(e) {
  return e.value;
}, getCommentNodeContent(e) {
  return e.data;
}, getDocumentTypeNodeName(e) {
  return e.name;
}, getDocumentTypeNodePublicId(e) {
  return e.publicId;
}, getDocumentTypeNodeSystemId(e) {
  return e.systemId;
}, isTextNode(e) {
  return e.nodeName === "#text";
}, isCommentNode(e) {
  return e.nodeName === "#comment";
}, isDocumentTypeNode(e) {
  return e.nodeName === "#documentType";
}, isElementNode(e) {
  return Object.prototype.hasOwnProperty.call(e, "tagName");
}, setNodeSourceCodeLocation(e, t) {
  e.sourceCodeLocation = t;
}, getNodeSourceCodeLocation(e) {
  return e.sourceCodeLocation;
}, updateNodeSourceCodeLocation(e, t) {
  e.sourceCodeLocation = {...e.sourceCodeLocation, ...t};
}}, fs = "html", ng = "about:legacy-compat", rg = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", hs = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", 
"-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", 
"-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", 
"-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", 
"-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"], ag = [...hs, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"], ig = new Set(["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"]), ps = ["-//w3c//dtd xhtml 1.0 frameset//", 
"-//w3c//dtd xhtml 1.0 transitional//"], ug = [...ps, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
function xi(e, t) {
  return t.some(n => e.startsWith(n));
}
function sg(e) {
  return e.name === fs && e.publicId === null && (e.systemId === null || e.systemId === ng);
}
function og(e) {
  if (e.name !== fs) {
    return ve.QUIRKS;
  }
  const {systemId:t} = e;
  if (t && t.toLowerCase() === rg) {
    return ve.QUIRKS;
  }
  let {publicId:n} = e;
  if (n !== null) {
    if (n = n.toLowerCase(), ig.has(n)) {
      return ve.QUIRKS;
    }
    let r = t === null ? ag : hs;
    if (xi(n, r)) {
      return ve.QUIRKS;
    }
    if (r = t === null ? ps : ug, xi(n, r)) {
      return ve.LIMITED_QUIRKS;
    }
  }
  return ve.NO_QUIRKS;
}
const Si = {TEXT_HTML:"text/html", APPLICATION_XML:"application/xhtml+xml"}, lg = "definitionurl", cg = "definitionURL", dg = new Map(["attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", 
"maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", 
"yChannelSelector", "zoomAndPan"].map(e => [e.toLowerCase(), e])), fg = new Map([["xlink:actuate", {prefix:"xlink", name:"actuate", namespace:P.XLINK}], ["xlink:arcrole", {prefix:"xlink", name:"arcrole", namespace:P.XLINK}], ["xlink:href", {prefix:"xlink", name:"href", namespace:P.XLINK}], ["xlink:role", {prefix:"xlink", name:"role", namespace:P.XLINK}], ["xlink:show", {prefix:"xlink", name:"show", namespace:P.XLINK}], ["xlink:title", {prefix:"xlink", name:"title", namespace:P.XLINK}], ["xlink:type", 
{prefix:"xlink", name:"type", namespace:P.XLINK}], ["xml:lang", {prefix:"xml", name:"lang", namespace:P.XML}], ["xml:space", {prefix:"xml", name:"space", namespace:P.XML}], ["xmlns", {prefix:"", name:"xmlns", namespace:P.XMLNS}], ["xmlns:xlink", {prefix:"xmlns", name:"xlink", namespace:P.XMLNS}]]), hg = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", 
"feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(e => [e.toLowerCase(), e])), pg = new Set([s.B, s.BIG, s.BLOCKQUOTE, s.BODY, s.BR, s.CENTER, s.CODE, s.DD, s.DIV, s.DL, s.DT, s.EM, s.EMBED, s.H1, 
s.H2, s.H3, s.H4, s.H5, s.H6, s.HEAD, s.HR, s.I, s.IMG, s.LI, s.LISTING, s.MENU, s.META, s.NOBR, s.OL, s.P, s.PRE, s.RUBY, s.S, s.SMALL, s.SPAN, s.STRONG, s.STRIKE, s.SUB, s.SUP, s.TABLE, s.TT, s.U, s.UL, s.VAR]);
function mg(e) {
  const t = e.tagID;
  return t === s.FONT && e.attrs.some(({name:r}) => r === Tt.COLOR || r === Tt.SIZE || r === Tt.FACE) || pg.has(t);
}
function ms(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    if (e.attrs[t].name === lg) {
      e.attrs[t].name = cg;
      break;
    }
  }
}
function gs(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = dg.get(e.attrs[t].name);
    n != null && (e.attrs[t].name = n);
  }
}
function ea(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = fg.get(e.attrs[t].name);
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
}
function gg(e) {
  const t = hg.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = vt(e.tagName));
}
function bg(e, t) {
  return t === P.MATHML && (e === s.MI || e === s.MO || e === s.MN || e === s.MS || e === s.MTEXT);
}
function Eg(e, t, n) {
  if (t === P.MATHML && e === s.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++) {
      if (n[r].name === Tt.ENCODING) {
        const a = n[r].value.toLowerCase();
        return a === Si.TEXT_HTML || a === Si.APPLICATION_XML;
      }
    }
  }
  return t === P.SVG && (e === s.FOREIGN_OBJECT || e === s.DESC || e === s.TITLE);
}
function Tg(e, t, n, r) {
  return (!r || r === P.HTML) && Eg(e, t, n) || (!r || r === P.MATHML) && bg(e, t);
}
const yg = "hidden", _g = 8, Ag = 3;
var _;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", 
  e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(_ || (_ = {}));
const xg = {startLine:-1, startCol:-1, startOffset:-1, endLine:-1, endCol:-1, endOffset:-1}, bs = new Set([s.TABLE, s.TBODY, s.TFOOT, s.THEAD, s.TR]), ki = {scriptingEnabled:!0, sourceCodeLocationInfo:!1, treeAdapter:ut, onParseError:null};
class Ci {
  constructor(t, n, r = null, a = null) {
    this.fragmentContext = r, this.scriptHandler = a, this.currentToken = null, this.stopped = !1, this.insertionMode = _.INITIAL, this.originalInsertionMode = _.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {...ki, ...t}, this.treeAdapter = this.options.treeAdapter, 
    this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new Wm(this.options, this), this.activeFormattingElements = new tg(this.treeAdapter), this.fragmentContextID = r ? vt(this.treeAdapter.getTagName(r)) : s.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new eg(this.document, this.treeAdapter, this);
  }
  static parse(t, n) {
    const r = new this(n);
    return r.tokenizer.write(t, !0), r.document;
  }
  static getFragmentParser(t, n) {
    const r = {...ki, ...n};
    t ?? (t = r.treeAdapter.createElement(I.TEMPLATE, P.HTML, []));
    const a = r.treeAdapter.createElement("documentmock", P.HTML, []), i = new this(r, a, t);
    return i.fragmentContextID === s.TEMPLATE && i.tmplInsertionModeStack.unshift(_.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, n), n;
  }
  _err(t, n, r) {
    var a;
    if (!this.onParseError) {
      return;
    }
    const i = (a = t.location) !== null && a !== void 0 ? a : xg, u = {code:n, startLine:i.startLine, startCol:i.startCol, startOffset:i.startOffset, endLine:r ? i.startLine : i.endLine, endCol:r ? i.startCol : i.endCol, endOffset:r ? i.startOffset : i.endOffset};
    this.onParseError(u);
  }
  onItemPush(t, n, r) {
    var a, i;
    (i = (a = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(a, t), r && this.openElements.stackTop > 0 && this._setContextModes(t, n);
  }
  onItemPop(t, n) {
    var r, a;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (a = (r = this.treeAdapter).onItemPop) === null || a === void 0 || a.call(r, t, this.openElements.current), n) {
      let i, u;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, u = this.fragmentContextID) : {current:i, currentTagId:u} = this.openElements, this._setContextModes(i, u);
    }
  }
  _setContextModes(t, n) {
    const r = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === P.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && t !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, t);
  }
  _switchToTextParsing(t, n) {
    this._insertElement(t, P.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = _.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = _.TEXT, this.originalInsertionMode = _.IN_BODY, this.tokenizer.state = fe.PLAINTEXT;
  }
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t;) {
      if (this.treeAdapter.getTagName(t) === I.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== P.HTML)) {
      switch(this.fragmentContextID) {
        case s.TITLE:
        case s.TEXTAREA:
          {
            this.tokenizer.state = fe.RCDATA;
            break;
          }
        case s.STYLE:
        case s.XMP:
        case s.IFRAME:
        case s.NOEMBED:
        case s.NOFRAMES:
        case s.NOSCRIPT:
          {
            this.tokenizer.state = fe.RAWTEXT;
            break;
          }
        case s.SCRIPT:
          {
            this.tokenizer.state = fe.SCRIPT_DATA;
            break;
          }
        case s.PLAINTEXT:
          {
            this.tokenizer.state = fe.PLAINTEXT;
            break;
          }
      }
    }
  }
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", a = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, a), t.location) {
      const u = this.treeAdapter.getChildNodes(this.document).find(o => this.treeAdapter.isDocumentTypeNode(o));
      u && this.treeAdapter.setNodeSourceCodeLocation(u, t.location);
    }
  }
  _attachElementToTree(t, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {...n, startTag:n};
      this.treeAdapter.setNodeSourceCodeLocation(t, r);
    }
    if (this._shouldFosterParentOnInsertion()) {
      this._fosterParentElement(t);
    } else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, t);
    }
  }
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location);
  }
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID);
  }
  _insertFakeElement(t, n) {
    const r = this.treeAdapter.createElement(t, P.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, P.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(I.HTML, P.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, s.HTML);
  }
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  _insertCharacters(t) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({parent:n, beforeElement:r} = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, t.chars, r) : this.treeAdapter.insertText(n, t.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, t.chars)), !t.location) {
      return;
    }
    const a = this.treeAdapter.getChildNodes(n), i = r ? a.lastIndexOf(r) : a.length, u = a[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(u)) {
      const {endLine:l, endCol:c, endOffset:f} = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(u, {endLine:l, endCol:c, endOffset:f});
    } else {
      this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(u, t.location);
    }
  }
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t)) {
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
    }
  }
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const r = n.location, a = this.treeAdapter.getTagName(t), i = n.type === Z.END_TAG && a === n.tagName ? {endTag:{...r}, endLine:r.endLine, endCol:r.endCol, endOffset:r.endOffset} : {endLine:r.startLine, endCol:r.startCol, endOffset:r.startOffset};
      this.treeAdapter.updateNodeSourceCodeLocation(t, i);
    }
  }
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML) {
      return !1;
    }
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : {current:n, currentTagId:r} = this.openElements, t.tagID === s.SVG && this.treeAdapter.getTagName(n) === I.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === P.MATHML ? !1 : this.tokenizer.inForeignNode || (t.tagID === s.MGLYPH || t.tagID === s.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, P.HTML);
  }
  _processToken(t) {
    switch(t.type) {
      case Z.CHARACTER:
        {
          this.onCharacter(t);
          break;
        }
      case Z.NULL_CHARACTER:
        {
          this.onNullCharacter(t);
          break;
        }
      case Z.COMMENT:
        {
          this.onComment(t);
          break;
        }
      case Z.DOCTYPE:
        {
          this.onDoctype(t);
          break;
        }
      case Z.START_TAG:
        {
          this._processStartTag(t);
          break;
        }
      case Z.END_TAG:
        {
          this.onEndTag(t);
          break;
        }
      case Z.EOF:
        {
          this.onEof(t);
          break;
        }
      case Z.WHITESPACE_CHARACTER:
        {
          this.onWhitespaceCharacter(t);
          break;
        }
    }
  }
  _isIntegrationPoint(t, n, r) {
    const a = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return Tg(t, a, i, r);
  }
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const n = this.activeFormattingElements.entries.findIndex(a => a.type === We.Marker || this.openElements.contains(a.element)), r = n === -1 ? t - 1 : n - 1;
      for (let a = r; a >= 0; a--) {
        const i = this.activeFormattingElements.entries[a];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = _.IN_ROW;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(s.P), this.openElements.popUntilTagNamePopped(s.P);
  }
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      switch(t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case s.TR:
          {
            this.insertionMode = _.IN_ROW;
            return;
          }
        case s.TBODY:
        case s.THEAD:
        case s.TFOOT:
          {
            this.insertionMode = _.IN_TABLE_BODY;
            return;
          }
        case s.CAPTION:
          {
            this.insertionMode = _.IN_CAPTION;
            return;
          }
        case s.COLGROUP:
          {
            this.insertionMode = _.IN_COLUMN_GROUP;
            return;
          }
        case s.TABLE:
          {
            this.insertionMode = _.IN_TABLE;
            return;
          }
        case s.BODY:
          {
            this.insertionMode = _.IN_BODY;
            return;
          }
        case s.FRAMESET:
          {
            this.insertionMode = _.IN_FRAMESET;
            return;
          }
        case s.SELECT:
          {
            this._resetInsertionModeForSelect(t);
            return;
          }
        case s.TEMPLATE:
          {
            this.insertionMode = this.tmplInsertionModeStack[0];
            return;
          }
        case s.HTML:
          {
            this.insertionMode = this.headElement ? _.AFTER_HEAD : _.BEFORE_HEAD;
            return;
          }
        case s.TD:
        case s.TH:
          {
            if (t > 0) {
              this.insertionMode = _.IN_CELL;
              return;
            }
            break;
          }
        case s.HEAD:
          {
            if (t > 0) {
              this.insertionMode = _.IN_HEAD;
              return;
            }
            break;
          }
      }
    }
    this.insertionMode = _.IN_BODY;
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0) {
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === s.TEMPLATE) {
          break;
        }
        if (r === s.TABLE) {
          this.insertionMode = _.IN_SELECT_IN_TABLE;
          return;
        }
      }
    }
    this.insertionMode = _.IN_SELECT;
  }
  _isElementCausesFosterParenting(t) {
    return bs.has(t);
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const n = this.openElements.items[t];
      switch(this.openElements.tagIDs[t]) {
        case s.TEMPLATE:
          {
            if (this.treeAdapter.getNamespaceURI(n) === P.HTML) {
              return {parent:this.treeAdapter.getTemplateContent(n), beforeElement:null};
            }
            break;
          }
        case s.TABLE:
          {
            const r = this.treeAdapter.getParentNode(n);
            return r ? {parent:r, beforeElement:n} : {parent:this.openElements.items[t - 1], beforeElement:null};
          }
      }
    }
    return {parent:this.openElements.items[0], beforeElement:null};
  }
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  _isSpecialElement(t, n) {
    const r = this.treeAdapter.getNamespaceURI(t);
    return Ym[r].has(n);
  }
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      J1(this, t);
      return;
    }
    switch(this.insertionMode) {
      case _.INITIAL:
        {
          jt(this, t);
          break;
        }
      case _.BEFORE_HTML:
        {
          Qt(this, t);
          break;
        }
      case _.BEFORE_HEAD:
        {
          Kt(this, t);
          break;
        }
      case _.IN_HEAD:
        {
          Zt(this, t);
          break;
        }
      case _.IN_HEAD_NO_SCRIPT:
        {
          Jt(this, t);
          break;
        }
      case _.AFTER_HEAD:
        {
          en(this, t);
          break;
        }
      case _.IN_BODY:
      case _.IN_CAPTION:
      case _.IN_CELL:
      case _.IN_TEMPLATE:
        {
          Ts(this, t);
          break;
        }
      case _.TEXT:
      case _.IN_SELECT:
      case _.IN_SELECT_IN_TABLE:
        {
          this._insertCharacters(t);
          break;
        }
      case _.IN_TABLE:
      case _.IN_TABLE_BODY:
      case _.IN_ROW:
        {
          hr(this, t);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          ks(this, t);
          break;
        }
      case _.IN_COLUMN_GROUP:
        {
          Rn(this, t);
          break;
        }
      case _.AFTER_BODY:
        {
          wn(this, t);
          break;
        }
      case _.AFTER_AFTER_BODY:
        {
          kn(this, t);
          break;
        }
    }
  }
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Z1(this, t);
      return;
    }
    switch(this.insertionMode) {
      case _.INITIAL:
        {
          jt(this, t);
          break;
        }
      case _.BEFORE_HTML:
        {
          Qt(this, t);
          break;
        }
      case _.BEFORE_HEAD:
        {
          Kt(this, t);
          break;
        }
      case _.IN_HEAD:
        {
          Zt(this, t);
          break;
        }
      case _.IN_HEAD_NO_SCRIPT:
        {
          Jt(this, t);
          break;
        }
      case _.AFTER_HEAD:
        {
          en(this, t);
          break;
        }
      case _.TEXT:
        {
          this._insertCharacters(t);
          break;
        }
      case _.IN_TABLE:
      case _.IN_TABLE_BODY:
      case _.IN_ROW:
        {
          hr(this, t);
          break;
        }
      case _.IN_COLUMN_GROUP:
        {
          Rn(this, t);
          break;
        }
      case _.AFTER_BODY:
        {
          wn(this, t);
          break;
        }
      case _.AFTER_AFTER_BODY:
        {
          kn(this, t);
          break;
        }
    }
  }
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      wr(this, t);
      return;
    }
    switch(this.insertionMode) {
      case _.INITIAL:
      case _.BEFORE_HTML:
      case _.BEFORE_HEAD:
      case _.IN_HEAD:
      case _.IN_HEAD_NO_SCRIPT:
      case _.AFTER_HEAD:
      case _.IN_BODY:
      case _.IN_TABLE:
      case _.IN_CAPTION:
      case _.IN_COLUMN_GROUP:
      case _.IN_TABLE_BODY:
      case _.IN_ROW:
      case _.IN_CELL:
      case _.IN_SELECT:
      case _.IN_SELECT_IN_TABLE:
      case _.IN_TEMPLATE:
      case _.IN_FRAMESET:
      case _.AFTER_FRAMESET:
        {
          wr(this, t);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          qt(this, t);
          break;
        }
      case _.AFTER_BODY:
        {
          Lg(this, t);
          break;
        }
      case _.AFTER_AFTER_BODY:
      case _.AFTER_AFTER_FRAMESET:
        {
          Rg(this, t);
          break;
        }
    }
  }
  onDoctype(t) {
    switch(this.skipNextNewLine = !1, this.insertionMode) {
      case _.INITIAL:
        {
          wg(this, t);
          break;
        }
      case _.BEFORE_HEAD:
      case _.IN_HEAD:
      case _.IN_HEAD_NO_SCRIPT:
      case _.AFTER_HEAD:
        {
          this._err(t, R.misplacedDoctype);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          qt(this, t);
          break;
        }
    }
  }
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, R.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? eb(this, t) : this._startTagOutsideForeignContent(t);
  }
  _startTagOutsideForeignContent(t) {
    switch(this.insertionMode) {
      case _.INITIAL:
        {
          jt(this, t);
          break;
        }
      case _.BEFORE_HTML:
        {
          Dg(this, t);
          break;
        }
      case _.BEFORE_HEAD:
        {
          Fg(this, t);
          break;
        }
      case _.IN_HEAD:
        {
          ze(this, t);
          break;
        }
      case _.IN_HEAD_NO_SCRIPT:
        {
          vg(this, t);
          break;
        }
      case _.AFTER_HEAD:
        {
          Hg(this, t);
          break;
        }
      case _.IN_BODY:
        {
          Se(this, t);
          break;
        }
      case _.IN_TABLE:
        {
          Dt(this, t);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          qt(this, t);
          break;
        }
      case _.IN_CAPTION:
        {
          M1(this, t);
          break;
        }
      case _.IN_COLUMN_GROUP:
        {
          ra(this, t);
          break;
        }
      case _.IN_TABLE_BODY:
        {
          qn(this, t);
          break;
        }
      case _.IN_ROW:
        {
          Gn(this, t);
          break;
        }
      case _.IN_CELL:
        {
          U1(this, t);
          break;
        }
      case _.IN_SELECT:
        {
          Ns(this, t);
          break;
        }
      case _.IN_SELECT_IN_TABLE:
        {
          z1(this, t);
          break;
        }
      case _.IN_TEMPLATE:
        {
          Y1(this, t);
          break;
        }
      case _.AFTER_BODY:
        {
          q1(this, t);
          break;
        }
      case _.IN_FRAMESET:
        {
          G1(this, t);
          break;
        }
      case _.AFTER_FRAMESET:
        {
          V1(this, t);
          break;
        }
      case _.AFTER_AFTER_BODY:
        {
          Q1(this, t);
          break;
        }
      case _.AFTER_AFTER_FRAMESET:
        {
          K1(this, t);
          break;
        }
    }
  }
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? tb(this, t) : this._endTagOutsideForeignContent(t);
  }
  _endTagOutsideForeignContent(t) {
    switch(this.insertionMode) {
      case _.INITIAL:
        {
          jt(this, t);
          break;
        }
      case _.BEFORE_HTML:
        {
          Pg(this, t);
          break;
        }
      case _.BEFORE_HEAD:
        {
          Mg(this, t);
          break;
        }
      case _.IN_HEAD:
        {
          Bg(this, t);
          break;
        }
      case _.IN_HEAD_NO_SCRIPT:
        {
          Ug(this, t);
          break;
        }
      case _.AFTER_HEAD:
        {
          zg(this, t);
          break;
        }
      case _.IN_BODY:
        {
          jn(this, t);
          break;
        }
      case _.TEXT:
        {
          C1(this, t);
          break;
        }
      case _.IN_TABLE:
        {
          un(this, t);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          qt(this, t);
          break;
        }
      case _.IN_CAPTION:
        {
          B1(this, t);
          break;
        }
      case _.IN_COLUMN_GROUP:
        {
          v1(this, t);
          break;
        }
      case _.IN_TABLE_BODY:
        {
          Dr(this, t);
          break;
        }
      case _.IN_ROW:
        {
          Is(this, t);
          break;
        }
      case _.IN_CELL:
        {
          H1(this, t);
          break;
        }
      case _.IN_SELECT:
        {
          Os(this, t);
          break;
        }
      case _.IN_SELECT_IN_TABLE:
        {
          $1(this, t);
          break;
        }
      case _.IN_TEMPLATE:
        {
          j1(this, t);
          break;
        }
      case _.AFTER_BODY:
        {
          Rs(this, t);
          break;
        }
      case _.IN_FRAMESET:
        {
          W1(this, t);
          break;
        }
      case _.AFTER_FRAMESET:
        {
          X1(this, t);
          break;
        }
      case _.AFTER_AFTER_BODY:
        {
          kn(this, t);
          break;
        }
    }
  }
  onEof(t) {
    switch(this.insertionMode) {
      case _.INITIAL:
        {
          jt(this, t);
          break;
        }
      case _.BEFORE_HTML:
        {
          Qt(this, t);
          break;
        }
      case _.BEFORE_HEAD:
        {
          Kt(this, t);
          break;
        }
      case _.IN_HEAD:
        {
          Zt(this, t);
          break;
        }
      case _.IN_HEAD_NO_SCRIPT:
        {
          Jt(this, t);
          break;
        }
      case _.AFTER_HEAD:
        {
          en(this, t);
          break;
        }
      case _.IN_BODY:
      case _.IN_TABLE:
      case _.IN_CAPTION:
      case _.IN_COLUMN_GROUP:
      case _.IN_TABLE_BODY:
      case _.IN_ROW:
      case _.IN_CELL:
      case _.IN_SELECT:
      case _.IN_SELECT_IN_TABLE:
        {
          xs(this, t);
          break;
        }
      case _.TEXT:
        {
          I1(this, t);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          qt(this, t);
          break;
        }
      case _.IN_TEMPLATE:
        {
          Ls(this, t);
          break;
        }
      case _.AFTER_BODY:
      case _.IN_FRAMESET:
      case _.AFTER_FRAMESET:
      case _.AFTER_AFTER_BODY:
      case _.AFTER_AFTER_FRAMESET:
        {
          na(this, t);
          break;
        }
    }
  }
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === b.LINE_FEED)) {
      if (t.chars.length === 1) {
        return;
      }
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch(this.insertionMode) {
      case _.IN_HEAD:
      case _.IN_HEAD_NO_SCRIPT:
      case _.AFTER_HEAD:
      case _.TEXT:
      case _.IN_COLUMN_GROUP:
      case _.IN_SELECT:
      case _.IN_SELECT_IN_TABLE:
      case _.IN_FRAMESET:
      case _.AFTER_FRAMESET:
        {
          this._insertCharacters(t);
          break;
        }
      case _.IN_BODY:
      case _.IN_CAPTION:
      case _.IN_CELL:
      case _.IN_TEMPLATE:
      case _.AFTER_BODY:
      case _.AFTER_AFTER_BODY:
      case _.AFTER_AFTER_FRAMESET:
        {
          Es(this, t);
          break;
        }
      case _.IN_TABLE:
      case _.IN_TABLE_BODY:
      case _.IN_ROW:
        {
          hr(this, t);
          break;
        }
      case _.IN_TABLE_TEXT:
        {
          Ss(this, t);
          break;
        }
    }
  }
}
function Sg(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagID) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : As(e, t), n;
}
function kg(e, t) {
  let n = null, r = e.openElements.stackTop;
  for (; r >= 0; r--) {
    const a = e.openElements.items[r];
    if (a === t.element) {
      break;
    }
    e._isSpecialElement(a, e.openElements.tagIDs[r]) && (n = a);
  }
  return n || (e.openElements.shortenToLength(Math.max(r, 0)), e.activeFormattingElements.removeEntry(t)), n;
}
function Cg(e, t, n) {
  let r = t, a = e.openElements.getCommonAncestor(t);
  for (let i = 0, u = a; u !== n; i++, u = a) {
    a = e.openElements.getCommonAncestor(u);
    const o = e.activeFormattingElements.getElementEntry(u), l = o && i >= Ag;
    !o || l ? (l && e.activeFormattingElements.removeEntry(o), e.openElements.remove(u)) : (u = Ig(e, o), r === t && (e.activeFormattingElements.bookmark = o), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(u, r), r = u);
  }
  return r;
}
function Ig(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function Ng(e, t, n) {
  const r = e.treeAdapter.getTagName(t), a = vt(r);
  if (e._isElementCausesFosterParenting(a)) {
    e._fosterParentElement(n);
  } else {
    const i = e.treeAdapter.getNamespaceURI(t);
    a === s.TEMPLATE && i === P.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function Og(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), {token:a} = n, i = e.treeAdapter.createElement(a.tagName, r, a.attrs);
  e._adoptNodes(t, i), e.treeAdapter.appendChild(t, i), e.activeFormattingElements.insertElementAfterBookmark(i, a), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, i, a.tagID);
}
function ta(e, t) {
  for (let n = 0; n < _g; n++) {
    const r = Sg(e, t);
    if (!r) {
      break;
    }
    const a = kg(e, r);
    if (!a) {
      break;
    }
    e.activeFormattingElements.bookmark = r;
    const i = Cg(e, a, r.element), u = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(i), u && Ng(e, u, i), Og(e, a, r);
  }
}
function wr(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function Lg(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Rg(e, t) {
  e._appendCommentNode(t, e.document);
}
function na(e, t) {
  if (e.stopped = !0, t.location) {
    const n = e.fragmentContext ? 0 : 2;
    for (let r = e.openElements.stackTop; r >= n; r--) {
      e._setEndLocation(e.openElements.items[r], t);
    }
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const r = e.openElements.items[0], a = e.treeAdapter.getNodeSourceCodeLocation(r);
      if (a && !a.endTag && (e._setEndLocation(r, t), e.openElements.stackTop >= 1)) {
        const i = e.openElements.items[1], u = e.treeAdapter.getNodeSourceCodeLocation(i);
        u && !u.endTag && e._setEndLocation(i, t);
      }
    }
  }
}
function wg(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? ve.QUIRKS : og(t);
  sg(t) || e._err(t, R.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = _.BEFORE_HTML;
}
function jt(e, t) {
  e._err(t, R.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, ve.QUIRKS), e.insertionMode = _.BEFORE_HTML, e._processToken(t);
}
function Dg(e, t) {
  t.tagID === s.HTML ? (e._insertElement(t, P.HTML), e.insertionMode = _.BEFORE_HEAD) : Qt(e, t);
}
function Pg(e, t) {
  const n = t.tagID;
  (n === s.HTML || n === s.HEAD || n === s.BODY || n === s.BR) && Qt(e, t);
}
function Qt(e, t) {
  e._insertFakeRootElement(), e.insertionMode = _.BEFORE_HEAD, e._processToken(t);
}
function Fg(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.HEAD:
      {
        e._insertElement(t, P.HTML), e.headElement = e.openElements.current, e.insertionMode = _.IN_HEAD;
        break;
      }
    default:
      Kt(e, t);
  }
}
function Mg(e, t) {
  const n = t.tagID;
  n === s.HEAD || n === s.BODY || n === s.HTML || n === s.BR ? Kt(e, t) : e._err(t, R.endTagWithoutMatchingOpenElement);
}
function Kt(e, t) {
  e._insertFakeElement(I.HEAD, s.HEAD), e.headElement = e.openElements.current, e.insertionMode = _.IN_HEAD, e._processToken(t);
}
function ze(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
      {
        e._appendElement(t, P.HTML), t.ackSelfClosing = !0;
        break;
      }
    case s.TITLE:
      {
        e._switchToTextParsing(t, fe.RCDATA);
        break;
      }
    case s.NOSCRIPT:
      {
        e.options.scriptingEnabled ? e._switchToTextParsing(t, fe.RAWTEXT) : (e._insertElement(t, P.HTML), e.insertionMode = _.IN_HEAD_NO_SCRIPT);
        break;
      }
    case s.NOFRAMES:
    case s.STYLE:
      {
        e._switchToTextParsing(t, fe.RAWTEXT);
        break;
      }
    case s.SCRIPT:
      {
        e._switchToTextParsing(t, fe.SCRIPT_DATA);
        break;
      }
    case s.TEMPLATE:
      {
        e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = _.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(_.IN_TEMPLATE);
        break;
      }
    case s.HEAD:
      {
        e._err(t, R.misplacedStartTagForHeadElement);
        break;
      }
    default:
      Zt(e, t);
  }
}
function Bg(e, t) {
  switch(t.tagID) {
    case s.HEAD:
      {
        e.openElements.pop(), e.insertionMode = _.AFTER_HEAD;
        break;
      }
    case s.BODY:
    case s.BR:
    case s.HTML:
      {
        Zt(e, t);
        break;
      }
    case s.TEMPLATE:
      {
        St(e, t);
        break;
      }
    default:
      e._err(t, R.endTagWithoutMatchingOpenElement);
  }
}
function St(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== s.TEMPLATE && e._err(t, R.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(s.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, R.endTagWithoutMatchingOpenElement);
}
function Zt(e, t) {
  e.openElements.pop(), e.insertionMode = _.AFTER_HEAD, e._processToken(t);
}
function vg(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.BASEFONT:
    case s.BGSOUND:
    case s.HEAD:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.STYLE:
      {
        ze(e, t);
        break;
      }
    case s.NOSCRIPT:
      {
        e._err(t, R.nestedNoscriptInHead);
        break;
      }
    default:
      Jt(e, t);
  }
}
function Ug(e, t) {
  switch(t.tagID) {
    case s.NOSCRIPT:
      {
        e.openElements.pop(), e.insertionMode = _.IN_HEAD;
        break;
      }
    case s.BR:
      {
        Jt(e, t);
        break;
      }
    default:
      e._err(t, R.endTagWithoutMatchingOpenElement);
  }
}
function Jt(e, t) {
  const n = t.type === Z.EOF ? R.openElementsLeftAfterEof : R.disallowedContentInNoscriptInHead;
  e._err(t, n), e.openElements.pop(), e.insertionMode = _.IN_HEAD, e._processToken(t);
}
function Hg(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.BODY:
      {
        e._insertElement(t, P.HTML), e.framesetOk = !1, e.insertionMode = _.IN_BODY;
        break;
      }
    case s.FRAMESET:
      {
        e._insertElement(t, P.HTML), e.insertionMode = _.IN_FRAMESET;
        break;
      }
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.SCRIPT:
    case s.STYLE:
    case s.TEMPLATE:
    case s.TITLE:
      {
        e._err(t, R.abandonedHeadElementChild), e.openElements.push(e.headElement, s.HEAD), ze(e, t), e.openElements.remove(e.headElement);
        break;
      }
    case s.HEAD:
      {
        e._err(t, R.misplacedStartTagForHeadElement);
        break;
      }
    default:
      en(e, t);
  }
}
function zg(e, t) {
  switch(t.tagID) {
    case s.BODY:
    case s.HTML:
    case s.BR:
      {
        en(e, t);
        break;
      }
    case s.TEMPLATE:
      {
        St(e, t);
        break;
      }
    default:
      e._err(t, R.endTagWithoutMatchingOpenElement);
  }
}
function en(e, t) {
  e._insertFakeElement(I.BODY, s.BODY), e.insertionMode = _.IN_BODY, Yn(e, t);
}
function Yn(e, t) {
  switch(t.type) {
    case Z.CHARACTER:
      {
        Ts(e, t);
        break;
      }
    case Z.WHITESPACE_CHARACTER:
      {
        Es(e, t);
        break;
      }
    case Z.COMMENT:
      {
        wr(e, t);
        break;
      }
    case Z.START_TAG:
      {
        Se(e, t);
        break;
      }
    case Z.END_TAG:
      {
        jn(e, t);
        break;
      }
    case Z.EOF:
      {
        xs(e, t);
        break;
      }
  }
}
function Es(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function Ts(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function $g(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Yg(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function jg(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, P.HTML), e.insertionMode = _.IN_FRAMESET);
}
function qg(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, P.HTML);
}
function Gg(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && Rr.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, P.HTML);
}
function Wg(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, P.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function Vg(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, P.HTML), n || (e.formElement = e.openElements.current));
}
function Xg(e, t) {
  e.framesetOk = !1;
  const n = t.tagID;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const a = e.openElements.tagIDs[r];
    if (n === s.LI && a === s.LI || (n === s.DD || n === s.DT) && (a === s.DD || a === s.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(a), e.openElements.popUntilTagNamePopped(a);
      break;
    }
    if (a !== s.ADDRESS && a !== s.DIV && a !== s.P && e._isSpecialElement(e.openElements.items[r], a)) {
      break;
    }
  }
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, P.HTML);
}
function Qg(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, P.HTML), e.tokenizer.state = fe.PLAINTEXT;
}
function Kg(e, t) {
  e.openElements.hasInScope(s.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML), e.framesetOk = !1;
}
function Zg(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(I.A);
  n && (ta(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Jg(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function e1(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(s.NOBR) && (ta(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, P.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function t1(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function n1(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== ve.QUIRKS && e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, P.HTML), e.framesetOk = !1, e.insertionMode = _.IN_TABLE;
}
function ys(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, P.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function _s(e) {
  const t = ls(e, Tt.TYPE);
  return t != null && t.toLowerCase() === yg;
}
function r1(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, P.HTML), _s(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function a1(e, t) {
  e._appendElement(t, P.HTML), t.ackSelfClosing = !0;
}
function i1(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._appendElement(t, P.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function u1(e, t) {
  t.tagName = I.IMG, t.tagID = s.IMG, ys(e, t);
}
function s1(e, t) {
  e._insertElement(t, P.HTML), e.skipNextNewLine = !0, e.tokenizer.state = fe.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = _.TEXT;
}
function o1(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, fe.RAWTEXT);
}
function l1(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, fe.RAWTEXT);
}
function Ii(e, t) {
  e._switchToTextParsing(t, fe.RAWTEXT);
}
function c1(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === _.IN_TABLE || e.insertionMode === _.IN_CAPTION || e.insertionMode === _.IN_TABLE_BODY || e.insertionMode === _.IN_ROW || e.insertionMode === _.IN_CELL ? _.IN_SELECT_IN_TABLE : _.IN_SELECT;
}
function d1(e, t) {
  e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML);
}
function f1(e, t) {
  e.openElements.hasInScope(s.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, P.HTML);
}
function h1(e, t) {
  e.openElements.hasInScope(s.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(s.RTC), e._insertElement(t, P.HTML);
}
function p1(e, t) {
  e._reconstructActiveFormattingElements(), ms(t), ea(t), t.selfClosing ? e._appendElement(t, P.MATHML) : e._insertElement(t, P.MATHML), t.ackSelfClosing = !0;
}
function m1(e, t) {
  e._reconstructActiveFormattingElements(), gs(t), ea(t), t.selfClosing ? e._appendElement(t, P.SVG) : e._insertElement(t, P.SVG), t.ackSelfClosing = !0;
}
function Ni(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, P.HTML);
}
function Se(e, t) {
  switch(t.tagID) {
    case s.I:
    case s.S:
    case s.B:
    case s.U:
    case s.EM:
    case s.TT:
    case s.BIG:
    case s.CODE:
    case s.FONT:
    case s.SMALL:
    case s.STRIKE:
    case s.STRONG:
      {
        Jg(e, t);
        break;
      }
    case s.A:
      {
        Zg(e, t);
        break;
      }
    case s.H1:
    case s.H2:
    case s.H3:
    case s.H4:
    case s.H5:
    case s.H6:
      {
        Gg(e, t);
        break;
      }
    case s.P:
    case s.DL:
    case s.OL:
    case s.UL:
    case s.DIV:
    case s.DIR:
    case s.NAV:
    case s.MAIN:
    case s.MENU:
    case s.ASIDE:
    case s.CENTER:
    case s.FIGURE:
    case s.FOOTER:
    case s.HEADER:
    case s.HGROUP:
    case s.DIALOG:
    case s.DETAILS:
    case s.ADDRESS:
    case s.ARTICLE:
    case s.SEARCH:
    case s.SECTION:
    case s.SUMMARY:
    case s.FIELDSET:
    case s.BLOCKQUOTE:
    case s.FIGCAPTION:
      {
        qg(e, t);
        break;
      }
    case s.LI:
    case s.DD:
    case s.DT:
      {
        Xg(e, t);
        break;
      }
    case s.BR:
    case s.IMG:
    case s.WBR:
    case s.AREA:
    case s.EMBED:
    case s.KEYGEN:
      {
        ys(e, t);
        break;
      }
    case s.HR:
      {
        i1(e, t);
        break;
      }
    case s.RB:
    case s.RTC:
      {
        f1(e, t);
        break;
      }
    case s.RT:
    case s.RP:
      {
        h1(e, t);
        break;
      }
    case s.PRE:
    case s.LISTING:
      {
        Wg(e, t);
        break;
      }
    case s.XMP:
      {
        o1(e, t);
        break;
      }
    case s.SVG:
      {
        m1(e, t);
        break;
      }
    case s.HTML:
      {
        $g(e, t);
        break;
      }
    case s.BASE:
    case s.LINK:
    case s.META:
    case s.STYLE:
    case s.TITLE:
    case s.SCRIPT:
    case s.BGSOUND:
    case s.BASEFONT:
    case s.TEMPLATE:
      {
        ze(e, t);
        break;
      }
    case s.BODY:
      {
        Yg(e, t);
        break;
      }
    case s.FORM:
      {
        Vg(e, t);
        break;
      }
    case s.NOBR:
      {
        e1(e, t);
        break;
      }
    case s.MATH:
      {
        p1(e, t);
        break;
      }
    case s.TABLE:
      {
        n1(e, t);
        break;
      }
    case s.INPUT:
      {
        r1(e, t);
        break;
      }
    case s.PARAM:
    case s.TRACK:
    case s.SOURCE:
      {
        a1(e, t);
        break;
      }
    case s.IMAGE:
      {
        u1(e, t);
        break;
      }
    case s.BUTTON:
      {
        Kg(e, t);
        break;
      }
    case s.APPLET:
    case s.OBJECT:
    case s.MARQUEE:
      {
        t1(e, t);
        break;
      }
    case s.IFRAME:
      {
        l1(e, t);
        break;
      }
    case s.SELECT:
      {
        c1(e, t);
        break;
      }
    case s.OPTION:
    case s.OPTGROUP:
      {
        d1(e, t);
        break;
      }
    case s.NOEMBED:
    case s.NOFRAMES:
      {
        Ii(e, t);
        break;
      }
    case s.FRAMESET:
      {
        jg(e, t);
        break;
      }
    case s.TEXTAREA:
      {
        s1(e, t);
        break;
      }
    case s.NOSCRIPT:
      {
        e.options.scriptingEnabled ? Ii(e, t) : Ni(e, t);
        break;
      }
    case s.PLAINTEXT:
      {
        Qg(e, t);
        break;
      }
    case s.COL:
    case s.TH:
    case s.TD:
    case s.TR:
    case s.HEAD:
    case s.FRAME:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.CAPTION:
    case s.COLGROUP:
      break;
    default:
      Ni(e, t);
  }
}
function g1(e, t) {
  if (e.openElements.hasInScope(s.BODY) && (e.insertionMode = _.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e._setEndLocation(n, t);
  }
}
function b1(e, t) {
  e.openElements.hasInScope(s.BODY) && (e.insertionMode = _.AFTER_BODY, Rs(e, t));
}
function E1(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function T1(e) {
  const t = e.openElements.tmplCount > 0, {formElement:n} = e;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(s.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(s.FORM) : n && e.openElements.remove(n));
}
function y1(e) {
  e.openElements.hasInButtonScope(s.P) || e._insertFakeElement(I.P, s.P), e._closePElement();
}
function _1(e) {
  e.openElements.hasInListItemScope(s.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(s.LI), e.openElements.popUntilTagNamePopped(s.LI));
}
function A1(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function x1(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function S1(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function k1(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(I.BR, s.BR), e.openElements.pop(), e.framesetOk = !1;
}
function As(e, t) {
  const n = t.tagName, r = t.tagID;
  for (let a = e.openElements.stackTop; a > 0; a--) {
    const i = e.openElements.items[a], u = e.openElements.tagIDs[a];
    if (r === u && (r !== s.UNKNOWN || e.treeAdapter.getTagName(i) === n)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.stackTop >= a && e.openElements.shortenToLength(a);
      break;
    }
    if (e._isSpecialElement(i, u)) {
      break;
    }
  }
}
function jn(e, t) {
  switch(t.tagID) {
    case s.A:
    case s.B:
    case s.I:
    case s.S:
    case s.U:
    case s.EM:
    case s.TT:
    case s.BIG:
    case s.CODE:
    case s.FONT:
    case s.NOBR:
    case s.SMALL:
    case s.STRIKE:
    case s.STRONG:
      {
        ta(e, t);
        break;
      }
    case s.P:
      {
        y1(e);
        break;
      }
    case s.DL:
    case s.UL:
    case s.OL:
    case s.DIR:
    case s.DIV:
    case s.NAV:
    case s.PRE:
    case s.MAIN:
    case s.MENU:
    case s.ASIDE:
    case s.BUTTON:
    case s.CENTER:
    case s.FIGURE:
    case s.FOOTER:
    case s.HEADER:
    case s.HGROUP:
    case s.DIALOG:
    case s.ADDRESS:
    case s.ARTICLE:
    case s.DETAILS:
    case s.SEARCH:
    case s.SECTION:
    case s.SUMMARY:
    case s.LISTING:
    case s.FIELDSET:
    case s.BLOCKQUOTE:
    case s.FIGCAPTION:
      {
        E1(e, t);
        break;
      }
    case s.LI:
      {
        _1(e);
        break;
      }
    case s.DD:
    case s.DT:
      {
        A1(e, t);
        break;
      }
    case s.H1:
    case s.H2:
    case s.H3:
    case s.H4:
    case s.H5:
    case s.H6:
      {
        x1(e);
        break;
      }
    case s.BR:
      {
        k1(e);
        break;
      }
    case s.BODY:
      {
        g1(e, t);
        break;
      }
    case s.HTML:
      {
        b1(e, t);
        break;
      }
    case s.FORM:
      {
        T1(e);
        break;
      }
    case s.APPLET:
    case s.OBJECT:
    case s.MARQUEE:
      {
        S1(e, t);
        break;
      }
    case s.TEMPLATE:
      {
        St(e, t);
        break;
      }
    default:
      As(e, t);
  }
}
function xs(e, t) {
  e.tmplInsertionModeStack.length > 0 ? Ls(e, t) : na(e, t);
}
function C1(e, t) {
  var n;
  t.tagID === s.SCRIPT && ((n = e.scriptHandler) === null || n === void 0 || n.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function I1(e, t) {
  e._err(t, R.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function hr(e, t) {
  if (e.openElements.currentTagId !== void 0 && bs.has(e.openElements.currentTagId)) {
    switch(e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = _.IN_TABLE_TEXT, t.type) {
      case Z.CHARACTER:
        {
          ks(e, t);
          break;
        }
      case Z.WHITESPACE_CHARACTER:
        {
          Ss(e, t);
          break;
        }
    }
  } else {
    dn(e, t);
  }
}
function N1(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, P.HTML), e.insertionMode = _.IN_CAPTION;
}
function O1(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, P.HTML), e.insertionMode = _.IN_COLUMN_GROUP;
}
function L1(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(I.COLGROUP, s.COLGROUP), e.insertionMode = _.IN_COLUMN_GROUP, ra(e, t);
}
function R1(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, P.HTML), e.insertionMode = _.IN_TABLE_BODY;
}
function w1(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(I.TBODY, s.TBODY), e.insertionMode = _.IN_TABLE_BODY, qn(e, t);
}
function D1(e, t) {
  e.openElements.hasInTableScope(s.TABLE) && (e.openElements.popUntilTagNamePopped(s.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function P1(e, t) {
  _s(t) ? e._appendElement(t, P.HTML) : dn(e, t), t.ackSelfClosing = !0;
}
function F1(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, P.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function Dt(e, t) {
  switch(t.tagID) {
    case s.TD:
    case s.TH:
    case s.TR:
      {
        w1(e, t);
        break;
      }
    case s.STYLE:
    case s.SCRIPT:
    case s.TEMPLATE:
      {
        ze(e, t);
        break;
      }
    case s.COL:
      {
        L1(e, t);
        break;
      }
    case s.FORM:
      {
        F1(e, t);
        break;
      }
    case s.TABLE:
      {
        D1(e, t);
        break;
      }
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
      {
        R1(e, t);
        break;
      }
    case s.INPUT:
      {
        P1(e, t);
        break;
      }
    case s.CAPTION:
      {
        N1(e, t);
        break;
      }
    case s.COLGROUP:
      {
        O1(e, t);
        break;
      }
    default:
      dn(e, t);
  }
}
function un(e, t) {
  switch(t.tagID) {
    case s.TABLE:
      {
        e.openElements.hasInTableScope(s.TABLE) && (e.openElements.popUntilTagNamePopped(s.TABLE), e._resetInsertionMode());
        break;
      }
    case s.TEMPLATE:
      {
        St(e, t);
        break;
      }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TBODY:
    case s.TD:
    case s.TFOOT:
    case s.TH:
    case s.THEAD:
    case s.TR:
      break;
    default:
      dn(e, t);
  }
}
function dn(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Yn(e, t), e.fosterParentingEnabled = n;
}
function Ss(e, t) {
  e.pendingCharacterTokens.push(t);
}
function ks(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function qt(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken) {
    for (; n < e.pendingCharacterTokens.length; n++) {
      dn(e, e.pendingCharacterTokens[n]);
    }
  } else {
    for (; n < e.pendingCharacterTokens.length; n++) {
      e._insertCharacters(e.pendingCharacterTokens[n]);
    }
  }
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const Cs = new Set([s.CAPTION, s.COL, s.COLGROUP, s.TBODY, s.TD, s.TFOOT, s.TH, s.THEAD, s.TR]);
function M1(e, t) {
  const n = t.tagID;
  Cs.has(n) ? e.openElements.hasInTableScope(s.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = _.IN_TABLE, Dt(e, t)) : Se(e, t);
}
function B1(e, t) {
  const n = t.tagID;
  switch(n) {
    case s.CAPTION:
    case s.TABLE:
      {
        e.openElements.hasInTableScope(s.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = _.IN_TABLE, n === s.TABLE && un(e, t));
        break;
      }
    case s.BODY:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TBODY:
    case s.TD:
    case s.TFOOT:
    case s.TH:
    case s.THEAD:
    case s.TR:
      break;
    default:
      jn(e, t);
  }
}
function ra(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.COL:
      {
        e._appendElement(t, P.HTML), t.ackSelfClosing = !0;
        break;
      }
    case s.TEMPLATE:
      {
        ze(e, t);
        break;
      }
    default:
      Rn(e, t);
  }
}
function v1(e, t) {
  switch(t.tagID) {
    case s.COLGROUP:
      {
        e.openElements.currentTagId === s.COLGROUP && (e.openElements.pop(), e.insertionMode = _.IN_TABLE);
        break;
      }
    case s.TEMPLATE:
      {
        St(e, t);
        break;
      }
    case s.COL:
      break;
    default:
      Rn(e, t);
  }
}
function Rn(e, t) {
  e.openElements.currentTagId === s.COLGROUP && (e.openElements.pop(), e.insertionMode = _.IN_TABLE, e._processToken(t));
}
function qn(e, t) {
  switch(t.tagID) {
    case s.TR:
      {
        e.openElements.clearBackToTableBodyContext(), e._insertElement(t, P.HTML), e.insertionMode = _.IN_ROW;
        break;
      }
    case s.TH:
    case s.TD:
      {
        e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(I.TR, s.TR), e.insertionMode = _.IN_ROW, Gn(e, t);
        break;
      }
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
      {
        e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE, Dt(e, t));
        break;
      }
    default:
      Dt(e, t);
  }
}
function Dr(e, t) {
  const n = t.tagID;
  switch(t.tagID) {
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
      {
        e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE);
        break;
      }
    case s.TABLE:
      {
        e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE, un(e, t));
        break;
      }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TD:
    case s.TH:
    case s.TR:
      break;
    default:
      un(e, t);
  }
}
function Gn(e, t) {
  switch(t.tagID) {
    case s.TH:
    case s.TD:
      {
        e.openElements.clearBackToTableRowContext(), e._insertElement(t, P.HTML), e.insertionMode = _.IN_CELL, e.activeFormattingElements.insertMarker();
        break;
      }
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.TR:
      {
        e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE_BODY, qn(e, t));
        break;
      }
    default:
      Dt(e, t);
  }
}
function Is(e, t) {
  switch(t.tagID) {
    case s.TR:
      {
        e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE_BODY);
        break;
      }
    case s.TABLE:
      {
        e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE_BODY, Dr(e, t));
        break;
      }
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
      {
        (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(s.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = _.IN_TABLE_BODY, Dr(e, t));
        break;
      }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TD:
    case s.TH:
      break;
    default:
      un(e, t);
  }
}
function U1(e, t) {
  const n = t.tagID;
  Cs.has(n) ? (e.openElements.hasInTableScope(s.TD) || e.openElements.hasInTableScope(s.TH)) && (e._closeTableCell(), Gn(e, t)) : Se(e, t);
}
function H1(e, t) {
  const n = t.tagID;
  switch(n) {
    case s.TD:
    case s.TH:
      {
        e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = _.IN_ROW);
        break;
      }
    case s.TABLE:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.TR:
      {
        e.openElements.hasInTableScope(n) && (e._closeTableCell(), Is(e, t));
        break;
      }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
      break;
    default:
      jn(e, t);
  }
}
function Ns(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.OPTION:
      {
        e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e._insertElement(t, P.HTML);
        break;
      }
    case s.OPTGROUP:
      {
        e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop(), e._insertElement(t, P.HTML);
        break;
      }
    case s.HR:
      {
        e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop(), e._appendElement(t, P.HTML), t.ackSelfClosing = !0;
        break;
      }
    case s.INPUT:
    case s.KEYGEN:
    case s.TEXTAREA:
    case s.SELECT:
      {
        e.openElements.hasInSelectScope(s.SELECT) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), t.tagID !== s.SELECT && e._processStartTag(t));
        break;
      }
    case s.SCRIPT:
    case s.TEMPLATE:
      {
        ze(e, t);
        break;
      }
  }
}
function Os(e, t) {
  switch(t.tagID) {
    case s.OPTGROUP:
      {
        e.openElements.stackTop > 0 && e.openElements.currentTagId === s.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === s.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop();
        break;
      }
    case s.OPTION:
      {
        e.openElements.currentTagId === s.OPTION && e.openElements.pop();
        break;
      }
    case s.SELECT:
      {
        e.openElements.hasInSelectScope(s.SELECT) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode());
        break;
      }
    case s.TEMPLATE:
      {
        St(e, t);
        break;
      }
  }
}
function z1(e, t) {
  const n = t.tagID;
  n === s.CAPTION || n === s.TABLE || n === s.TBODY || n === s.TFOOT || n === s.THEAD || n === s.TR || n === s.TD || n === s.TH ? (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : Ns(e, t);
}
function $1(e, t) {
  const n = t.tagID;
  n === s.CAPTION || n === s.TABLE || n === s.TBODY || n === s.TFOOT || n === s.THEAD || n === s.TR || n === s.TD || n === s.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : Os(e, t);
}
function Y1(e, t) {
  switch(t.tagID) {
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.SCRIPT:
    case s.STYLE:
    case s.TEMPLATE:
    case s.TITLE:
      {
        ze(e, t);
        break;
      }
    case s.CAPTION:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
      {
        e.tmplInsertionModeStack[0] = _.IN_TABLE, e.insertionMode = _.IN_TABLE, Dt(e, t);
        break;
      }
    case s.COL:
      {
        e.tmplInsertionModeStack[0] = _.IN_COLUMN_GROUP, e.insertionMode = _.IN_COLUMN_GROUP, ra(e, t);
        break;
      }
    case s.TR:
      {
        e.tmplInsertionModeStack[0] = _.IN_TABLE_BODY, e.insertionMode = _.IN_TABLE_BODY, qn(e, t);
        break;
      }
    case s.TD:
    case s.TH:
      {
        e.tmplInsertionModeStack[0] = _.IN_ROW, e.insertionMode = _.IN_ROW, Gn(e, t);
        break;
      }
    default:
      e.tmplInsertionModeStack[0] = _.IN_BODY, e.insertionMode = _.IN_BODY, Se(e, t);
  }
}
function j1(e, t) {
  t.tagID === s.TEMPLATE && St(e, t);
}
function Ls(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(s.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : na(e, t);
}
function q1(e, t) {
  t.tagID === s.HTML ? Se(e, t) : wn(e, t);
}
function Rs(e, t) {
  var n;
  if (t.tagID === s.HTML) {
    if (e.fragmentContext || (e.insertionMode = _.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === s.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const r = e.openElements.items[1];
      r && !(!((n = e.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && e._setEndLocation(r, t);
    }
  } else {
    wn(e, t);
  }
}
function wn(e, t) {
  e.insertionMode = _.IN_BODY, Yn(e, t);
}
function G1(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.FRAMESET:
      {
        e._insertElement(t, P.HTML);
        break;
      }
    case s.FRAME:
      {
        e._appendElement(t, P.HTML), t.ackSelfClosing = !0;
        break;
      }
    case s.NOFRAMES:
      {
        ze(e, t);
        break;
      }
  }
}
function W1(e, t) {
  t.tagID === s.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== s.FRAMESET && (e.insertionMode = _.AFTER_FRAMESET));
}
function V1(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.NOFRAMES:
      {
        ze(e, t);
        break;
      }
  }
}
function X1(e, t) {
  t.tagID === s.HTML && (e.insertionMode = _.AFTER_AFTER_FRAMESET);
}
function Q1(e, t) {
  t.tagID === s.HTML ? Se(e, t) : kn(e, t);
}
function kn(e, t) {
  e.insertionMode = _.IN_BODY, Yn(e, t);
}
function K1(e, t) {
  switch(t.tagID) {
    case s.HTML:
      {
        Se(e, t);
        break;
      }
    case s.NOFRAMES:
      {
        ze(e, t);
        break;
      }
  }
}
function Z1(e, t) {
  t.chars = le, e._insertCharacters(t);
}
function J1(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function ws(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== P.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current);) {
    e.openElements.pop();
  }
}
function eb(e, t) {
  if (mg(t)) {
    ws(e), e._startTagOutsideForeignContent(t);
  } else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === P.MATHML ? ms(t) : r === P.SVG && (gg(t), gs(t)), ea(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function tb(e, t) {
  if (t.tagID === s.P || t.tagID === s.BR) {
    ws(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === P.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const a = e.treeAdapter.getTagName(r);
    if (a.toLowerCase() === t.tagName) {
      t.tagName = a, e.openElements.shortenToLength(n);
      break;
    }
  }
}
I.AREA, I.BASE, I.BASEFONT, I.BGSOUND, I.BR, I.COL, I.EMBED, I.FRAME, I.HR, I.IMG, I.INPUT, I.KEYGEN, I.LINK, I.META, I.PARAM, I.SOURCE, I.TRACK, I.WBR;
const nb = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, rb = new Set(["mdxFlowExpression", "mdxJsxFlowElement", "mdxJsxTextElement", "mdxTextExpression", "mdxjsEsm"]), Oi = {sourceCodeLocationInfo:!0, scriptingEnabled:!1};
function Ds(e, t) {
  const n = hb(e), r = Mu("type", {handlers:{root:ab, element:ib, text:ub, comment:Fs, doctype:sb, raw:lb}, unknown:cb}), a = {parser:n ? new Ci(Oi) : Ci.getFragmentParser(void 0, Oi), handle(o) {
    r(o, a);
  }, stitches:!1, options:t || {}};
  r(e, a), Ut(a, Qe());
  const i = n ? a.parser.document : a.parser.getFragment(), u = pm(i, {file:a.options.file});
  return a.stitches && $n(u, "comment", function(o, l, c) {
    const f = o;
    if (f.value.stitch && c && l !== void 0) {
      const d = c.children;
      return d[l] = f.value.stitch, l;
    }
  }), u.type === "root" && u.children.length === 1 && u.children[0].type === e.type ? u.children[0] : u;
}
function Ps(e, t) {
  let n = -1;
  if (e) {
    for (; ++n < e.length;) {
      t.handle(e[n]);
    }
  }
}
function ab(e, t) {
  Ps(e.children, t);
}
function ib(e, t) {
  db(e, t), Ps(e.children, t), fb(e, t);
}
function ub(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const n = {type:Z.CHARACTER, chars:e.value, location:fn(e)};
  Ut(t, Qe(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function sb(e, t) {
  const n = {type:Z.DOCTYPE, name:"html", forceQuirks:!1, publicId:"", systemId:"", location:fn(e)};
  Ut(t, Qe(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function ob(e, t) {
  t.stitches = !0;
  const n = pb(e);
  if ("children" in e && "children" in n) {
    const r = Ds({type:"root", children:e.children}, t.options);
    n.children = r.children;
  }
  Fs({type:"comment", value:{stitch:n}}, t);
}
function Fs(e, t) {
  const n = e.value, r = {type:Z.COMMENT, data:n, location:fn(e)};
  Ut(t, Qe(e)), t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken);
}
function lb(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, Ms(t, Qe(e)), t.parser.tokenizer.write(t.options.tagfilter ? e.value.replace(nb, "\x26lt;$1$2") : e.value, !1), 
  t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(n);
  }
}
function cb(e, t) {
  const n = e;
  if (t.options.passThrough && t.options.passThrough.includes(n.type)) {
    ob(n, t);
  } else {
    let r = "";
    throw rb.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + 
    n.type + "` node" + r);
  }
}
function Ut(e, t) {
  Ms(e, t);
  const n = e.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = e.parser.tokenizer.preprocessor.line, n.location.endCol = e.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = fe.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = 
  -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = {name:"", value:""};
}
function Ms(e, t) {
  if (t && t.offset !== void 0) {
    const n = {startLine:t.line, startCol:t.column, startOffset:t.offset, endLine:-1, endCol:-1, endOffset:-1};
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = n;
  }
}
function db(e, t) {
  const n = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === fe.PLAINTEXT) {
    return;
  }
  Ut(t, Qe(e));
  const r = t.parser.openElements.current;
  let a = "namespaceURI" in r ? r.namespaceURI : bt.html;
  a === bt.html && n === "svg" && (a = bt.svg);
  const i = Tm({...e, children:[]}, {space:a === bt.svg ? "svg" : "html"}), u = {type:Z.START_TAG, tagName:n, tagID:vt(n), selfClosing:!1, ackSelfClosing:!1, attrs:"attrs" in i ? i.attrs : [], location:fn(e)};
  t.parser.currentToken = u, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = n;
}
function fb(e, t) {
  const n = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && Im.includes(n) || t.parser.tokenizer.state === fe.PLAINTEXT) {
    return;
  }
  Ut(t, Mn(e));
  const r = {type:Z.END_TAG, tagName:n, tagID:vt(n), selfClosing:!1, ackSelfClosing:!1, attrs:[], location:fn(e)};
  t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken), n === t.parser.tokenizer.lastStartTagName && (t.parser.tokenizer.state === fe.RCDATA || t.parser.tokenizer.state === fe.RAWTEXT || t.parser.tokenizer.state === fe.SCRIPT_DATA) && (t.parser.tokenizer.state = fe.DATA);
}
function hb(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function fn(e) {
  const t = Qe(e) || {line:void 0, column:void 0, offset:void 0}, n = Mn(e) || {line:void 0, column:void 0, offset:void 0};
  return {startLine:t.line, startCol:t.column, startOffset:t.offset, endLine:n.line, endCol:n.column, endOffset:n.offset};
}
function pb(e) {
  return "children" in e ? wt({...e, children:[]}) : wt(e);
}
function mb(e) {
  return function(t, n) {
    return Ds(t, {...e, file:n});
  };
}
function Bs(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") {
    r += e;
  } else if (typeof e == "object") {
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++) {
        e[t] && (n = Bs(e[t])) && (r && (r += " "), r += n);
      }
    } else {
      for (n in e) {
        e[n] && (r && (r += " "), r += n);
      }
    }
  }
  return r;
}
function vs() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) {
    (e = arguments[n]) && (t = Bs(e)) && (r && (r += " "), r += t);
  }
  return r;
}
var gb = Object.create, Wn = Object.defineProperty, bb = Object.defineProperties, Eb = Object.getOwnPropertyDescriptor, Tb = Object.getOwnPropertyDescriptors, Us = Object.getOwnPropertyNames, Dn = Object.getOwnPropertySymbols, yb = Object.getPrototypeOf, aa = Object.prototype.hasOwnProperty, Hs = Object.prototype.propertyIsEnumerable, Li = (e, t, n) => t in e ? Wn(e, t, {enumerable:!0, configurable:!0, writable:!0, value:n}) : e[t] = n, Xe = (e, t) => {
  for (var n in t || (t = {})) {
    aa.call(t, n) && Li(e, n, t[n]);
  }
  if (Dn) {
    for (var n of Dn(t)) {
      Hs.call(t, n) && Li(e, n, t[n]);
    }
  }
  return e;
}, Vn = (e, t) => bb(e, Tb(t)), zs = (e, t) => {
  var n = {};
  for (var r in e) {
    aa.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  }
  if (e != null && Dn) {
    for (var r of Dn(e)) {
      t.indexOf(r) < 0 && Hs.call(e, r) && (n[r] = e[r]);
    }
  }
  return n;
}, _b = (e, t) => function() {
  return t || (0,e[Us(e)[0]])((t = {exports:{}}).exports, t), t.exports;
}, Ab = (e, t) => {
  for (var n in t) {
    Wn(e, n, {get:t[n], enumerable:!0});
  }
}, xb = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function") {
    for (let a of Us(t)) {
      !aa.call(e, a) && a !== n && Wn(e, a, {get:() => t[a], enumerable:!(r = Eb(t, a)) || r.enumerable});
    }
  }
  return e;
}, Sb = (e, t, n) => (n = e != null ? gb(yb(e)) : {}, xb(!e || !e.__esModule ? Wn(n, "default", {value:e, enumerable:!0}) : n, e)), kb = _b({["../../node_modules/.pnpm/prismjs@1.29.0_patch_hash\x3dvrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js"](e, t) {
  var n = function() {
    var r = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, a = 0, i = {}, u = {util:{encode:function g(T) {
      return T instanceof o ? new o(T.type, g(T.content), T.alias) : Array.isArray(T) ? T.map(g) : T.replace(/&/g, "\x26amp;").replace(/</g, "\x26lt;").replace(/\u00a0/g, " ");
    }, type:function(g) {
      return Object.prototype.toString.call(g).slice(8, -1);
    }, objId:function(g) {
      return g.__id || Object.defineProperty(g, "__id", {value:++a}), g.__id;
    }, clone:function g(T, A) {
      A = A || {};
      var y, C;
      switch(u.util.type(T)) {
        case "Object":
          if (C = u.util.objId(T), A[C]) {
            return A[C];
          }
          y = {}, A[C] = y;
          for (var N in T) {
            T.hasOwnProperty(N) && (y[N] = g(T[N], A));
          }
          return y;
        case "Array":
          return C = u.util.objId(T), A[C] ? A[C] : (y = [], A[C] = y, T.forEach(function(v, B) {
            y[B] = g(v, A);
          }), y);
        default:
          return T;
      }
    }, getLanguage:function(g) {
      for (; g;) {
        var T = r.exec(g.className);
        if (T) {
          return T[1].toLowerCase();
        }
        g = g.parentElement;
      }
      return "none";
    }, setLanguage:function(g, T) {
      g.className = g.className.replace(RegExp(r, "gi"), ""), g.classList.add("language-" + T);
    }, isActive:function(g, T, A) {
      for (var y = "no-" + T; g;) {
        var C = g.classList;
        if (C.contains(T)) {
          return !0;
        }
        if (C.contains(y)) {
          return !1;
        }
        g = g.parentElement;
      }
      return !!A;
    }}, languages:{plain:i, plaintext:i, text:i, txt:i, extend:function(g, T) {
      var A = u.util.clone(u.languages[g]);
      for (var y in T) {
        A[y] = T[y];
      }
      return A;
    }, insertBefore:function(g, T, A, y) {
      y = y || u.languages;
      var C = y[g], N = {};
      for (var v in C) {
        if (C.hasOwnProperty(v)) {
          if (v == T) {
            for (var B in A) {
              A.hasOwnProperty(B) && (N[B] = A[B]);
            }
          }
          A.hasOwnProperty(v) || (N[v] = C[v]);
        }
      }
      var O = y[g];
      return y[g] = N, u.languages.DFS(u.languages, function(j, W) {
        W === O && j != g && (this[j] = N);
      }), N;
    }, DFS:function g(T, A, y, C) {
      C = C || {};
      var N = u.util.objId;
      for (var v in T) {
        if (T.hasOwnProperty(v)) {
          A.call(T, v, T[v], y || v);
          var B = T[v], O = u.util.type(B);
          O === "Object" && !C[N(B)] ? (C[N(B)] = !0, g(B, A, null, C)) : O === "Array" && !C[N(B)] && (C[N(B)] = !0, g(B, A, v, C));
        }
      }
    }}, plugins:{}, highlight:function(g, T, A) {
      var y = {code:g, grammar:T, language:A};
      if (u.hooks.run("before-tokenize", y), !y.grammar) {
        throw new Error('The language "' + y.language + '" has no grammar.');
      }
      return y.tokens = u.tokenize(y.code, y.grammar), u.hooks.run("after-tokenize", y), o.stringify(u.util.encode(y.tokens), y.language);
    }, tokenize:function(g, T) {
      var A = T.rest;
      if (A) {
        for (var y in A) {
          T[y] = A[y];
        }
        delete T.rest;
      }
      var C = new f();
      return d(C, C.head, g), c(g, C, T, C.head, 0), p(C);
    }, hooks:{all:{}, add:function(g, T) {
      var A = u.hooks.all;
      A[g] = A[g] || [], A[g].push(T);
    }, run:function(g, T) {
      var A = u.hooks.all[g];
      if (!(!A || !A.length)) {
        for (var y = 0, C; C = A[y++];) {
          C(T);
        }
      }
    }}, Token:o};
    function o(g, T, A, y) {
      this.type = g, this.content = T, this.alias = A, this.length = (y || "").length | 0;
    }
    o.stringify = function g(T, A) {
      if (typeof T == "string") {
        return T;
      }
      if (Array.isArray(T)) {
        var y = "";
        return T.forEach(function(O) {
          y += g(O, A);
        }), y;
      }
      var C = {type:T.type, content:g(T.content, A), tag:"span", classes:["token", T.type], attributes:{}, language:A}, N = T.alias;
      N && (Array.isArray(N) ? Array.prototype.push.apply(C.classes, N) : C.classes.push(N)), u.hooks.run("wrap", C);
      var v = "";
      for (var B in C.attributes) {
        v += " " + B + '\x3d"' + (C.attributes[B] || "").replace(/"/g, "\x26quot;") + '"';
      }
      return "\x3c" + C.tag + ' class\x3d"' + C.classes.join(" ") + '"' + v + "\x3e" + C.content + "\x3c/" + C.tag + "\x3e";
    };
    function l(g, T, A, y) {
      g.lastIndex = T;
      var C = g.exec(A);
      if (C && y && C[1]) {
        var N = C[1].length;
        C.index += N, C[0] = C[0].slice(N);
      }
      return C;
    }
    function c(g, T, A, y, C, N) {
      for (var v in A) {
        if (!(!A.hasOwnProperty(v) || !A[v])) {
          var B = A[v];
          B = Array.isArray(B) ? B : [B];
          for (var O = 0; O < B.length; ++O) {
            if (N && N.cause == v + "," + O) {
              return;
            }
            var j = B[O], W = j.inside, $ = !!j.lookbehind, L = !!j.greedy, z = j.alias;
            if (L && !j.pattern.global) {
              var Y = j.pattern.toString().match(/[imsuy]*$/)[0];
              j.pattern = RegExp(j.pattern.source, Y + "g");
            }
            for (var ne = j.pattern || j, X = y.next, V = C; X !== T.tail && !(N && V >= N.reach); V += X.value.length, X = X.next) {
              var ue = X.value;
              if (T.length > g.length) {
                return;
              }
              if (!(ue instanceof o)) {
                var oe = 1, se;
                if (L) {
                  if (se = l(ne, V, g, $), !se || se.index >= g.length) {
                    break;
                  }
                  var Ee = se.index, Oe = se.index + se[0].length, x = V;
                  for (x += X.value.length; Ee >= x;) {
                    X = X.next, x += X.value.length;
                  }
                  if (x -= X.value.length, V = x, X.value instanceof o) {
                    continue;
                  }
                  for (var he = X; he !== T.tail && (x < Oe || typeof he.value == "string"); he = he.next) {
                    oe++, x += he.value.length;
                  }
                  oe--, ue = g.slice(V, x), se.index -= V;
                } else if (se = l(ne, 0, ue, $), !se) {
                  continue;
                }
                var Ee = se.index, S = se[0], Te = ue.slice(0, Ee), Me = ue.slice(Ee + S.length), ce = V + ue.length;
                N && ce > N.reach && (N.reach = ce);
                var $e = X.prev;
                Te && ($e = d(T, $e, Te), V += Te.length), m(T, $e, oe);
                var Ye = new o(v, W ? u.tokenize(S, W) : S, z, S);
                if (X = d(T, $e, Ye), Me && d(T, X, Me), oe > 1) {
                  var je = {cause:v + "," + O, reach:ce};
                  c(g, T, A, X.prev, V, je), N && je.reach > N.reach && (N.reach = je.reach);
                }
              }
            }
          }
        }
      }
    }
    function f() {
      var g = {value:null, prev:null, next:null}, T = {value:null, prev:g, next:null};
      g.next = T, this.head = g, this.tail = T, this.length = 0;
    }
    function d(g, T, A) {
      var y = T.next, C = {value:A, prev:T, next:y};
      return T.next = C, y.prev = C, g.length++, C;
    }
    function m(g, T, A) {
      for (var y = T.next, C = 0; C < A && y !== g.tail; C++) {
        y = y.next;
      }
      T.next = y, y.prev = T, g.length -= C;
    }
    function p(g) {
      for (var T = [], A = g.head.next; A !== g.tail;) {
        T.push(A.value), A = A.next;
      }
      return T;
    }
    return u;
  }();
  t.exports = n, n.default = n;
}}), D = Sb(kb());
D.languages.markup = {comment:{pattern:/\x3c!--(?:(?!\x3c!--)[\s\S])*?--\x3e/, greedy:!0}, prolog:{pattern:/<\?[\s\S]+?\?>/, greedy:!0}, doctype:{pattern:/<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|\x3c!--(?:[^-]|-(?!->))*--\x3e)*\]\s*)?>/i, greedy:!0, inside:{"internal-subset":{pattern:/(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind:!0, greedy:!0, inside:null}, string:{pattern:/"[^"]*"|'[^']*'/, greedy:!0}, punctuation:/^<!|>$|[[\]]/, "doctype-tag":/^DOCTYPE/i, name:/[^\s<>'"]+/}}, 
cdata:{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i, greedy:!0}, tag:{pattern:/<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy:!0, inside:{tag:{pattern:/^<\/?[^\s>\/]+/, inside:{punctuation:/^<\/?/, namespace:/^[^\s>\/:]+:/}}, "special-attr":[], "attr-value":{pattern:/=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside:{punctuation:[{pattern:/^=/, alias:"attr-equals"}, {pattern:/^(\s*)["']|["']$/, lookbehind:!0}]}}, punctuation:/\/?>/, 
"attr-name":{pattern:/[^\s>\/]+/, inside:{namespace:/^[^\s>\/:]+:/}}}}, entity:[{pattern:/&[\da-z]{1,8};/i, alias:"named-entity"}, /&#x?[\da-f]{1,8};/i]}, D.languages.markup.tag.inside["attr-value"].inside.entity = D.languages.markup.entity, D.languages.markup.doctype.inside["internal-subset"].inside = D.languages.markup, D.hooks.add("wrap", function(e) {
  e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "\x26"));
}), Object.defineProperty(D.languages.markup.tag, "addInlined", {value:function(e, r) {
  var n = {}, n = (n["language-" + r] = {pattern:/(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind:!0, inside:D.languages[r]}, n.cdata = /^<!\[CDATA\[|\]\]>$/i, {"included-cdata":{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i, inside:n}}), r = (n["language-" + r] = {pattern:/[\s\S]+/, inside:D.languages[r]}, {});
  r[e] = {pattern:RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
    return e;
  }), "i"), lookbehind:!0, greedy:!0, inside:n}, D.languages.insertBefore("markup", "cdata", r);
}}), Object.defineProperty(D.languages.markup.tag, "addAttribute", {value:function(e, t) {
  D.languages.markup.tag.inside["special-attr"].push({pattern:RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind:!0, inside:{"attr-name":/^[^\s=]+/, "attr-value":{pattern:/=[\s\S]+/, inside:{value:{pattern:/(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind:!0, alias:[t, "language-" + t], inside:D.languages[t]}, punctuation:[{pattern:/^=/, alias:"attr-equals"}, /"|'/]}}}});
}}), D.languages.html = D.languages.markup, D.languages.mathml = D.languages.markup, D.languages.svg = D.languages.markup, D.languages.xml = D.languages.extend("markup", {}), D.languages.ssml = D.languages.xml, D.languages.atom = D.languages.xml, D.languages.rss = D.languages.xml, function(e) {
  var t = {pattern:/\\[\\(){}[\]^$+*?|.]/, alias:"escape"}, n = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, r = "(?:[^\\\\-]|" + n.source + ")", r = RegExp(r + "-" + r), a = {pattern:/(<|')[^<>']+(?=[>']$)/, lookbehind:!0, alias:"variable"};
  e.languages.regex = {"char-class":{pattern:/((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/, lookbehind:!0, inside:{"char-class-negation":{pattern:/(^\[)\^/, lookbehind:!0, alias:"operator"}, "char-class-punctuation":{pattern:/^\[|\]$/, alias:"punctuation"}, range:{pattern:r, inside:{escape:n, "range-punctuation":{pattern:/-/, alias:"operator"}}}, "special-escape":t, "char-set":{pattern:/\\[wsd]|\\p\{[^{}]+\}/i, alias:"class-name"}, escape:n}}, "special-escape":t, "char-set":{pattern:/\.|\\[wsd]|\\p\{[^{}]+\}/i, 
  alias:"class-name"}, backreference:[{pattern:/\\(?![123][0-7]{2})[1-9]/, alias:"keyword"}, {pattern:/\\k<[^<>']+>/, alias:"keyword", inside:{"group-name":a}}], anchor:{pattern:/[$^]|\\[ABbGZz]/, alias:"function"}, escape:n, group:[{pattern:/\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/, alias:"punctuation", inside:{"group-name":a}}, {pattern:/\)/, alias:"punctuation"}], quantifier:{pattern:/(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/, alias:"number"}, alternation:{pattern:/\|/, 
  alias:"keyword"}};
}(D), D.languages.clike = {comment:[{pattern:/(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind:!0, greedy:!0}, {pattern:/(^|[^\\:])\/\/.*/, lookbehind:!0, greedy:!0}], string:{pattern:/(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy:!0}, "class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind:!0, inside:{punctuation:/[.\\]/}}, keyword:/\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, 
boolean:/\b(?:false|true)\b/, function:/\b\w+(?=\()/, number:/\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator:/[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation:/[{}[\];(),.:]/}, D.languages.javascript = D.languages.extend("clike", {"class-name":[D.languages.clike["class-name"], {pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind:!0}], keyword:[{pattern:/((?:^|\})\s*)catch\b/, lookbehind:!0}, 
{pattern:/(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind:!0}], function:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, 
number:{pattern:RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source), lookbehind:!0}, operator:/--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/}), D.languages.javascript["class-name"][0].pattern = 
/(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, D.languages.insertBefore("javascript", "keyword", {regex:{pattern:RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source), 
lookbehind:!0, greedy:!0, inside:{"regex-source":{pattern:/^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind:!0, alias:"language-regex", inside:D.languages.regex}, "regex-delimiter":/^\/|\/$/, "regex-flags":/^[a-z]+$/}}, "function-variable":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias:"function"}, parameter:[{pattern:/(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, 
lookbehind:!0, inside:D.languages.javascript}, {pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind:!0, inside:D.languages.javascript}, {pattern:/(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind:!0, inside:D.languages.javascript}, {pattern:/((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, 
lookbehind:!0, inside:D.languages.javascript}], constant:/\b[A-Z](?:[A-Z_]|\dx?)*\b/}), D.languages.insertBefore("javascript", "string", {hashbang:{pattern:/^#!.*/, greedy:!0, alias:"comment"}, "template-string":{pattern:/`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy:!0, inside:{"template-punctuation":{pattern:/^`|`$/, alias:"string"}, interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind:!0, inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/, 
alias:"punctuation"}, rest:D.languages.javascript}}, string:/[\s\S]+/}}, "string-property":{pattern:/((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind:!0, greedy:!0, alias:"property"}}), D.languages.insertBefore("javascript", "operator", {"literal-property":{pattern:/((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind:!0, alias:"property"}}), D.languages.markup && (D.languages.markup.tag.addInlined("script", "javascript"), 
D.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), D.languages.js = D.languages.javascript, D.languages.actionscript = D.languages.extend("javascript", {keyword:/\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/, 
operator:/\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/}), D.languages.actionscript["class-name"].alias = "function", delete D.languages.actionscript.parameter, delete D.languages.actionscript["literal-property"], D.languages.markup && D.languages.insertBefore("actionscript", "string", {xml:{pattern:/(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/, lookbehind:!0, inside:D.languages.markup}}), function(e) {
  var t = /#(?!\{).+/, n = {pattern:/#\{[^}]+\}/, alias:"variable"};
  e.languages.coffeescript = e.languages.extend("javascript", {comment:t, string:[{pattern:/'(?:\\[\s\S]|[^\\'])*'/, greedy:!0}, {pattern:/"(?:\\[\s\S]|[^\\"])*"/, greedy:!0, inside:{interpolation:n}}], keyword:/\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/, 
  "class-member":{pattern:/@(?!\d)\w+/, alias:"variable"}}), e.languages.insertBefore("coffeescript", "comment", {"multiline-comment":{pattern:/###[\s\S]+?###/, alias:"comment"}, "block-regex":{pattern:/\/{3}[\s\S]*?\/{3}/, alias:"regex", inside:{comment:t, interpolation:n}}}), e.languages.insertBefore("coffeescript", "string", {"inline-javascript":{pattern:/`(?:\\[\s\S]|[^\\`])*`/, inside:{delimiter:{pattern:/^`|`$/, alias:"punctuation"}, script:{pattern:/[\s\S]+/, alias:"language-javascript", inside:e.languages.javascript}}}, 
  "multiline-string":[{pattern:/'''[\s\S]*?'''/, greedy:!0, alias:"string"}, {pattern:/"""[\s\S]*?"""/, greedy:!0, alias:"string", inside:{interpolation:n}}]}), e.languages.insertBefore("coffeescript", "keyword", {property:/(?!\d)\w+(?=\s*:(?!:))/}), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}(D), function(e) {
  var t = e.languages.javadoclike = {parameter:{pattern:/(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m, lookbehind:!0}, keyword:{pattern:/(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m, lookbehind:!0}, punctuation:/[{}]/};
  Object.defineProperty(t, "addSupport", {value:function(n, r) {
    (n = typeof n == "string" ? [n] : n).forEach(function(a) {
      var i = function(d) {
        d.inside || (d.inside = {}), d.inside.rest = r;
      }, u = "doc-comment";
      if (o = e.languages[a]) {
        var o, l = o[u];
        if ((l = l || (o = e.languages.insertBefore(a, "comment", {"doc-comment":{pattern:/(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/, lookbehind:!0, alias:"comment"}}))[u]) instanceof RegExp && (l = o[u] = {pattern:l}), Array.isArray(l)) {
          for (var c = 0, f = l.length; c < f; c++) {
            l[c] instanceof RegExp && (l[c] = {pattern:l[c]}), i(l[c]);
          }
        } else {
          i(l);
        }
      }
    });
  }}), t.addSupport(["java", "javascript", "php"], t);
}(D), function(e) {
  var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, t = (e.languages.css = {comment:/\/\*[\s\S]*?\*\//, atrule:{pattern:RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + t.source + ")*?" + /(?:;|(?=\s*\{))/.source), inside:{rule:/^@[\w-]+/, "selector-function-argument":{pattern:/(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind:!0, alias:"selector"}, keyword:{pattern:/(^|[^\w-])(?:and|not|only|or)(?![\w-])/, 
  lookbehind:!0}}}, url:{pattern:RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy:!0, inside:{function:/^url/i, punctuation:/^\(|\)$/, string:{pattern:RegExp("^" + t.source + "$"), alias:"url"}}}, selector:{pattern:RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?\x3d\\s*\\{)"), lookbehind:!0}, string:{pattern:t, greedy:!0}, property:{pattern:/(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, 
  lookbehind:!0}, important:/!important\b/i, function:{pattern:/(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind:!0}, punctuation:/[(){};:,]/}, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
  t && (t.tag.addInlined("style", "css"), t.tag.addAttribute("style", "css"));
}(D), function(e) {
  var t = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, t = (e.languages.css.selector = {pattern:e.languages.css.selector.pattern, lookbehind:!0, inside:t = {"pseudo-element":/:(?:after|before|first-letter|first-line|selection)|::[-\w]+/, "pseudo-class":/:[-\w]+/, class:/\.[-\w]+/, id:/#[-\w]+/, attribute:{pattern:RegExp(`\\[(?:[^[\\]"']|` + t.source + ")*\\]"), greedy:!0, inside:{punctuation:/^\[|\]$/, "case-sensitivity":{pattern:/(\s)[si]$/i, lookbehind:!0, alias:"keyword"}, namespace:{pattern:/^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/, 
  lookbehind:!0, inside:{punctuation:/\|$/}}, "attr-name":{pattern:/^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/, lookbehind:!0}, "attr-value":[t, {pattern:/(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/, lookbehind:!0}], operator:/[|~*^$]?=/}}, "n-th":[{pattern:/(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/, lookbehind:!0, inside:{number:/[\dn]+/, operator:/[+-]/}}, {pattern:/(\(\s*)(?:even|odd)(?=\s*\))/i, lookbehind:!0}], combinator:/>|\+|~|\|\|/, punctuation:/[(),]/}}, e.languages.css.atrule.inside["selector-function-argument"].inside = 
  t, e.languages.insertBefore("css", "property", {variable:{pattern:/(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i, lookbehind:!0}}), {pattern:/(\b\d+)(?:%|[a-z]+(?![\w-]))/, lookbehind:!0}), n = {pattern:/(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/, lookbehind:!0};
  e.languages.insertBefore("css", "function", {operator:{pattern:/(\s)[+\-*\/](?=\s)/, lookbehind:!0}, hexcode:{pattern:/\B#[\da-f]{3,8}\b/i, alias:"color"}, color:[{pattern:/(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i, 
  lookbehind:!0}, {pattern:/\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i, inside:{unit:t, number:n, function:/[\w-]+(?=\()/, punctuation:/[(),]/}}], entity:/\\[\da-f]{1,8}/i, unit:t, number:n});
}(D), function(e) {
  var t = /[*&][^\s[\]{},]+/, n = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, r = "(?:" + n.source + "(?:[ \t]+" + t.source + ")?|" + t.source + "(?:[ \t]+" + n.source + ")?)", a = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
    return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
  }), i = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
  function u(o, l) {
    l = (l || "").replace(/m/g, "") + "m";
    var c = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
      return r;
    }).replace(/<<value>>/g, function() {
      return o;
    });
    return RegExp(c, l);
  }
  e.languages.yaml = {scalar:{pattern:RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
    return r;
  })), lookbehind:!0, alias:"string"}, comment:/#.*/, key:{pattern:RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
    return r;
  }).replace(/<<key>>/g, function() {
    return "(?:" + a + "|" + i + ")";
  })), lookbehind:!0, greedy:!0, alias:"atrule"}, directive:{pattern:/(^[ \t]*)%.+/m, lookbehind:!0, alias:"important"}, datetime:{pattern:u(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source), lookbehind:!0, alias:"number"}, boolean:{pattern:u(/false|true/.source, "i"), lookbehind:!0, alias:"important"}, null:{pattern:u(/null|~/.source, "i"), lookbehind:!0, alias:"important"}, string:{pattern:u(i), 
  lookbehind:!0, greedy:!0}, number:{pattern:u(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"), lookbehind:!0}, tag:n, important:t, punctuation:/---|[:[\]{}\-,|>?]|\.\.\./}, e.languages.yml = e.languages.yaml;
}(D), function(e) {
  var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function n(c) {
    return c = c.replace(/<inner>/g, function() {
      return t;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + c + ")");
  }
  var r = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return r;
  }), i = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, u = (e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {"front-matter-block":{pattern:/(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/, lookbehind:!0, greedy:!0, inside:{punctuation:/^---|---$/, "front-matter":{pattern:/\S+(?:\s+\S+)*/, alias:["yaml", "language-yaml"], inside:e.languages.yaml}}}, blockquote:{pattern:/^>(?:[\t ]*>)*/m, alias:"punctuation"}, 
  table:{pattern:RegExp("^" + a + i + "(?:" + a + ")*", "m"), inside:{"table-data-rows":{pattern:RegExp("^(" + a + i + ")(?:" + a + ")*$"), lookbehind:!0, inside:{"table-data":{pattern:RegExp(r), inside:e.languages.markdown}, punctuation:/\|/}}, "table-line":{pattern:RegExp("^(" + a + ")" + i + "$"), lookbehind:!0, inside:{punctuation:/\||:?-{3,}:?/}}, "table-header-row":{pattern:RegExp("^" + a + "$"), inside:{"table-header":{pattern:RegExp(r), alias:"important", inside:e.languages.markdown}, punctuation:/\|/}}}}, 
  code:[{pattern:/((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/, lookbehind:!0, alias:"keyword"}, {pattern:/^```[\s\S]*?^```$/m, greedy:!0, inside:{"code-block":{pattern:/^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m, lookbehind:!0}, "code-language":{pattern:/^(```).+/, lookbehind:!0}, punctuation:/```/}}], title:[{pattern:/\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m, alias:"important", inside:{punctuation:/==+$|--+$/}}, {pattern:/(^\s*)#.+/m, lookbehind:!0, 
  alias:"important", inside:{punctuation:/^#+|#+$/}}], hr:{pattern:/(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m, lookbehind:!0, alias:"punctuation"}, list:{pattern:/(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m, lookbehind:!0, alias:"punctuation"}, "url-reference":{pattern:/!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/, inside:{variable:{pattern:/^(!?\[)[^\]]+/, lookbehind:!0}, string:/(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/, 
  punctuation:/^[\[\]!:]|[<>]/}, alias:"url"}, bold:{pattern:n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source), lookbehind:!0, greedy:!0, inside:{content:{pattern:/(^..)[\s\S]+(?=..$)/, lookbehind:!0, inside:{}}, punctuation:/\*\*|__/}}, italic:{pattern:n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source), lookbehind:!0, greedy:!0, inside:{content:{pattern:/(^.)[\s\S]+(?=.$)/, lookbehind:!0, 
  inside:{}}, punctuation:/[*_]/}}, strike:{pattern:n(/(~~?)(?:(?!~)<inner>)+\2/.source), lookbehind:!0, greedy:!0, inside:{content:{pattern:/(^~~?)[\s\S]+(?=\1$)/, lookbehind:!0, inside:{}}, punctuation:/~~?/}}, "code-snippet":{pattern:/(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/, lookbehind:!0, greedy:!0, alias:["code", "keyword"]}, url:{pattern:n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source), lookbehind:!0, greedy:!0, 
  inside:{operator:/^!/, content:{pattern:/(^\[)[^\]]+(?=\])/, lookbehind:!0, inside:{}}, variable:{pattern:/(^\][ \t]?\[)[^\]]+(?=\]$)/, lookbehind:!0}, url:{pattern:/(^\]\()[^\s)]+/, lookbehind:!0}, string:{pattern:/(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/, lookbehind:!0}}}}), ["url", "bold", "italic", "strike"].forEach(function(c) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(f) {
      c !== f && (e.languages.markdown[c].inside.content.inside[f] = e.languages.markdown[f]);
    });
  }), e.hooks.add("after-tokenize", function(c) {
    c.language !== "markdown" && c.language !== "md" || function f(d) {
      if (d && typeof d != "string") {
        for (var m = 0, p = d.length; m < p; m++) {
          var g, T = d[m];
          T.type !== "code" ? f(T.content) : (g = T.content[1], T = T.content[3], g && T && g.type === "code-language" && T.type === "code-block" && typeof g.content == "string" && (g = g.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), g = "language-" + (g = (/[a-z][\w-]*/i.exec(g) || [""])[0].toLowerCase()), T.alias ? typeof T.alias == "string" ? T.alias = [T.alias, g] : T.alias.push(g) : T.alias = [g]));
        }
      }
    }(c.tokens);
  }), e.hooks.add("wrap", function(c) {
    if (c.type === "code-block") {
      for (var f = "", d = 0, m = c.classes.length; d < m; d++) {
        var p = c.classes[d], p = /language-(.+)/.exec(p);
        if (p) {
          f = p[1];
          break;
        }
      }
      var g, T = e.languages[f];
      T ? c.content = e.highlight(function(A) {
        return A = A.replace(u, ""), A = A.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(y, C) {
          var N;
          return (C = C.toLowerCase())[0] === "#" ? (N = C[1] === "x" ? parseInt(C.slice(2), 16) : Number(C.slice(1)), l(N)) : o[C] || y;
        });
      }(c.content), T, f) : f && f !== "none" && e.plugins.autoloader && (g = "md-" + (new Date()).valueOf() + "-" + Math.floor(1e16 * Math.random()), c.attributes.id = g, e.plugins.autoloader.loadLanguages(f, function() {
        var A = document.getElementById(g);
        A && (A.innerHTML = e.highlight(A.textContent, e.languages[f], f));
      }));
    }
  }), RegExp(e.languages.markup.tag.pattern.source, "gi")), o = {amp:"\x26", lt:"\x3c", gt:"\x3e", quot:'"'}, l = String.fromCodePoint || String.fromCharCode;
  e.languages.md = e.languages.markdown;
}(D), D.languages.graphql = {comment:/#.*/, description:{pattern:/(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i, greedy:!0, alias:"string", inside:{"language-markdown":{pattern:/(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/, lookbehind:!0, inside:D.languages.markdown}}}, string:{pattern:/"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/, greedy:!0}, number:/(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, boolean:/\b(?:false|true)\b/, variable:/\$[a-z_]\w*/i, directive:{pattern:/@[a-z_]\w*/i, alias:"function"}, 
"attr-name":{pattern:/\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i, greedy:!0}, "atom-input":{pattern:/\b[A-Z]\w*Input\b/, alias:"class-name"}, scalar:/\b(?:Boolean|Float|ID|Int|String)\b/, constant:/\b[A-Z][A-Z_\d]*\b/, "class-name":{pattern:/(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/, lookbehind:!0}, fragment:{pattern:/(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/, lookbehind:!0, alias:"function"}, "definition-mutation":{pattern:/(\bmutation\s+)[a-zA-Z_]\w*/, 
lookbehind:!0, alias:"function"}, "definition-query":{pattern:/(\bquery\s+)[a-zA-Z_]\w*/, lookbehind:!0, alias:"function"}, keyword:/\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/, operator:/[!=|&]|\.{3}/, "property-query":/\w+(?=\s*\()/, object:/\w+(?=\s*\{)/, punctuation:/[!(){}\[\]:=,]/, property:/\w+/}, D.hooks.add("after-tokenize", function(e) {
  if (e.language === "graphql") {
    for (var t = e.tokens.filter(function(g) {
      return typeof g != "string" && g.type !== "comment" && g.type !== "scalar";
    }), n = 0; n < t.length;) {
      var r = t[n++];
      if (r.type === "keyword" && r.content === "mutation") {
        var a = [];
        if (d(["definition-mutation", "punctuation"]) && f(1).content === "(") {
          n += 2;
          var i = m(/^\($/, /^\)$/);
          if (i === -1) {
            continue;
          }
          for (; n < i; n++) {
            var u = f(0);
            u.type === "variable" && (p(u, "variable-input"), a.push(u.content));
          }
          n = i + 1;
        }
        if (d(["punctuation", "property-query"]) && f(0).content === "{" && (n++, p(f(0), "property-mutation"), 0 < a.length)) {
          var o = m(/^\{$/, /^\}$/);
          if (o !== -1) {
            for (var l = n; l < o; l++) {
              var c = t[l];
              c.type === "variable" && 0 <= a.indexOf(c.content) && p(c, "variable-input");
            }
          }
        }
      }
    }
  }
  function f(g) {
    return t[n + g];
  }
  function d(g, T) {
    T = T || 0;
    for (var A = 0; A < g.length; A++) {
      var y = f(A + T);
      if (!y || y.type !== g[A]) {
        return;
      }
    }
    return 1;
  }
  function m(g, T) {
    for (var A = 1, y = n; y < t.length; y++) {
      var C = t[y], N = C.content;
      if (C.type === "punctuation" && typeof N == "string") {
        if (g.test(N)) {
          A++;
        } else if (T.test(N) && --A === 0) {
          return y;
        }
      }
    }
    return -1;
  }
  function p(g, T) {
    var A = g.alias;
    A ? Array.isArray(A) || (g.alias = A = [A]) : g.alias = A = [], A.push(T);
  }
}), D.languages.sql = {comment:{pattern:/(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/, lookbehind:!0}, variable:[{pattern:/@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/, greedy:!0}, /@[\w.$]+/], string:{pattern:/(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/, greedy:!0, lookbehind:!0}, identifier:{pattern:/(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/, greedy:!0, lookbehind:!0, inside:{punctuation:/^`|`$/}}, function:/\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, keyword:/\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i, 
boolean:/\b(?:FALSE|NULL|TRUE)\b/i, number:/\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i, operator:/[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i, punctuation:/[;[\]()`,.]/}, function(e) {
  var t = e.languages.javascript["template-string"], n = t.pattern.source, r = t.inside.interpolation, a = r.inside["interpolation-punctuation"], i = r.pattern.source;
  function u(d, m) {
    if (e.languages[d]) {
      return {pattern:RegExp("((?:" + m + ")\\s*)" + n), lookbehind:!0, greedy:!0, inside:{"template-punctuation":{pattern:/^`|`$/, alias:"string"}, "embedded-code":{pattern:/[\s\S]+/, alias:d}}};
    }
  }
  function o(d, m, p) {
    return d = {code:d, grammar:m, language:p}, e.hooks.run("before-tokenize", d), d.tokens = e.tokenize(d.code, d.grammar), e.hooks.run("after-tokenize", d), d.tokens;
  }
  function l(d, m, p) {
    var A = e.tokenize(d, {interpolation:{pattern:RegExp(i), lookbehind:!0}}), g = 0, T = {}, A = o(A.map(function(C) {
      if (typeof C == "string") {
        return C;
      }
      for (var N, v, C = C.content; d.indexOf((v = g++, N = "___" + p.toUpperCase() + "_" + v + "___")) !== -1;) {
      }
      return T[N] = C, N;
    }).join(""), m, p), y = Object.keys(T);
    return g = 0, function C(N) {
      for (var v = 0; v < N.length; v++) {
        if (g >= y.length) {
          return;
        }
        var B, O, j, W, $, L, z, Y = N[v];
        typeof Y == "string" || typeof Y.content == "string" ? (B = y[g], (z = (L = typeof Y == "string" ? Y : Y.content).indexOf(B)) !== -1 && (++g, O = L.substring(0, z), $ = T[B], j = void 0, (W = {})["interpolation-punctuation"] = a, (W = e.tokenize($, W)).length === 3 && ((j = [1, 1]).push.apply(j, o(W[1], e.languages.javascript, "javascript")), W.splice.apply(W, j)), j = new e.Token("interpolation", W, r.alias, $), W = L.substring(z + B.length), $ = [], O && $.push(O), $.push(j), W && (C(L = 
        [W]), $.push.apply($, L)), typeof Y == "string" ? (N.splice.apply(N, [v, 1].concat($)), v += $.length - 1) : Y.content = $)) : (z = Y.content, Array.isArray(z) ? C(z) : C([z]));
      }
    }(A), new e.Token(p, A, "language-" + p, d);
  }
  e.languages.javascript["template-string"] = [u("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source), u("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source), u("svg", /\bsvg/.source), u("markdown", /\b(?:markdown|md)/.source), u("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source), u("sql", /\bsql/.source), t].filter(Boolean);
  var c = {javascript:!0, js:!0, typescript:!0, ts:!0, jsx:!0, tsx:!0};
  function f(d) {
    return typeof d == "string" ? d : Array.isArray(d) ? d.map(f).join("") : f(d.content);
  }
  e.hooks.add("after-tokenize", function(d) {
    d.language in c && function m(p) {
      for (var g = 0, T = p.length; g < T; g++) {
        var A, y, C, N = p[g];
        typeof N != "string" && (A = N.content, Array.isArray(A) ? N.type === "template-string" ? (N = A[1], A.length === 3 && typeof N != "string" && N.type === "embedded-code" && (y = f(N), N = N.alias, N = Array.isArray(N) ? N[0] : N, C = e.languages[N]) && (A[1] = l(y, C, N))) : m(A) : typeof A != "string" && m([A]));
      }
    }(d.tokens);
  });
}(D), function(e) {
  e.languages.typescript = e.languages.extend("javascript", {"class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/, lookbehind:!0, greedy:!0, inside:null}, builtin:/\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/}), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, 
  /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
  var t = e.languages.extend("typescript", {});
  delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {decorator:{pattern:/@[$\w\xA0-\uFFFF]+/, inside:{at:{pattern:/^@/, alias:"operator"}, function:/^[\s\S]+/}}, "generic-function":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/, greedy:!0, inside:{function:/^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/, generic:{pattern:/<[\s\S]+/, alias:"class-name", 
  inside:t}}}}), e.languages.ts = e.languages.typescript;
}(D), function(e) {
  var t = e.languages.javascript, n = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, r = "(@(?:arg|argument|param|property)\\s+(?:" + n + "\\s+)?)";
  e.languages.jsdoc = e.languages.extend("javadoclike", {parameter:{pattern:RegExp(r + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source), lookbehind:!0, inside:{punctuation:/\./}}}), e.languages.insertBefore("jsdoc", "keyword", {"optional-parameter":{pattern:RegExp(r + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source), lookbehind:!0, inside:{parameter:{pattern:/(^\[)[$\w\xA0-\uFFFF\.]+/, lookbehind:!0, inside:{punctuation:/\./}}, code:{pattern:/(=)[\s\S]*(?=\]$)/, lookbehind:!0, inside:t, 
  alias:"language-javascript"}, punctuation:/[=[\]]/}}, "class-name":[{pattern:RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
    return n;
  })), lookbehind:!0, inside:{punctuation:/\./}}, {pattern:RegExp("(@[a-z]+\\s+)" + n), lookbehind:!0, inside:{string:t.string, number:t.number, boolean:t.boolean, keyword:e.languages.typescript.keyword, operator:/=>|\.\.\.|[&|?:*]/, punctuation:/[.,;=<>{}()[\]]/}}], example:{pattern:/(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/, lookbehind:!0, inside:{code:{pattern:/^([\t ]*(?:\*\s*)?)\S.*$/m, lookbehind:!0, inside:t, alias:"language-javascript"}}}}), e.languages.javadoclike.addSupport("javascript", 
  e.languages.jsdoc);
}(D), function(e) {
  e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {type:[{pattern:/\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/, alias:"class-name"}]}), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", 
  "operator", {"flow-punctuation":{pattern:/\{\||\|\}/, alias:"punctuation"}}), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [e.languages.flow.keyword]), e.languages.flow.keyword.unshift({pattern:/(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/, lookbehind:!0}, {pattern:/(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/, lookbehind:!0});
}(D), D.languages.n4js = D.languages.extend("javascript", {keyword:/\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/}), D.languages.insertBefore("n4js", "constant", {annotation:{pattern:/@+\w+/, 
alias:"operator"}}), D.languages.n4jsd = D.languages.n4js, function(e) {
  function t(u, o) {
    return RegExp(u.replace(/<ID>/g, function() {
      return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
    }), o);
  }
  e.languages.insertBefore("javascript", "function-variable", {"method-variable":{pattern:RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source), lookbehind:!0, alias:["function-variable", "method", "function", "property-access"]}}), e.languages.insertBefore("javascript", "function", {method:{pattern:RegExp("(\\.\\s*)" + e.languages.javascript.function.source), lookbehind:!0, alias:["function", "property-access"]}}), e.languages.insertBefore("javascript", "constant", {"known-class-name":[{pattern:/\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/, 
  alias:"class-name"}, {pattern:/\b(?:[A-Z]\w*)Error\b/, alias:"class-name"}]}), e.languages.insertBefore("javascript", "keyword", {imports:{pattern:t(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source), lookbehind:!0, inside:e.languages.javascript}, exports:{pattern:t(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source), lookbehind:!0, inside:e.languages.javascript}}), e.languages.javascript.keyword.unshift({pattern:/\b(?:as|default|export|from|import)\b/, 
  alias:"module"}, {pattern:/\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/, alias:"control-flow"}, {pattern:/\bnull\b/, alias:["null", "nil"]}, {pattern:/\bundefined\b/, alias:"nil"}), e.languages.insertBefore("javascript", "operator", {spread:{pattern:/\.{3}/, alias:"operator"}, arrow:{pattern:/=>/, alias:"operator"}}), e.languages.insertBefore("javascript", "punctuation", {"property-access":{pattern:t(/(\.\s*)#?<ID>/.source), lookbehind:!0}, "maybe-class-name":{pattern:/(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/, 
  lookbehind:!0}, dom:{pattern:/\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/, alias:"variable"}, console:{pattern:/\bconsole(?=\s*\.)/, alias:"class-name"}});
  for (var n = ["function", "function-variable", "method", "method-variable", "property-access"], r = 0; r < n.length; r++) {
    var i = n[r], a = e.languages.javascript[i], i = (a = e.util.type(a) === "RegExp" ? e.languages.javascript[i] = {pattern:a} : a).inside || {};
    (a.inside = i)["maybe-class-name"] = /^[A-Z][\s\S]*/;
  }
}(D), function(e) {
  var t = e.util.clone(e.languages.javascript), n = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, r = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, a = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function i(l, c) {
    return l = l.replace(/<S>/g, function() {
      return n;
    }).replace(/<BRACES>/g, function() {
      return r;
    }).replace(/<SPREAD>/g, function() {
      return a;
    }), RegExp(l, c);
  }
  a = i(a).source, e.languages.jsx = e.languages.extend("markup", t), e.languages.jsx.tag.pattern = i(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), e.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, e.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, e.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, 
  e.languages.jsx.tag.inside.comment = t.comment, e.languages.insertBefore("inside", "attr-name", {spread:{pattern:i(/<SPREAD>/.source), inside:e.languages.jsx}}, e.languages.jsx.tag), e.languages.insertBefore("inside", "special-attr", {script:{pattern:i(/=<BRACES>/.source), alias:"language-javascript", inside:{"script-punctuation":{pattern:/^=(?=\{)/, alias:"punctuation"}, rest:e.languages.jsx}}}, e.languages.jsx.tag);
  function u(l) {
    for (var c = [], f = 0; f < l.length; f++) {
      var d = l[f], m = !1;
      typeof d != "string" && (d.type === "tag" && d.content[0] && d.content[0].type === "tag" ? d.content[0].content[0].content === "\x3c/" ? 0 < c.length && c[c.length - 1].tagName === o(d.content[0].content[1]) && c.pop() : d.content[d.content.length - 1].content !== "/\x3e" && c.push({tagName:o(d.content[0].content[1]), openedBraces:0}) : 0 < c.length && d.type === "punctuation" && d.content === "{" ? c[c.length - 1].openedBraces++ : 0 < c.length && 0 < c[c.length - 1].openedBraces && d.type === 
      "punctuation" && d.content === "}" ? c[c.length - 1].openedBraces-- : m = !0), (m || typeof d == "string") && 0 < c.length && c[c.length - 1].openedBraces === 0 && (m = o(d), f < l.length - 1 && (typeof l[f + 1] == "string" || l[f + 1].type === "plain-text") && (m += o(l[f + 1]), l.splice(f + 1, 1)), 0 < f && (typeof l[f - 1] == "string" || l[f - 1].type === "plain-text") && (m = o(l[f - 1]) + m, l.splice(f - 1, 1), f--), l[f] = new e.Token("plain-text", m, null, m)), d.content && typeof d.content != 
      "string" && u(d.content);
    }
  }
  var o = function(l) {
    return l ? typeof l == "string" ? l : typeof l.content == "string" ? l.content : l.content.map(o).join("") : "";
  };
  e.hooks.add("after-tokenize", function(l) {
    l.language !== "jsx" && l.language !== "tsx" || u(l.tokens);
  });
}(D), function(e) {
  var t = e.util.clone(e.languages.typescript), t = (e.languages.tsx = e.languages.extend("jsx", t), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
  t.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + t.pattern.source + ")", t.pattern.flags), t.lookbehind = !0;
}(D), D.languages.swift = {comment:{pattern:/(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/, lookbehind:!0, greedy:!0}, "string-literal":[{pattern:RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source), lookbehind:!0, greedy:!0, inside:{interpolation:{pattern:/(\\\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind:!0, 
inside:null}, "interpolation-punctuation":{pattern:/^\)|\\\($/, alias:"punctuation"}, punctuation:/\\(?=[\r\n])/, string:/[\s\S]+/}}, {pattern:RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"), lookbehind:!0, greedy:!0, inside:{interpolation:{pattern:/(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind:!0, inside:null}, "interpolation-punctuation":{pattern:/^\)|\\#+\($/, 
alias:"punctuation"}, string:/[\s\S]+/}}], directive:{pattern:RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ \t]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"), alias:"property", inside:{"directive-name":/^#\w+/, boolean:/\b(?:false|true)\b/, number:/\b\d+(?:\.\d+)*\b/, operator:/!|&&|\|\||[<>]=?/, punctuation:/[(),]/}}, literal:{pattern:/#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/, 
alias:"constant"}, "other-directive":{pattern:/#\w+\b/, alias:"property"}, attribute:{pattern:/@\w+/, alias:"atrule"}, "function-definition":{pattern:/(\bfunc\s+)\w+/, lookbehind:!0, alias:"function"}, label:{pattern:/\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/, lookbehind:!0, alias:"important"}, keyword:/\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/, 
boolean:/\b(?:false|true)\b/, nil:{pattern:/\bnil\b/, alias:"constant"}, "short-argument":/\$\d+\b/, omit:{pattern:/\b_\b/, alias:"keyword"}, number:/\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i, "class-name":/\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/, function:/\b[a-z_]\w*(?=\s*\()/i, constant:/\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/, operator:/[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/, punctuation:/[{}[\]();,.:\\]/}, D.languages.swift["string-literal"].forEach(function(e) {
  e.inside.interpolation.inside = D.languages.swift;
}), function(e) {
  e.languages.kotlin = e.languages.extend("clike", {keyword:{pattern:/(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/, 
  lookbehind:!0}, function:[{pattern:/(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/, greedy:!0}, {pattern:/(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/, lookbehind:!0, greedy:!0}], number:/\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/, operator:/\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/}), delete e.languages.kotlin["class-name"];
  var t = {"interpolation-punctuation":{pattern:/^\$\{?|\}$/, alias:"punctuation"}, expression:{pattern:/[\s\S]+/, inside:e.languages.kotlin}};
  e.languages.insertBefore("kotlin", "string", {"string-literal":[{pattern:/"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/, alias:"multiline", inside:{interpolation:{pattern:/\$(?:[a-z_]\w*|\{[^{}]*\})/i, inside:t}, string:/[\s\S]+/}}, {pattern:/"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/, alias:"singleline", inside:{interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i, lookbehind:!0, inside:t}, string:/[\s\S]+/}}], char:{pattern:/'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/, 
  greedy:!0}}), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {annotation:{pattern:/\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/, alias:"builtin"}}), e.languages.insertBefore("kotlin", "function", {label:{pattern:/\b\w+@|@\w+\b/, alias:"symbol"}}), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}(D), D.languages.c = D.languages.extend("clike", {comment:{pattern:/\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/, greedy:!0}, string:{pattern:/"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy:!0}, "class-name":{pattern:/(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/, lookbehind:!0}, keyword:/\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/, 
function:/\b[a-z_]\w*(?=\s*\()/i, number:/(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i, operator:/>>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/}), D.languages.insertBefore("c", "string", {char:{pattern:/'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/, greedy:!0}}), D.languages.insertBefore("c", "string", {macro:{pattern:/(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im, lookbehind:!0, greedy:!0, 
alias:"property", inside:{string:[{pattern:/^(#\s*include\s*)<[^>]+>/, lookbehind:!0}, D.languages.c.string], char:D.languages.c.char, comment:D.languages.c.comment, "macro-name":[{pattern:/(^#\s*define\s+)\w+\b(?!\()/i, lookbehind:!0}, {pattern:/(^#\s*define\s+)\w+\b(?=\()/i, lookbehind:!0, alias:"function"}], directive:{pattern:/^(#\s*)[a-z]+/, lookbehind:!0, alias:"keyword"}, "directive-hash":/^#/, punctuation:/##|\\(?=[\r\n])/, expression:{pattern:/\S[\s\S]*/, inside:D.languages.c}}}}), D.languages.insertBefore("c", 
"function", {constant:/\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/}), delete D.languages.c.boolean, D.languages.objectivec = D.languages.extend("c", {string:{pattern:/@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy:!0}, keyword:/\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/, 
operator:/-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/}), delete D.languages.objectivec["class-name"], D.languages.objc = D.languages.objectivec, D.languages.reason = D.languages.extend("clike", {string:{pattern:/"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/, greedy:!0}, "class-name":/\b[A-Z]\w*/, keyword:/\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/, 
operator:/\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/}), D.languages.insertBefore("reason", "class-name", {char:{pattern:/'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/, greedy:!0}, constructor:/\b[A-Z]\w*\b(?!\s*\.)/, label:{pattern:/\b[a-z]\w*(?=::)/, alias:"symbol"}}), delete D.languages.reason.function, function(e) {
  for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, n = 0; n < 2; n++) {
    t = t.replace(/<self>/g, function() {
      return t;
    });
  }
  t = t.replace(/<self>/g, function() {
    return /[^\s\S]/.source;
  }), e.languages.rust = {comment:[{pattern:RegExp(/(^|[^\\])/.source + t), lookbehind:!0, greedy:!0}, {pattern:/(^|[^\\:])\/\/.*/, lookbehind:!0, greedy:!0}], string:{pattern:/b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/, greedy:!0}, char:{pattern:/b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/, greedy:!0}, attribute:{pattern:/#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/, greedy:!0, alias:"attr-name", inside:{string:null}}, "closure-params":{pattern:/([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/, 
  lookbehind:!0, greedy:!0, inside:{"closure-punctuation":{pattern:/^\||\|$/, alias:"punctuation"}, rest:null}}, "lifetime-annotation":{pattern:/'\w+/, alias:"symbol"}, "fragment-specifier":{pattern:/(\$\w+:)[a-z]+/, lookbehind:!0, alias:"punctuation"}, variable:/\$\w+/, "function-definition":{pattern:/(\bfn\s+)\w+/, lookbehind:!0, alias:"function"}, "type-definition":{pattern:/(\b(?:enum|struct|trait|type|union)\s+)\w+/, lookbehind:!0, alias:"class-name"}, "module-declaration":[{pattern:/(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/, 
  lookbehind:!0, alias:"namespace"}, {pattern:/(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/, lookbehind:!0, alias:"namespace", inside:{punctuation:/::/}}], keyword:[/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/, /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/], 
  function:/\b[a-z_]\w*(?=\s*(?:::\s*<|\())/, macro:{pattern:/\b\w+!/, alias:"property"}, constant:/\b[A-Z_][A-Z_\d]+\b/, "class-name":/\b[A-Z]\w*\b/, namespace:{pattern:/(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/, inside:{punctuation:/::/}}, number:/\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/, boolean:/\b(?:false|true)\b/, punctuation:/->|\.\.=|\.{1,3}|::|[{}[\];(),:]/, 
  operator:/[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/}, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}(D), D.languages.go = D.languages.extend("clike", {string:{pattern:/(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/, lookbehind:!0, greedy:!0}, keyword:/\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/, boolean:/\b(?:_|false|iota|nil|true)\b/, number:[/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i], 
operator:/[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./, builtin:/\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/}), D.languages.insertBefore("go", "string", {char:{pattern:/'(?:\\.|[^'\\\r\n]){0,10}'/, greedy:!0}}), delete D.languages.go["class-name"], function(e) {
  var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, 
  n = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return t.source;
  });
  e.languages.cpp = e.languages.extend("c", {"class-name":[{pattern:RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
    return t.source;
  })), lookbehind:!0}, /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/, /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i, /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/], keyword:t, number:{pattern:/(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i, greedy:!0}, operator:/>>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/, boolean:/\b(?:false|true)\b/}), 
  e.languages.insertBefore("cpp", "string", {module:{pattern:RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
    return n;
  }) + ")"), lookbehind:!0, greedy:!0, inside:{string:/^[<"][\s\S]+/, operator:/:/, punctuation:/\./}}, "raw-string":{pattern:/R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/, alias:"string", greedy:!0}}), e.languages.insertBefore("cpp", "keyword", {"generic-function":{pattern:/\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i, inside:{function:/^\w+/, generic:{pattern:/<[\s\S]+/, alias:"class-name", inside:e.languages.cpp}}}}), e.languages.insertBefore("cpp", "operator", {"double-colon":{pattern:/::/, 
  alias:"punctuation"}}), e.languages.insertBefore("cpp", "class-name", {"base-clause":{pattern:/(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/, lookbehind:!0, greedy:!0, inside:e.languages.extend("cpp", {})}}), e.languages.insertBefore("inside", "double-colon", {"class-name":/\b[a-z_]\w*\b(?!\s*::)/i}, e.languages.cpp["base-clause"]);
}(D), D.languages.python = {comment:{pattern:/(^|[^\\])#.*/, lookbehind:!0, greedy:!0}, "string-interpolation":{pattern:/(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i, greedy:!0, inside:{interpolation:{pattern:/((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/, lookbehind:!0, inside:{"format-spec":{pattern:/(:)[^:(){}]+(?=\}$)/, lookbehind:!0}, "conversion-option":{pattern:/![sra](?=[:}]$)/, alias:"punctuation"}, rest:null}}, string:/[\s\S]+/}}, 
"triple-quoted-string":{pattern:/(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i, greedy:!0, alias:"string"}, string:{pattern:/(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i, greedy:!0}, function:{pattern:/((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g, lookbehind:!0}, "class-name":{pattern:/(\bclass\s+)\w+/i, lookbehind:!0}, decorator:{pattern:/(^[\t ]*)@\w+(?:\.\w+)*/m, lookbehind:!0, alias:["annotation", "punctuation"], inside:{punctuation:/\./}}, keyword:/\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/, 
builtin:/\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/, 
boolean:/\b(?:False|None|True)\b/, number:/\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i, operator:/[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/, punctuation:/[{}[\];(),.:]/}, D.languages.python["string-interpolation"].inside.interpolation.inside.rest = D.languages.python, D.languages.py = D.languages.python, D.languages.json = {property:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/, lookbehind:!0, 
greedy:!0}, string:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/, lookbehind:!0, greedy:!0}, comment:{pattern:/\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/, greedy:!0}, number:/-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, punctuation:/[{}[\],]/, operator:/:/, boolean:/\b(?:false|true)\b/, null:{pattern:/\bnull\b/, alias:"keyword"}}, D.languages.webmanifest = D.languages.json;
var tn = {};
Ab(tn, {dracula:() => Ib, duotoneDark:() => Ob, duotoneLight:() => Rb, github:() => Db, gruvboxMaterialDark:() => oE, gruvboxMaterialLight:() => cE, jettwaveDark:() => eE, jettwaveLight:() => nE, nightOwl:() => Fb, nightOwlLight:() => Bb, oceanicNext:() => Ub, okaidia:() => zb, oneDark:() => aE, oneLight:() => uE, palenight:() => Yb, shadesOfPurple:() => qb, synthwave84:() => Wb, ultramin:() => Xb, vsDark:() => $s, vsLight:() => Zb});
var Cb = {plain:{color:"#F8F8F2", backgroundColor:"#282A36"}, styles:[{types:["prolog", "constant", "builtin"], style:{color:"rgb(189, 147, 249)"}}, {types:["inserted", "function"], style:{color:"rgb(80, 250, 123)"}}, {types:["deleted"], style:{color:"rgb(255, 85, 85)"}}, {types:["changed"], style:{color:"rgb(255, 184, 108)"}}, {types:["punctuation", "symbol"], style:{color:"rgb(248, 248, 242)"}}, {types:["string", "char", "tag", "selector"], style:{color:"rgb(255, 121, 198)"}}, {types:["keyword", 
"variable"], style:{color:"rgb(189, 147, 249)", fontStyle:"italic"}}, {types:["comment"], style:{color:"rgb(98, 114, 164)"}}, {types:["attr-name"], style:{color:"rgb(241, 250, 140)"}}]}, Ib = Cb, Nb = {plain:{backgroundColor:"#2a2734", color:"#9a86fd"}, styles:[{types:["comment", "prolog", "doctype", "cdata", "punctuation"], style:{color:"#6c6783"}}, {types:["namespace"], style:{opacity:0.7}}, {types:["tag", "operator", "number"], style:{color:"#e09142"}}, {types:["property", "function"], style:{color:"#9a86fd"}}, 
{types:["tag-id", "selector", "atrule-id"], style:{color:"#eeebff"}}, {types:["attr-name"], style:{color:"#c4b9fe"}}, {types:["boolean", "string", "entity", "url", "attr-value", "keyword", "control", "directive", "unit", "statement", "regex", "atrule", "placeholder", "variable"], style:{color:"#ffcc99"}}, {types:["deleted"], style:{textDecorationLine:"line-through"}}, {types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", 
"bold"], style:{fontWeight:"bold"}}, {types:["important"], style:{color:"#c4b9fe"}}]}, Ob = Nb, Lb = {plain:{backgroundColor:"#faf8f5", color:"#728fcb"}, styles:[{types:["comment", "prolog", "doctype", "cdata", "punctuation"], style:{color:"#b6ad9a"}}, {types:["namespace"], style:{opacity:0.7}}, {types:["tag", "operator", "number"], style:{color:"#063289"}}, {types:["property", "function"], style:{color:"#b29762"}}, {types:["tag-id", "selector", "atrule-id"], style:{color:"#2d2006"}}, {types:["attr-name"], 
style:{color:"#896724"}}, {types:["boolean", "string", "entity", "url", "attr-value", "keyword", "control", "directive", "unit", "statement", "regex", "atrule"], style:{color:"#728fcb"}}, {types:["placeholder", "variable"], style:{color:"#93abdc"}}, {types:["deleted"], style:{textDecorationLine:"line-through"}}, {types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", "bold"], style:{fontWeight:"bold"}}, {types:["important"], 
style:{color:"#896724"}}]}, Rb = Lb, wb = {plain:{color:"#393A34", backgroundColor:"#f6f8fa"}, styles:[{types:["comment", "prolog", "doctype", "cdata"], style:{color:"#999988", fontStyle:"italic"}}, {types:["namespace"], style:{opacity:0.7}}, {types:["string", "attr-value"], style:{color:"#e3116c"}}, {types:["punctuation", "operator"], style:{color:"#393A34"}}, {types:["entity", "url", "symbol", "number", "boolean", "variable", "constant", "property", "regex", "inserted"], style:{color:"#36acaa"}}, 
{types:["atrule", "keyword", "attr-name", "selector"], style:{color:"#00a4db"}}, {types:["function", "deleted", "tag"], style:{color:"#d73a49"}}, {types:["function-variable"], style:{color:"#6f42c1"}}, {types:["tag", "selector", "keyword"], style:{color:"#00009f"}}]}, Db = wb, Pb = {plain:{color:"#d6deeb", backgroundColor:"#011627"}, styles:[{types:["changed"], style:{color:"rgb(162, 191, 252)", fontStyle:"italic"}}, {types:["deleted"], style:{color:"rgba(239, 83, 80, 0.56)", fontStyle:"italic"}}, 
{types:["inserted", "attr-name"], style:{color:"rgb(173, 219, 103)", fontStyle:"italic"}}, {types:["comment"], style:{color:"rgb(99, 119, 119)", fontStyle:"italic"}}, {types:["string", "url"], style:{color:"rgb(173, 219, 103)"}}, {types:["variable"], style:{color:"rgb(214, 222, 235)"}}, {types:["number"], style:{color:"rgb(247, 140, 108)"}}, {types:["builtin", "char", "constant", "function"], style:{color:"rgb(130, 170, 255)"}}, {types:["punctuation"], style:{color:"rgb(199, 146, 234)"}}, {types:["selector", 
"doctype"], style:{color:"rgb(199, 146, 234)", fontStyle:"italic"}}, {types:["class-name"], style:{color:"rgb(255, 203, 139)"}}, {types:["tag", "operator", "keyword"], style:{color:"rgb(127, 219, 202)"}}, {types:["boolean"], style:{color:"rgb(255, 88, 116)"}}, {types:["property"], style:{color:"rgb(128, 203, 196)"}}, {types:["namespace"], style:{color:"rgb(178, 204, 214)"}}]}, Fb = Pb, Mb = {plain:{color:"#403f53", backgroundColor:"#FBFBFB"}, styles:[{types:["changed"], style:{color:"rgb(162, 191, 252)", 
fontStyle:"italic"}}, {types:["deleted"], style:{color:"rgba(239, 83, 80, 0.56)", fontStyle:"italic"}}, {types:["inserted", "attr-name"], style:{color:"rgb(72, 118, 214)", fontStyle:"italic"}}, {types:["comment"], style:{color:"rgb(152, 159, 177)", fontStyle:"italic"}}, {types:["string", "builtin", "char", "constant", "url"], style:{color:"rgb(72, 118, 214)"}}, {types:["variable"], style:{color:"rgb(201, 103, 101)"}}, {types:["number"], style:{color:"rgb(170, 9, 130)"}}, {types:["punctuation"], style:{color:"rgb(153, 76, 195)"}}, 
{types:["function", "selector", "doctype"], style:{color:"rgb(153, 76, 195)", fontStyle:"italic"}}, {types:["class-name"], style:{color:"rgb(17, 17, 17)"}}, {types:["tag"], style:{color:"rgb(153, 76, 195)"}}, {types:["operator", "property", "keyword", "namespace"], style:{color:"rgb(12, 150, 155)"}}, {types:["boolean"], style:{color:"rgb(188, 84, 84)"}}]}, Bb = Mb, Re = {char:"#D8DEE9", comment:"#999999", keyword:"#c5a5c5", primitive:"#5a9bcf", string:"#8dc891", variable:"#d7deea", boolean:"#ff8b50", 
tag:"#fc929e", function:"#79b6f2", className:"#FAC863"}, vb = {plain:{backgroundColor:"#282c34", color:"#ffffff"}, styles:[{types:["attr-name"], style:{color:Re.keyword}}, {types:["attr-value"], style:{color:Re.string}}, {types:["comment", "block-comment", "prolog", "doctype", "cdata", "shebang"], style:{color:Re.comment}}, {types:["property", "number", "function-name", "constant", "symbol", "deleted"], style:{color:Re.primitive}}, {types:["boolean"], style:{color:Re.boolean}}, {types:["tag"], style:{color:Re.tag}}, 
{types:["string"], style:{color:Re.string}}, {types:["punctuation"], style:{color:Re.string}}, {types:["selector", "char", "builtin", "inserted"], style:{color:Re.char}}, {types:["function"], style:{color:Re.function}}, {types:["operator", "entity", "url", "variable"], style:{color:Re.variable}}, {types:["keyword"], style:{color:Re.keyword}}, {types:["atrule", "class-name"], style:{color:Re.className}}, {types:["important"], style:{fontWeight:"400"}}, {types:["bold"], style:{fontWeight:"bold"}}, 
{types:["italic"], style:{fontStyle:"italic"}}, {types:["namespace"], style:{opacity:0.7}}]}, Ub = vb, Hb = {plain:{color:"#f8f8f2", backgroundColor:"#272822"}, styles:[{types:["changed"], style:{color:"rgb(162, 191, 252)", fontStyle:"italic"}}, {types:["deleted"], style:{color:"#f92672", fontStyle:"italic"}}, {types:["inserted"], style:{color:"rgb(173, 219, 103)", fontStyle:"italic"}}, {types:["comment"], style:{color:"#8292a2", fontStyle:"italic"}}, {types:["string", "url"], style:{color:"#a6e22e"}}, 
{types:["variable"], style:{color:"#f8f8f2"}}, {types:["number"], style:{color:"#ae81ff"}}, {types:["builtin", "char", "constant", "function", "class-name"], style:{color:"#e6db74"}}, {types:["punctuation"], style:{color:"#f8f8f2"}}, {types:["selector", "doctype"], style:{color:"#a6e22e", fontStyle:"italic"}}, {types:["tag", "operator", "keyword"], style:{color:"#66d9ef"}}, {types:["boolean"], style:{color:"#ae81ff"}}, {types:["namespace"], style:{color:"rgb(178, 204, 214)", opacity:0.7}}, {types:["tag", 
"property"], style:{color:"#f92672"}}, {types:["attr-name"], style:{color:"#a6e22e !important"}}, {types:["doctype"], style:{color:"#8292a2"}}, {types:["rule"], style:{color:"#e6db74"}}]}, zb = Hb, $b = {plain:{color:"#bfc7d5", backgroundColor:"#292d3e"}, styles:[{types:["comment"], style:{color:"rgb(105, 112, 152)", fontStyle:"italic"}}, {types:["string", "inserted"], style:{color:"rgb(195, 232, 141)"}}, {types:["number"], style:{color:"rgb(247, 140, 108)"}}, {types:["builtin", "char", "constant", 
"function"], style:{color:"rgb(130, 170, 255)"}}, {types:["punctuation", "selector"], style:{color:"rgb(199, 146, 234)"}}, {types:["variable"], style:{color:"rgb(191, 199, 213)"}}, {types:["class-name", "attr-name"], style:{color:"rgb(255, 203, 107)"}}, {types:["tag", "deleted"], style:{color:"rgb(255, 85, 114)"}}, {types:["operator"], style:{color:"rgb(137, 221, 255)"}}, {types:["boolean"], style:{color:"rgb(255, 88, 116)"}}, {types:["keyword"], style:{fontStyle:"italic"}}, {types:["doctype"], style:{color:"rgb(199, 146, 234)", 
fontStyle:"italic"}}, {types:["namespace"], style:{color:"rgb(178, 204, 214)"}}, {types:["url"], style:{color:"rgb(221, 221, 221)"}}]}, Yb = $b, jb = {plain:{color:"#9EFEFF", backgroundColor:"#2D2A55"}, styles:[{types:["changed"], style:{color:"rgb(255, 238, 128)"}}, {types:["deleted"], style:{color:"rgba(239, 83, 80, 0.56)"}}, {types:["inserted"], style:{color:"rgb(173, 219, 103)"}}, {types:["comment"], style:{color:"rgb(179, 98, 255)", fontStyle:"italic"}}, {types:["punctuation"], style:{color:"rgb(255, 255, 255)"}}, 
{types:["constant"], style:{color:"rgb(255, 98, 140)"}}, {types:["string", "url"], style:{color:"rgb(165, 255, 144)"}}, {types:["variable"], style:{color:"rgb(255, 238, 128)"}}, {types:["number", "boolean"], style:{color:"rgb(255, 98, 140)"}}, {types:["attr-name"], style:{color:"rgb(255, 180, 84)"}}, {types:["keyword", "operator", "property", "namespace", "tag", "selector", "doctype"], style:{color:"rgb(255, 157, 0)"}}, {types:["builtin", "char", "constant", "function", "class-name"], style:{color:"rgb(250, 208, 0)"}}]}, 
qb = jb, Gb = {plain:{backgroundColor:"linear-gradient(to bottom, #2a2139 75%, #34294f)", backgroundImage:"#34294f", color:"#f92aad", textShadow:"0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"}, styles:[{types:["comment", "block-comment", "prolog", "doctype", "cdata"], style:{color:"#495495", fontStyle:"italic"}}, {types:["punctuation"], style:{color:"#ccc"}}, {types:["tag", "attr-name", "namespace", "number", "unit", "hexcode", "deleted"], style:{color:"#e2777a"}}, {types:["property", "selector"], 
style:{color:"#72f1b8", textShadow:"0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"}}, {types:["function-name"], style:{color:"#6196cc"}}, {types:["boolean", "selector-id", "function"], style:{color:"#fdfdfd", textShadow:"0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"}}, {types:["class-name", "maybe-class-name", "builtin"], style:{color:"#fff5f6", textShadow:"0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"}}, {types:["constant", "symbol"], 
style:{color:"#f92aad", textShadow:"0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"}}, {types:["important", "atrule", "keyword", "selector-class"], style:{color:"#f4eee4", textShadow:"0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"}}, {types:["string", "char", "attr-value", "regex", "variable"], style:{color:"#f87c32"}}, {types:["parameter"], style:{fontStyle:"italic"}}, {types:["entity", "url"], style:{color:"#67cdcc"}}, {types:["operator"], style:{color:"ffffffee"}}, {types:["important", 
"bold"], style:{fontWeight:"bold"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["entity"], style:{cursor:"help"}}, {types:["inserted"], style:{color:"green"}}]}, Wb = Gb, Vb = {plain:{color:"#282a2e", backgroundColor:"#ffffff"}, styles:[{types:["comment"], style:{color:"rgb(197, 200, 198)"}}, {types:["string", "number", "builtin", "variable"], style:{color:"rgb(150, 152, 150)"}}, {types:["class-name", "function", "tag", "attr-name"], style:{color:"rgb(40, 42, 46)"}}]}, Xb = Vb, Qb = 
{plain:{color:"#9CDCFE", backgroundColor:"#1E1E1E"}, styles:[{types:["prolog"], style:{color:"rgb(0, 0, 128)"}}, {types:["comment"], style:{color:"rgb(106, 153, 85)"}}, {types:["builtin", "changed", "keyword", "interpolation-punctuation"], style:{color:"rgb(86, 156, 214)"}}, {types:["number", "inserted"], style:{color:"rgb(181, 206, 168)"}}, {types:["constant"], style:{color:"rgb(100, 102, 149)"}}, {types:["attr-name", "variable"], style:{color:"rgb(156, 220, 254)"}}, {types:["deleted", "string", 
"attr-value", "template-punctuation"], style:{color:"rgb(206, 145, 120)"}}, {types:["selector"], style:{color:"rgb(215, 186, 125)"}}, {types:["tag"], style:{color:"rgb(78, 201, 176)"}}, {types:["tag"], languages:["markup"], style:{color:"rgb(86, 156, 214)"}}, {types:["punctuation", "operator"], style:{color:"rgb(212, 212, 212)"}}, {types:["punctuation"], languages:["markup"], style:{color:"#808080"}}, {types:["function"], style:{color:"rgb(220, 220, 170)"}}, {types:["class-name"], style:{color:"rgb(78, 201, 176)"}}, 
{types:["char"], style:{color:"rgb(209, 105, 105)"}}]}, $s = Qb, Kb = {plain:{color:"#000000", backgroundColor:"#ffffff"}, styles:[{types:["comment"], style:{color:"rgb(0, 128, 0)"}}, {types:["builtin"], style:{color:"rgb(0, 112, 193)"}}, {types:["number", "variable", "inserted"], style:{color:"rgb(9, 134, 88)"}}, {types:["operator"], style:{color:"rgb(0, 0, 0)"}}, {types:["constant", "char"], style:{color:"rgb(129, 31, 63)"}}, {types:["tag"], style:{color:"rgb(128, 0, 0)"}}, {types:["attr-name"], 
style:{color:"rgb(255, 0, 0)"}}, {types:["deleted", "string"], style:{color:"rgb(163, 21, 21)"}}, {types:["changed", "punctuation"], style:{color:"rgb(4, 81, 165)"}}, {types:["function", "keyword"], style:{color:"rgb(0, 0, 255)"}}, {types:["class-name"], style:{color:"rgb(38, 127, 153)"}}]}, Zb = Kb, Jb = {plain:{color:"#f8fafc", backgroundColor:"#011627"}, styles:[{types:["prolog"], style:{color:"#000080"}}, {types:["comment"], style:{color:"#6A9955"}}, {types:["builtin", "changed", "keyword", "interpolation-punctuation"], 
style:{color:"#569CD6"}}, {types:["number", "inserted"], style:{color:"#B5CEA8"}}, {types:["constant"], style:{color:"#f8fafc"}}, {types:["attr-name", "variable"], style:{color:"#9CDCFE"}}, {types:["deleted", "string", "attr-value", "template-punctuation"], style:{color:"#cbd5e1"}}, {types:["selector"], style:{color:"#D7BA7D"}}, {types:["tag"], style:{color:"#0ea5e9"}}, {types:["tag"], languages:["markup"], style:{color:"#0ea5e9"}}, {types:["punctuation", "operator"], style:{color:"#D4D4D4"}}, {types:["punctuation"], 
languages:["markup"], style:{color:"#808080"}}, {types:["function"], style:{color:"#7dd3fc"}}, {types:["class-name"], style:{color:"#0ea5e9"}}, {types:["char"], style:{color:"#D16969"}}]}, eE = Jb, tE = {plain:{color:"#0f172a", backgroundColor:"#f1f5f9"}, styles:[{types:["prolog"], style:{color:"#000080"}}, {types:["comment"], style:{color:"#6A9955"}}, {types:["builtin", "changed", "keyword", "interpolation-punctuation"], style:{color:"#0c4a6e"}}, {types:["number", "inserted"], style:{color:"#B5CEA8"}}, 
{types:["constant"], style:{color:"#0f172a"}}, {types:["attr-name", "variable"], style:{color:"#0c4a6e"}}, {types:["deleted", "string", "attr-value", "template-punctuation"], style:{color:"#64748b"}}, {types:["selector"], style:{color:"#D7BA7D"}}, {types:["tag"], style:{color:"#0ea5e9"}}, {types:["tag"], languages:["markup"], style:{color:"#0ea5e9"}}, {types:["punctuation", "operator"], style:{color:"#475569"}}, {types:["punctuation"], languages:["markup"], style:{color:"#808080"}}, {types:["function"], 
style:{color:"#0e7490"}}, {types:["class-name"], style:{color:"#0ea5e9"}}, {types:["char"], style:{color:"#D16969"}}]}, nE = tE, rE = {plain:{backgroundColor:"hsl(220, 13%, 18%)", color:"hsl(220, 14%, 71%)", textShadow:"0 1px rgba(0, 0, 0, 0.3)"}, styles:[{types:["comment", "prolog", "cdata"], style:{color:"hsl(220, 10%, 40%)"}}, {types:["doctype", "punctuation", "entity"], style:{color:"hsl(220, 14%, 71%)"}}, {types:["attr-name", "class-name", "maybe-class-name", "boolean", "constant", "number", 
"atrule"], style:{color:"hsl(29, 54%, 61%)"}}, {types:["keyword"], style:{color:"hsl(286, 60%, 67%)"}}, {types:["property", "tag", "symbol", "deleted", "important"], style:{color:"hsl(355, 65%, 65%)"}}, {types:["selector", "string", "char", "builtin", "inserted", "regex", "attr-value"], style:{color:"hsl(95, 38%, 62%)"}}, {types:["variable", "operator", "function"], style:{color:"hsl(207, 82%, 66%)"}}, {types:["url"], style:{color:"hsl(187, 47%, 55%)"}}, {types:["deleted"], style:{textDecorationLine:"line-through"}}, 
{types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", "bold"], style:{fontWeight:"bold"}}, {types:["important"], style:{color:"hsl(220, 14%, 71%)"}}]}, aE = rE, iE = {plain:{backgroundColor:"hsl(230, 1%, 98%)", color:"hsl(230, 8%, 24%)"}, styles:[{types:["comment", "prolog", "cdata"], style:{color:"hsl(230, 4%, 64%)"}}, {types:["doctype", "punctuation", "entity"], style:{color:"hsl(230, 8%, 24%)"}}, {types:["attr-name", 
"class-name", "boolean", "constant", "number", "atrule"], style:{color:"hsl(35, 99%, 36%)"}}, {types:["keyword"], style:{color:"hsl(301, 63%, 40%)"}}, {types:["property", "tag", "symbol", "deleted", "important"], style:{color:"hsl(5, 74%, 59%)"}}, {types:["selector", "string", "char", "builtin", "inserted", "regex", "attr-value", "punctuation"], style:{color:"hsl(119, 34%, 47%)"}}, {types:["variable", "operator", "function"], style:{color:"hsl(221, 87%, 60%)"}}, {types:["url"], style:{color:"hsl(198, 99%, 37%)"}}, 
{types:["deleted"], style:{textDecorationLine:"line-through"}}, {types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", "bold"], style:{fontWeight:"bold"}}, {types:["important"], style:{color:"hsl(230, 8%, 24%)"}}]}, uE = iE, sE = {plain:{color:"#ebdbb2", backgroundColor:"#292828"}, styles:[{types:["imports", "class-name", "maybe-class-name", "constant", "doctype", "builtin", "function"], style:{color:"#d8a657"}}, {types:["property-access"], 
style:{color:"#7daea3"}}, {types:["tag"], style:{color:"#e78a4e"}}, {types:["attr-name", "char", "url", "regex"], style:{color:"#a9b665"}}, {types:["attr-value", "string"], style:{color:"#89b482"}}, {types:["comment", "prolog", "cdata", "operator", "inserted"], style:{color:"#a89984"}}, {types:["delimiter", "boolean", "keyword", "selector", "important", "atrule", "property", "variable", "deleted"], style:{color:"#ea6962"}}, {types:["entity", "number", "symbol"], style:{color:"#d3869b"}}]}, oE = sE, 
lE = {plain:{color:"#654735", backgroundColor:"#f9f5d7"}, styles:[{types:["delimiter", "boolean", "keyword", "selector", "important", "atrule", "property", "variable", "deleted"], style:{color:"#af2528"}}, {types:["imports", "class-name", "maybe-class-name", "constant", "doctype", "builtin"], style:{color:"#b4730e"}}, {types:["string", "attr-value"], style:{color:"#477a5b"}}, {types:["property-access"], style:{color:"#266b79"}}, {types:["function", "attr-name", "char", "url"], style:{color:"#72761e"}}, 
{types:["tag"], style:{color:"#b94c07"}}, {types:["comment", "prolog", "cdata", "operator", "inserted"], style:{color:"#a89984"}}, {types:["entity", "number", "symbol"], style:{color:"#924f79"}}]}, cE = lE, dE = e => (0,require$react.useCallback)(t => {
  var n = t, {className:r, style:a, line:i} = n, u = zs(n, ["className", "style", "line"]);
  const o = Vn(Xe({}, u), {className:vs("token-line", r)});
  return typeof e == "object" && "plain" in e && (o.style = e.plain), typeof a == "object" && (o.style = Xe(Xe({}, o.style || {}), a)), o;
}, [e]), fE = e => {
  const t = (0,require$react.useCallback)(({types:n, empty:r}) => {
    if (e != null) {
      {
        if (n.length === 1 && n[0] === "plain") {
          return r != null ? {display:"inline-block"} : void 0;
        }
        if (n.length === 1 && r != null) {
          return e[n[0]];
        }
      }
      return Object.assign(r != null ? {display:"inline-block"} : {}, ...n.map(a => e[a]));
    }
  }, [e]);
  return (0,require$react.useCallback)(n => {
    var r = n, {token:a, className:i, style:u} = r, o = zs(r, ["token", "className", "style"]);
    const l = Vn(Xe({}, o), {className:vs("token", ...a.types, i), children:a.content, style:t(a)});
    return u != null && (l.style = Xe(Xe({}, l.style || {}), u)), l;
  }, [t]);
}, hE = /\r\n|\r|\n/, Ri = e => {
  e.length === 0 ? e.push({types:["plain"], content:`
`, empty:!0}) : e.length === 1 && e[0].content === "" && (e[0].content = `
`, e[0].empty = !0);
}, wi = (e, t) => {
  const n = e.length;
  return n > 0 && e[n - 1] === t ? e : e.concat(t);
}, pE = e => {
  const t = [[]], n = [e], r = [0], a = [e.length];
  let i = 0, u = 0, o = [];
  const l = [o];
  for (; u > -1;) {
    for (; (i = r[u]++) < a[u];) {
      let c, f = t[u];
      const m = n[u][i];
      if (typeof m == "string" ? (f = u > 0 ? f : ["plain"], c = m) : (f = wi(f, m.type), m.alias && (f = wi(f, m.alias)), c = m.content), typeof c != "string") {
        u++, t.push(f), n.push(c), r.push(0), a.push(c.length);
        continue;
      }
      const p = c.split(hE), g = p.length;
      o.push({types:f, content:p[0]});
      for (let T = 1; T < g; T++) {
        Ri(o), l.push(o = []), o.push({types:f, content:p[T]});
      }
    }
    u--, t.pop(), n.pop(), r.pop(), a.pop();
  }
  return Ri(o), l;
}, Di = pE, mE = ({prism:e, code:t, grammar:n, language:r}) => (0,require$react.useMemo)(() => {
  if (n == null) {
    return Di([t]);
  }
  const a = {code:t, grammar:n, language:r, tokens:[]};
  return e.hooks.run("before-tokenize", a), a.tokens = e.tokenize(t, n), e.hooks.run("after-tokenize", a), Di(a.tokens);
}, [t, n, r, e]), gE = (e, t) => {
  const {plain:n} = e, r = e.styles.reduce((a, i) => {
    const {languages:u, style:o} = i;
    return u && !u.includes(t) || i.types.forEach(l => {
      const c = Xe(Xe({}, a[l]), o);
      a[l] = c;
    }), a;
  }, {});
  return r.root = n, r.plain = Vn(Xe({}, n), {backgroundColor:void 0}), r;
}, bE = gE, EE = ({children:e, language:t, code:n, theme:r, prism:a}) => {
  const i = t.toLowerCase(), u = bE(r, i), o = dE(u), l = fE(u), c = a.languages[i], f = mE({prism:a, language:i, code:n, grammar:c});
  return e({tokens:f, className:`prism-code language-${i}`, style:u != null ? u.root : {}, getLineProps:o, getTokenProps:l});
}, TE = e => (0,require$react.createElement)(EE, Vn(Xe({}, e), {prism:e.prism || D, theme:e.theme || $s, code:e.code, language:e.language}));
const yE = {monokai:tn.vsDark, "night-owl":tn.nightOwl, "proxy-console":tn.vsDark}, Pi = {".ts":"typescript", ".tsx":"tsx", ".js":"javascript", ".jsx":"jsx", ".mjs":"javascript", ".cjs":"javascript", ".py":"python", ".rs":"rust", ".go":"go", ".clj":"clojure", ".cljs":"clojure", ".cljc":"clojure", ".edn":"clojure", ".java":"java", ".kt":"kotlin", ".swift":"swift", ".scala":"scala", ".rb":"ruby", ".php":"php", ".c":"c", ".cpp":"cpp", ".h":"c", ".hpp":"cpp", ".cs":"csharp", ".html":"markup", ".htm":"markup", 
".css":"css", ".scss":"scss", ".less":"less", ".json":"json", ".yaml":"yaml", ".yml":"yaml", ".toml":"toml", ".xml":"markup", ".sql":"sql", ".sh":"bash", ".bash":"bash", ".zsh":"bash", ".dockerfile":"docker", ".makefile":"makefile", ".md":"markdown", ".mdx":"mdx", ".graphql":"graphql", ".gql":"graphql", ".proto":"protobuf", ".diff":"diff", ".patch":"diff"}, Fi = {node:"javascript", python:"python", python3:"python", bash:"bash", sh:"bash", zsh:"bash", ruby:"ruby", perl:"perl", php:"php"};
function _E(e, t, n) {
  var a;
  if (n) {
    return n;
  }
  if (t) {
    const i = "." + ((a = t.split(".").pop()) == null ? void 0 : a.toLowerCase());
    if (Pi[i]) {
      return Pi[i];
    }
  }
  const r = e.split(`
`)[0];
  if (r.startsWith("#!")) {
    const i = r.match(/#!\s*(?:\/usr\/bin\/env\s+)?(\w+)/);
    if (i && Fi[i[1]]) {
      return Fi[i[1]];
    }
  }
  return "text";
}
const AE = {typescript:"typescript", tsx:"tsx", javascript:"javascript", jsx:"jsx", python:"python", rust:"rust", go:"go", clojure:"clojure", java:"java", kotlin:"kotlin", swift:"swift", scala:"scala", ruby:"ruby", php:"php", c:"c", cpp:"cpp", csharp:"csharp", markup:"markup", html:"markup", css:"css", scss:"scss", json:"json", yaml:"yaml", bash:"bash", sql:"sql", graphql:"graphql", markdown:"markdown", diff:"diff"}, xE = ({code:e, language:t, filename:n, theme:r = "dark", lineNumbers:a = !0, highlightLines:i = 
[], startLine:u = 1, maxLines:o, showCopy:l = !0, showLanguage:c = !0, collapsible:f = !1, defaultCollapsed:d = !1, wrap:m = !1, diff:p = "none", onCopy:g, className:T}) => {
  const [A, y] = (0,require$react.useState)(!1), [C, N] = (0,require$react.useState)(d), [v, B] = (0,require$react.useState)(!1), O = (0,require$react.useMemo)(() => _E(e, n, t), [e, n, t]), j = (0,require$react.useMemo)(() => AE[O] || O, [O]), W = Gi(r), $ = W.colors, L = (0,require$react.useMemo)(() => yE[W.name] ?? tn.vsDark, [W.name]), z = (0,require$react.useMemo)(() => e.split(`
`), [e]), Y = (0,require$react.useMemo)(() => !o || v ? z : z.slice(0, o), [z, o, v]), ne = (0,require$react.useCallback)(async() => {
    try {
      await navigator.clipboard.writeText(e), y(!0), g == null || g(), setTimeout(() => y(!1), 2e3);
    } catch (V) {
      console.error("Failed to copy:", V);
    }
  }, [e, g]), X = (0,require$react.useMemo)(() => p === "add" ? {backgroundColor:$.alpha.blue._15, borderLeft:`3px solid ${$.accent.cyan}`} : p === "remove" ? {backgroundColor:$.alpha.red._15, borderLeft:`3px solid ${$.accent.red}`} : {}, [p, $]);
  return C ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:T, "data-component":"code-block", "data-language":O, "data-collapsed":!0, onClick:() => N(!1), style:{background:$.background.elevated, padding:"8px 12px", borderRadius:h.radius.md, cursor:"pointer", display:"flex", alignItems:"center", gap:"8px", fontFamily:h.fontFamily.mono, fontSize:13, color:$.text.muted, ...X}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u25b6"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {children:n || O}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{marginLeft:"auto", opacity:0.5}, children:[z.length, " lines"]})]}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:T, "data-component":"code-block", "data-language":O, "data-diff":p, style:{background:$.background.elevated, borderRadius:h.radius.md, overflow:"hidden", position:"relative", ...X}, children:[(c || l || f) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", 
  justifyContent:"space-between", padding:"8px 12px", background:k($.text.default, 0.02), borderBottom:`1px solid ${$.border.subtle}`}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8}, children:[f && (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => N(!0), style:{background:"none", border:"none", color:$.text.muted, cursor:"pointer", padding:0, fontSize:12}, children:"\u25bc"}), c && (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{fontSize:12, color:$.text.muted, textTransform:"uppercase", letterSpacing:"0.5px"}, children:n || O})]}), l && (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:ne, style:{background:"none", border:"none", color:A ? $.accent.cyan : $.text.muted, cursor:"pointer", fontSize:12, padding:"4px 8px", borderRadius:h.radius.xs, transition:"color 0.2s"}, children:A ? "\u2713 Copied" : "Copy"})]}), (0,require$react_SLASH_jsx_runtime.jsx)(TE, {theme:L, code:Y.join(`
`), language:j, children:({className:V, style:ue, tokens:oe, getLineProps:se, getTokenProps:Oe}) => (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:V, style:{...ue, margin:0, padding:h.spacing[4], overflow:"auto", maxHeight:o ? `${o * 20 + 32}px` : void 0, whiteSpace:m ? "pre-wrap" : "pre", wordBreak:m ? "break-all" : void 0, background:"transparent"}, children:oe.map((x, he) => {
    const Ee = u + he, S = i.includes(Ee);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {...se({line:x}), style:{display:"flex", backgroundColor:S ? k($.accent.cyan, 0.1) : "transparent", borderLeft:S ? `2px solid ${$.accent.cyan}` : "2px solid transparent"}, children:[a && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{display:"inline-block", width:40, marginRight:16, textAlign:"right", color:$.text.subtle, userSelect:"none", opacity:0.5}, children:Ee}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{flex:1}, 
    children:x.map((Te, Me) => (0,require$react_SLASH_jsx_runtime.jsx)("span", {...Oe({token:Te})}, Me))})]}, he);
  })})}), o && z.length > o && !v && (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => B(!0), style:{width:"100%", padding:"8px", background:k($.text.default, 0.02), border:"none", borderTop:`1px solid ${$.border.subtle}`, color:$.text.muted, cursor:"pointer", fontSize:12}, children:["Show ", z.length - o, " more lines"]})]});
}, SE = {1:32, 2:24, 3:20, 4:18, 5:16, 6:14};
function Pr(e) {
  return typeof e == "string" || typeof e == "number" ? String(e) : Array.isArray(e) ? e.map(Pr).join("") : default$$require$react.default.isValidElement(e) ? Pr(e.props.children) : "";
}
function kE(e) {
  return e.trim().toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-");
}
function CE(e) {
  const t = e == null ? void 0 : e.match(/language-([^\s]+)/);
  return t == null ? void 0 : t[1];
}
function Nt(e, t, n) {
  return ({children:r, ...a}) => {
    const i = `h${e}`, u = Pr(r), o = kE(u);
    return (0,require$react_SLASH_jsx_runtime.jsx)(i, {...a, id:o, style:{marginTop:e === 1 ? 0 : 24, marginBottom:16, fontSize:SE[e], fontWeight:e === 1 ? 700 : 600, color:t.text.default, cursor:n ? "pointer" : void 0}, onClick:n ? () => n(o, u) : void 0, children:r});
  };
}
const HE = ({content:e, variant:t = "default", theme:n = "dark", lineNumbers:r = !0, copyButton:a = !0, linkTarget:i = "_blank", sanitize:u = !0, maxLines:o, onLinkClick:l, onHeadingClick:c, className:f}) => {
  const m = Gi(n).colors, p = (0,require$react.useCallback)((A, y) => {
    l && (y.preventDefault(), l(A, y));
  }, [l]), g = (0,require$react.useMemo)(() => u ? [] : [mb], [u]), T = (0,require$react.useMemo)(() => ({h1:Nt(1, m, c), h2:Nt(2, m, c), h3:Nt(3, m, c), h4:Nt(4, m, c), h5:Nt(5, m, c), h6:Nt(6, m, c), p:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("p", {...y, style:{marginTop:0, marginBottom:16, lineHeight:1.7, color:m.text.default}, children:A}), a:({href:A, children:y, ...C}) => (0,require$react_SLASH_jsx_runtime.jsx)("a", {...C, href:A, style:{color:m.accent.cyan, textDecoration:"none"}, 
  target:i, rel:i === "_blank" ? "noopener noreferrer" : void 0, onClick:A && l ? N => p(A, N) : void 0, children:y}), code:({className:A, children:y, ...C}) => (0,require$react_SLASH_jsx_runtime.jsx)("code", {...C, className:A, style:{background:k(m.text.default, 0.05), padding:"2px 6px", borderRadius:h.radius.xs, fontFamily:h.fontFamily.mono, fontSize:"0.9em"}, children:y}), pre:({children:A}) => {
    if (default$$require$react.default.isValidElement(A)) {
      const y = String(A.props.children ?? "").replace(/\n$/, "");
      return (0,require$react_SLASH_jsx_runtime.jsx)(xE, {code:y, language:CE(A.props.className), lineNumbers:r, showCopy:a, maxLines:o, theme:n, showLanguage:!0});
    }
    return (0,require$react_SLASH_jsx_runtime.jsx)("pre", {children:A});
  }, blockquote:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("blockquote", {...y, style:{margin:"16px 0", padding:"8px 16px", borderLeft:`4px solid ${m.accent.cyan}`, background:k(m.accent.cyan, 0.05), color:m.text.muted}, children:A}), ul:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("ul", {...y, style:{marginTop:0, marginBottom:16, paddingLeft:24, lineHeight:1.7, color:m.text.default}, children:A}), ol:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("ol", 
  {...y, style:{marginTop:0, marginBottom:16, paddingLeft:24, lineHeight:1.7, color:m.text.default}, children:A}), li:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("li", {...y, style:{marginBottom:4}, children:A}), hr:A => (0,require$react_SLASH_jsx_runtime.jsx)("hr", {...A, style:{border:"none", height:1, background:m.border.default, margin:"24px 0"}}), img:({src:A, alt:y, ...C}) => (0,require$react_SLASH_jsx_runtime.jsx)("img", {...C, src:A || "", alt:y || "", style:{maxWidth:"100%", 
  height:"auto", borderRadius:h.radius.md}}), table:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{overflowX:"auto", margin:"16px 0"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("table", {...y, style:{width:"100%", borderCollapse:"collapse", fontSize:t === "compact" ? 13 : 14}, children:A})}), th:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("th", {...y, style:{padding:"8px 12px", textAlign:"left", borderBottom:`2px solid ${m.border.default}`, 
  color:m.text.default, fontWeight:600}, children:A}), td:({children:A, ...y}) => (0,require$react_SLASH_jsx_runtime.jsx)("td", {...y, style:{padding:"8px 12px", borderBottom:`1px solid ${m.border.subtle}`, color:m.text.default}, children:A})}), [a, p, r, i, o, c, l, n, m, t]);
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:f, "data-component":"markdown", "data-variant":t, role:"article", "aria-label":"Markdown content", style:{fontFamily:"inherit", fontSize:t === "compact" ? 13 : 14, lineHeight:1.6, maxWidth:t === "full" ? "100%" : "65ch"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(j0, {remarkPlugins:[rm], rehypePlugins:g, skipHtml:u, components:T, children:e})});
};
h.colors.background.surface, `${h.colors.border.default}`, `${h.colors.border.default}`, h.colors.background.elevated, h.shadow.md, h.colors.background.elevated, h.shadow.md;
h.fontFamily.sans;
`${h.colors.border.default}`;
function zE({title:e, message:t, actionLabel:n, onAction:r, icon:a = "\ud83d\udced"}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"2rem", textAlign:"center", gap:"1rem"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:"3rem", lineHeight:1, opacity:0.6}, children:a}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {style:{margin:"0 0 0.5rem 0", fontSize:"1.125rem", fontWeight:600, color:"var(--token-colors-text-default)"}, 
  children:e}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{margin:0, fontSize:"0.875rem", color:"var(--token-colors-text-muted)", maxWidth:"24rem"}, children:t})]}), n && r && (0,require$react_SLASH_jsx_runtime.jsx)(Wi, {variant:"primary", onClick:r, children:n})]});
}
const IE = {}, tt = IE, NE = (tt == null ? void 0 : tt.VITE_API_BASE) ?? "", OE = "knoxx_user_email", LE = "knoxx_org_slug";
var Bi;
const RE = ((Bi = tt == null ? void 0 : tt.VITE_KNOXX_DEV_USER_EMAIL) == null ? void 0 : Bi.trim()) ?? "";
var vi;
const wE = ((vi = tt == null ? void 0 : tt.VITE_KNOXX_DEV_ORG_SLUG) == null ? void 0 : vi.trim()) ?? "";
function Mi(e) {
  var t;
  if (typeof window > "u") {
    return null;
  }
  try {
    const n = (t = localStorage.getItem(e)) == null ? void 0 : t.trim();
    return n || null;
  } catch {
    return null;
  }
}
function DE(e) {
  const t = new Headers(e || {}), n = Mi(OE) ?? RE, r = Mi(LE) ?? wE;
  return n && !t.has("x-knoxx-user-email") && t.set("x-knoxx-user-email", n), r && !t.has("x-knoxx-org-slug") && t.set("x-knoxx-org-slug", r), t;
}
function PE(e) {
  if (!e || typeof e != "object") {
    return null;
  }
  const t = e, n = [typeof t.error == "string" ? t.error : null, typeof t.detail == "string" ? t.detail : null, typeof t.message == "string" ? t.message : null, typeof t.error_code == "string" ? `code=${t.error_code}` : null, typeof t.model_error == "string" ? t.model_error : null].filter(Boolean);
  return n.length > 0 ? n.join(" | ") : null;
}
async function ye(e, t) {
  let n;
  try {
    const r = (t == null ? void 0 : t.body) != null;
    n = await fetch(`${NE}${e}`, {credentials:"include", headers:{...Object.fromEntries(DE({...(r ? {"Content-Type":"application/json"} : {}), ...((t == null ? void 0 : t.headers) ?? {})}).entries())}, ...t});
  } catch (r) {
    const a = r instanceof Error ? r.message : String(r);
    throw new Error(`Request to ${e} failed before the server responded. This usually means the reverse proxy or upstream service reset the connection. ${a}`);
  }
  if (!n.ok) {
    const r = await n.text();
    let a = r;
    try {
      a = PE(JSON.parse(r)) ?? r;
    } catch {
    }
    throw new Error(`${n.status} ${n.statusText}${a ? ` - ${a}` : ""}`);
  }
  return await n.json();
}
async function $E() {
  return ye("/api/auth/context");
}
function ia(e) {
  return e != null && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function Ys(e, ...t) {
  for (const n of t) {
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      return e[n];
    }
  }
}
function yn(e, t, n = "") {
  const r = Ys(e, ...t);
  return typeof r == "string" ? r : n;
}
function FE(e) {
  return Array.isArray(e) ? e.map(ia) : [];
}
function ME(e) {
  const t = ia(e), n = yn(t, ["id"]);
  return {id:n, label:yn(t, ["label"], n), description:yn(t, ["description"]), riskLevel:yn(t, ["riskLevel", "risk-level", "risk_level"], "standard")};
}
async function YE() {
  const e = ia(await ye("/api/admin/tools"));
  return {tools:FE(Ys(e, "tools")).map(ME)};
}
async function jE() {
  return ye("/api/admin/config/discord");
}
async function qE(e) {
  return ye("/api/admin/config/discord", {method:"PUT", body:JSON.stringify({discordBotToken:e})});
}
async function GE() {
  return ye("/api/admin/config/events");
}
async function WE(e) {
  return ye("/api/admin/config/events", {method:"PUT", body:JSON.stringify(e)});
}
async function VE(e) {
  return ye(`/api/admin/config/events/jobs/${encodeURIComponent(e)}/run`, {method:"POST"});
}
async function XE(e) {
  return ye(`/api/admin/triggers/${encodeURIComponent(e)}/fire`, {method:"POST"});
}
async function QE(e) {
  return ye("/api/admin/config/events/dispatch", {method:"POST", body:JSON.stringify(e)});
}
async function KE() {
  return ye("/api/admin/config/events/runtime/stop", {method:"POST"});
}
async function ZE() {
  return ye("/api/admin/config/events/runtime/start", {method:"POST"});
}
async function JE() {
  return ye("/api/admin/config/events/runtime/reset", {method:"POST"});
}
async function eT(e) {
  const t = e ? `?kind=${encodeURIComponent(e)}` : "";
  return ye(`/api/admin/contracts${t}`);
}
async function tT(e, t = "agents") {
  return ye(`/api/admin/contracts/${encodeURIComponent(e)}?kind=${encodeURIComponent(t)}`);
}
async function nT(e, t, n = "agents") {
  return ye(`/api/admin/contracts/${encodeURIComponent(e)}`, {method:"PUT", body:JSON.stringify({ednText:t, kind:n})});
}
async function rT(e, t = "agents") {
  return ye("/api/admin/contracts/validate", {method:"POST", body:JSON.stringify({ednText:e, kind:t})});
}
async function aT(e, t, n = "agents") {
  return ye(`/api/admin/contracts/${encodeURIComponent(e)}/copy`, {method:"POST", body:JSON.stringify({newId:t, kind:n})});
}

};